/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * GXM Gateway API - Combined
 * Combined OpenAPI specification for all GXM APIs (Auth, Webhooks, Payroll Plus, Main)
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import { customInstance } from '../axios-instance';
export type PostAuthOtp200Data = { [key: string]: unknown };

export type PostAuthOtp200 = {
  success?: boolean;
  data?: PostAuthOtp200Data;
  message?: string;
};

export type PostAuthOtp400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostAuthOtp401 = {
  success?: boolean;
  error?: string;
};

export type PostAuthOtp500 = {
  success?: boolean;
  error?: string;
};

export type HeadAuthOtp200Data = { [key: string]: unknown };

export type HeadAuthOtp200 = {
  success?: boolean;
  data?: HeadAuthOtp200Data;
  message?: string;
};

export type HeadAuthOtp400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type HeadAuthOtp401 = {
  success?: boolean;
  error?: string;
};

export type HeadAuthOtp500 = {
  success?: boolean;
  error?: string;
};

export type PostAuthVerifyOtp200Data = { [key: string]: unknown };

export type PostAuthVerifyOtp200 = {
  success?: boolean;
  data?: PostAuthVerifyOtp200Data;
  message?: string;
};

export type PostAuthVerifyOtp400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostAuthVerifyOtp401 = {
  success?: boolean;
  error?: string;
};

export type PostAuthVerifyOtp500 = {
  success?: boolean;
  error?: string;
};

export type HeadAuthVerifyOtp200Data = { [key: string]: unknown };

export type HeadAuthVerifyOtp200 = {
  success?: boolean;
  data?: HeadAuthVerifyOtp200Data;
  message?: string;
};

export type HeadAuthVerifyOtp400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type HeadAuthVerifyOtp401 = {
  success?: boolean;
  error?: string;
};

export type HeadAuthVerifyOtp500 = {
  success?: boolean;
  error?: string;
};

export type PostWebhookWorkosEvents200Data = { [key: string]: unknown };

export type PostWebhookWorkosEvents200 = {
  success?: boolean;
  data?: PostWebhookWorkosEvents200Data;
  message?: string;
};

export type PostWebhookWorkosEvents400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostWebhookWorkosEvents401 = {
  success?: boolean;
  error?: string;
};

export type PostWebhookWorkosEvents500 = {
  success?: boolean;
  error?: string;
};

export type PostWebhookPayrollPlusEvents200Data = { [key: string]: unknown };

export type PostWebhookPayrollPlusEvents200 = {
  success?: boolean;
  data?: PostWebhookPayrollPlusEvents200Data;
  message?: string;
};

export type PostWebhookPayrollPlusEvents400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostWebhookPayrollPlusEvents401 = {
  success?: boolean;
  error?: string;
};

export type PostWebhookPayrollPlusEvents500 = {
  success?: boolean;
  error?: string;
};

export type GetVersion200Data = { [key: string]: unknown };

export type GetVersion200 = {
  success?: boolean;
  data?: GetVersion200Data;
  message?: string;
};

export type GetVersion400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetVersion401 = {
  success?: boolean;
  error?: string;
};

export type GetVersion500 = {
  success?: boolean;
  error?: string;
};

export type GetVerifyToken200Data = { [key: string]: unknown };

export type GetVerifyToken200 = {
  success?: boolean;
  data?: GetVerifyToken200Data;
  message?: string;
};

export type GetVerifyToken400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetVerifyToken401 = {
  success?: boolean;
  error?: string;
};

export type GetVerifyToken500 = {
  success?: boolean;
  error?: string;
};

export type PutUsersIdEntityAccess200Data = { [key: string]: unknown };

export type PutUsersIdEntityAccess200 = {
  success?: boolean;
  data?: PutUsersIdEntityAccess200Data;
  message?: string;
};

export type PutUsersIdEntityAccess400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PutUsersIdEntityAccess401 = {
  success?: boolean;
  error?: string;
};

export type PutUsersIdEntityAccess500 = {
  success?: boolean;
  error?: string;
};

export type GetUsersIdEntityAccess200Data = { [key: string]: unknown };

export type GetUsersIdEntityAccess200 = {
  success?: boolean;
  data?: GetUsersIdEntityAccess200Data;
  message?: string;
};

export type GetUsersIdEntityAccess400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetUsersIdEntityAccess401 = {
  success?: boolean;
  error?: string;
};

export type GetUsersIdEntityAccess500 = {
  success?: boolean;
  error?: string;
};

export type DeleteUsersIdEntityAccess200Data = { [key: string]: unknown };

export type DeleteUsersIdEntityAccess200 = {
  success?: boolean;
  data?: DeleteUsersIdEntityAccess200Data;
  message?: string;
};

export type DeleteUsersIdEntityAccess400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type DeleteUsersIdEntityAccess401 = {
  success?: boolean;
  error?: string;
};

export type DeleteUsersIdEntityAccess500 = {
  success?: boolean;
  error?: string;
};

export type PutProcessesTasksId200Data = { [key: string]: unknown };

export type PutProcessesTasksId200 = {
  success?: boolean;
  data?: PutProcessesTasksId200Data;
  message?: string;
};

export type PutProcessesTasksId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PutProcessesTasksId401 = {
  success?: boolean;
  error?: string;
};

export type PutProcessesTasksId500 = {
  success?: boolean;
  error?: string;
};

export type PatchProcessesTasksId200Data = { [key: string]: unknown };

export type PatchProcessesTasksId200 = {
  success?: boolean;
  data?: PatchProcessesTasksId200Data;
  message?: string;
};

export type PatchProcessesTasksId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PatchProcessesTasksId401 = {
  success?: boolean;
  error?: string;
};

export type PatchProcessesTasksId500 = {
  success?: boolean;
  error?: string;
};

export type PutEntitiesShareholdersShareholderId200Data = { [key: string]: unknown };

export type PutEntitiesShareholdersShareholderId200 = {
  success?: boolean;
  data?: PutEntitiesShareholdersShareholderId200Data;
  message?: string;
};

export type PutEntitiesShareholdersShareholderId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PutEntitiesShareholdersShareholderId401 = {
  success?: boolean;
  error?: string;
};

export type PutEntitiesShareholdersShareholderId500 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesShareholdersShareholderId200Data = { [key: string]: unknown };

export type GetEntitiesShareholdersShareholderId200 = {
  success?: boolean;
  data?: GetEntitiesShareholdersShareholderId200Data;
  message?: string;
};

export type GetEntitiesShareholdersShareholderId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntitiesShareholdersShareholderId401 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesShareholdersShareholderId500 = {
  success?: boolean;
  error?: string;
};

export type DeleteEntitiesShareholdersShareholderId200Data = { [key: string]: unknown };

export type DeleteEntitiesShareholdersShareholderId200 = {
  success?: boolean;
  data?: DeleteEntitiesShareholdersShareholderId200Data;
  message?: string;
};

export type DeleteEntitiesShareholdersShareholderId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type DeleteEntitiesShareholdersShareholderId401 = {
  success?: boolean;
  error?: string;
};

export type DeleteEntitiesShareholdersShareholderId500 = {
  success?: boolean;
  error?: string;
};

export type PutEntitiesShareholdersRegistryRegistryId200Data = { [key: string]: unknown };

export type PutEntitiesShareholdersRegistryRegistryId200 = {
  success?: boolean;
  data?: PutEntitiesShareholdersRegistryRegistryId200Data;
  message?: string;
};

export type PutEntitiesShareholdersRegistryRegistryId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PutEntitiesShareholdersRegistryRegistryId401 = {
  success?: boolean;
  error?: string;
};

export type PutEntitiesShareholdersRegistryRegistryId500 = {
  success?: boolean;
  error?: string;
};

export type DeleteEntitiesShareholdersRegistryRegistryId200DataEntityId = string | null;

export type DeleteEntitiesShareholdersRegistryRegistryId200Data = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  registry_id: string;
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  shareholder_id: string;
  transaction_type: string;
  entity_id?: DeleteEntitiesShareholdersRegistryRegistryId200DataEntityId;
  deleted_at: string;
};

export type DeleteEntitiesShareholdersRegistryRegistryId200 = {
  success: true;
  data: DeleteEntitiesShareholdersRegistryRegistryId200Data;
  message: string;
  statusCode: 200;
  status: true;
};

export type PutRequestsIdStatus200Data = { [key: string]: unknown };

export type PutRequestsIdStatus200 = {
  success?: boolean;
  data?: PutRequestsIdStatus200Data;
  message?: string;
};

export type PutRequestsIdStatus400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PutRequestsIdStatus401 = {
  success?: boolean;
  error?: string;
};

export type PutRequestsIdStatus500 = {
  success?: boolean;
  error?: string;
};

export type PutPersonnelUpdateId200Data = { [key: string]: unknown };

export type PutPersonnelUpdateId200 = {
  success?: boolean;
  data?: PutPersonnelUpdateId200Data;
  message?: string;
};

export type PutPersonnelUpdateId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PutPersonnelUpdateId401 = {
  success?: boolean;
  error?: string;
};

export type PutPersonnelUpdateId500 = {
  success?: boolean;
  error?: string;
};

export type PatchPayslipMatchingResults200Data = { [key: string]: unknown };

export type PatchPayslipMatchingResults200 = {
  success?: boolean;
  data?: PatchPayslipMatchingResults200Data;
  message?: string;
};

export type PatchPayslipMatchingResults400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PatchPayslipMatchingResults401 = {
  success?: boolean;
  error?: string;
};

export type PatchPayslipMatchingResults500 = {
  success?: boolean;
  error?: string;
};

export type PatchPayslipMatchingResultId200Data = { [key: string]: unknown };

export type PatchPayslipMatchingResultId200 = {
  success?: boolean;
  data?: PatchPayslipMatchingResultId200Data;
  message?: string;
};

export type PatchPayslipMatchingResultId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PatchPayslipMatchingResultId401 = {
  success?: boolean;
  error?: string;
};

export type PatchPayslipMatchingResultId500 = {
  success?: boolean;
  error?: string;
};

export type PutEntitiesOfficersOfficerId200Data = { [key: string]: unknown };

export type PutEntitiesOfficersOfficerId200 = {
  success?: boolean;
  data?: PutEntitiesOfficersOfficerId200Data;
  message?: string;
};

export type PutEntitiesOfficersOfficerId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PutEntitiesOfficersOfficerId401 = {
  success?: boolean;
  error?: string;
};

export type PutEntitiesOfficersOfficerId500 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesOfficersOfficerId200Data = { [key: string]: unknown };

export type GetEntitiesOfficersOfficerId200 = {
  success?: boolean;
  data?: GetEntitiesOfficersOfficerId200Data;
  message?: string;
};

export type GetEntitiesOfficersOfficerId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntitiesOfficersOfficerId401 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesOfficersOfficerId500 = {
  success?: boolean;
  error?: string;
};

export type PutLspId200Data = { [key: string]: unknown };

export type PutLspId200 = {
  success?: boolean;
  data?: PutLspId200Data;
  message?: string;
};

export type PutLspId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PutLspId401 = {
  success?: boolean;
  error?: string;
};

export type PutLspId500 = {
  success?: boolean;
  error?: string;
};

export type GetLspId200Data = { [key: string]: unknown };

export type GetLspId200 = {
  success?: boolean;
  data?: GetLspId200Data;
  message?: string;
};

export type GetLspId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetLspId401 = {
  success?: boolean;
  error?: string;
};

export type GetLspId500 = {
  success?: boolean;
  error?: string;
};

export type PutEntitiesIdPlusConfig200Data = { [key: string]: unknown };

export type PutEntitiesIdPlusConfig200 = {
  success?: boolean;
  data?: PutEntitiesIdPlusConfig200Data;
  message?: string;
};

export type PutEntitiesIdPlusConfig400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PutEntitiesIdPlusConfig401 = {
  success?: boolean;
  error?: string;
};

export type PutEntitiesIdPlusConfig500 = {
  success?: boolean;
  error?: string;
};

export type PutEntitiesEmployeeEmployeeId200Data = { [key: string]: unknown };

export type PutEntitiesEmployeeEmployeeId200 = {
  success?: boolean;
  data?: PutEntitiesEmployeeEmployeeId200Data;
  message?: string;
};

export type PutEntitiesEmployeeEmployeeId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PutEntitiesEmployeeEmployeeId401 = {
  success?: boolean;
  error?: string;
};

export type PutEntitiesEmployeeEmployeeId500 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesEmployeeEmployeeId200Data = { [key: string]: unknown };

export type GetEntitiesEmployeeEmployeeId200 = {
  success?: boolean;
  data?: GetEntitiesEmployeeEmployeeId200Data;
  message?: string;
};

export type GetEntitiesEmployeeEmployeeId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntitiesEmployeeEmployeeId401 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesEmployeeEmployeeId500 = {
  success?: boolean;
  error?: string;
};

export type DeleteEntitiesEmployeeEmployeeId200Data = { [key: string]: unknown };

export type DeleteEntitiesEmployeeEmployeeId200 = {
  success?: boolean;
  data?: DeleteEntitiesEmployeeEmployeeId200Data;
  message?: string;
};

export type DeleteEntitiesEmployeeEmployeeId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type DeleteEntitiesEmployeeEmployeeId401 = {
  success?: boolean;
  error?: string;
};

export type DeleteEntitiesEmployeeEmployeeId500 = {
  success?: boolean;
  error?: string;
};

export type PutEntitiesDirectorsDirectorId200Data = { [key: string]: unknown };

export type PutEntitiesDirectorsDirectorId200 = {
  success?: boolean;
  data?: PutEntitiesDirectorsDirectorId200Data;
  message?: string;
};

export type PutEntitiesDirectorsDirectorId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PutEntitiesDirectorsDirectorId401 = {
  success?: boolean;
  error?: string;
};

export type PutEntitiesDirectorsDirectorId500 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesDirectorsDirectorId200Data = { [key: string]: unknown };

export type GetEntitiesDirectorsDirectorId200 = {
  success?: boolean;
  data?: GetEntitiesDirectorsDirectorId200Data;
  message?: string;
};

export type GetEntitiesDirectorsDirectorId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntitiesDirectorsDirectorId401 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesDirectorsDirectorId500 = {
  success?: boolean;
  error?: string;
};

export type DeleteEntitiesDirectorsDirectorId200Data = { [key: string]: unknown };

export type DeleteEntitiesDirectorsDirectorId200 = {
  success?: boolean;
  data?: DeleteEntitiesDirectorsDirectorId200Data;
  message?: string;
};

export type DeleteEntitiesDirectorsDirectorId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type DeleteEntitiesDirectorsDirectorId401 = {
  success?: boolean;
  error?: string;
};

export type DeleteEntitiesDirectorsDirectorId500 = {
  success?: boolean;
  error?: string;
};

export type PutEntitiesDirectorsDirectorIdAppointmentsAppointmentId200Data = { [key: string]: unknown };

export type PutEntitiesDirectorsDirectorIdAppointmentsAppointmentId200 = {
  success?: boolean;
  data?: PutEntitiesDirectorsDirectorIdAppointmentsAppointmentId200Data;
  message?: string;
};

export type PutEntitiesDirectorsDirectorIdAppointmentsAppointmentId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PutEntitiesDirectorsDirectorIdAppointmentsAppointmentId401 = {
  success?: boolean;
  error?: string;
};

export type PutEntitiesDirectorsDirectorIdAppointmentsAppointmentId500 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesDirectorsDirectorIdAppointmentsAppointmentId200Data = { [key: string]: unknown };

export type GetEntitiesDirectorsDirectorIdAppointmentsAppointmentId200 = {
  success?: boolean;
  data?: GetEntitiesDirectorsDirectorIdAppointmentsAppointmentId200Data;
  message?: string;
};

export type GetEntitiesDirectorsDirectorIdAppointmentsAppointmentId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntitiesDirectorsDirectorIdAppointmentsAppointmentId401 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesDirectorsDirectorIdAppointmentsAppointmentId500 = {
  success?: boolean;
  error?: string;
};

export type DeleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId200Data = { [key: string]: unknown };

export type DeleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId200 = {
  success?: boolean;
  data?: DeleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId200Data;
  message?: string;
};

export type DeleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type DeleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId401 = {
  success?: boolean;
  error?: string;
};

export type DeleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId500 = {
  success?: boolean;
  error?: string;
};

export type PatchIdDescription200Data = { [key: string]: unknown };

export type PatchIdDescription200 = {
  success?: boolean;
  data?: PatchIdDescription200Data;
  message?: string;
};

export type PatchIdDescription400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PatchIdDescription401 = {
  success?: boolean;
  error?: string;
};

export type PatchIdDescription500 = {
  success?: boolean;
  error?: string;
};

export type PostIdDescription200Data = { [key: string]: unknown };

export type PostIdDescription200 = {
  success?: boolean;
  data?: PostIdDescription200Data;
  message?: string;
};

export type PostIdDescription400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostIdDescription401 = {
  success?: boolean;
  error?: string;
};

export type PostIdDescription500 = {
  success?: boolean;
  error?: string;
};

export type PutAddressesId200Data = { [key: string]: unknown };

export type PutAddressesId200 = {
  success?: boolean;
  data?: PutAddressesId200Data;
  message?: string;
};

export type PutAddressesId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PutAddressesId401 = {
  success?: boolean;
  error?: string;
};

export type PutAddressesId500 = {
  success?: boolean;
  error?: string;
};

export type DeleteAddressesId200Data = { [key: string]: unknown };

export type DeleteAddressesId200 = {
  success?: boolean;
  data?: DeleteAddressesId200Data;
  message?: string;
};

export type DeleteAddressesId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type DeleteAddressesId401 = {
  success?: boolean;
  error?: string;
};

export type DeleteAddressesId500 = {
  success?: boolean;
  error?: string;
};

export type PostPayslipsMatchingTrigger200Data = { [key: string]: unknown };

export type PostPayslipsMatchingTrigger200 = {
  success?: boolean;
  data?: PostPayslipsMatchingTrigger200Data;
  message?: string;
};

export type PostPayslipsMatchingTrigger400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostPayslipsMatchingTrigger401 = {
  success?: boolean;
  error?: string;
};

export type PostPayslipsMatchingTrigger500 = {
  success?: boolean;
  error?: string;
};

export type PostNotificationsTrigger200Data = { [key: string]: unknown };

export type PostNotificationsTrigger200 = {
  success?: boolean;
  data?: PostNotificationsTrigger200Data;
  message?: string;
};

export type PostNotificationsTrigger400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostNotificationsTrigger401 = {
  success?: boolean;
  error?: string;
};

export type PostNotificationsTrigger500 = {
  success?: boolean;
  error?: string;
};

export type PostFileTags200Data = { [key: string]: unknown };

export type PostFileTags200 = {
  success?: boolean;
  data?: PostFileTags200Data;
  message?: string;
};

export type PostFileTags400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostFileTags401 = {
  success?: boolean;
  error?: string;
};

export type PostFileTags500 = {
  success?: boolean;
  error?: string;
};

export type PostStats200Data = { [key: string]: unknown };

export type PostStats200 = {
  success?: boolean;
  data?: PostStats200Data;
  message?: string;
};

export type PostStats400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostStats401 = {
  success?: boolean;
  error?: string;
};

export type PostStats500 = {
  success?: boolean;
  error?: string;
};

export type PostFilesSearch200Data = { [key: string]: unknown };

export type PostFilesSearch200 = {
  success?: boolean;
  data?: PostFilesSearch200Data;
  message?: string;
};

export type PostFilesSearch400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostFilesSearch401 = {
  success?: boolean;
  error?: string;
};

export type PostFilesSearch500 = {
  success?: boolean;
  error?: string;
};

export type PutPayslipMatchingResultsRestoreMatchingResultId200Data = { [key: string]: unknown };

export type PutPayslipMatchingResultsRestoreMatchingResultId200 = {
  success?: boolean;
  data?: PutPayslipMatchingResultsRestoreMatchingResultId200Data;
  message?: string;
};

export type PutPayslipMatchingResultsRestoreMatchingResultId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PutPayslipMatchingResultsRestoreMatchingResultId401 = {
  success?: boolean;
  error?: string;
};

export type PutPayslipMatchingResultsRestoreMatchingResultId500 = {
  success?: boolean;
  error?: string;
};

export type PostConversationsId200Data = { [key: string]: unknown };

export type PostConversationsId200 = {
  success?: boolean;
  data?: PostConversationsId200Data;
  message?: string;
};

export type PostConversationsId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostConversationsId401 = {
  success?: boolean;
  error?: string;
};

export type PostConversationsId500 = {
  success?: boolean;
  error?: string;
};

export type DeleteConversationsId200Data = { [key: string]: unknown };

export type DeleteConversationsId200 = {
  success?: boolean;
  data?: DeleteConversationsId200Data;
  message?: string;
};

export type DeleteConversationsId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type DeleteConversationsId401 = {
  success?: boolean;
  error?: string;
};

export type DeleteConversationsId500 = {
  success?: boolean;
  error?: string;
};

export type PostAttachmentsRestore200Data = { [key: string]: unknown };

export type PostAttachmentsRestore200 = {
  success?: boolean;
  data?: PostAttachmentsRestore200Data;
  message?: string;
};

export type PostAttachmentsRestore400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostAttachmentsRestore401 = {
  success?: boolean;
  error?: string;
};

export type PostAttachmentsRestore500 = {
  success?: boolean;
  error?: string;
};

export type PostPayslipsMatchingManualMatch200Data = { [key: string]: unknown };

export type PostPayslipsMatchingManualMatch200 = {
  success?: boolean;
  data?: PostPayslipsMatchingManualMatch200Data;
  message?: string;
};

export type PostPayslipsMatchingManualMatch400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostPayslipsMatchingManualMatch401 = {
  success?: boolean;
  error?: string;
};

export type PostPayslipsMatchingManualMatch500 = {
  success?: boolean;
  error?: string;
};

export type PostEmployeeTaxStatementNotify200Data = { [key: string]: unknown };

export type PostEmployeeTaxStatementNotify200 = {
  success?: boolean;
  data?: PostEmployeeTaxStatementNotify200Data;
  message?: string;
};

export type PostEmployeeTaxStatementNotify400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostEmployeeTaxStatementNotify401 = {
  success?: boolean;
  error?: string;
};

export type PostEmployeeTaxStatementNotify500 = {
  success?: boolean;
  error?: string;
};

export type PostPayslipsManualMatch200Data = { [key: string]: unknown };

export type PostPayslipsManualMatch200 = {
  success?: boolean;
  data?: PostPayslipsManualMatch200Data;
  message?: string;
};

export type PostPayslipsManualMatch400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostPayslipsManualMatch401 = {
  success?: boolean;
  error?: string;
};

export type PostPayslipsManualMatch500 = {
  success?: boolean;
  error?: string;
};

export type PostLspOnboard200Data = { [key: string]: unknown };

export type PostLspOnboard200 = {
  success?: boolean;
  data?: PostLspOnboard200Data;
  message?: string;
};

export type PostLspOnboard400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostLspOnboard401 = {
  success?: boolean;
  error?: string;
};

export type PostLspOnboard500 = {
  success?: boolean;
  error?: string;
};

export type GetLogout200Data = { [key: string]: unknown };

export type GetLogout200 = {
  success?: boolean;
  data?: GetLogout200Data;
  message?: string;
};

export type GetLogout400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetLogout401 = {
  success?: boolean;
  error?: string;
};

export type GetLogout500 = {
  success?: boolean;
  error?: string;
};

export type GetLogin200Data = { [key: string]: unknown };

export type GetLogin200 = {
  success?: boolean;
  data?: GetLogin200Data;
  message?: string;
};

export type GetLogin400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetLogin401 = {
  success?: boolean;
  error?: string;
};

export type GetLogin500 = {
  success?: boolean;
  error?: string;
};

export type GetHealthWebhooks200Data = { [key: string]: unknown };

export type GetHealthWebhooks200 = {
  success?: boolean;
  data?: GetHealthWebhooks200Data;
  message?: string;
};

export type GetHealthWebhooks400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetHealthWebhooks401 = {
  success?: boolean;
  error?: string;
};

export type GetHealthWebhooks500 = {
  success?: boolean;
  error?: string;
};

export type GetTaxDocsYears200Data = { [key: string]: unknown };

export type GetTaxDocsYears200 = {
  success?: boolean;
  data?: GetTaxDocsYears200Data;
  message?: string;
};

export type GetTaxDocsYears400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetTaxDocsYears401 = {
  success?: boolean;
  error?: string;
};

export type GetTaxDocsYears500 = {
  success?: boolean;
  error?: string;
};

export type GetPayslipsYears200Data = { [key: string]: unknown };

export type GetPayslipsYears200 = {
  success?: boolean;
  data?: GetPayslipsYears200Data;
  message?: string;
};

export type GetPayslipsYears400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetPayslipsYears401 = {
  success?: boolean;
  error?: string;
};

export type GetPayslipsYears500 = {
  success?: boolean;
  error?: string;
};

export type GetContainerSasToken200Data = { [key: string]: unknown };

export type GetContainerSasToken200 = {
  success?: boolean;
  data?: GetContainerSasToken200Data;
  message?: string;
};

export type GetContainerSasToken400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetContainerSasToken401 = {
  success?: boolean;
  error?: string;
};

export type GetContainerSasToken500 = {
  success?: boolean;
  error?: string;
};

export type GetUsersIdAudit200Data = { [key: string]: unknown };

export type GetUsersIdAudit200 = {
  success?: boolean;
  data?: GetUsersIdAudit200Data;
  message?: string;
};

export type GetUsersIdAudit400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetUsersIdAudit401 = {
  success?: boolean;
  error?: string;
};

export type GetUsersIdAudit500 = {
  success?: boolean;
  error?: string;
};

export type GetUserManagementUsersUserRoles200Data = { [key: string]: unknown };

export type GetUserManagementUsersUserRoles200 = {
  success?: boolean;
  data?: GetUserManagementUsersUserRoles200Data;
  message?: string;
};

export type GetUserManagementUsersUserRoles400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetUserManagementUsersUserRoles401 = {
  success?: boolean;
  error?: string;
};

export type GetUserManagementUsersUserRoles500 = {
  success?: boolean;
  error?: string;
};

export type GetUsersCurrentMe200Data = { [key: string]: unknown };

export type GetUsersCurrentMe200 = {
  success?: boolean;
  data?: GetUsersCurrentMe200Data;
  message?: string;
};

export type GetUsersCurrentMe400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetUsersCurrentMe401 = {
  success?: boolean;
  error?: string;
};

export type GetUsersCurrentMe500 = {
  success?: boolean;
  error?: string;
};

export type GetEventsUpcoming200Data = { [key: string]: unknown };

export type GetEventsUpcoming200 = {
  success?: boolean;
  data?: GetEventsUpcoming200Data;
  message?: string;
};

export type GetEventsUpcoming400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEventsUpcoming401 = {
  success?: boolean;
  error?: string;
};

export type GetEventsUpcoming500 = {
  success?: boolean;
  error?: string;
};

export type GetTaxDocs200Data = { [key: string]: unknown };

export type GetTaxDocs200 = {
  success?: boolean;
  data?: GetTaxDocs200Data;
  message?: string;
};

export type GetTaxDocs400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetTaxDocs401 = {
  success?: boolean;
  error?: string;
};

export type GetTaxDocs500 = {
  success?: boolean;
  error?: string;
};

export type GetStates200Data = { [key: string]: unknown };

export type GetStates200 = {
  success?: boolean;
  data?: GetStates200Data;
  message?: string;
};

export type GetStates400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetStates401 = {
  success?: boolean;
  error?: string;
};

export type GetStates500 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesEntityIdShareholders200Data = { [key: string]: unknown };

export type GetEntitiesEntityIdShareholders200 = {
  success?: boolean;
  data?: GetEntitiesEntityIdShareholders200Data;
  message?: string;
};

export type GetEntitiesEntityIdShareholders400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntitiesEntityIdShareholders401 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesEntityIdShareholders500 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesShareholdersShareholderIdAudit200Data = { [key: string]: unknown };

export type GetEntitiesShareholdersShareholderIdAudit200 = {
  success?: boolean;
  data?: GetEntitiesShareholdersShareholderIdAudit200Data;
  message?: string;
};

export type GetEntitiesShareholdersShareholderIdAudit400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntitiesShareholdersShareholderIdAudit401 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesShareholdersShareholderIdAudit500 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesShareholdersShareholderIdRegistry200Data = { [key: string]: unknown };

export type GetEntitiesShareholdersShareholderIdRegistry200 = {
  success?: boolean;
  data?: GetEntitiesShareholdersShareholderIdRegistry200Data;
  message?: string;
};

export type GetEntitiesShareholdersShareholderIdRegistry400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntitiesShareholdersShareholderIdRegistry401 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesShareholdersShareholderIdRegistry500 = {
  success?: boolean;
  error?: string;
};

export type PostEntitiesShareholdersShareholderIdRegistry200Data = { [key: string]: unknown };

export type PostEntitiesShareholdersShareholderIdRegistry200 = {
  success?: boolean;
  data?: PostEntitiesShareholdersShareholderIdRegistry200Data;
  message?: string;
};

export type PostEntitiesShareholdersShareholderIdRegistry400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostEntitiesShareholdersShareholderIdRegistry401 = {
  success?: boolean;
  error?: string;
};

export type PostEntitiesShareholdersShareholderIdRegistry500 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesShareholdersShareholderIdRegistryAudit200Data = { [key: string]: unknown };

export type GetEntitiesShareholdersShareholderIdRegistryAudit200 = {
  success?: boolean;
  data?: GetEntitiesShareholdersShareholderIdRegistryAudit200Data;
  message?: string;
};

export type GetEntitiesShareholdersShareholderIdRegistryAudit400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntitiesShareholdersShareholderIdRegistryAudit401 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesShareholdersShareholderIdRegistryAudit500 = {
  success?: boolean;
  error?: string;
};

export type GetServices200Data = { [key: string]: unknown };

export type GetServices200 = {
  success?: boolean;
  data?: GetServices200Data;
  message?: string;
};

export type GetServices400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetServices401 = {
  success?: boolean;
  error?: string;
};

export type GetServices500 = {
  success?: boolean;
  error?: string;
};

export type GetEntityIdServicesAudit200Data = { [key: string]: unknown };

export type GetEntityIdServicesAudit200 = {
  success?: boolean;
  data?: GetEntityIdServicesAudit200Data;
  message?: string;
};

export type GetEntityIdServicesAudit400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntityIdServicesAudit401 = {
  success?: boolean;
  error?: string;
};

export type GetEntityIdServicesAudit500 = {
  success?: boolean;
  error?: string;
};

export type GetRequests200Data = { [key: string]: unknown };

export type GetRequests200 = {
  success?: boolean;
  data?: GetRequests200Data;
  message?: string;
};

export type GetRequests400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetRequests401 = {
  success?: boolean;
  error?: string;
};

export type GetRequests500 = {
  success?: boolean;
  error?: string;
};

export type PostRequests200Data = { [key: string]: unknown };

export type PostRequests200 = {
  success?: boolean;
  data?: PostRequests200Data;
  message?: string;
};

export type PostRequests400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostRequests401 = {
  success?: boolean;
  error?: string;
};

export type PostRequests500 = {
  success?: boolean;
  error?: string;
};

export type GetRequestsId200Data = { [key: string]: unknown };

export type GetRequestsId200 = {
  success?: boolean;
  data?: GetRequestsId200Data;
  message?: string;
};

export type GetRequestsId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetRequestsId401 = {
  success?: boolean;
  error?: string;
};

export type GetRequestsId500 = {
  success?: boolean;
  error?: string;
};

export type GetRequestsIdDocuments200Data = { [key: string]: unknown };

export type GetRequestsIdDocuments200 = {
  success?: boolean;
  data?: GetRequestsIdDocuments200Data;
  message?: string;
};

export type GetRequestsIdDocuments400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetRequestsIdDocuments401 = {
  success?: boolean;
  error?: string;
};

export type GetRequestsIdDocuments500 = {
  success?: boolean;
  error?: string;
};

export type GetRequestsRequestIdAudit200Data = { [key: string]: unknown };

export type GetRequestsRequestIdAudit200 = {
  success?: boolean;
  data?: GetRequestsRequestIdAudit200Data;
  message?: string;
};

export type GetRequestsRequestIdAudit400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetRequestsRequestIdAudit401 = {
  success?: boolean;
  error?: string;
};

export type GetRequestsRequestIdAudit500 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesEntityIdDocumentsRecent200Data = { [key: string]: unknown };

export type GetEntitiesEntityIdDocumentsRecent200 = {
  success?: boolean;
  data?: GetEntitiesEntityIdDocumentsRecent200Data;
  message?: string;
};

export type GetEntitiesEntityIdDocumentsRecent400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntitiesEntityIdDocumentsRecent401 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesEntityIdDocumentsRecent500 = {
  success?: boolean;
  error?: string;
};

export type GetIdMessagesPublic200Data = { [key: string]: unknown };

export type GetIdMessagesPublic200 = {
  success?: boolean;
  data?: GetIdMessagesPublic200Data;
  message?: string;
};

export type GetIdMessagesPublic400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetIdMessagesPublic401 = {
  success?: boolean;
  error?: string;
};

export type GetIdMessagesPublic500 = {
  success?: boolean;
  error?: string;
};

export type GetProcessTemplates200Data = { [key: string]: unknown };

export type GetProcessTemplates200 = {
  success?: boolean;
  data?: GetProcessTemplates200Data;
  message?: string;
};

export type GetProcessTemplates400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetProcessTemplates401 = {
  success?: boolean;
  error?: string;
};

export type GetProcessTemplates500 = {
  success?: boolean;
  error?: string;
};

export type GetProcessesIdAudit200Data = { [key: string]: unknown };

export type GetProcessesIdAudit200 = {
  success?: boolean;
  data?: GetProcessesIdAudit200Data;
  message?: string;
};

export type GetProcessesIdAudit400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetProcessesIdAudit401 = {
  success?: boolean;
  error?: string;
};

export type GetProcessesIdAudit500 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesEntityIdPersonnel200Data = { [key: string]: unknown };

export type GetEntitiesEntityIdPersonnel200 = {
  success?: boolean;
  data?: GetEntitiesEntityIdPersonnel200Data;
  message?: string;
};

export type GetEntitiesEntityIdPersonnel400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntitiesEntityIdPersonnel401 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesEntityIdPersonnel500 = {
  success?: boolean;
  error?: string;
};

export type PostEntitiesEntityIdPersonnel200Data = { [key: string]: unknown };

export type PostEntitiesEntityIdPersonnel200 = {
  success?: boolean;
  data?: PostEntitiesEntityIdPersonnel200Data;
  message?: string;
};

export type PostEntitiesEntityIdPersonnel400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostEntitiesEntityIdPersonnel401 = {
  success?: boolean;
  error?: string;
};

export type PostEntitiesEntityIdPersonnel500 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesEntityIdPersonnelAudit200Data = { [key: string]: unknown };

export type GetEntitiesEntityIdPersonnelAudit200 = {
  success?: boolean;
  data?: GetEntitiesEntityIdPersonnelAudit200Data;
  message?: string;
};

export type GetEntitiesEntityIdPersonnelAudit400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntitiesEntityIdPersonnelAudit401 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesEntityIdPersonnelAudit500 = {
  success?: boolean;
  error?: string;
};

export type GetPayslips200Data = { [key: string]: unknown };

export type GetPayslips200 = {
  success?: boolean;
  data?: GetPayslips200Data;
  message?: string;
};

export type GetPayslips400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetPayslips401 = {
  success?: boolean;
  error?: string;
};

export type GetPayslips500 = {
  success?: boolean;
  error?: string;
};

export type GetPayslipMatchingResultsProcessId200Data = { [key: string]: unknown };

export type GetPayslipMatchingResultsProcessId200 = {
  success?: boolean;
  data?: GetPayslipMatchingResultsProcessId200Data;
  message?: string;
};

export type GetPayslipMatchingResultsProcessId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetPayslipMatchingResultsProcessId401 = {
  success?: boolean;
  error?: string;
};

export type GetPayslipMatchingResultsProcessId500 = {
  success?: boolean;
  error?: string;
};

export type GetPayslipMatchingResultsResultId200Data = { [key: string]: unknown };

export type GetPayslipMatchingResultsResultId200 = {
  success?: boolean;
  data?: GetPayslipMatchingResultsResultId200Data;
  message?: string;
};

export type GetPayslipMatchingResultsResultId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetPayslipMatchingResultsResultId401 = {
  success?: boolean;
  error?: string;
};

export type GetPayslipMatchingResultsResultId500 = {
  success?: boolean;
  error?: string;
};

export type DeletePayslipMatchingResultsResultId200Data = { [key: string]: unknown };

export type DeletePayslipMatchingResultsResultId200 = {
  success?: boolean;
  data?: DeletePayslipMatchingResultsResultId200Data;
  message?: string;
};

export type DeletePayslipMatchingResultsResultId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type DeletePayslipMatchingResultsResultId401 = {
  success?: boolean;
  error?: string;
};

export type DeletePayslipMatchingResultsResultId500 = {
  success?: boolean;
  error?: string;
};

export type GetOrganizations200Data = { [key: string]: unknown };

export type GetOrganizations200 = {
  success?: boolean;
  data?: GetOrganizations200Data;
  message?: string;
};

export type GetOrganizations400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetOrganizations401 = {
  success?: boolean;
  error?: string;
};

export type GetOrganizations500 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesEntityIdOfficers200Data = { [key: string]: unknown };

export type GetEntitiesEntityIdOfficers200 = {
  success?: boolean;
  data?: GetEntitiesEntityIdOfficers200Data;
  message?: string;
};

export type GetEntitiesEntityIdOfficers400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntitiesEntityIdOfficers401 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesEntityIdOfficers500 = {
  success?: boolean;
  error?: string;
};

export type PostEntitiesEntityIdOfficers200Data = { [key: string]: unknown };

export type PostEntitiesEntityIdOfficers200 = {
  success?: boolean;
  data?: PostEntitiesEntityIdOfficers200Data;
  message?: string;
};

export type PostEntitiesEntityIdOfficers400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostEntitiesEntityIdOfficers401 = {
  success?: boolean;
  error?: string;
};

export type PostEntitiesEntityIdOfficers500 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesOfficersOfficerIdAudit200Data = { [key: string]: unknown };

export type GetEntitiesOfficersOfficerIdAudit200 = {
  success?: boolean;
  data?: GetEntitiesOfficersOfficerIdAudit200Data;
  message?: string;
};

export type GetEntitiesOfficersOfficerIdAudit400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntitiesOfficersOfficerIdAudit401 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesOfficersOfficerIdAudit500 = {
  success?: boolean;
  error?: string;
};

export type GetProcessesIdMilestones200Data = { [key: string]: unknown };

export type GetProcessesIdMilestones200 = {
  success?: boolean;
  data?: GetProcessesIdMilestones200Data;
  message?: string;
};

export type GetProcessesIdMilestones400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetProcessesIdMilestones401 = {
  success?: boolean;
  error?: string;
};

export type GetProcessesIdMilestones500 = {
  success?: boolean;
  error?: string;
};

export type GetProcessesMilestonesIdSiblings200Data = { [key: string]: unknown };

export type GetProcessesMilestonesIdSiblings200 = {
  success?: boolean;
  data?: GetProcessesMilestonesIdSiblings200Data;
  message?: string;
};

export type GetProcessesMilestonesIdSiblings400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetProcessesMilestonesIdSiblings401 = {
  success?: boolean;
  error?: string;
};

export type GetProcessesMilestonesIdSiblings500 = {
  success?: boolean;
  error?: string;
};

export type GetLsps200Data = { [key: string]: unknown };

export type GetLsps200 = {
  success?: boolean;
  data?: GetLsps200Data;
  message?: string;
};

export type GetLsps400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetLsps401 = {
  success?: boolean;
  error?: string;
};

export type GetLsps500 = {
  success?: boolean;
  error?: string;
};

export type GetLspsAudits200Data = { [key: string]: unknown };

export type GetLspsAudits200 = {
  success?: boolean;
  data?: GetLspsAudits200Data;
  message?: string;
};

export type GetLspsAudits400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetLspsAudits401 = {
  success?: boolean;
  error?: string;
};

export type GetLspsAudits500 = {
  success?: boolean;
  error?: string;
};

export type GetLspIdAudit200Data = { [key: string]: unknown };

export type GetLspIdAudit200 = {
  success?: boolean;
  data?: GetLspIdAudit200Data;
  message?: string;
};

export type GetLspIdAudit400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetLspIdAudit401 = {
  success?: boolean;
  error?: string;
};

export type GetLspIdAudit500 = {
  success?: boolean;
  error?: string;
};

export type GetIdMessagesInternal200Data = { [key: string]: unknown };

export type GetIdMessagesInternal200 = {
  success?: boolean;
  data?: GetIdMessagesInternal200Data;
  message?: string;
};

export type GetIdMessagesInternal400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetIdMessagesInternal401 = {
  success?: boolean;
  error?: string;
};

export type GetIdMessagesInternal500 = {
  success?: boolean;
  error?: string;
};

export type GetHolidays200Data = { [key: string]: unknown };

export type GetHolidays200 = {
  success?: boolean;
  data?: GetHolidays200Data;
  message?: string;
};

export type GetHolidays400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetHolidays401 = {
  success?: boolean;
  error?: string;
};

export type GetHolidays500 = {
  success?: boolean;
  error?: string;
};

export type GetEvents200Data = { [key: string]: unknown };

export type GetEvents200 = {
  success?: boolean;
  data?: GetEvents200Data;
  message?: string;
};

export type GetEvents400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEvents401 = {
  success?: boolean;
  error?: string;
};

export type GetEvents500 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesIdPlusConfigAudit200Data = { [key: string]: unknown };

export type GetEntitiesIdPlusConfigAudit200 = {
  success?: boolean;
  data?: GetEntitiesIdPlusConfigAudit200Data;
  message?: string;
};

export type GetEntitiesIdPlusConfigAudit400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntitiesIdPlusConfigAudit401 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesIdPlusConfigAudit500 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesEntityIdLsp200Data = { [key: string]: unknown };

export type GetEntitiesEntityIdLsp200 = {
  success?: boolean;
  data?: GetEntitiesEntityIdLsp200Data;
  message?: string;
};

export type GetEntitiesEntityIdLsp400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntitiesEntityIdLsp401 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesEntityIdLsp500 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesIdAudit200Data = { [key: string]: unknown };

export type GetEntitiesIdAudit200 = {
  success?: boolean;
  data?: GetEntitiesIdAudit200Data;
  message?: string;
};

export type GetEntitiesIdAudit400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntitiesIdAudit401 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesIdAudit500 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesAudit200Data = { [key: string]: unknown };

export type GetEntitiesAudit200 = {
  success?: boolean;
  data?: GetEntitiesAudit200Data;
  message?: string;
};

export type GetEntitiesAudit400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntitiesAudit401 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesAudit500 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesEntityIdEmployee200Data = { [key: string]: unknown };

export type GetEntitiesEntityIdEmployee200 = {
  success?: boolean;
  data?: GetEntitiesEntityIdEmployee200Data;
  message?: string;
};

export type GetEntitiesEntityIdEmployee400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntitiesEntityIdEmployee401 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesEntityIdEmployee500 = {
  success?: boolean;
  error?: string;
};

export type PostEntitiesEntityIdEmployee200Data = { [key: string]: unknown };

export type PostEntitiesEntityIdEmployee200 = {
  success?: boolean;
  data?: PostEntitiesEntityIdEmployee200Data;
  message?: string;
};

export type PostEntitiesEntityIdEmployee400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostEntitiesEntityIdEmployee401 = {
  success?: boolean;
  error?: string;
};

export type PostEntitiesEntityIdEmployee500 = {
  success?: boolean;
  error?: string;
};

export type GetEmployeeAudit200Data = { [key: string]: unknown };

export type GetEmployeeAudit200 = {
  success?: boolean;
  data?: GetEmployeeAudit200Data;
  message?: string;
};

export type GetEmployeeAudit400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEmployeeAudit401 = {
  success?: boolean;
  error?: string;
};

export type GetEmployeeAudit500 = {
  success?: boolean;
  error?: string;
};

export type GetEssProfileMe200Data = { [key: string]: unknown };

export type GetEssProfileMe200 = {
  success?: boolean;
  data?: GetEssProfileMe200Data;
  message?: string;
};

export type GetEssProfileMe400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEssProfileMe401 = {
  success?: boolean;
  error?: string;
};

export type GetEssProfileMe500 = {
  success?: boolean;
  error?: string;
};

export type GetDocuments200Data = { [key: string]: unknown };

export type GetDocuments200 = {
  success?: boolean;
  data?: GetDocuments200Data;
  message?: string;
};

export type GetDocuments400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetDocuments401 = {
  success?: boolean;
  error?: string;
};

export type GetDocuments500 = {
  success?: boolean;
  error?: string;
};

export type PostDocumentVersion200Data = { [key: string]: unknown };

export type PostDocumentVersion200 = {
  success?: boolean;
  data?: PostDocumentVersion200Data;
  message?: string;
};

export type PostDocumentVersion400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostDocumentVersion401 = {
  success?: boolean;
  error?: string;
};

export type PostDocumentVersion500 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesEntityIdDocumentFolders200Data = { [key: string]: unknown };

export type GetEntitiesEntityIdDocumentFolders200 = {
  success?: boolean;
  data?: GetEntitiesEntityIdDocumentFolders200Data;
  message?: string;
};

export type GetEntitiesEntityIdDocumentFolders400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntitiesEntityIdDocumentFolders401 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesEntityIdDocumentFolders500 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesEntityIdDirectors200Data = { [key: string]: unknown };

export type GetEntitiesEntityIdDirectors200 = {
  success?: boolean;
  data?: GetEntitiesEntityIdDirectors200Data;
  message?: string;
};

export type GetEntitiesEntityIdDirectors400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntitiesEntityIdDirectors401 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesEntityIdDirectors500 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesEntityIdDirectorsAudit200Data = { [key: string]: unknown };

export type GetEntitiesEntityIdDirectorsAudit200 = {
  success?: boolean;
  data?: GetEntitiesEntityIdDirectorsAudit200Data;
  message?: string;
};

export type GetEntitiesEntityIdDirectorsAudit400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntitiesEntityIdDirectorsAudit401 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesEntityIdDirectorsAudit500 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesDirectorsDirectorIdAppointments200Data = { [key: string]: unknown };

export type GetEntitiesDirectorsDirectorIdAppointments200 = {
  success?: boolean;
  data?: GetEntitiesDirectorsDirectorIdAppointments200Data;
  message?: string;
};

export type GetEntitiesDirectorsDirectorIdAppointments400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntitiesDirectorsDirectorIdAppointments401 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesDirectorsDirectorIdAppointments500 = {
  success?: boolean;
  error?: string;
};

export type PostEntitiesDirectorsDirectorIdAppointments200Data = { [key: string]: unknown };

export type PostEntitiesDirectorsDirectorIdAppointments200 = {
  success?: boolean;
  data?: PostEntitiesDirectorsDirectorIdAppointments200Data;
  message?: string;
};

export type PostEntitiesDirectorsDirectorIdAppointments400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostEntitiesDirectorsDirectorIdAppointments401 = {
  success?: boolean;
  error?: string;
};

export type PostEntitiesDirectorsDirectorIdAppointments500 = {
  success?: boolean;
  error?: string;
};

export type GetLspIdCustomerAudit200Data = { [key: string]: unknown };

export type GetLspIdCustomerAudit200 = {
  success?: boolean;
  data?: GetLspIdCustomerAudit200Data;
  message?: string;
};

export type GetLspIdCustomerAudit400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetLspIdCustomerAudit401 = {
  success?: boolean;
  error?: string;
};

export type GetLspIdCustomerAudit500 = {
  success?: boolean;
  error?: string;
};

export type GetConversations200Data = { [key: string]: unknown };

export type GetConversations200 = {
  success?: boolean;
  data?: GetConversations200Data;
  message?: string;
};

export type GetConversations400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetConversations401 = {
  success?: boolean;
  error?: string;
};

export type GetConversations500 = {
  success?: boolean;
  error?: string;
};

export type GetComments200Data = { [key: string]: unknown };

export type GetComments200 = {
  success?: boolean;
  data?: GetComments200Data;
  message?: string;
};

export type GetComments400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetComments401 = {
  success?: boolean;
  error?: string;
};

export type GetComments500 = {
  success?: boolean;
  error?: string;
};

export type PostComments200Data = { [key: string]: unknown };

export type PostComments200 = {
  success?: boolean;
  data?: PostComments200Data;
  message?: string;
};

export type PostComments400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostComments401 = {
  success?: boolean;
  error?: string;
};

export type PostComments500 = {
  success?: boolean;
  error?: string;
};

export type GetCities200Data = { [key: string]: unknown };

export type GetCities200 = {
  success?: boolean;
  data?: GetCities200Data;
  message?: string;
};

export type GetCities400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetCities401 = {
  success?: boolean;
  error?: string;
};

export type GetCities500 = {
  success?: boolean;
  error?: string;
};

export type GetBlobDownload200Data = { [key: string]: unknown };

export type GetBlobDownload200 = {
  success?: boolean;
  data?: GetBlobDownload200Data;
  message?: string;
};

export type GetBlobDownload400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetBlobDownload401 = {
  success?: boolean;
  error?: string;
};

export type GetBlobDownload500 = {
  success?: boolean;
  error?: string;
};

export type GetAttachmentsIdAudit200Data = { [key: string]: unknown };

export type GetAttachmentsIdAudit200 = {
  success?: boolean;
  data?: GetAttachmentsIdAudit200Data;
  message?: string;
};

export type GetAttachmentsIdAudit400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetAttachmentsIdAudit401 = {
  success?: boolean;
  error?: string;
};

export type GetAttachmentsIdAudit500 = {
  success?: boolean;
  error?: string;
};

export type PostAttachmentsIdAudit200Data = { [key: string]: unknown };

export type PostAttachmentsIdAudit200 = {
  success?: boolean;
  data?: PostAttachmentsIdAudit200Data;
  message?: string;
};

export type PostAttachmentsIdAudit400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostAttachmentsIdAudit401 = {
  success?: boolean;
  error?: string;
};

export type PostAttachmentsIdAudit500 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesEntityIdAddresses200Data = { [key: string]: unknown };

export type GetEntitiesEntityIdAddresses200 = {
  success?: boolean;
  data?: GetEntitiesEntityIdAddresses200Data;
  message?: string;
};

export type GetEntitiesEntityIdAddresses400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntitiesEntityIdAddresses401 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesEntityIdAddresses500 = {
  success?: boolean;
  error?: string;
};

export type PostEntitiesEntityIdAddresses200Data = { [key: string]: unknown };

export type PostEntitiesEntityIdAddresses200 = {
  success?: boolean;
  data?: PostEntitiesEntityIdAddresses200Data;
  message?: string;
};

export type PostEntitiesEntityIdAddresses400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostEntitiesEntityIdAddresses401 = {
  success?: boolean;
  error?: string;
};

export type PostEntitiesEntityIdAddresses500 = {
  success?: boolean;
  error?: string;
};

export type GetAddressesIdAudit200Data = { [key: string]: unknown };

export type GetAddressesIdAudit200 = {
  success?: boolean;
  data?: GetAddressesIdAudit200Data;
  message?: string;
};

export type GetAddressesIdAudit400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetAddressesIdAudit401 = {
  success?: boolean;
  error?: string;
};

export type GetAddressesIdAudit500 = {
  success?: boolean;
  error?: string;
};

export type PostEssWebhookNotifications200Data = { [key: string]: unknown };

export type PostEssWebhookNotifications200 = {
  success?: boolean;
  data?: PostEssWebhookNotifications200Data;
  message?: string;
};

export type PostEssWebhookNotifications400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostEssWebhookNotifications401 = {
  success?: boolean;
  error?: string;
};

export type PostEssWebhookNotifications500 = {
  success?: boolean;
  error?: string;
};

export type PostTaxDocsDownload200Data = { [key: string]: unknown };

export type PostTaxDocsDownload200 = {
  success?: boolean;
  data?: PostTaxDocsDownload200Data;
  message?: string;
};

export type PostTaxDocsDownload400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostTaxDocsDownload401 = {
  success?: boolean;
  error?: string;
};

export type PostTaxDocsDownload500 = {
  success?: boolean;
  error?: string;
};

export type PostPayslipsDownload200Data = { [key: string]: unknown };

export type PostPayslipsDownload200 = {
  success?: boolean;
  data?: PostPayslipsDownload200Data;
  message?: string;
};

export type PostPayslipsDownload400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostPayslipsDownload401 = {
  success?: boolean;
  error?: string;
};

export type PostPayslipsDownload500 = {
  success?: boolean;
  error?: string;
};

export type PutUsersCurrentMeNotificationsPublicMessages200Data = { [key: string]: unknown };

export type PutUsersCurrentMeNotificationsPublicMessages200 = {
  success?: boolean;
  data?: PutUsersCurrentMeNotificationsPublicMessages200Data;
  message?: string;
};

export type PutUsersCurrentMeNotificationsPublicMessages400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PutUsersCurrentMeNotificationsPublicMessages401 = {
  success?: boolean;
  error?: string;
};

export type PutUsersCurrentMeNotificationsPublicMessages500 = {
  success?: boolean;
  error?: string;
};

export type DeleteUsersId200Data = { [key: string]: unknown };

export type DeleteUsersId200 = {
  success?: boolean;
  data?: DeleteUsersId200Data;
  message?: string;
};

export type DeleteUsersId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type DeleteUsersId401 = {
  success?: boolean;
  error?: string;
};

export type DeleteUsersId500 = {
  success?: boolean;
  error?: string;
};

export type PutUsersIdBodyRole = typeof PutUsersIdBodyRole[keyof typeof PutUsersIdBodyRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PutUsersIdBodyRole = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  GXM_ADMIN: 'GXM_ADMIN',
  GXM_USER: 'GXM_USER',
  GXM_MANAGER: 'GXM_MANAGER',
  LSP_USER: 'LSP_USER',
  LSP_MANAGER: 'LSP_MANAGER',
  CUSTOMER_MANAGER: 'CUSTOMER_MANAGER',
  CUSTOMER: 'CUSTOMER',
} as const;

export type PutUsersIdBody = {
  role?: PutUsersIdBodyRole;
  /** @maxLength 100 */
  first_name?: string;
  /** @maxLength 100 */
  last_name?: string;
  other_name?: string;
  preferred_name?: string;
  assigned_tenants?: string[];
};

export type PutUsersId200 = {
  success: true;
  data: [number];
  message: string;
  statusCode: 200;
  status: true;
};

export type GetUsersId200DataWorkosId = string | null;

export type GetUsersId200DataLastName = string | null;

export type GetUsersId200DataOtherName = string | null;

export type GetUsersId200DataPreferredName = string | null;

export type GetUsersId200DataRole = typeof GetUsersId200DataRole[keyof typeof GetUsersId200DataRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUsersId200DataRole = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  GXM_ADMIN: 'GXM_ADMIN',
  GXM_USER: 'GXM_USER',
  GXM_MANAGER: 'GXM_MANAGER',
  LSP_USER: 'LSP_USER',
  LSP_MANAGER: 'LSP_MANAGER',
  CUSTOMER_MANAGER: 'CUSTOMER_MANAGER',
  CUSTOMER: 'CUSTOMER',
} as const;

export type GetUsersId200DataTenants = string[] | null;

export type GetUsersId200DataAccessAnyOfItem = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  entity_id?: string;
  services?: string[];
};

export type GetUsersId200DataAccess = GetUsersId200DataAccessAnyOfItem[] | null;

export type GetUsersId200DataLspId = string | null;

export type GetUsersId200DataTimezone = string | null;

export type GetUsersId200DataProfilePicture = string | null;

export type GetUsersId200DataConfigAnyOf = {[key: string]: unknown};

export type GetUsersId200DataConfig = GetUsersId200DataConfigAnyOf | null;

export type GetUsersId200DataDeletedAt = string | null;

export type GetUsersId200Data = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  workos_id: GetUsersId200DataWorkosId;
  /** @pattern ^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$ */
  email: string;
  first_name: string;
  last_name: GetUsersId200DataLastName;
  other_name: GetUsersId200DataOtherName;
  preferred_name: GetUsersId200DataPreferredName;
  role: GetUsersId200DataRole;
  tenants: GetUsersId200DataTenants;
  access: GetUsersId200DataAccess;
  lsp_id: GetUsersId200DataLspId;
  timezone: GetUsersId200DataTimezone;
  profile_picture: GetUsersId200DataProfilePicture;
  config: GetUsersId200DataConfig;
  createdAt: string;
  updatedAt: string;
  deletedAt: GetUsersId200DataDeletedAt;
};

export type GetUsersId200 = {
  success: true;
  data: GetUsersId200Data;
  message: string;
  statusCode: 200;
  status: true;
};

export type DeleteProcessesId200Data = { [key: string]: unknown };

export type DeleteProcessesId200 = {
  success?: boolean;
  data?: DeleteProcessesId200Data;
  message?: string;
};

export type DeleteProcessesId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type DeleteProcessesId401 = {
  success?: boolean;
  error?: string;
};

export type DeleteProcessesId500 = {
  success?: boolean;
  error?: string;
};

export type GetProcessesId200DataDueDate = string | null;

export type GetProcessesId200DataFlagged = boolean | null;

export type GetProcessesId200DataProcessTemplateId = string | null;

export type GetProcessesId200DataRequestId = string | null;

export type GetProcessesId200DataEntityDataAnyOfName = string | null;

export type GetProcessesId200DataEntityDataAnyOfCountry = string | null;

export type GetProcessesId200DataEntityDataAnyOfTimezone = string | null;

export type GetProcessesId200DataEntityDataAnyOfTenantDataAnyOfPayslipPortalLink = string | null;

export type GetProcessesId200DataEntityDataAnyOfTenantDataAnyOf = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  name: string;
  payslip_portal_link: GetProcessesId200DataEntityDataAnyOfTenantDataAnyOfPayslipPortalLink;
};

export type GetProcessesId200DataEntityDataAnyOfTenantData = GetProcessesId200DataEntityDataAnyOfTenantDataAnyOf | null;

export type GetProcessesId200DataEntityDataAnyOf = {
  name: GetProcessesId200DataEntityDataAnyOfName;
  country: GetProcessesId200DataEntityDataAnyOfCountry;
  timezone: GetProcessesId200DataEntityDataAnyOfTimezone;
  tenantData: GetProcessesId200DataEntityDataAnyOfTenantData;
};

export type GetProcessesId200DataEntityData = GetProcessesId200DataEntityDataAnyOf | null;

export type GetProcessesId200DataServiceDataAnyOfServiceCode = string | null;

export type GetProcessesId200DataServiceDataAnyOf = {
  name: string;
  service_code: GetProcessesId200DataServiceDataAnyOfServiceCode;
};

export type GetProcessesId200DataServiceData = GetProcessesId200DataServiceDataAnyOf | null;

export type GetProcessesId200DataStatusDataAnyOfCode = string | null;

export type GetProcessesId200DataStatusDataAnyOfPrimaryColor = string | null;

export type GetProcessesId200DataStatusDataAnyOfSecondaryColor = string | null;

export type GetProcessesId200DataStatusDataAnyOf = {
  name: string;
  code: GetProcessesId200DataStatusDataAnyOfCode;
  primary_color: GetProcessesId200DataStatusDataAnyOfPrimaryColor;
  secondary_color: GetProcessesId200DataStatusDataAnyOfSecondaryColor;
};

export type GetProcessesId200DataStatusData = GetProcessesId200DataStatusDataAnyOf | null;

export type GetProcessesId200DataTemplateDataAnyOfTemplate = unknown | null;

export type GetProcessesId200DataTemplateDataAnyOf = {
  template: GetProcessesId200DataTemplateDataAnyOfTemplate;
};

export type GetProcessesId200DataTemplateData = GetProcessesId200DataTemplateDataAnyOf | null;

export type GetProcessesId200DataEscalationAssignee = string | null;

export type GetProcessesId200DataEscalationStatus = string | null;

export type GetProcessesId200DataEscalation = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  cc: string[];
  assignee: GetProcessesId200DataEscalationAssignee;
  created_by: string;
  status: GetProcessesId200DataEscalationStatus;
};

export type GetProcessesId200Data = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  name: string;
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  entity_id: string;
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  service_id: string;
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  status_id: string;
  due_date: GetProcessesId200DataDueDate;
  flagged: GetProcessesId200DataFlagged;
  process_template_id: GetProcessesId200DataProcessTemplateId;
  request_id: GetProcessesId200DataRequestId;
  createdAt: string;
  updatedAt: string;
  entityData: GetProcessesId200DataEntityData;
  serviceData: GetProcessesId200DataServiceData;
  statusData: GetProcessesId200DataStatusData;
  templateData: GetProcessesId200DataTemplateData;
  escalation?: GetProcessesId200DataEscalation;
};

export type GetProcessesId200 = {
  success: true;
  data: GetProcessesId200Data;
  message: string;
  statusCode: 200;
  status: true;
};

export type DeletePersonnelDeleteId200Data = { [key: string]: unknown };

export type DeletePersonnelDeleteId200 = {
  success?: boolean;
  data?: DeletePersonnelDeleteId200Data;
  message?: string;
};

export type DeletePersonnelDeleteId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type DeletePersonnelDeleteId401 = {
  success?: boolean;
  error?: string;
};

export type DeletePersonnelDeleteId500 = {
  success?: boolean;
  error?: string;
};

export type DeletePayslipMatchingResultsMatchingResultId200Data = { [key: string]: unknown };

export type DeletePayslipMatchingResultsMatchingResultId200 = {
  success?: boolean;
  data?: DeletePayslipMatchingResultsMatchingResultId200Data;
  message?: string;
};

export type DeletePayslipMatchingResultsMatchingResultId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type DeletePayslipMatchingResultsMatchingResultId401 = {
  success?: boolean;
  error?: string;
};

export type DeletePayslipMatchingResultsMatchingResultId500 = {
  success?: boolean;
  error?: string;
};

export type DeleteAttachments200Data = { [key: string]: unknown };

export type DeleteAttachments200 = {
  success?: boolean;
  data?: DeleteAttachments200Data;
  message?: string;
};

export type DeleteAttachments400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type DeleteAttachments401 = {
  success?: boolean;
  error?: string;
};

export type DeleteAttachments500 = {
  success?: boolean;
  error?: string;
};

export type PostEntitiesEntityIdEmployeeId200Data = { [key: string]: unknown };

export type PostEntitiesEntityIdEmployeeId200 = {
  success?: boolean;
  data?: PostEntitiesEntityIdEmployeeId200Data;
  message?: string;
};

export type PostEntitiesEntityIdEmployeeId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostEntitiesEntityIdEmployeeId401 = {
  success?: boolean;
  error?: string;
};

export type PostEntitiesEntityIdEmployeeId500 = {
  success?: boolean;
  error?: string;
};

export type PostBulkImportPayrollPlusTasks200Data = { [key: string]: unknown };

export type PostBulkImportPayrollPlusTasks200 = {
  success?: boolean;
  data?: PostBulkImportPayrollPlusTasks200Data;
  message?: string;
};

export type PostBulkImportPayrollPlusTasks400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostBulkImportPayrollPlusTasks401 = {
  success?: boolean;
  error?: string;
};

export type PostBulkImportPayrollPlusTasks500 = {
  success?: boolean;
  error?: string;
};

export type GetAuthUrl200Data = { [key: string]: unknown };

export type GetAuthUrl200 = {
  success?: boolean;
  data?: GetAuthUrl200Data;
  message?: string;
};

export type GetAuthUrl400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetAuthUrl401 = {
  success?: boolean;
  error?: string;
};

export type GetAuthUrl500 = {
  success?: boolean;
  error?: string;
};

export type PostShareholders200Data = { [key: string]: unknown };

export type PostShareholders200 = {
  success?: boolean;
  data?: PostShareholders200Data;
  message?: string;
};

export type PostShareholders400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostShareholders401 = {
  success?: boolean;
  error?: string;
};

export type PostShareholders500 = {
  success?: boolean;
  error?: string;
};

export type PostPayslipProcessingMessageAdd200Data = { [key: string]: unknown };

export type PostPayslipProcessingMessageAdd200 = {
  success?: boolean;
  data?: PostPayslipProcessingMessageAdd200Data;
  message?: string;
};

export type PostPayslipProcessingMessageAdd400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostPayslipProcessingMessageAdd401 = {
  success?: boolean;
  error?: string;
};

export type PostPayslipProcessingMessageAdd500 = {
  success?: boolean;
  error?: string;
};

export type PostPayslipMatchingResultsMessageAdd200Data = { [key: string]: unknown };

export type PostPayslipMatchingResultsMessageAdd200 = {
  success?: boolean;
  data?: PostPayslipMatchingResultsMessageAdd200Data;
  message?: string;
};

export type PostPayslipMatchingResultsMessageAdd400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostPayslipMatchingResultsMessageAdd401 = {
  success?: boolean;
  error?: string;
};

export type PostPayslipMatchingResultsMessageAdd500 = {
  success?: boolean;
  error?: string;
};

export type PostPayslipMatchingResultsAdd200Data = { [key: string]: unknown };

export type PostPayslipMatchingResultsAdd200 = {
  success?: boolean;
  data?: PostPayslipMatchingResultsAdd200Data;
  message?: string;
};

export type PostPayslipMatchingResultsAdd400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostPayslipMatchingResultsAdd401 = {
  success?: boolean;
  error?: string;
};

export type PostPayslipMatchingResultsAdd500 = {
  success?: boolean;
  error?: string;
};

export type PostPayslipMatchingResult200Data = { [key: string]: unknown };

export type PostPayslipMatchingResult200 = {
  success?: boolean;
  data?: PostPayslipMatchingResult200Data;
  message?: string;
};

export type PostPayslipMatchingResult400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostPayslipMatchingResult401 = {
  success?: boolean;
  error?: string;
};

export type PostPayslipMatchingResult500 = {
  success?: boolean;
  error?: string;
};

export type PostMessagesAdd200Data = { [key: string]: unknown };

export type PostMessagesAdd200 = {
  success?: boolean;
  data?: PostMessagesAdd200Data;
  message?: string;
};

export type PostMessagesAdd400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostMessagesAdd401 = {
  success?: boolean;
  error?: string;
};

export type PostMessagesAdd500 = {
  success?: boolean;
  error?: string;
};

export type PostFilesAdd200Data = { [key: string]: unknown };

export type PostFilesAdd200 = {
  success?: boolean;
  data?: PostFilesAdd200Data;
  message?: string;
};

export type PostFilesAdd400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostFilesAdd401 = {
  success?: boolean;
  error?: string;
};

export type PostFilesAdd500 = {
  success?: boolean;
  error?: string;
};

export type PostDirectors200Data = { [key: string]: unknown };

export type PostDirectors200 = {
  success?: boolean;
  data?: PostDirectors200Data;
  message?: string;
};

export type PostDirectors400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostDirectors401 = {
  success?: boolean;
  error?: string;
};

export type PostDirectors500 = {
  success?: boolean;
  error?: string;
};

export type GetDomainsVerify200Data = { [key: string]: unknown };

export type GetDomainsVerify200 = {
  success?: boolean;
  data?: GetDomainsVerify200Data;
  message?: string;
};

export type GetDomainsVerify400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetDomainsVerify401 = {
  success?: boolean;
  error?: string;
};

export type GetDomainsVerify500 = {
  success?: boolean;
  error?: string;
};

export type PutEntitiesIdBodyType = typeof PutEntitiesIdBodyType[keyof typeof PutEntitiesIdBodyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PutEntitiesIdBodyType = {
  Branch: 'Branch',
  Subsidiary: 'Subsidiary',
  Representative_Office: 'Representative Office',
  NRE: 'NRE',
  Parent_Entity: 'Parent Entity',
  No_Entity: 'No Entity',
} as const;

export type PutEntitiesIdBodyStatus = typeof PutEntitiesIdBodyStatus[keyof typeof PutEntitiesIdBodyStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PutEntitiesIdBodyStatus = {
  Active: 'Active',
  Action_Required: 'Action Required',
  Incomplete: 'Incomplete',
  Non_Compliant: 'Non Compliant',
  Dormant: 'Dormant',
} as const;

export type PutEntitiesIdBodyAccountManagerId = string | null;

export type PutEntitiesIdBodyParent = string | null;

export type PutEntitiesIdBody = {
  /**
   * @minLength 1
   * @maxLength 100
   */
  name?: string;
  /** @maxLength 100 */
  trading_name?: string;
  /** @maxLength 50 */
  tax_id?: string;
  /** @maxLength 3 */
  country?: string;
  /** @maxLength 50 */
  registration_number?: string;
  type?: PutEntitiesIdBodyType;
  status?: PutEntitiesIdBodyStatus;
  domains?: string[];
  /** @maxLength 200 */
  business_activity?: string;
  /** @maxLength 100 */
  salesforce_id?: string;
  account_manager_id?: PutEntitiesIdBodyAccountManagerId;
  active_services?: string[];
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  organization?: string;
  parent?: PutEntitiesIdBodyParent;
  /** @maxLength 50 */
  timezone?: string;
};

export type PutEntitiesId200 = {
  success: true;
  data: [number];
  message: string;
  statusCode: 200;
  status: true;
};

export type GetEntitiesId200DataName = string | null;

export type GetEntitiesId200DataTradingName = string | null;

export type GetEntitiesId200DataTaxId = string | null;

export type GetEntitiesId200DataCountry = string | null;

export type GetEntitiesId200DataRegistrationNumber = string | null;

export type GetEntitiesId200DataType = 'Branch' | 'Subsidiary' | 'Representative Office' | 'NRE' | 'Parent Entity' | 'No Entity' | null;

export type GetEntitiesId200DataStatus = 'Active' | 'Action Required' | 'Incomplete' | 'Non Compliant' | 'Dormant' | null;

export type GetEntitiesId200DataDomains = string[] | null;

export type GetEntitiesId200DataBusinessActivity = string | null;

export type GetEntitiesId200DataSalesforceId = string | null;

export type GetEntitiesId200DataAccountManagerId = string | null;

export type GetEntitiesId200DataActiveServicesItemDescription = string | null;

export type GetEntitiesId200DataActiveServicesItemIcon = string | null;

export type GetEntitiesId200DataActiveServicesItemPrimaryColor = string | null;

export type GetEntitiesId200DataActiveServicesItemSecondaryColor = string | null;

export type GetEntitiesId200DataActiveServicesItemPayslipUrl = string[] | null;

export type GetEntitiesId200DataActiveServicesItemCreatedBy = string | null;

export type GetEntitiesId200DataActiveServicesItem = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  name: string;
  service_code: string;
  description: GetEntitiesId200DataActiveServicesItemDescription;
  icon: GetEntitiesId200DataActiveServicesItemIcon;
  primary_color: GetEntitiesId200DataActiveServicesItemPrimaryColor;
  secondary_color: GetEntitiesId200DataActiveServicesItemSecondaryColor;
  payslip_url: GetEntitiesId200DataActiveServicesItemPayslipUrl;
  created_by: GetEntitiesId200DataActiveServicesItemCreatedBy;
  createdAt: string;
  updatedAt: string;
};

export type GetEntitiesId200DataIsActive = boolean | null;

export type GetEntitiesId200DataTimezone = string | null;

export type GetEntitiesId200DataPointContact = string | null;

export type GetEntitiesId200DataCreatedBy = string | null;

export type GetEntitiesId200DataUpdatedBy = string | null;

export type GetEntitiesId200DataParent = string | null;

export type GetEntitiesId200DataTenantId = string | null;

export type GetEntitiesId200DataEntityPlusConfig = string | null;

export type GetEntitiesId200DataParentEntityAnyOfName = string | null;

export type GetEntitiesId200DataParentEntityAnyOfCountry = string | null;

export type GetEntitiesId200DataParentEntityAnyOf = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  name: GetEntitiesId200DataParentEntityAnyOfName;
  country: GetEntitiesId200DataParentEntityAnyOfCountry;
};

export type GetEntitiesId200DataParentEntity = GetEntitiesId200DataParentEntityAnyOf | null;

export type GetEntitiesId200DataTenantDataAnyOfPayslipPortalLink = string | null;

export type GetEntitiesId200DataTenantDataAnyOf = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  name: string;
  payslip_portal_link: GetEntitiesId200DataTenantDataAnyOfPayslipPortalLink;
};

export type GetEntitiesId200DataTenantData = GetEntitiesId200DataTenantDataAnyOf | null;

export type GetEntitiesId200DataEntityPlusConfigDataAnyOfIncorporationDate = string | null;

export type GetEntitiesId200DataEntityPlusConfigDataAnyOfAcquisitionDate = string | null;

export type GetEntitiesId200DataEntityPlusConfigDataAnyOfSaleClosureDate = string | null;

export type GetEntitiesId200DataEntityPlusConfigDataAnyOf = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  incorporation_date: GetEntitiesId200DataEntityPlusConfigDataAnyOfIncorporationDate;
  acquisition_date: GetEntitiesId200DataEntityPlusConfigDataAnyOfAcquisitionDate;
  sale_closure_date: GetEntitiesId200DataEntityPlusConfigDataAnyOfSaleClosureDate;
};

export type GetEntitiesId200DataEntityPlusConfigData = GetEntitiesId200DataEntityPlusConfigDataAnyOf | null;

export type GetEntitiesId200DataAccountManagerDataAnyOfSurname = string | null;

export type GetEntitiesId200DataAccountManagerDataAnyOfOtherName = string | null;

export type GetEntitiesId200DataAccountManagerDataAnyOfPreferredName = string | null;

export type GetEntitiesId200DataAccountManagerDataAnyOfPhoneCode = string | null;

export type GetEntitiesId200DataAccountManagerDataAnyOfPhoneNumber = string | null;

export type GetEntitiesId200DataAccountManagerDataAnyOf = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  given_name: string;
  surname: GetEntitiesId200DataAccountManagerDataAnyOfSurname;
  other_name: GetEntitiesId200DataAccountManagerDataAnyOfOtherName;
  preferred_name: GetEntitiesId200DataAccountManagerDataAnyOfPreferredName;
  /** @pattern ^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$ */
  email: string;
  country: string;
  phone_code: GetEntitiesId200DataAccountManagerDataAnyOfPhoneCode;
  phone_number: GetEntitiesId200DataAccountManagerDataAnyOfPhoneNumber;
};

export type GetEntitiesId200DataAccountManagerData = GetEntitiesId200DataAccountManagerDataAnyOf | null;

export type GetEntitiesId200DataChildrenItemName = string | null;

export type GetEntitiesId200DataChildrenItemCountry = string | null;

export type GetEntitiesId200DataChildrenItemType = 'Branch' | 'Subsidiary' | 'Representative Office' | 'NRE' | 'Parent Entity' | 'No Entity' | null;

export type GetEntitiesId200DataChildrenItemStatus = 'Active' | 'Action Required' | 'Incomplete' | 'Non Compliant' | 'Dormant' | null;

export type GetEntitiesId200DataChildrenItemTenantId = string | null;

export type GetEntitiesId200DataChildrenItemParent = string | null;

export type GetEntitiesId200DataChildrenItemAccountManagerDataAnyOfSurname = string | null;

export type GetEntitiesId200DataChildrenItemAccountManagerDataAnyOfPreferredName = string | null;

export type GetEntitiesId200DataChildrenItemAccountManagerDataAnyOf = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  given_name: string;
  surname: GetEntitiesId200DataChildrenItemAccountManagerDataAnyOfSurname;
  preferred_name: GetEntitiesId200DataChildrenItemAccountManagerDataAnyOfPreferredName;
};

export type GetEntitiesId200DataChildrenItemAccountManagerData = GetEntitiesId200DataChildrenItemAccountManagerDataAnyOf | null;

export type GetEntitiesId200DataChildrenItem = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  name: GetEntitiesId200DataChildrenItemName;
  country: GetEntitiesId200DataChildrenItemCountry;
  type: GetEntitiesId200DataChildrenItemType;
  status: GetEntitiesId200DataChildrenItemStatus;
  tenant_id: GetEntitiesId200DataChildrenItemTenantId;
  parent: GetEntitiesId200DataChildrenItemParent;
  accountManagerData: GetEntitiesId200DataChildrenItemAccountManagerData;
};

export type GetEntitiesId200Data = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  name: GetEntitiesId200DataName;
  trading_name: GetEntitiesId200DataTradingName;
  tax_id: GetEntitiesId200DataTaxId;
  country: GetEntitiesId200DataCountry;
  registration_number: GetEntitiesId200DataRegistrationNumber;
  type: GetEntitiesId200DataType;
  status: GetEntitiesId200DataStatus;
  domains: GetEntitiesId200DataDomains;
  business_activity: GetEntitiesId200DataBusinessActivity;
  salesforce_id: GetEntitiesId200DataSalesforceId;
  account_manager_id: GetEntitiesId200DataAccountManagerId;
  active_services: GetEntitiesId200DataActiveServicesItem[];
  is_active: GetEntitiesId200DataIsActive;
  timezone: GetEntitiesId200DataTimezone;
  point_contact: GetEntitiesId200DataPointContact;
  created_by: GetEntitiesId200DataCreatedBy;
  updated_by: GetEntitiesId200DataUpdatedBy;
  parent: GetEntitiesId200DataParent;
  tenant_id: GetEntitiesId200DataTenantId;
  entity_plus_config: GetEntitiesId200DataEntityPlusConfig;
  createdAt: string;
  updatedAt: string;
  parentEntity: GetEntitiesId200DataParentEntity;
  tenantData: GetEntitiesId200DataTenantData;
  entityPlusConfigData: GetEntitiesId200DataEntityPlusConfigData;
  accountManagerData: GetEntitiesId200DataAccountManagerData;
  children: GetEntitiesId200DataChildrenItem[];
};

export type GetEntitiesId200 = {
  success: true;
  data: GetEntitiesId200Data;
  message: string;
  statusCode: 200;
  status: true;
};

export type PatchAccountManagersId200Data = { [key: string]: unknown };

export type PatchAccountManagersId200 = {
  success?: boolean;
  data?: PatchAccountManagersId200Data;
  message?: string;
};

export type PatchAccountManagersId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PatchAccountManagersId401 = {
  success?: boolean;
  error?: string;
};

export type PatchAccountManagersId500 = {
  success?: boolean;
  error?: string;
};

export type GetAccountManagersId200Data = { [key: string]: unknown };

export type GetAccountManagersId200 = {
  success?: boolean;
  data?: GetAccountManagersId200Data;
  message?: string;
};

export type GetAccountManagersId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetAccountManagersId401 = {
  success?: boolean;
  error?: string;
};

export type GetAccountManagersId500 = {
  success?: boolean;
  error?: string;
};

export type DeleteAccountManagersId200Data = { [key: string]: unknown };

export type DeleteAccountManagersId200 = {
  success?: boolean;
  data?: DeleteAccountManagersId200Data;
  message?: string;
};

export type DeleteAccountManagersId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type DeleteAccountManagersId401 = {
  success?: boolean;
  error?: string;
};

export type DeleteAccountManagersId500 = {
  success?: boolean;
  error?: string;
};

export type GetTenantsTenantIdAudit200Data = { [key: string]: unknown };

export type GetTenantsTenantIdAudit200 = {
  success?: boolean;
  data?: GetTenantsTenantIdAudit200Data;
  message?: string;
};

export type GetTenantsTenantIdAudit400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetTenantsTenantIdAudit401 = {
  success?: boolean;
  error?: string;
};

export type GetTenantsTenantIdAudit500 = {
  success?: boolean;
  error?: string;
};

export type GetTenantsTenantIdAssignedUsersAudit200Data = { [key: string]: unknown };

export type GetTenantsTenantIdAssignedUsersAudit200 = {
  success?: boolean;
  data?: GetTenantsTenantIdAssignedUsersAudit200Data;
  message?: string;
};

export type GetTenantsTenantIdAssignedUsersAudit400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetTenantsTenantIdAssignedUsersAudit401 = {
  success?: boolean;
  error?: string;
};

export type GetTenantsTenantIdAssignedUsersAudit500 = {
  success?: boolean;
  error?: string;
};

export type PostEntitiesShareholdersShareholderIdRestore200Data = { [key: string]: unknown };

export type PostEntitiesShareholdersShareholderIdRestore200 = {
  success?: boolean;
  data?: PostEntitiesShareholdersShareholderIdRestore200Data;
  message?: string;
};

export type PostEntitiesShareholdersShareholderIdRestore400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostEntitiesShareholdersShareholderIdRestore401 = {
  success?: boolean;
  error?: string;
};

export type PostEntitiesShareholdersShareholderIdRestore500 = {
  success?: boolean;
  error?: string;
};

export type PostDocumentsPromote200DataTags = {[key: string]: string};

export type PostDocumentsPromote200Data = {
  message: string;
  containerName: string;
  blobName: string;
  tags: PostDocumentsPromote200DataTags;
  promotedBy: string;
  targetCategory: string;
  targetSubCategory: string;
};

export type PostDocumentsPromote200 = {
  success: true;
  data: PostDocumentsPromote200Data;
  message: string;
  statusCode: 200;
  status: true;
};

export type GetTenantsLspTenantIdEntityAccessAudit200Data = { [key: string]: unknown };

export type GetTenantsLspTenantIdEntityAccessAudit200 = {
  success?: boolean;
  data?: GetTenantsLspTenantIdEntityAccessAudit200Data;
  message?: string;
};

export type GetTenantsLspTenantIdEntityAccessAudit400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetTenantsLspTenantIdEntityAccessAudit401 = {
  success?: boolean;
  error?: string;
};

export type GetTenantsLspTenantIdEntityAccessAudit500 = {
  success?: boolean;
  error?: string;
};

export type PutTenantsLspTenantIdEntityAccessEntityId200Data = { [key: string]: unknown };

export type PutTenantsLspTenantIdEntityAccessEntityId200 = {
  success?: boolean;
  data?: PutTenantsLspTenantIdEntityAccessEntityId200Data;
  message?: string;
};

export type PutTenantsLspTenantIdEntityAccessEntityId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PutTenantsLspTenantIdEntityAccessEntityId401 = {
  success?: boolean;
  error?: string;
};

export type PutTenantsLspTenantIdEntityAccessEntityId500 = {
  success?: boolean;
  error?: string;
};

export type DeleteTenantsLspTenantIdEntityAccessEntityId200Data = { [key: string]: unknown };

export type DeleteTenantsLspTenantIdEntityAccessEntityId200 = {
  success?: boolean;
  data?: DeleteTenantsLspTenantIdEntityAccessEntityId200Data;
  message?: string;
};

export type DeleteTenantsLspTenantIdEntityAccessEntityId400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type DeleteTenantsLspTenantIdEntityAccessEntityId401 = {
  success?: boolean;
  error?: string;
};

export type DeleteTenantsLspTenantIdEntityAccessEntityId500 = {
  success?: boolean;
  error?: string;
};

export type GetTenantsLspTenantIdEntityAccess200Data = { [key: string]: unknown };

export type GetTenantsLspTenantIdEntityAccess200 = {
  success?: boolean;
  data?: GetTenantsLspTenantIdEntityAccess200Data;
  message?: string;
};

export type GetTenantsLspTenantIdEntityAccess400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetTenantsLspTenantIdEntityAccess401 = {
  success?: boolean;
  error?: string;
};

export type GetTenantsLspTenantIdEntityAccess500 = {
  success?: boolean;
  error?: string;
};

export type PostTenantsLspTenantIdEntityAccess200Data = { [key: string]: unknown };

export type PostTenantsLspTenantIdEntityAccess200 = {
  success?: boolean;
  data?: PostTenantsLspTenantIdEntityAccess200Data;
  message?: string;
};

export type PostTenantsLspTenantIdEntityAccess400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostTenantsLspTenantIdEntityAccess401 = {
  success?: boolean;
  error?: string;
};

export type PostTenantsLspTenantIdEntityAccess500 = {
  success?: boolean;
  error?: string;
};

export type GetUsers200DataUsersItemWorkosId = string | null;

export type GetUsers200DataUsersItemLastName = string | null;

export type GetUsers200DataUsersItemOtherName = string | null;

export type GetUsers200DataUsersItemPreferredName = string | null;

export type GetUsers200DataUsersItemRole = typeof GetUsers200DataUsersItemRole[keyof typeof GetUsers200DataUsersItemRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUsers200DataUsersItemRole = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  GXM_ADMIN: 'GXM_ADMIN',
  GXM_USER: 'GXM_USER',
  GXM_MANAGER: 'GXM_MANAGER',
  LSP_USER: 'LSP_USER',
  LSP_MANAGER: 'LSP_MANAGER',
  CUSTOMER_MANAGER: 'CUSTOMER_MANAGER',
  CUSTOMER: 'CUSTOMER',
} as const;

export type GetUsers200DataUsersItemTenants = string[] | null;

export type GetUsers200DataUsersItemAccessAnyOfItem = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  entity_id?: string;
  services?: string[];
};

export type GetUsers200DataUsersItemAccess = GetUsers200DataUsersItemAccessAnyOfItem[] | null;

export type GetUsers200DataUsersItemLspId = string | null;

export type GetUsers200DataUsersItemTimezone = string | null;

export type GetUsers200DataUsersItemProfilePicture = string | null;

export type GetUsers200DataUsersItemConfigAnyOf = {[key: string]: unknown};

export type GetUsers200DataUsersItemConfig = GetUsers200DataUsersItemConfigAnyOf | null;

export type GetUsers200DataUsersItemDeletedAt = string | null;

export type GetUsers200DataUsersItem = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  workos_id: GetUsers200DataUsersItemWorkosId;
  /** @pattern ^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$ */
  email: string;
  first_name: string;
  last_name: GetUsers200DataUsersItemLastName;
  other_name: GetUsers200DataUsersItemOtherName;
  preferred_name: GetUsers200DataUsersItemPreferredName;
  role: GetUsers200DataUsersItemRole;
  tenants: GetUsers200DataUsersItemTenants;
  access: GetUsers200DataUsersItemAccess;
  lsp_id: GetUsers200DataUsersItemLspId;
  timezone: GetUsers200DataUsersItemTimezone;
  profile_picture: GetUsers200DataUsersItemProfilePicture;
  config: GetUsers200DataUsersItemConfig;
  createdAt: string;
  updatedAt: string;
  deletedAt: GetUsers200DataUsersItemDeletedAt;
};

export type GetUsers200DataPagination = {
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  page: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  pageSize: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  total: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  totalPages: number;
};

export type GetUsers200Data = {
  users: GetUsers200DataUsersItem[];
  pagination: GetUsers200DataPagination;
};

export type GetUsers200 = {
  success: true;
  data: GetUsers200Data;
  message: string;
  statusCode: 200;
  status: true;
};

export type GetTenants200DataTenantsItemType = typeof GetTenants200DataTenantsItemType[keyof typeof GetTenants200DataTenantsItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTenants200DataTenantsItemType = {
  CUSTOMER: 'CUSTOMER',
  LSP: 'LSP',
} as const;

export type GetTenants200DataTenantsItemStatus = typeof GetTenants200DataTenantsItemStatus[keyof typeof GetTenants200DataTenantsItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTenants200DataTenantsItemStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;

export type GetTenants200DataTenantsItemBillingStartDate = string | null;

export type GetTenants200DataTenantsItemBillingEndDate = string | null;

export type GetTenants200DataTenantsItemPayslipPortalLink = string | null;

export type GetTenants200DataTenantsItemCustomerAdminAnyOfSurname = string | null;

export type GetTenants200DataTenantsItemCustomerAdminAnyOfOtherName = string | null;

export type GetTenants200DataTenantsItemCustomerAdminAnyOfPreferredName = string | null;

export type GetTenants200DataTenantsItemCustomerAdminAnyOfPhoneCode = string | null;

export type GetTenants200DataTenantsItemCustomerAdminAnyOfPhoneNumber = string | null;

export type GetTenants200DataTenantsItemCustomerAdminAnyOf = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  given_name: string;
  surname: GetTenants200DataTenantsItemCustomerAdminAnyOfSurname;
  other_name: GetTenants200DataTenantsItemCustomerAdminAnyOfOtherName;
  preferred_name: GetTenants200DataTenantsItemCustomerAdminAnyOfPreferredName;
  /** @pattern ^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$ */
  contact_email: string;
  country: string;
  phone_code: GetTenants200DataTenantsItemCustomerAdminAnyOfPhoneCode;
  phone_number: GetTenants200DataTenantsItemCustomerAdminAnyOfPhoneNumber;
};

export type GetTenants200DataTenantsItemCustomerAdmin = GetTenants200DataTenantsItemCustomerAdminAnyOf | null;

export type GetTenants200DataTenantsItemAccountManagerAnyOfSurname = string | null;

export type GetTenants200DataTenantsItemAccountManagerAnyOfOtherName = string | null;

export type GetTenants200DataTenantsItemAccountManagerAnyOfPreferredName = string | null;

export type GetTenants200DataTenantsItemAccountManagerAnyOfPhoneCode = string | null;

export type GetTenants200DataTenantsItemAccountManagerAnyOfPhoneNumber = string | null;

export type GetTenants200DataTenantsItemAccountManagerAnyOf = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  given_name: string;
  surname: GetTenants200DataTenantsItemAccountManagerAnyOfSurname;
  other_name: GetTenants200DataTenantsItemAccountManagerAnyOfOtherName;
  preferred_name: GetTenants200DataTenantsItemAccountManagerAnyOfPreferredName;
  /** @pattern ^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$ */
  email: string;
  country: string;
  phone_code: GetTenants200DataTenantsItemAccountManagerAnyOfPhoneCode;
  phone_number: GetTenants200DataTenantsItemAccountManagerAnyOfPhoneNumber;
};

export type GetTenants200DataTenantsItemAccountManagerAnyOfSeven = { [key: string]: unknown };

export type GetTenants200DataTenantsItemAccountManager = GetTenants200DataTenantsItemAccountManagerAnyOf | GetTenants200DataTenantsItemAccountManagerAnyOfSeven;

export type GetTenants200DataTenantsItem = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  tenant_name: string;
  type: GetTenants200DataTenantsItemType;
  demo_tenant: boolean;
  account_name: string;
  domains: string[];
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  total_number_of_users: number;
  salesforce_id: string;
  country: string;
  status: GetTenants200DataTenantsItemStatus;
  billing_start_date: GetTenants200DataTenantsItemBillingStartDate;
  billing_end_date: GetTenants200DataTenantsItemBillingEndDate;
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  organization_id: string;
  supports_payroll_plus: boolean;
  payslip_portal_link: GetTenants200DataTenantsItemPayslipPortalLink;
  createdAt: string;
  updatedAt: string;
  customer_admin: GetTenants200DataTenantsItemCustomerAdmin;
  account_manager: GetTenants200DataTenantsItemAccountManager;
};

export type GetTenants200DataPagination = {
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  page: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  pageSize: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  total: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  totalPages: number;
};

export type GetTenants200Data = {
  tenants: GetTenants200DataTenantsItem[];
  pagination: GetTenants200DataPagination;
};

export type GetTenants200 = {
  success: true;
  data: GetTenants200Data;
  message: string;
  statusCode: 200;
  status: true;
};

export type PostTenantsBodyType = typeof PostTenantsBodyType[keyof typeof PostTenantsBodyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostTenantsBodyType = {
  CUSTOMER: 'CUSTOMER',
  LSP: 'LSP',
} as const;

export type PostTenantsBodyTotalNumberOfUsers = number | string;

export type PostTenantsBodySalesforceId = string | null;

export type PostTenantsBodyStatus = typeof PostTenantsBodyStatus[keyof typeof PostTenantsBodyStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostTenantsBodyStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;

export type PostTenantsBodyBillingEndDate = string | null;

export type PostTenantsBodyPayslipPortalLink = string | null;

export type PostTenantsBodyAccountManagerId = string | null;

export type PostTenantsBodyCustomerAdminPhoneNumber = string | null;

export type PostTenantsBodyCustomerAdmin = {
  /** @minLength 1 */
  given_name: string;
  surname?: string;
  other_name?: string;
  preferred_name?: string;
  /**
   * @minLength 1
   * @pattern ^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$
   */
  contact_email: string;
  /** @minLength 1 */
  country: string;
  phone_code?: string;
  phone_number?: PostTenantsBodyCustomerAdminPhoneNumber;
};

export type PostTenantsBody = {
  /** @minLength 1 */
  tenant_name: string;
  type: PostTenantsBodyType;
  demo_tenant?: boolean;
  /** @minLength 1 */
  account_name: string;
  /** @minItems 1 */
  domains: string[];
  total_number_of_users: PostTenantsBodyTotalNumberOfUsers;
  salesforce_id?: PostTenantsBodySalesforceId;
  /** @minLength 1 */
  country: string;
  status: PostTenantsBodyStatus;
  /**
   * @minLength 1
   * @pattern ^\d{2}\/\d{2}\/\d{4}$
   */
  billing_start_date: string;
  billing_end_date?: PostTenantsBodyBillingEndDate;
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  organization_id: string;
  supports_payroll_plus?: boolean;
  payslip_portal_link?: PostTenantsBodyPayslipPortalLink;
  account_manager_id?: PostTenantsBodyAccountManagerId;
  customer_admin: PostTenantsBodyCustomerAdmin;
};

export type PostTenants200Data = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  tenantId: string;
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  customerAdminId: string;
};

export type PostTenants200 = {
  success: true;
  data: PostTenants200Data;
  message: string;
  statusCode: 200;
  status: true;
};

export type GetTenantsId200DataType = typeof GetTenantsId200DataType[keyof typeof GetTenantsId200DataType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTenantsId200DataType = {
  CUSTOMER: 'CUSTOMER',
  LSP: 'LSP',
} as const;

export type GetTenantsId200DataStatus = typeof GetTenantsId200DataStatus[keyof typeof GetTenantsId200DataStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTenantsId200DataStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;

export type GetTenantsId200DataBillingStartDate = string | null;

export type GetTenantsId200DataBillingEndDate = string | null;

export type GetTenantsId200DataPayslipPortalLink = string | null;

export type GetTenantsId200DataCustomerAdminAnyOfSurname = string | null;

export type GetTenantsId200DataCustomerAdminAnyOfOtherName = string | null;

export type GetTenantsId200DataCustomerAdminAnyOfPreferredName = string | null;

export type GetTenantsId200DataCustomerAdminAnyOfPhoneCode = string | null;

export type GetTenantsId200DataCustomerAdminAnyOfPhoneNumber = string | null;

export type GetTenantsId200DataCustomerAdminAnyOf = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  given_name: string;
  surname: GetTenantsId200DataCustomerAdminAnyOfSurname;
  other_name: GetTenantsId200DataCustomerAdminAnyOfOtherName;
  preferred_name: GetTenantsId200DataCustomerAdminAnyOfPreferredName;
  /** @pattern ^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$ */
  contact_email: string;
  country: string;
  phone_code: GetTenantsId200DataCustomerAdminAnyOfPhoneCode;
  phone_number: GetTenantsId200DataCustomerAdminAnyOfPhoneNumber;
};

export type GetTenantsId200DataCustomerAdmin = GetTenantsId200DataCustomerAdminAnyOf | null;

export type GetTenantsId200DataAccountManagerAnyOfSurname = string | null;

export type GetTenantsId200DataAccountManagerAnyOfOtherName = string | null;

export type GetTenantsId200DataAccountManagerAnyOfPreferredName = string | null;

export type GetTenantsId200DataAccountManagerAnyOfPhoneCode = string | null;

export type GetTenantsId200DataAccountManagerAnyOfPhoneNumber = string | null;

export type GetTenantsId200DataAccountManagerAnyOf = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  given_name: string;
  surname: GetTenantsId200DataAccountManagerAnyOfSurname;
  other_name: GetTenantsId200DataAccountManagerAnyOfOtherName;
  preferred_name: GetTenantsId200DataAccountManagerAnyOfPreferredName;
  /** @pattern ^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$ */
  email: string;
  country: string;
  phone_code: GetTenantsId200DataAccountManagerAnyOfPhoneCode;
  phone_number: GetTenantsId200DataAccountManagerAnyOfPhoneNumber;
};

export type GetTenantsId200DataAccountManagerAnyOfSeven = { [key: string]: unknown };

export type GetTenantsId200DataAccountManager = GetTenantsId200DataAccountManagerAnyOf | GetTenantsId200DataAccountManagerAnyOfSeven;

export type GetTenantsId200Data = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  tenant_name: string;
  type: GetTenantsId200DataType;
  demo_tenant: boolean;
  account_name: string;
  domains: string[];
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  total_number_of_users: number;
  salesforce_id: string;
  country: string;
  status: GetTenantsId200DataStatus;
  billing_start_date: GetTenantsId200DataBillingStartDate;
  billing_end_date: GetTenantsId200DataBillingEndDate;
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  organization_id: string;
  supports_payroll_plus: boolean;
  payslip_portal_link: GetTenantsId200DataPayslipPortalLink;
  createdAt: string;
  updatedAt: string;
  customer_admin: GetTenantsId200DataCustomerAdmin;
  account_manager: GetTenantsId200DataAccountManager;
};

export type GetTenantsId200 = {
  success: true;
  data: GetTenantsId200Data;
  message: string;
  statusCode: 200;
  status: true;
};

export type PatchTenantsIdBodyType = 'CUSTOMER' | 'LSP' | string;

export type PatchTenantsIdBodyTotalNumberOfUsers = number | string;

export type PatchTenantsIdBodySalesforceIdAnyOf = string | null;

export type PatchTenantsIdBodySalesforceId = PatchTenantsIdBodySalesforceIdAnyOf | null;

export type PatchTenantsIdBodyStatus = typeof PatchTenantsIdBodyStatus[keyof typeof PatchTenantsIdBodyStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchTenantsIdBodyStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;

export type PatchTenantsIdBodyBillingStartDate = string | null;

export type PatchTenantsIdBodyBillingEndDateAnyOf = string | null;

export type PatchTenantsIdBodyBillingEndDate = PatchTenantsIdBodyBillingEndDateAnyOf | null;

export type PatchTenantsIdBodyPayslipPortalLinkAnyOf = string | null;

export type PatchTenantsIdBodyPayslipPortalLink = PatchTenantsIdBodyPayslipPortalLinkAnyOf | null;

export type PatchTenantsIdBodyAccountManagerId = string | null;

export type PatchTenantsIdBodyCustomerAdminPhoneNumber = string | null;

export type PatchTenantsIdBodyCustomerAdmin = {
  /** @minLength 1 */
  given_name?: string;
  surname?: string;
  other_name?: string;
  preferred_name?: string;
  contact_email?: string;
  /** @minLength 1 */
  country?: string;
  phone_code?: string;
  phone_number?: PatchTenantsIdBodyCustomerAdminPhoneNumber;
};

export type PatchTenantsIdBody = {
  /** @minLength 1 */
  tenant_name?: string;
  type?: PatchTenantsIdBodyType;
  demo_tenant?: boolean;
  /** @minLength 1 */
  account_name?: string;
  /** @minItems 1 */
  domains?: string[];
  total_number_of_users?: PatchTenantsIdBodyTotalNumberOfUsers;
  salesforce_id?: PatchTenantsIdBodySalesforceId;
  /** @minLength 1 */
  country?: string;
  status?: PatchTenantsIdBodyStatus;
  billing_start_date?: PatchTenantsIdBodyBillingStartDate;
  billing_end_date?: PatchTenantsIdBodyBillingEndDate;
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  organization_id?: string;
  supports_payroll_plus?: boolean;
  payslip_portal_link?: PatchTenantsIdBodyPayslipPortalLink;
  account_manager_id?: PatchTenantsIdBodyAccountManagerId;
  customer_admin?: PatchTenantsIdBodyCustomerAdmin;
};

export type PatchTenantsId200DataType = typeof PatchTenantsId200DataType[keyof typeof PatchTenantsId200DataType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchTenantsId200DataType = {
  CUSTOMER: 'CUSTOMER',
  LSP: 'LSP',
} as const;

export type PatchTenantsId200DataStatus = typeof PatchTenantsId200DataStatus[keyof typeof PatchTenantsId200DataStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchTenantsId200DataStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;

export type PatchTenantsId200DataBillingStartDate = string | null;

export type PatchTenantsId200DataBillingEndDate = string | null;

export type PatchTenantsId200DataPayslipPortalLink = string | null;

export type PatchTenantsId200DataCustomerAdminAnyOfSurname = string | null;

export type PatchTenantsId200DataCustomerAdminAnyOfOtherName = string | null;

export type PatchTenantsId200DataCustomerAdminAnyOfPreferredName = string | null;

export type PatchTenantsId200DataCustomerAdminAnyOfPhoneCode = string | null;

export type PatchTenantsId200DataCustomerAdminAnyOfPhoneNumber = string | null;

export type PatchTenantsId200DataCustomerAdminAnyOf = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  given_name: string;
  surname: PatchTenantsId200DataCustomerAdminAnyOfSurname;
  other_name: PatchTenantsId200DataCustomerAdminAnyOfOtherName;
  preferred_name: PatchTenantsId200DataCustomerAdminAnyOfPreferredName;
  /** @pattern ^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$ */
  contact_email: string;
  country: string;
  phone_code: PatchTenantsId200DataCustomerAdminAnyOfPhoneCode;
  phone_number: PatchTenantsId200DataCustomerAdminAnyOfPhoneNumber;
};

export type PatchTenantsId200DataCustomerAdmin = PatchTenantsId200DataCustomerAdminAnyOf | null;

export type PatchTenantsId200DataAccountManagerAnyOfSurname = string | null;

export type PatchTenantsId200DataAccountManagerAnyOfOtherName = string | null;

export type PatchTenantsId200DataAccountManagerAnyOfPreferredName = string | null;

export type PatchTenantsId200DataAccountManagerAnyOfPhoneCode = string | null;

export type PatchTenantsId200DataAccountManagerAnyOfPhoneNumber = string | null;

export type PatchTenantsId200DataAccountManagerAnyOf = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  given_name: string;
  surname: PatchTenantsId200DataAccountManagerAnyOfSurname;
  other_name: PatchTenantsId200DataAccountManagerAnyOfOtherName;
  preferred_name: PatchTenantsId200DataAccountManagerAnyOfPreferredName;
  /** @pattern ^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$ */
  email: string;
  country: string;
  phone_code: PatchTenantsId200DataAccountManagerAnyOfPhoneCode;
  phone_number: PatchTenantsId200DataAccountManagerAnyOfPhoneNumber;
};

export type PatchTenantsId200DataAccountManagerAnyOfSeven = { [key: string]: unknown };

export type PatchTenantsId200DataAccountManager = PatchTenantsId200DataAccountManagerAnyOf | PatchTenantsId200DataAccountManagerAnyOfSeven;

export type PatchTenantsId200Data = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  tenant_name: string;
  type: PatchTenantsId200DataType;
  demo_tenant: boolean;
  account_name: string;
  domains: string[];
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  total_number_of_users: number;
  salesforce_id: string;
  country: string;
  status: PatchTenantsId200DataStatus;
  billing_start_date: PatchTenantsId200DataBillingStartDate;
  billing_end_date: PatchTenantsId200DataBillingEndDate;
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  organization_id: string;
  supports_payroll_plus: boolean;
  payslip_portal_link: PatchTenantsId200DataPayslipPortalLink;
  createdAt: string;
  updatedAt: string;
  customer_admin: PatchTenantsId200DataCustomerAdmin;
  account_manager: PatchTenantsId200DataAccountManager;
};

export type PatchTenantsId200 = {
  success: true;
  data: PatchTenantsId200Data;
  message: string;
  statusCode: 200;
  status: true;
};

export type DeleteTenantsId200Data = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  tenant_id: string;
  deleted_at: string;
};

export type DeleteTenantsId200 = {
  success: true;
  data: DeleteTenantsId200Data;
  message: string;
  statusCode: 200;
  status: true;
};

export type GetTenantsTenantIdEntities200Data = { [key: string]: unknown };

export type GetTenantsTenantIdEntities200 = {
  success?: boolean;
  data?: GetTenantsTenantIdEntities200Data;
  message?: string;
};

export type GetTenantsTenantIdEntities400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetTenantsTenantIdEntities401 = {
  success?: boolean;
  error?: string;
};

export type GetTenantsTenantIdEntities500 = {
  success?: boolean;
  error?: string;
};

export type GetProcesses200DataProcessesItemDueDate = string | null;

export type GetProcesses200DataProcessesItemFlagged = boolean | null;

export type GetProcesses200DataProcessesItemProcessTemplateId = string | null;

export type GetProcesses200DataProcessesItem = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  name: string;
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  entity_id: string;
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  service_id: string;
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  status_id: string;
  due_date: GetProcesses200DataProcessesItemDueDate;
  flagged: GetProcesses200DataProcessesItemFlagged;
  process_template_id: GetProcesses200DataProcessesItemProcessTemplateId;
  createdAt: string;
  updatedAt: string;
  isEscalated?: boolean;
  isFlagged?: boolean;
};

export type GetProcesses200DataPagination = {
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  page: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  pageSize: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  total: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  totalPages: number;
};

export type GetProcesses200Data = {
  processes: GetProcesses200DataProcessesItem[];
  pagination: GetProcesses200DataPagination;
};

export type GetProcesses200 = {
  success: true;
  data: GetProcesses200Data;
  message: string;
  statusCode: 200;
  status: true;
};

export type GetAccountManagerIdManagedEntities200Data = { [key: string]: unknown };

export type GetAccountManagerIdManagedEntities200 = {
  success?: boolean;
  data?: GetAccountManagerIdManagedEntities200Data;
  message?: string;
};

export type GetAccountManagerIdManagedEntities400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetAccountManagerIdManagedEntities401 = {
  success?: boolean;
  error?: string;
};

export type GetAccountManagerIdManagedEntities500 = {
  success?: boolean;
  error?: string;
};

export type GetEntities200DataItemName = string | null;

export type GetEntities200DataItemTradingName = string | null;

export type GetEntities200DataItemTaxId = string | null;

export type GetEntities200DataItemCountry = string | null;

export type GetEntities200DataItemRegistrationNumber = string | null;

export type GetEntities200DataItemType = 'Branch' | 'Subsidiary' | 'Representative Office' | 'NRE' | 'Parent Entity' | 'No Entity' | null;

export type GetEntities200DataItemStatus = 'Active' | 'Action Required' | 'Incomplete' | 'Non Compliant' | 'Dormant' | null;

export type GetEntities200DataItemDomains = string[] | null;

export type GetEntities200DataItemBusinessActivity = string | null;

export type GetEntities200DataItemSalesforceId = string | null;

export type GetEntities200DataItemAccountManagerId = string | null;

export type GetEntities200DataItemActiveServices = string[] | null;

export type GetEntities200DataItemIsActive = boolean | null;

export type GetEntities200DataItemTimezone = string | null;

export type GetEntities200DataItemPointContact = string | null;

export type GetEntities200DataItemCreatedBy = string | null;

export type GetEntities200DataItemUpdatedBy = string | null;

export type GetEntities200DataItemParent = string | null;

export type GetEntities200DataItemTenantId = string | null;

export type GetEntities200DataItemParentEntityAnyOfName = string | null;

export type GetEntities200DataItemParentEntityAnyOfCountry = string | null;

export type GetEntities200DataItemParentEntityAnyOf = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  name: GetEntities200DataItemParentEntityAnyOfName;
  country: GetEntities200DataItemParentEntityAnyOfCountry;
};

export type GetEntities200DataItemParentEntity = GetEntities200DataItemParentEntityAnyOf | null;

export type GetEntities200DataItemTenantDataAnyOf = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  name: string;
};

export type GetEntities200DataItemTenantData = GetEntities200DataItemTenantDataAnyOf | null;

export type GetEntities200DataItemAccountManagerDataAnyOfSurname = string | null;

export type GetEntities200DataItemAccountManagerDataAnyOfPreferredName = string | null;

export type GetEntities200DataItemAccountManagerDataAnyOf = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  given_name: string;
  surname: GetEntities200DataItemAccountManagerDataAnyOfSurname;
  preferred_name: GetEntities200DataItemAccountManagerDataAnyOfPreferredName;
};

export type GetEntities200DataItemAccountManagerData = GetEntities200DataItemAccountManagerDataAnyOf | null;

export type GetEntities200DataItemServicesItemProcessTemplatesItem = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  name: string;
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  service: string;
  process_category: string;
};

export type GetEntities200DataItemServicesItem = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  name: string;
  process_templates: GetEntities200DataItemServicesItemProcessTemplatesItem[];
};

export type GetEntities200DataItem = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  name: GetEntities200DataItemName;
  trading_name: GetEntities200DataItemTradingName;
  tax_id: GetEntities200DataItemTaxId;
  country: GetEntities200DataItemCountry;
  registration_number: GetEntities200DataItemRegistrationNumber;
  type: GetEntities200DataItemType;
  status: GetEntities200DataItemStatus;
  domains: GetEntities200DataItemDomains;
  business_activity: GetEntities200DataItemBusinessActivity;
  salesforce_id: GetEntities200DataItemSalesforceId;
  account_manager_id: GetEntities200DataItemAccountManagerId;
  active_services: GetEntities200DataItemActiveServices;
  is_active: GetEntities200DataItemIsActive;
  timezone: GetEntities200DataItemTimezone;
  point_contact: GetEntities200DataItemPointContact;
  created_by: GetEntities200DataItemCreatedBy;
  updated_by: GetEntities200DataItemUpdatedBy;
  parent: GetEntities200DataItemParent;
  tenant_id: GetEntities200DataItemTenantId;
  createdAt: string;
  updatedAt: string;
  parentEntity: GetEntities200DataItemParentEntity;
  tenantData: GetEntities200DataItemTenantData;
  accountManagerData: GetEntities200DataItemAccountManagerData;
  services: GetEntities200DataItemServicesItem[];
};

export type GetEntities200 = {
  success: true;
  data: GetEntities200DataItem[];
  message: string;
  statusCode: 200;
  status: true;
};

export type PostEntitiesBodyParent = string | null;

export type PostEntitiesBodyType = typeof PostEntitiesBodyType[keyof typeof PostEntitiesBodyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostEntitiesBodyType = {
  Branch: 'Branch',
  Subsidiary: 'Subsidiary',
  Representative_Office: 'Representative Office',
  NRE: 'NRE',
  Parent_Entity: 'Parent Entity',
  No_Entity: 'No Entity',
} as const;

export type PostEntitiesBodyStatus = typeof PostEntitiesBodyStatus[keyof typeof PostEntitiesBodyStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostEntitiesBodyStatus = {
  Active: 'Active',
  Action_Required: 'Action Required',
  Incomplete: 'Incomplete',
  Non_Compliant: 'Non Compliant',
  Dormant: 'Dormant',
} as const;

export type PostEntitiesBodyAccountManagerId = string | null;

export type PostEntitiesBodyAddressItemType = typeof PostEntitiesBodyAddressItemType[keyof typeof PostEntitiesBodyAddressItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostEntitiesBodyAddressItemType = {
  Registered: 'Registered',
  Trading: 'Trading',
  Physical: 'Physical',
  Other: 'Other',
} as const;

export type PostEntitiesBodyAddressItem = {
  type: PostEntitiesBodyAddressItemType;
  /**
   * @minLength 1
   * @maxLength 3
   */
  country: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  address_line_1: string;
  /** @maxLength 100 */
  address_line_2?: string;
  /** @maxLength 50 */
  city?: string;
  /** @maxLength 50 */
  state?: string;
  /**
   * @minLength 1
   * @maxLength 20
   */
  postalcode: string;
};

export type PostEntitiesBodyKeypersonnelsItem = {
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /**
   * @maxLength 200
   * @pattern ^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$
   */
  email: string;
  /** @maxLength 20 */
  phone?: string;
  /** @maxLength 100 */
  position?: string;
};

export type PostEntitiesBodyEntityPlusDataIncorporationDate = string | null;

export type PostEntitiesBodyEntityPlusDataAcquisitionDate = string | null;

export type PostEntitiesBodyEntityPlusDataSaleClosureDate = string | null;

export type PostEntitiesBodyEntityPlusData = {
  incorporation_date?: PostEntitiesBodyEntityPlusDataIncorporationDate;
  acquisition_date?: PostEntitiesBodyEntityPlusDataAcquisitionDate;
  sale_closure_date?: PostEntitiesBodyEntityPlusDataSaleClosureDate;
};

export type PostEntitiesBody = {
  parent?: PostEntitiesBodyParent;
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /** @maxLength 100 */
  trading_name?: string;
  /** @maxLength 50 */
  tax_id?: string;
  /**
   * @minLength 1
   * @maxLength 3
   */
  country: string;
  /** @maxLength 50 */
  registration_number?: string;
  type?: PostEntitiesBodyType;
  status?: PostEntitiesBodyStatus;
  domains?: string[];
  /** @maxLength 200 */
  business_activity?: string;
  /** @maxLength 100 */
  salesforce_id?: string;
  account_manager_id?: PostEntitiesBodyAccountManagerId;
  active_services?: string[];
  address?: PostEntitiesBodyAddressItem[];
  keypersonnels?: PostEntitiesBodyKeypersonnelsItem[];
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  organization: string;
  entityPlusData?: PostEntitiesBodyEntityPlusData;
  /** @maxLength 50 */
  timezone?: string;
};

export type PostEntities200Data = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  name: string;
  country: string;
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  tenant_id: string;
};

export type PostEntities200 = {
  success: true;
  data: PostEntities200Data;
  message: string;
  statusCode: 200;
  status: true;
};

export type GetAccountManagers200Data = { [key: string]: unknown };

export type GetAccountManagers200 = {
  success?: boolean;
  data?: GetAccountManagers200Data;
  message?: string;
};

export type GetAccountManagers400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetAccountManagers401 = {
  success?: boolean;
  error?: string;
};

export type GetAccountManagers500 = {
  success?: boolean;
  error?: string;
};

export type PostAccountManagers200Data = { [key: string]: unknown };

export type PostAccountManagers200 = {
  success?: boolean;
  data?: PostAccountManagers200Data;
  message?: string;
};

export type PostAccountManagers400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostAccountManagers401 = {
  success?: boolean;
  error?: string;
};

export type PostAccountManagers500 = {
  success?: boolean;
  error?: string;
};

export type PostTenantsTenantIdShareholdersDuplicates200Data = { [key: string]: unknown };

export type PostTenantsTenantIdShareholdersDuplicates200 = {
  success?: boolean;
  data?: PostTenantsTenantIdShareholdersDuplicates200Data;
  message?: string;
};

export type PostTenantsTenantIdShareholdersDuplicates400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostTenantsTenantIdShareholdersDuplicates401 = {
  success?: boolean;
  error?: string;
};

export type PostTenantsTenantIdShareholdersDuplicates500 = {
  success?: boolean;
  error?: string;
};

export type PostTenantsTenantIdDirectorsDuplicates200Data = { [key: string]: unknown };

export type PostTenantsTenantIdDirectorsDuplicates200 = {
  success?: boolean;
  data?: PostTenantsTenantIdDirectorsDuplicates200Data;
  message?: string;
};

export type PostTenantsTenantIdDirectorsDuplicates400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type PostTenantsTenantIdDirectorsDuplicates401 = {
  success?: boolean;
  error?: string;
};

export type PostTenantsTenantIdDirectorsDuplicates500 = {
  success?: boolean;
  error?: string;
};

export type GetDirectorIdAudit200Data = { [key: string]: unknown };

export type GetDirectorIdAudit200 = {
  success?: boolean;
  data?: GetDirectorIdAudit200Data;
  message?: string;
};

export type GetDirectorIdAudit400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetDirectorIdAudit401 = {
  success?: boolean;
  error?: string;
};

export type GetDirectorIdAudit500 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesIdDirectorAppointmentsDirectorIdAudit200Data = { [key: string]: unknown };

export type GetEntitiesIdDirectorAppointmentsDirectorIdAudit200 = {
  success?: boolean;
  data?: GetEntitiesIdDirectorAppointmentsDirectorIdAudit200Data;
  message?: string;
};

export type GetEntitiesIdDirectorAppointmentsDirectorIdAudit400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetEntitiesIdDirectorAppointmentsDirectorIdAudit401 = {
  success?: boolean;
  error?: string;
};

export type GetEntitiesIdDirectorAppointmentsDirectorIdAudit500 = {
  success?: boolean;
  error?: string;
};

export type PostEntitiesEntityIdProcessesBody = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  template: string;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  startDate: string;
  force?: boolean;
};

export type PostEntitiesEntityIdProcesses200Data = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  name: string;
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  entity_id: string;
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  service_id: string;
};

export type PostEntitiesEntityIdProcesses200 = {
  success: true;
  data: PostEntitiesEntityIdProcesses200Data;
  message: string;
  statusCode: 200;
  status: true;
};

export type PostPermissionsCheckBodyResource = typeof PostPermissionsCheckBodyResource[keyof typeof PostPermissionsCheckBodyResource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostPermissionsCheckBodyResource = {
  audittrail: 'audittrail',
  comment: 'comment',
  dashboards: 'dashboards',
  director: 'director',
  documents: 'documents',
  employee: 'employee',
  entity: 'entity',
  events: 'events',
  officer: 'officer',
  payslip: 'payslip',
  process: 'process',
  request: 'request',
  shareholder: 'shareholder',
  task: 'task',
  usermanagement: 'usermanagement',
} as const;

export type PostPermissionsCheckBodyAction = typeof PostPermissionsCheckBodyAction[keyof typeof PostPermissionsCheckBodyAction];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostPermissionsCheckBodyAction = {
  view: 'view',
  list: 'list',
  create: 'create',
  modify: 'modify',
  delete: 'delete',
  execute: 'execute',
  upload: 'upload',
  approve: 'approve',
  release: 'release',
  change_overdue_status: 'change_overdue_status',
  mark_not_needed: 'mark_not_needed',
  view_internal: 'view_internal',
  create_internal: 'create_internal',
  update_status: 'update_status',
  reassign: 'reassign',
  view_any: 'view_any',
  view_self: 'view_self',
  modify_any: 'modify_any',
  modify_self: 'modify_self',
} as const;

export type PostPermissionsCheckBodyResourceAttr = {[key: string]: unknown};

export type PostPermissionsCheckBody = {
  resource: PostPermissionsCheckBodyResource;
  action: PostPermissionsCheckBodyAction;
  resourceId?: string;
  resourceAttr?: PostPermissionsCheckBodyResourceAttr;
};

export type PostPermissionsCheck200Data = {
  allowed: boolean;
};

export type PostPermissionsCheck200 = {
  success: true;
  data: PostPermissionsCheck200Data;
  message: string;
  statusCode: 200;
  status: true;
};

export type GetAccountManagerIdEntitiesAudit200Data = { [key: string]: unknown };

export type GetAccountManagerIdEntitiesAudit200 = {
  success?: boolean;
  data?: GetAccountManagerIdEntitiesAudit200Data;
  message?: string;
};

export type GetAccountManagerIdEntitiesAudit400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetAccountManagerIdEntitiesAudit401 = {
  success?: boolean;
  error?: string;
};

export type GetAccountManagerIdEntitiesAudit500 = {
  success?: boolean;
  error?: string;
};

export type GetAccountManagerIdAudit200Data = { [key: string]: unknown };

export type GetAccountManagerIdAudit200 = {
  success?: boolean;
  data?: GetAccountManagerIdAudit200Data;
  message?: string;
};

export type GetAccountManagerIdAudit400 = {
  success?: boolean;
  error?: string;
  message?: string;
};

export type GetAccountManagerIdAudit401 = {
  success?: boolean;
  error?: string;
};

export type GetAccountManagerIdAudit500 = {
  success?: boolean;
  error?: string;
};

/**
 * Create Auth O T P endpoint
 * @summary Create Auth O T P
 */
export const postAuthOtp = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostAuthOtp200>(
      {url: `/auth/otp`, method: 'POST', signal
    },
      );
    }
  


export const getPostAuthOtpMutationOptions = <TError = PostAuthOtp400 | PostAuthOtp401 | PostAuthOtp500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthOtp>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthOtp>>, TError,void, TContext> => {

const mutationKey = ['postAuthOtp'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthOtp>>, void> = () => {
          

          return  postAuthOtp()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthOtpMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthOtp>>>
    
    export type PostAuthOtpMutationError = PostAuthOtp400 | PostAuthOtp401 | PostAuthOtp500

    /**
 * @summary Create Auth O T P
 */
export const usePostAuthOtp = <TError = PostAuthOtp400 | PostAuthOtp401 | PostAuthOtp500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthOtp>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthOtp>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostAuthOtpMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Process Auth O T P endpoint
 * @summary Process Auth O T P
 */
export const headAuthOtp = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<HeadAuthOtp200>(
      {url: `/auth/otp`, method: 'HEAD', signal
    },
      );
    }
  


export const getHeadAuthOtpMutationOptions = <TError = HeadAuthOtp400 | HeadAuthOtp401 | HeadAuthOtp500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof headAuthOtp>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof headAuthOtp>>, TError,void, TContext> => {

const mutationKey = ['headAuthOtp'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof headAuthOtp>>, void> = () => {
          

          return  headAuthOtp()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HeadAuthOtpMutationResult = NonNullable<Awaited<ReturnType<typeof headAuthOtp>>>
    
    export type HeadAuthOtpMutationError = HeadAuthOtp400 | HeadAuthOtp401 | HeadAuthOtp500

    /**
 * @summary Process Auth O T P
 */
export const useHeadAuthOtp = <TError = HeadAuthOtp400 | HeadAuthOtp401 | HeadAuthOtp500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof headAuthOtp>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof headAuthOtp>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getHeadAuthOtpMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Auth Callback endpoint
 * @summary Create Auth Callback
 */
export const postAuthVerifyOtp = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostAuthVerifyOtp200>(
      {url: `/auth/verify-otp`, method: 'POST', signal
    },
      );
    }
  


export const getPostAuthVerifyOtpMutationOptions = <TError = PostAuthVerifyOtp400 | PostAuthVerifyOtp401 | PostAuthVerifyOtp500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthVerifyOtp>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthVerifyOtp>>, TError,void, TContext> => {

const mutationKey = ['postAuthVerifyOtp'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthVerifyOtp>>, void> = () => {
          

          return  postAuthVerifyOtp()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthVerifyOtpMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthVerifyOtp>>>
    
    export type PostAuthVerifyOtpMutationError = PostAuthVerifyOtp400 | PostAuthVerifyOtp401 | PostAuthVerifyOtp500

    /**
 * @summary Create Auth Callback
 */
export const usePostAuthVerifyOtp = <TError = PostAuthVerifyOtp400 | PostAuthVerifyOtp401 | PostAuthVerifyOtp500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthVerifyOtp>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthVerifyOtp>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostAuthVerifyOtpMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Process Auth Callback endpoint
 * @summary Process Auth Callback
 */
export const headAuthVerifyOtp = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<HeadAuthVerifyOtp200>(
      {url: `/auth/verify-otp`, method: 'HEAD', signal
    },
      );
    }
  


export const getHeadAuthVerifyOtpMutationOptions = <TError = HeadAuthVerifyOtp400 | HeadAuthVerifyOtp401 | HeadAuthVerifyOtp500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof headAuthVerifyOtp>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof headAuthVerifyOtp>>, TError,void, TContext> => {

const mutationKey = ['headAuthVerifyOtp'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof headAuthVerifyOtp>>, void> = () => {
          

          return  headAuthVerifyOtp()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HeadAuthVerifyOtpMutationResult = NonNullable<Awaited<ReturnType<typeof headAuthVerifyOtp>>>
    
    export type HeadAuthVerifyOtpMutationError = HeadAuthVerifyOtp400 | HeadAuthVerifyOtp401 | HeadAuthVerifyOtp500

    /**
 * @summary Process Auth Callback
 */
export const useHeadAuthVerifyOtp = <TError = HeadAuthVerifyOtp400 | HeadAuthVerifyOtp401 | HeadAuthVerifyOtp500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof headAuthVerifyOtp>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof headAuthVerifyOtp>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getHeadAuthVerifyOtpMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Webhook User Upsert endpoint
 * @summary Create Webhook User Upsert
 */
export const postWebhookWorkosEvents = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostWebhookWorkosEvents200>(
      {url: `/webhook/workos/events`, method: 'POST', signal
    },
      );
    }
  


export const getPostWebhookWorkosEventsMutationOptions = <TError = PostWebhookWorkosEvents400 | PostWebhookWorkosEvents401 | PostWebhookWorkosEvents500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWebhookWorkosEvents>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postWebhookWorkosEvents>>, TError,void, TContext> => {

const mutationKey = ['postWebhookWorkosEvents'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postWebhookWorkosEvents>>, void> = () => {
          

          return  postWebhookWorkosEvents()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostWebhookWorkosEventsMutationResult = NonNullable<Awaited<ReturnType<typeof postWebhookWorkosEvents>>>
    
    export type PostWebhookWorkosEventsMutationError = PostWebhookWorkosEvents400 | PostWebhookWorkosEvents401 | PostWebhookWorkosEvents500

    /**
 * @summary Create Webhook User Upsert
 */
export const usePostWebhookWorkosEvents = <TError = PostWebhookWorkosEvents400 | PostWebhookWorkosEvents401 | PostWebhookWorkosEvents500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWebhookWorkosEvents>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postWebhookWorkosEvents>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostWebhookWorkosEventsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Payroll Plus Webhook Event endpoint
 * @summary Create Payroll Plus Webhook Event
 */
export const postWebhookPayrollPlusEvents = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostWebhookPayrollPlusEvents200>(
      {url: `/webhook/payroll-plus/events`, method: 'POST', signal
    },
      );
    }
  


export const getPostWebhookPayrollPlusEventsMutationOptions = <TError = PostWebhookPayrollPlusEvents400 | PostWebhookPayrollPlusEvents401 | PostWebhookPayrollPlusEvents500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWebhookPayrollPlusEvents>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postWebhookPayrollPlusEvents>>, TError,void, TContext> => {

const mutationKey = ['postWebhookPayrollPlusEvents'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postWebhookPayrollPlusEvents>>, void> = () => {
          

          return  postWebhookPayrollPlusEvents()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostWebhookPayrollPlusEventsMutationResult = NonNullable<Awaited<ReturnType<typeof postWebhookPayrollPlusEvents>>>
    
    export type PostWebhookPayrollPlusEventsMutationError = PostWebhookPayrollPlusEvents400 | PostWebhookPayrollPlusEvents401 | PostWebhookPayrollPlusEvents500

    /**
 * @summary Create Payroll Plus Webhook Event
 */
export const usePostWebhookPayrollPlusEvents = <TError = PostWebhookPayrollPlusEvents400 | PostWebhookPayrollPlusEvents401 | PostWebhookPayrollPlusEvents500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWebhookPayrollPlusEvents>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postWebhookPayrollPlusEvents>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostWebhookPayrollPlusEventsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Version endpoint
 * @summary Fetch Version
 */
export const getVersion = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetVersion200>(
      {url: `/version`, method: 'GET', signal
    },
      );
    }
  



export const getGetVersionQueryKey = () => {
    return [
    `/version`
    ] as const;
    }

    
export const getGetVersionQueryOptions = <TData = Awaited<ReturnType<typeof getVersion>>, TError = GetVersion400 | GetVersion401 | GetVersion500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVersionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVersion>>> = ({ signal }) => getVersion(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getVersion>>>
export type GetVersionQueryError = GetVersion400 | GetVersion401 | GetVersion500


export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = GetVersion400 | GetVersion401 | GetVersion500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersion>>,
          TError,
          Awaited<ReturnType<typeof getVersion>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = GetVersion400 | GetVersion401 | GetVersion500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersion>>,
          TError,
          Awaited<ReturnType<typeof getVersion>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = GetVersion400 | GetVersion401 | GetVersion500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Version
 */

export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = GetVersion400 | GetVersion401 | GetVersion500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVersionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Verify Token endpoint
 * @summary Fetch Verify Token
 */
export const getVerifyToken = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetVerifyToken200>(
      {url: `/verifyToken`, method: 'GET', signal
    },
      );
    }
  



export const getGetVerifyTokenQueryKey = () => {
    return [
    `/verifyToken`
    ] as const;
    }

    
export const getGetVerifyTokenQueryOptions = <TData = Awaited<ReturnType<typeof getVerifyToken>>, TError = GetVerifyToken400 | GetVerifyToken401 | GetVerifyToken500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifyToken>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVerifyTokenQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVerifyToken>>> = ({ signal }) => getVerifyToken(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVerifyToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVerifyTokenQueryResult = NonNullable<Awaited<ReturnType<typeof getVerifyToken>>>
export type GetVerifyTokenQueryError = GetVerifyToken400 | GetVerifyToken401 | GetVerifyToken500


export function useGetVerifyToken<TData = Awaited<ReturnType<typeof getVerifyToken>>, TError = GetVerifyToken400 | GetVerifyToken401 | GetVerifyToken500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifyToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerifyToken>>,
          TError,
          Awaited<ReturnType<typeof getVerifyToken>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVerifyToken<TData = Awaited<ReturnType<typeof getVerifyToken>>, TError = GetVerifyToken400 | GetVerifyToken401 | GetVerifyToken500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifyToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerifyToken>>,
          TError,
          Awaited<ReturnType<typeof getVerifyToken>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVerifyToken<TData = Awaited<ReturnType<typeof getVerifyToken>>, TError = GetVerifyToken400 | GetVerifyToken401 | GetVerifyToken500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifyToken>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Verify Token
 */

export function useGetVerifyToken<TData = Awaited<ReturnType<typeof getVerifyToken>>, TError = GetVerifyToken400 | GetVerifyToken401 | GetVerifyToken500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifyToken>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVerifyTokenQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update Users Entity Access Update endpoint
 * @summary Update Users Entity Access Update
 */
export const putUsersIdEntityAccess = (
    id: string,
 ) => {
      
      
      return customInstance<PutUsersIdEntityAccess200>(
      {url: `/users/${id}/entity-access`, method: 'PUT'
    },
      );
    }
  


export const getPutUsersIdEntityAccessMutationOptions = <TError = PutUsersIdEntityAccess400 | PutUsersIdEntityAccess401 | PutUsersIdEntityAccess500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUsersIdEntityAccess>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putUsersIdEntityAccess>>, TError,{id: string}, TContext> => {

const mutationKey = ['putUsersIdEntityAccess'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUsersIdEntityAccess>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  putUsersIdEntityAccess(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUsersIdEntityAccessMutationResult = NonNullable<Awaited<ReturnType<typeof putUsersIdEntityAccess>>>
    
    export type PutUsersIdEntityAccessMutationError = PutUsersIdEntityAccess400 | PutUsersIdEntityAccess401 | PutUsersIdEntityAccess500

    /**
 * @summary Update Users Entity Access Update
 */
export const usePutUsersIdEntityAccess = <TError = PutUsersIdEntityAccess400 | PutUsersIdEntityAccess401 | PutUsersIdEntityAccess500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUsersIdEntityAccess>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putUsersIdEntityAccess>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPutUsersIdEntityAccessMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Users Entity Access Get endpoint
 * @summary Fetch Users Entity Access Get
 */
export const getUsersIdEntityAccess = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetUsersIdEntityAccess200>(
      {url: `/users/${id}/entity-access`, method: 'GET', signal
    },
      );
    }
  



export const getGetUsersIdEntityAccessQueryKey = (id?: string,) => {
    return [
    `/users/${id}/entity-access`
    ] as const;
    }

    
export const getGetUsersIdEntityAccessQueryOptions = <TData = Awaited<ReturnType<typeof getUsersIdEntityAccess>>, TError = GetUsersIdEntityAccess400 | GetUsersIdEntityAccess401 | GetUsersIdEntityAccess500>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersIdEntityAccess>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersIdEntityAccessQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersIdEntityAccess>>> = ({ signal }) => getUsersIdEntityAccess(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsersIdEntityAccess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersIdEntityAccessQueryResult = NonNullable<Awaited<ReturnType<typeof getUsersIdEntityAccess>>>
export type GetUsersIdEntityAccessQueryError = GetUsersIdEntityAccess400 | GetUsersIdEntityAccess401 | GetUsersIdEntityAccess500


export function useGetUsersIdEntityAccess<TData = Awaited<ReturnType<typeof getUsersIdEntityAccess>>, TError = GetUsersIdEntityAccess400 | GetUsersIdEntityAccess401 | GetUsersIdEntityAccess500>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersIdEntityAccess>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersIdEntityAccess>>,
          TError,
          Awaited<ReturnType<typeof getUsersIdEntityAccess>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersIdEntityAccess<TData = Awaited<ReturnType<typeof getUsersIdEntityAccess>>, TError = GetUsersIdEntityAccess400 | GetUsersIdEntityAccess401 | GetUsersIdEntityAccess500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersIdEntityAccess>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersIdEntityAccess>>,
          TError,
          Awaited<ReturnType<typeof getUsersIdEntityAccess>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersIdEntityAccess<TData = Awaited<ReturnType<typeof getUsersIdEntityAccess>>, TError = GetUsersIdEntityAccess400 | GetUsersIdEntityAccess401 | GetUsersIdEntityAccess500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersIdEntityAccess>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Users Entity Access Get
 */

export function useGetUsersIdEntityAccess<TData = Awaited<ReturnType<typeof getUsersIdEntityAccess>>, TError = GetUsersIdEntityAccess400 | GetUsersIdEntityAccess401 | GetUsersIdEntityAccess500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersIdEntityAccess>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersIdEntityAccessQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Delete Users Entity Access Delete endpoint
 * @summary Delete Users Entity Access Delete
 */
export const deleteUsersIdEntityAccess = (
    id: string,
 ) => {
      
      
      return customInstance<DeleteUsersIdEntityAccess200>(
      {url: `/users/${id}/entity-access`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteUsersIdEntityAccessMutationOptions = <TError = DeleteUsersIdEntityAccess400 | DeleteUsersIdEntityAccess401 | DeleteUsersIdEntityAccess500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUsersIdEntityAccess>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteUsersIdEntityAccess>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteUsersIdEntityAccess'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUsersIdEntityAccess>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteUsersIdEntityAccess(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUsersIdEntityAccessMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUsersIdEntityAccess>>>
    
    export type DeleteUsersIdEntityAccessMutationError = DeleteUsersIdEntityAccess400 | DeleteUsersIdEntityAccess401 | DeleteUsersIdEntityAccess500

    /**
 * @summary Delete Users Entity Access Delete
 */
export const useDeleteUsersIdEntityAccess = <TError = DeleteUsersIdEntityAccess400 | DeleteUsersIdEntityAccess401 | DeleteUsersIdEntityAccess500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUsersIdEntityAccess>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUsersIdEntityAccess>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteUsersIdEntityAccessMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update Process Task Update endpoint
 * @summary Update Process Task Update
 */
export const putProcessesTasksId = (
    id: string,
 ) => {
      
      
      return customInstance<PutProcessesTasksId200>(
      {url: `/processes/tasks/${id}`, method: 'PUT'
    },
      );
    }
  


export const getPutProcessesTasksIdMutationOptions = <TError = PutProcessesTasksId400 | PutProcessesTasksId401 | PutProcessesTasksId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProcessesTasksId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putProcessesTasksId>>, TError,{id: string}, TContext> => {

const mutationKey = ['putProcessesTasksId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putProcessesTasksId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  putProcessesTasksId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutProcessesTasksIdMutationResult = NonNullable<Awaited<ReturnType<typeof putProcessesTasksId>>>
    
    export type PutProcessesTasksIdMutationError = PutProcessesTasksId400 | PutProcessesTasksId401 | PutProcessesTasksId500

    /**
 * @summary Update Process Task Update
 */
export const usePutProcessesTasksId = <TError = PutProcessesTasksId400 | PutProcessesTasksId401 | PutProcessesTasksId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProcessesTasksId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putProcessesTasksId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPutProcessesTasksIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update Process Task Update endpoint
 * @summary Update Process Task Update
 */
export const patchProcessesTasksId = (
    id: string,
 ) => {
      
      
      return customInstance<PatchProcessesTasksId200>(
      {url: `/processes/tasks/${id}`, method: 'PATCH'
    },
      );
    }
  


export const getPatchProcessesTasksIdMutationOptions = <TError = PatchProcessesTasksId400 | PatchProcessesTasksId401 | PatchProcessesTasksId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProcessesTasksId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchProcessesTasksId>>, TError,{id: string}, TContext> => {

const mutationKey = ['patchProcessesTasksId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchProcessesTasksId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  patchProcessesTasksId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchProcessesTasksIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchProcessesTasksId>>>
    
    export type PatchProcessesTasksIdMutationError = PatchProcessesTasksId400 | PatchProcessesTasksId401 | PatchProcessesTasksId500

    /**
 * @summary Update Process Task Update
 */
export const usePatchProcessesTasksId = <TError = PatchProcessesTasksId400 | PatchProcessesTasksId401 | PatchProcessesTasksId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProcessesTasksId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchProcessesTasksId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPatchProcessesTasksIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update Entities Shareholders Update endpoint
 * @summary Update Entities Shareholders Update
 */
export const putEntitiesShareholdersShareholderId = (
    shareholderId: string,
 ) => {
      
      
      return customInstance<PutEntitiesShareholdersShareholderId200>(
      {url: `/entities/shareholders/${shareholderId}`, method: 'PUT'
    },
      );
    }
  


export const getPutEntitiesShareholdersShareholderIdMutationOptions = <TError = PutEntitiesShareholdersShareholderId400 | PutEntitiesShareholdersShareholderId401 | PutEntitiesShareholdersShareholderId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEntitiesShareholdersShareholderId>>, TError,{shareholderId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putEntitiesShareholdersShareholderId>>, TError,{shareholderId: string}, TContext> => {

const mutationKey = ['putEntitiesShareholdersShareholderId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEntitiesShareholdersShareholderId>>, {shareholderId: string}> = (props) => {
          const {shareholderId} = props ?? {};

          return  putEntitiesShareholdersShareholderId(shareholderId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEntitiesShareholdersShareholderIdMutationResult = NonNullable<Awaited<ReturnType<typeof putEntitiesShareholdersShareholderId>>>
    
    export type PutEntitiesShareholdersShareholderIdMutationError = PutEntitiesShareholdersShareholderId400 | PutEntitiesShareholdersShareholderId401 | PutEntitiesShareholdersShareholderId500

    /**
 * @summary Update Entities Shareholders Update
 */
export const usePutEntitiesShareholdersShareholderId = <TError = PutEntitiesShareholdersShareholderId400 | PutEntitiesShareholdersShareholderId401 | PutEntitiesShareholdersShareholderId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEntitiesShareholdersShareholderId>>, TError,{shareholderId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEntitiesShareholdersShareholderId>>,
        TError,
        {shareholderId: string},
        TContext
      > => {

      const mutationOptions = getPutEntitiesShareholdersShareholderIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Entities Shareholders Get endpoint
 * @summary Fetch Entities Shareholders Get
 */
export const getEntitiesShareholdersShareholderId = (
    shareholderId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesShareholdersShareholderId200>(
      {url: `/entities/shareholders/${shareholderId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesShareholdersShareholderIdQueryKey = (shareholderId?: string,) => {
    return [
    `/entities/shareholders/${shareholderId}`
    ] as const;
    }

    
export const getGetEntitiesShareholdersShareholderIdQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesShareholdersShareholderId>>, TError = GetEntitiesShareholdersShareholderId400 | GetEntitiesShareholdersShareholderId401 | GetEntitiesShareholdersShareholderId500>(shareholderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesShareholdersShareholderIdQueryKey(shareholderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderId>>> = ({ signal }) => getEntitiesShareholdersShareholderId(shareholderId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(shareholderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesShareholdersShareholderIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderId>>>
export type GetEntitiesShareholdersShareholderIdQueryError = GetEntitiesShareholdersShareholderId400 | GetEntitiesShareholdersShareholderId401 | GetEntitiesShareholdersShareholderId500


export function useGetEntitiesShareholdersShareholderId<TData = Awaited<ReturnType<typeof getEntitiesShareholdersShareholderId>>, TError = GetEntitiesShareholdersShareholderId400 | GetEntitiesShareholdersShareholderId401 | GetEntitiesShareholdersShareholderId500>(
 shareholderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesShareholdersShareholderId>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesShareholdersShareholderId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesShareholdersShareholderId<TData = Awaited<ReturnType<typeof getEntitiesShareholdersShareholderId>>, TError = GetEntitiesShareholdersShareholderId400 | GetEntitiesShareholdersShareholderId401 | GetEntitiesShareholdersShareholderId500>(
 shareholderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesShareholdersShareholderId>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesShareholdersShareholderId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesShareholdersShareholderId<TData = Awaited<ReturnType<typeof getEntitiesShareholdersShareholderId>>, TError = GetEntitiesShareholdersShareholderId400 | GetEntitiesShareholdersShareholderId401 | GetEntitiesShareholdersShareholderId500>(
 shareholderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Entities Shareholders Get
 */

export function useGetEntitiesShareholdersShareholderId<TData = Awaited<ReturnType<typeof getEntitiesShareholdersShareholderId>>, TError = GetEntitiesShareholdersShareholderId400 | GetEntitiesShareholdersShareholderId401 | GetEntitiesShareholdersShareholderId500>(
 shareholderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesShareholdersShareholderIdQueryOptions(shareholderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Delete Entities Shareholders Delete endpoint
 * @summary Delete Entities Shareholders Delete
 */
export const deleteEntitiesShareholdersShareholderId = (
    shareholderId: string,
 ) => {
      
      
      return customInstance<DeleteEntitiesShareholdersShareholderId200>(
      {url: `/entities/shareholders/${shareholderId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteEntitiesShareholdersShareholderIdMutationOptions = <TError = DeleteEntitiesShareholdersShareholderId400 | DeleteEntitiesShareholdersShareholderId401 | DeleteEntitiesShareholdersShareholderId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEntitiesShareholdersShareholderId>>, TError,{shareholderId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteEntitiesShareholdersShareholderId>>, TError,{shareholderId: string}, TContext> => {

const mutationKey = ['deleteEntitiesShareholdersShareholderId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEntitiesShareholdersShareholderId>>, {shareholderId: string}> = (props) => {
          const {shareholderId} = props ?? {};

          return  deleteEntitiesShareholdersShareholderId(shareholderId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEntitiesShareholdersShareholderIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEntitiesShareholdersShareholderId>>>
    
    export type DeleteEntitiesShareholdersShareholderIdMutationError = DeleteEntitiesShareholdersShareholderId400 | DeleteEntitiesShareholdersShareholderId401 | DeleteEntitiesShareholdersShareholderId500

    /**
 * @summary Delete Entities Shareholders Delete
 */
export const useDeleteEntitiesShareholdersShareholderId = <TError = DeleteEntitiesShareholdersShareholderId400 | DeleteEntitiesShareholdersShareholderId401 | DeleteEntitiesShareholdersShareholderId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEntitiesShareholdersShareholderId>>, TError,{shareholderId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEntitiesShareholdersShareholderId>>,
        TError,
        {shareholderId: string},
        TContext
      > => {

      const mutationOptions = getDeleteEntitiesShareholdersShareholderIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update Entities Shareholders Registry Update endpoint
 * @summary Update Entities Shareholders Registry Update
 */
export const putEntitiesShareholdersRegistryRegistryId = (
    registryId: string,
 ) => {
      
      
      return customInstance<PutEntitiesShareholdersRegistryRegistryId200>(
      {url: `/entities/shareholders/registry/${registryId}`, method: 'PUT'
    },
      );
    }
  


export const getPutEntitiesShareholdersRegistryRegistryIdMutationOptions = <TError = PutEntitiesShareholdersRegistryRegistryId400 | PutEntitiesShareholdersRegistryRegistryId401 | PutEntitiesShareholdersRegistryRegistryId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEntitiesShareholdersRegistryRegistryId>>, TError,{registryId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putEntitiesShareholdersRegistryRegistryId>>, TError,{registryId: string}, TContext> => {

const mutationKey = ['putEntitiesShareholdersRegistryRegistryId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEntitiesShareholdersRegistryRegistryId>>, {registryId: string}> = (props) => {
          const {registryId} = props ?? {};

          return  putEntitiesShareholdersRegistryRegistryId(registryId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEntitiesShareholdersRegistryRegistryIdMutationResult = NonNullable<Awaited<ReturnType<typeof putEntitiesShareholdersRegistryRegistryId>>>
    
    export type PutEntitiesShareholdersRegistryRegistryIdMutationError = PutEntitiesShareholdersRegistryRegistryId400 | PutEntitiesShareholdersRegistryRegistryId401 | PutEntitiesShareholdersRegistryRegistryId500

    /**
 * @summary Update Entities Shareholders Registry Update
 */
export const usePutEntitiesShareholdersRegistryRegistryId = <TError = PutEntitiesShareholdersRegistryRegistryId400 | PutEntitiesShareholdersRegistryRegistryId401 | PutEntitiesShareholdersRegistryRegistryId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEntitiesShareholdersRegistryRegistryId>>, TError,{registryId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEntitiesShareholdersRegistryRegistryId>>,
        TError,
        {registryId: string},
        TContext
      > => {

      const mutationOptions = getPutEntitiesShareholdersRegistryRegistryIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete Delete Shareholder Transaction endpoint
 * @summary Delete Delete Shareholder Transaction
 */
export const deleteEntitiesShareholdersRegistryRegistryId = (
    registryId: string,
 ) => {
      
      
      return customInstance<DeleteEntitiesShareholdersRegistryRegistryId200>(
      {url: `/entities/shareholders/registry/${registryId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteEntitiesShareholdersRegistryRegistryIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEntitiesShareholdersRegistryRegistryId>>, TError,{registryId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteEntitiesShareholdersRegistryRegistryId>>, TError,{registryId: string}, TContext> => {

const mutationKey = ['deleteEntitiesShareholdersRegistryRegistryId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEntitiesShareholdersRegistryRegistryId>>, {registryId: string}> = (props) => {
          const {registryId} = props ?? {};

          return  deleteEntitiesShareholdersRegistryRegistryId(registryId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEntitiesShareholdersRegistryRegistryIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEntitiesShareholdersRegistryRegistryId>>>
    
    export type DeleteEntitiesShareholdersRegistryRegistryIdMutationError = unknown

    /**
 * @summary Delete Delete Shareholder Transaction
 */
export const useDeleteEntitiesShareholdersRegistryRegistryId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEntitiesShareholdersRegistryRegistryId>>, TError,{registryId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEntitiesShareholdersRegistryRegistryId>>,
        TError,
        {registryId: string},
        TContext
      > => {

      const mutationOptions = getDeleteEntitiesShareholdersRegistryRegistryIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update Requests Status Update endpoint
 * @summary Update Requests Status Update
 */
export const putRequestsIdStatus = (
    id: string,
 ) => {
      
      
      return customInstance<PutRequestsIdStatus200>(
      {url: `/requests/${id}/status`, method: 'PUT'
    },
      );
    }
  


export const getPutRequestsIdStatusMutationOptions = <TError = PutRequestsIdStatus400 | PutRequestsIdStatus401 | PutRequestsIdStatus500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putRequestsIdStatus>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putRequestsIdStatus>>, TError,{id: string}, TContext> => {

const mutationKey = ['putRequestsIdStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putRequestsIdStatus>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  putRequestsIdStatus(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutRequestsIdStatusMutationResult = NonNullable<Awaited<ReturnType<typeof putRequestsIdStatus>>>
    
    export type PutRequestsIdStatusMutationError = PutRequestsIdStatus400 | PutRequestsIdStatus401 | PutRequestsIdStatus500

    /**
 * @summary Update Requests Status Update
 */
export const usePutRequestsIdStatus = <TError = PutRequestsIdStatus400 | PutRequestsIdStatus401 | PutRequestsIdStatus500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putRequestsIdStatus>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putRequestsIdStatus>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPutRequestsIdStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update Personnel Update endpoint
 * @summary Update Personnel Update
 */
export const putPersonnelUpdateId = (
    id: string,
 ) => {
      
      
      return customInstance<PutPersonnelUpdateId200>(
      {url: `/personnel/update/${id}`, method: 'PUT'
    },
      );
    }
  


export const getPutPersonnelUpdateIdMutationOptions = <TError = PutPersonnelUpdateId400 | PutPersonnelUpdateId401 | PutPersonnelUpdateId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPersonnelUpdateId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putPersonnelUpdateId>>, TError,{id: string}, TContext> => {

const mutationKey = ['putPersonnelUpdateId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPersonnelUpdateId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  putPersonnelUpdateId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPersonnelUpdateIdMutationResult = NonNullable<Awaited<ReturnType<typeof putPersonnelUpdateId>>>
    
    export type PutPersonnelUpdateIdMutationError = PutPersonnelUpdateId400 | PutPersonnelUpdateId401 | PutPersonnelUpdateId500

    /**
 * @summary Update Personnel Update
 */
export const usePutPersonnelUpdateId = <TError = PutPersonnelUpdateId400 | PutPersonnelUpdateId401 | PutPersonnelUpdateId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPersonnelUpdateId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPersonnelUpdateId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPutPersonnelUpdateIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update Update Payslip Matching Results endpoint
 * @summary Update Update Payslip Matching Results
 */
export const patchPayslipMatchingResults = (
    
 ) => {
      
      
      return customInstance<PatchPayslipMatchingResults200>(
      {url: `/payslip/matching-results`, method: 'PATCH'
    },
      );
    }
  


export const getPatchPayslipMatchingResultsMutationOptions = <TError = PatchPayslipMatchingResults400 | PatchPayslipMatchingResults401 | PatchPayslipMatchingResults500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPayslipMatchingResults>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchPayslipMatchingResults>>, TError,void, TContext> => {

const mutationKey = ['patchPayslipMatchingResults'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchPayslipMatchingResults>>, void> = () => {
          

          return  patchPayslipMatchingResults()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchPayslipMatchingResultsMutationResult = NonNullable<Awaited<ReturnType<typeof patchPayslipMatchingResults>>>
    
    export type PatchPayslipMatchingResultsMutationError = PatchPayslipMatchingResults400 | PatchPayslipMatchingResults401 | PatchPayslipMatchingResults500

    /**
 * @summary Update Update Payslip Matching Results
 */
export const usePatchPayslipMatchingResults = <TError = PatchPayslipMatchingResults400 | PatchPayslipMatchingResults401 | PatchPayslipMatchingResults500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPayslipMatchingResults>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchPayslipMatchingResults>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPatchPayslipMatchingResultsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update Update Payslip Matching Result endpoint
 * @summary Update Update Payslip Matching Result
 */
export const patchPayslipMatchingResultId = (
    id: string,
 ) => {
      
      
      return customInstance<PatchPayslipMatchingResultId200>(
      {url: `/payslip-matching-result/${id}`, method: 'PATCH'
    },
      );
    }
  


export const getPatchPayslipMatchingResultIdMutationOptions = <TError = PatchPayslipMatchingResultId400 | PatchPayslipMatchingResultId401 | PatchPayslipMatchingResultId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPayslipMatchingResultId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchPayslipMatchingResultId>>, TError,{id: string}, TContext> => {

const mutationKey = ['patchPayslipMatchingResultId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchPayslipMatchingResultId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  patchPayslipMatchingResultId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchPayslipMatchingResultIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchPayslipMatchingResultId>>>
    
    export type PatchPayslipMatchingResultIdMutationError = PatchPayslipMatchingResultId400 | PatchPayslipMatchingResultId401 | PatchPayslipMatchingResultId500

    /**
 * @summary Update Update Payslip Matching Result
 */
export const usePatchPayslipMatchingResultId = <TError = PatchPayslipMatchingResultId400 | PatchPayslipMatchingResultId401 | PatchPayslipMatchingResultId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPayslipMatchingResultId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchPayslipMatchingResultId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPatchPayslipMatchingResultIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update Update Officer endpoint
 * @summary Update Update Officer
 */
export const putEntitiesOfficersOfficerId = (
    officerId: string,
 ) => {
      
      
      return customInstance<PutEntitiesOfficersOfficerId200>(
      {url: `/entities/officers/${officerId}`, method: 'PUT'
    },
      );
    }
  


export const getPutEntitiesOfficersOfficerIdMutationOptions = <TError = PutEntitiesOfficersOfficerId400 | PutEntitiesOfficersOfficerId401 | PutEntitiesOfficersOfficerId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEntitiesOfficersOfficerId>>, TError,{officerId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putEntitiesOfficersOfficerId>>, TError,{officerId: string}, TContext> => {

const mutationKey = ['putEntitiesOfficersOfficerId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEntitiesOfficersOfficerId>>, {officerId: string}> = (props) => {
          const {officerId} = props ?? {};

          return  putEntitiesOfficersOfficerId(officerId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEntitiesOfficersOfficerIdMutationResult = NonNullable<Awaited<ReturnType<typeof putEntitiesOfficersOfficerId>>>
    
    export type PutEntitiesOfficersOfficerIdMutationError = PutEntitiesOfficersOfficerId400 | PutEntitiesOfficersOfficerId401 | PutEntitiesOfficersOfficerId500

    /**
 * @summary Update Update Officer
 */
export const usePutEntitiesOfficersOfficerId = <TError = PutEntitiesOfficersOfficerId400 | PutEntitiesOfficersOfficerId401 | PutEntitiesOfficersOfficerId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEntitiesOfficersOfficerId>>, TError,{officerId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEntitiesOfficersOfficerId>>,
        TError,
        {officerId: string},
        TContext
      > => {

      const mutationOptions = getPutEntitiesOfficersOfficerIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Fetch Officer endpoint
 * @summary Fetch Fetch Officer
 */
export const getEntitiesOfficersOfficerId = (
    officerId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesOfficersOfficerId200>(
      {url: `/entities/officers/${officerId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesOfficersOfficerIdQueryKey = (officerId?: string,) => {
    return [
    `/entities/officers/${officerId}`
    ] as const;
    }

    
export const getGetEntitiesOfficersOfficerIdQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesOfficersOfficerId>>, TError = GetEntitiesOfficersOfficerId400 | GetEntitiesOfficersOfficerId401 | GetEntitiesOfficersOfficerId500>(officerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesOfficersOfficerId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesOfficersOfficerIdQueryKey(officerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesOfficersOfficerId>>> = ({ signal }) => getEntitiesOfficersOfficerId(officerId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(officerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesOfficersOfficerId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesOfficersOfficerIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesOfficersOfficerId>>>
export type GetEntitiesOfficersOfficerIdQueryError = GetEntitiesOfficersOfficerId400 | GetEntitiesOfficersOfficerId401 | GetEntitiesOfficersOfficerId500


export function useGetEntitiesOfficersOfficerId<TData = Awaited<ReturnType<typeof getEntitiesOfficersOfficerId>>, TError = GetEntitiesOfficersOfficerId400 | GetEntitiesOfficersOfficerId401 | GetEntitiesOfficersOfficerId500>(
 officerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesOfficersOfficerId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesOfficersOfficerId>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesOfficersOfficerId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesOfficersOfficerId<TData = Awaited<ReturnType<typeof getEntitiesOfficersOfficerId>>, TError = GetEntitiesOfficersOfficerId400 | GetEntitiesOfficersOfficerId401 | GetEntitiesOfficersOfficerId500>(
 officerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesOfficersOfficerId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesOfficersOfficerId>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesOfficersOfficerId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesOfficersOfficerId<TData = Awaited<ReturnType<typeof getEntitiesOfficersOfficerId>>, TError = GetEntitiesOfficersOfficerId400 | GetEntitiesOfficersOfficerId401 | GetEntitiesOfficersOfficerId500>(
 officerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesOfficersOfficerId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Fetch Officer
 */

export function useGetEntitiesOfficersOfficerId<TData = Awaited<ReturnType<typeof getEntitiesOfficersOfficerId>>, TError = GetEntitiesOfficersOfficerId400 | GetEntitiesOfficersOfficerId401 | GetEntitiesOfficersOfficerId500>(
 officerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesOfficersOfficerId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesOfficersOfficerIdQueryOptions(officerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update Lsp Update endpoint
 * @summary Update Lsp Update
 */
export const putLspId = (
    id: string,
 ) => {
      
      
      return customInstance<PutLspId200>(
      {url: `/lsp/${id}`, method: 'PUT'
    },
      );
    }
  


export const getPutLspIdMutationOptions = <TError = PutLspId400 | PutLspId401 | PutLspId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putLspId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putLspId>>, TError,{id: string}, TContext> => {

const mutationKey = ['putLspId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putLspId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  putLspId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutLspIdMutationResult = NonNullable<Awaited<ReturnType<typeof putLspId>>>
    
    export type PutLspIdMutationError = PutLspId400 | PutLspId401 | PutLspId500

    /**
 * @summary Update Lsp Update
 */
export const usePutLspId = <TError = PutLspId400 | PutLspId401 | PutLspId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putLspId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putLspId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPutLspIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Lsp endpoint
 * @summary Fetch Lsp
 */
export const getLspId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetLspId200>(
      {url: `/lsp/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetLspIdQueryKey = (id?: string,) => {
    return [
    `/lsp/${id}`
    ] as const;
    }

    
export const getGetLspIdQueryOptions = <TData = Awaited<ReturnType<typeof getLspId>>, TError = GetLspId400 | GetLspId401 | GetLspId500>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLspId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLspIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLspId>>> = ({ signal }) => getLspId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLspId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLspIdQueryResult = NonNullable<Awaited<ReturnType<typeof getLspId>>>
export type GetLspIdQueryError = GetLspId400 | GetLspId401 | GetLspId500


export function useGetLspId<TData = Awaited<ReturnType<typeof getLspId>>, TError = GetLspId400 | GetLspId401 | GetLspId500>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLspId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLspId>>,
          TError,
          Awaited<ReturnType<typeof getLspId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLspId<TData = Awaited<ReturnType<typeof getLspId>>, TError = GetLspId400 | GetLspId401 | GetLspId500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLspId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLspId>>,
          TError,
          Awaited<ReturnType<typeof getLspId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLspId<TData = Awaited<ReturnType<typeof getLspId>>, TError = GetLspId400 | GetLspId401 | GetLspId500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLspId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Lsp
 */

export function useGetLspId<TData = Awaited<ReturnType<typeof getLspId>>, TError = GetLspId400 | GetLspId401 | GetLspId500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLspId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLspIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update Update Entity Plus Config endpoint
 * @summary Update Update Entity Plus Config
 */
export const putEntitiesIdPlusConfig = (
    id: string,
 ) => {
      
      
      return customInstance<PutEntitiesIdPlusConfig200>(
      {url: `/entities/${id}/plus-config`, method: 'PUT'
    },
      );
    }
  


export const getPutEntitiesIdPlusConfigMutationOptions = <TError = PutEntitiesIdPlusConfig400 | PutEntitiesIdPlusConfig401 | PutEntitiesIdPlusConfig500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEntitiesIdPlusConfig>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putEntitiesIdPlusConfig>>, TError,{id: string}, TContext> => {

const mutationKey = ['putEntitiesIdPlusConfig'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEntitiesIdPlusConfig>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  putEntitiesIdPlusConfig(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEntitiesIdPlusConfigMutationResult = NonNullable<Awaited<ReturnType<typeof putEntitiesIdPlusConfig>>>
    
    export type PutEntitiesIdPlusConfigMutationError = PutEntitiesIdPlusConfig400 | PutEntitiesIdPlusConfig401 | PutEntitiesIdPlusConfig500

    /**
 * @summary Update Update Entity Plus Config
 */
export const usePutEntitiesIdPlusConfig = <TError = PutEntitiesIdPlusConfig400 | PutEntitiesIdPlusConfig401 | PutEntitiesIdPlusConfig500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEntitiesIdPlusConfig>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEntitiesIdPlusConfig>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPutEntitiesIdPlusConfigMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update Entities Employee Update endpoint
 * @summary Update Entities Employee Update
 */
export const putEntitiesEmployeeEmployeeId = (
    employeeId: string,
 ) => {
      
      
      return customInstance<PutEntitiesEmployeeEmployeeId200>(
      {url: `/entities/employee/${employeeId}`, method: 'PUT'
    },
      );
    }
  


export const getPutEntitiesEmployeeEmployeeIdMutationOptions = <TError = PutEntitiesEmployeeEmployeeId400 | PutEntitiesEmployeeEmployeeId401 | PutEntitiesEmployeeEmployeeId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEntitiesEmployeeEmployeeId>>, TError,{employeeId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putEntitiesEmployeeEmployeeId>>, TError,{employeeId: string}, TContext> => {

const mutationKey = ['putEntitiesEmployeeEmployeeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEntitiesEmployeeEmployeeId>>, {employeeId: string}> = (props) => {
          const {employeeId} = props ?? {};

          return  putEntitiesEmployeeEmployeeId(employeeId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEntitiesEmployeeEmployeeIdMutationResult = NonNullable<Awaited<ReturnType<typeof putEntitiesEmployeeEmployeeId>>>
    
    export type PutEntitiesEmployeeEmployeeIdMutationError = PutEntitiesEmployeeEmployeeId400 | PutEntitiesEmployeeEmployeeId401 | PutEntitiesEmployeeEmployeeId500

    /**
 * @summary Update Entities Employee Update
 */
export const usePutEntitiesEmployeeEmployeeId = <TError = PutEntitiesEmployeeEmployeeId400 | PutEntitiesEmployeeEmployeeId401 | PutEntitiesEmployeeEmployeeId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEntitiesEmployeeEmployeeId>>, TError,{employeeId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEntitiesEmployeeEmployeeId>>,
        TError,
        {employeeId: string},
        TContext
      > => {

      const mutationOptions = getPutEntitiesEmployeeEmployeeIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Entities Employee endpoint
 * @summary Fetch Entities Employee
 */
export const getEntitiesEmployeeEmployeeId = (
    employeeId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesEmployeeEmployeeId200>(
      {url: `/entities/employee/${employeeId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesEmployeeEmployeeIdQueryKey = (employeeId?: string,) => {
    return [
    `/entities/employee/${employeeId}`
    ] as const;
    }

    
export const getGetEntitiesEmployeeEmployeeIdQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesEmployeeEmployeeId>>, TError = GetEntitiesEmployeeEmployeeId400 | GetEntitiesEmployeeEmployeeId401 | GetEntitiesEmployeeEmployeeId500>(employeeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEmployeeEmployeeId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesEmployeeEmployeeIdQueryKey(employeeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesEmployeeEmployeeId>>> = ({ signal }) => getEntitiesEmployeeEmployeeId(employeeId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(employeeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEmployeeEmployeeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesEmployeeEmployeeIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesEmployeeEmployeeId>>>
export type GetEntitiesEmployeeEmployeeIdQueryError = GetEntitiesEmployeeEmployeeId400 | GetEntitiesEmployeeEmployeeId401 | GetEntitiesEmployeeEmployeeId500


export function useGetEntitiesEmployeeEmployeeId<TData = Awaited<ReturnType<typeof getEntitiesEmployeeEmployeeId>>, TError = GetEntitiesEmployeeEmployeeId400 | GetEntitiesEmployeeEmployeeId401 | GetEntitiesEmployeeEmployeeId500>(
 employeeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEmployeeEmployeeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesEmployeeEmployeeId>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesEmployeeEmployeeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesEmployeeEmployeeId<TData = Awaited<ReturnType<typeof getEntitiesEmployeeEmployeeId>>, TError = GetEntitiesEmployeeEmployeeId400 | GetEntitiesEmployeeEmployeeId401 | GetEntitiesEmployeeEmployeeId500>(
 employeeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEmployeeEmployeeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesEmployeeEmployeeId>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesEmployeeEmployeeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesEmployeeEmployeeId<TData = Awaited<ReturnType<typeof getEntitiesEmployeeEmployeeId>>, TError = GetEntitiesEmployeeEmployeeId400 | GetEntitiesEmployeeEmployeeId401 | GetEntitiesEmployeeEmployeeId500>(
 employeeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEmployeeEmployeeId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Entities Employee
 */

export function useGetEntitiesEmployeeEmployeeId<TData = Awaited<ReturnType<typeof getEntitiesEmployeeEmployeeId>>, TError = GetEntitiesEmployeeEmployeeId400 | GetEntitiesEmployeeEmployeeId401 | GetEntitiesEmployeeEmployeeId500>(
 employeeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEmployeeEmployeeId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesEmployeeEmployeeIdQueryOptions(employeeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Delete Delete Employee endpoint
 * @summary Delete Delete Employee
 */
export const deleteEntitiesEmployeeEmployeeId = (
    employeeId: string,
 ) => {
      
      
      return customInstance<DeleteEntitiesEmployeeEmployeeId200>(
      {url: `/entities/employee/${employeeId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteEntitiesEmployeeEmployeeIdMutationOptions = <TError = DeleteEntitiesEmployeeEmployeeId400 | DeleteEntitiesEmployeeEmployeeId401 | DeleteEntitiesEmployeeEmployeeId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEntitiesEmployeeEmployeeId>>, TError,{employeeId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteEntitiesEmployeeEmployeeId>>, TError,{employeeId: string}, TContext> => {

const mutationKey = ['deleteEntitiesEmployeeEmployeeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEntitiesEmployeeEmployeeId>>, {employeeId: string}> = (props) => {
          const {employeeId} = props ?? {};

          return  deleteEntitiesEmployeeEmployeeId(employeeId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEntitiesEmployeeEmployeeIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEntitiesEmployeeEmployeeId>>>
    
    export type DeleteEntitiesEmployeeEmployeeIdMutationError = DeleteEntitiesEmployeeEmployeeId400 | DeleteEntitiesEmployeeEmployeeId401 | DeleteEntitiesEmployeeEmployeeId500

    /**
 * @summary Delete Delete Employee
 */
export const useDeleteEntitiesEmployeeEmployeeId = <TError = DeleteEntitiesEmployeeEmployeeId400 | DeleteEntitiesEmployeeEmployeeId401 | DeleteEntitiesEmployeeEmployeeId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEntitiesEmployeeEmployeeId>>, TError,{employeeId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEntitiesEmployeeEmployeeId>>,
        TError,
        {employeeId: string},
        TContext
      > => {

      const mutationOptions = getDeleteEntitiesEmployeeEmployeeIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update Update Director endpoint
 * @summary Update Update Director
 */
export const putEntitiesDirectorsDirectorId = (
    directorId: string,
 ) => {
      
      
      return customInstance<PutEntitiesDirectorsDirectorId200>(
      {url: `/entities/directors/${directorId}`, method: 'PUT'
    },
      );
    }
  


export const getPutEntitiesDirectorsDirectorIdMutationOptions = <TError = PutEntitiesDirectorsDirectorId400 | PutEntitiesDirectorsDirectorId401 | PutEntitiesDirectorsDirectorId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEntitiesDirectorsDirectorId>>, TError,{directorId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putEntitiesDirectorsDirectorId>>, TError,{directorId: string}, TContext> => {

const mutationKey = ['putEntitiesDirectorsDirectorId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEntitiesDirectorsDirectorId>>, {directorId: string}> = (props) => {
          const {directorId} = props ?? {};

          return  putEntitiesDirectorsDirectorId(directorId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEntitiesDirectorsDirectorIdMutationResult = NonNullable<Awaited<ReturnType<typeof putEntitiesDirectorsDirectorId>>>
    
    export type PutEntitiesDirectorsDirectorIdMutationError = PutEntitiesDirectorsDirectorId400 | PutEntitiesDirectorsDirectorId401 | PutEntitiesDirectorsDirectorId500

    /**
 * @summary Update Update Director
 */
export const usePutEntitiesDirectorsDirectorId = <TError = PutEntitiesDirectorsDirectorId400 | PutEntitiesDirectorsDirectorId401 | PutEntitiesDirectorsDirectorId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEntitiesDirectorsDirectorId>>, TError,{directorId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEntitiesDirectorsDirectorId>>,
        TError,
        {directorId: string},
        TContext
      > => {

      const mutationOptions = getPutEntitiesDirectorsDirectorIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Fetch Director endpoint
 * @summary Fetch Fetch Director
 */
export const getEntitiesDirectorsDirectorId = (
    directorId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesDirectorsDirectorId200>(
      {url: `/entities/directors/${directorId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesDirectorsDirectorIdQueryKey = (directorId?: string,) => {
    return [
    `/entities/directors/${directorId}`
    ] as const;
    }

    
export const getGetEntitiesDirectorsDirectorIdQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesDirectorsDirectorId>>, TError = GetEntitiesDirectorsDirectorId400 | GetEntitiesDirectorsDirectorId401 | GetEntitiesDirectorsDirectorId500>(directorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesDirectorsDirectorId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesDirectorsDirectorIdQueryKey(directorId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesDirectorsDirectorId>>> = ({ signal }) => getEntitiesDirectorsDirectorId(directorId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(directorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesDirectorsDirectorId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesDirectorsDirectorIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesDirectorsDirectorId>>>
export type GetEntitiesDirectorsDirectorIdQueryError = GetEntitiesDirectorsDirectorId400 | GetEntitiesDirectorsDirectorId401 | GetEntitiesDirectorsDirectorId500


export function useGetEntitiesDirectorsDirectorId<TData = Awaited<ReturnType<typeof getEntitiesDirectorsDirectorId>>, TError = GetEntitiesDirectorsDirectorId400 | GetEntitiesDirectorsDirectorId401 | GetEntitiesDirectorsDirectorId500>(
 directorId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesDirectorsDirectorId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesDirectorsDirectorId>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesDirectorsDirectorId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesDirectorsDirectorId<TData = Awaited<ReturnType<typeof getEntitiesDirectorsDirectorId>>, TError = GetEntitiesDirectorsDirectorId400 | GetEntitiesDirectorsDirectorId401 | GetEntitiesDirectorsDirectorId500>(
 directorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesDirectorsDirectorId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesDirectorsDirectorId>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesDirectorsDirectorId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesDirectorsDirectorId<TData = Awaited<ReturnType<typeof getEntitiesDirectorsDirectorId>>, TError = GetEntitiesDirectorsDirectorId400 | GetEntitiesDirectorsDirectorId401 | GetEntitiesDirectorsDirectorId500>(
 directorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesDirectorsDirectorId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Fetch Director
 */

export function useGetEntitiesDirectorsDirectorId<TData = Awaited<ReturnType<typeof getEntitiesDirectorsDirectorId>>, TError = GetEntitiesDirectorsDirectorId400 | GetEntitiesDirectorsDirectorId401 | GetEntitiesDirectorsDirectorId500>(
 directorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesDirectorsDirectorId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesDirectorsDirectorIdQueryOptions(directorId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Delete Delete Director endpoint
 * @summary Delete Delete Director
 */
export const deleteEntitiesDirectorsDirectorId = (
    directorId: string,
 ) => {
      
      
      return customInstance<DeleteEntitiesDirectorsDirectorId200>(
      {url: `/entities/directors/${directorId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteEntitiesDirectorsDirectorIdMutationOptions = <TError = DeleteEntitiesDirectorsDirectorId400 | DeleteEntitiesDirectorsDirectorId401 | DeleteEntitiesDirectorsDirectorId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEntitiesDirectorsDirectorId>>, TError,{directorId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteEntitiesDirectorsDirectorId>>, TError,{directorId: string}, TContext> => {

const mutationKey = ['deleteEntitiesDirectorsDirectorId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEntitiesDirectorsDirectorId>>, {directorId: string}> = (props) => {
          const {directorId} = props ?? {};

          return  deleteEntitiesDirectorsDirectorId(directorId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEntitiesDirectorsDirectorIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEntitiesDirectorsDirectorId>>>
    
    export type DeleteEntitiesDirectorsDirectorIdMutationError = DeleteEntitiesDirectorsDirectorId400 | DeleteEntitiesDirectorsDirectorId401 | DeleteEntitiesDirectorsDirectorId500

    /**
 * @summary Delete Delete Director
 */
export const useDeleteEntitiesDirectorsDirectorId = <TError = DeleteEntitiesDirectorsDirectorId400 | DeleteEntitiesDirectorsDirectorId401 | DeleteEntitiesDirectorsDirectorId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEntitiesDirectorsDirectorId>>, TError,{directorId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEntitiesDirectorsDirectorId>>,
        TError,
        {directorId: string},
        TContext
      > => {

      const mutationOptions = getDeleteEntitiesDirectorsDirectorIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update Update Director Appointment endpoint
 * @summary Update Update Director Appointment
 */
export const putEntitiesDirectorsDirectorIdAppointmentsAppointmentId = (
    directorId: string,
    appointmentId: string,
 ) => {
      
      
      return customInstance<PutEntitiesDirectorsDirectorIdAppointmentsAppointmentId200>(
      {url: `/entities/directors/${directorId}/appointments/${appointmentId}`, method: 'PUT'
    },
      );
    }
  


export const getPutEntitiesDirectorsDirectorIdAppointmentsAppointmentIdMutationOptions = <TError = PutEntitiesDirectorsDirectorIdAppointmentsAppointmentId400 | PutEntitiesDirectorsDirectorIdAppointmentsAppointmentId401 | PutEntitiesDirectorsDirectorIdAppointmentsAppointmentId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>, TError,{directorId: string;appointmentId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>, TError,{directorId: string;appointmentId: string}, TContext> => {

const mutationKey = ['putEntitiesDirectorsDirectorIdAppointmentsAppointmentId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>, {directorId: string;appointmentId: string}> = (props) => {
          const {directorId,appointmentId} = props ?? {};

          return  putEntitiesDirectorsDirectorIdAppointmentsAppointmentId(directorId,appointmentId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEntitiesDirectorsDirectorIdAppointmentsAppointmentIdMutationResult = NonNullable<Awaited<ReturnType<typeof putEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>>
    
    export type PutEntitiesDirectorsDirectorIdAppointmentsAppointmentIdMutationError = PutEntitiesDirectorsDirectorIdAppointmentsAppointmentId400 | PutEntitiesDirectorsDirectorIdAppointmentsAppointmentId401 | PutEntitiesDirectorsDirectorIdAppointmentsAppointmentId500

    /**
 * @summary Update Update Director Appointment
 */
export const usePutEntitiesDirectorsDirectorIdAppointmentsAppointmentId = <TError = PutEntitiesDirectorsDirectorIdAppointmentsAppointmentId400 | PutEntitiesDirectorsDirectorIdAppointmentsAppointmentId401 | PutEntitiesDirectorsDirectorIdAppointmentsAppointmentId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>, TError,{directorId: string;appointmentId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>,
        TError,
        {directorId: string;appointmentId: string},
        TContext
      > => {

      const mutationOptions = getPutEntitiesDirectorsDirectorIdAppointmentsAppointmentIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Fetch Director Appointment endpoint
 * @summary Fetch Fetch Director Appointment
 */
export const getEntitiesDirectorsDirectorIdAppointmentsAppointmentId = (
    directorId: string,
    appointmentId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesDirectorsDirectorIdAppointmentsAppointmentId200>(
      {url: `/entities/directors/${directorId}/appointments/${appointmentId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesDirectorsDirectorIdAppointmentsAppointmentIdQueryKey = (directorId?: string,
    appointmentId?: string,) => {
    return [
    `/entities/directors/${directorId}/appointments/${appointmentId}`
    ] as const;
    }

    
export const getGetEntitiesDirectorsDirectorIdAppointmentsAppointmentIdQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>, TError = GetEntitiesDirectorsDirectorIdAppointmentsAppointmentId400 | GetEntitiesDirectorsDirectorIdAppointmentsAppointmentId401 | GetEntitiesDirectorsDirectorIdAppointmentsAppointmentId500>(directorId: string,
    appointmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesDirectorsDirectorIdAppointmentsAppointmentIdQueryKey(directorId,appointmentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>> = ({ signal }) => getEntitiesDirectorsDirectorIdAppointmentsAppointmentId(directorId,appointmentId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(directorId && appointmentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesDirectorsDirectorIdAppointmentsAppointmentIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>>
export type GetEntitiesDirectorsDirectorIdAppointmentsAppointmentIdQueryError = GetEntitiesDirectorsDirectorIdAppointmentsAppointmentId400 | GetEntitiesDirectorsDirectorIdAppointmentsAppointmentId401 | GetEntitiesDirectorsDirectorIdAppointmentsAppointmentId500


export function useGetEntitiesDirectorsDirectorIdAppointmentsAppointmentId<TData = Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>, TError = GetEntitiesDirectorsDirectorIdAppointmentsAppointmentId400 | GetEntitiesDirectorsDirectorIdAppointmentsAppointmentId401 | GetEntitiesDirectorsDirectorIdAppointmentsAppointmentId500>(
 directorId: string,
    appointmentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesDirectorsDirectorIdAppointmentsAppointmentId<TData = Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>, TError = GetEntitiesDirectorsDirectorIdAppointmentsAppointmentId400 | GetEntitiesDirectorsDirectorIdAppointmentsAppointmentId401 | GetEntitiesDirectorsDirectorIdAppointmentsAppointmentId500>(
 directorId: string,
    appointmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesDirectorsDirectorIdAppointmentsAppointmentId<TData = Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>, TError = GetEntitiesDirectorsDirectorIdAppointmentsAppointmentId400 | GetEntitiesDirectorsDirectorIdAppointmentsAppointmentId401 | GetEntitiesDirectorsDirectorIdAppointmentsAppointmentId500>(
 directorId: string,
    appointmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Fetch Director Appointment
 */

export function useGetEntitiesDirectorsDirectorIdAppointmentsAppointmentId<TData = Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>, TError = GetEntitiesDirectorsDirectorIdAppointmentsAppointmentId400 | GetEntitiesDirectorsDirectorIdAppointmentsAppointmentId401 | GetEntitiesDirectorsDirectorIdAppointmentsAppointmentId500>(
 directorId: string,
    appointmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesDirectorsDirectorIdAppointmentsAppointmentIdQueryOptions(directorId,appointmentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Delete Delete Director Appointment endpoint
 * @summary Delete Delete Director Appointment
 */
export const deleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId = (
    directorId: string,
    appointmentId: string,
 ) => {
      
      
      return customInstance<DeleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId200>(
      {url: `/entities/directors/${directorId}/appointments/${appointmentId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteEntitiesDirectorsDirectorIdAppointmentsAppointmentIdMutationOptions = <TError = DeleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId400 | DeleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId401 | DeleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>, TError,{directorId: string;appointmentId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>, TError,{directorId: string;appointmentId: string}, TContext> => {

const mutationKey = ['deleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>, {directorId: string;appointmentId: string}> = (props) => {
          const {directorId,appointmentId} = props ?? {};

          return  deleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId(directorId,appointmentId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEntitiesDirectorsDirectorIdAppointmentsAppointmentIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>>
    
    export type DeleteEntitiesDirectorsDirectorIdAppointmentsAppointmentIdMutationError = DeleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId400 | DeleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId401 | DeleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId500

    /**
 * @summary Delete Delete Director Appointment
 */
export const useDeleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId = <TError = DeleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId400 | DeleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId401 | DeleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>, TError,{directorId: string;appointmentId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEntitiesDirectorsDirectorIdAppointmentsAppointmentId>>,
        TError,
        {directorId: string;appointmentId: string},
        TContext
      > => {

      const mutationOptions = getDeleteEntitiesDirectorsDirectorIdAppointmentsAppointmentIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update Update Description endpoint
 * @summary Update Update Description
 */
export const patchIdDescription = (
    id: string,
 ) => {
      
      
      return customInstance<PatchIdDescription200>(
      {url: `/${id}/description`, method: 'PATCH'
    },
      );
    }
  


export const getPatchIdDescriptionMutationOptions = <TError = PatchIdDescription400 | PatchIdDescription401 | PatchIdDescription500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchIdDescription>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchIdDescription>>, TError,{id: string}, TContext> => {

const mutationKey = ['patchIdDescription'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchIdDescription>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  patchIdDescription(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchIdDescriptionMutationResult = NonNullable<Awaited<ReturnType<typeof patchIdDescription>>>
    
    export type PatchIdDescriptionMutationError = PatchIdDescription400 | PatchIdDescription401 | PatchIdDescription500

    /**
 * @summary Update Update Description
 */
export const usePatchIdDescription = <TError = PatchIdDescription400 | PatchIdDescription401 | PatchIdDescription500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchIdDescription>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchIdDescription>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPatchIdDescriptionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Add Description endpoint
 * @summary Create Add Description
 */
export const postIdDescription = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostIdDescription200>(
      {url: `/${id}/description`, method: 'POST', signal
    },
      );
    }
  


export const getPostIdDescriptionMutationOptions = <TError = PostIdDescription400 | PostIdDescription401 | PostIdDescription500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIdDescription>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postIdDescription>>, TError,{id: string}, TContext> => {

const mutationKey = ['postIdDescription'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIdDescription>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postIdDescription(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIdDescriptionMutationResult = NonNullable<Awaited<ReturnType<typeof postIdDescription>>>
    
    export type PostIdDescriptionMutationError = PostIdDescription400 | PostIdDescription401 | PostIdDescription500

    /**
 * @summary Create Add Description
 */
export const usePostIdDescription = <TError = PostIdDescription400 | PostIdDescription401 | PostIdDescription500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIdDescription>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIdDescription>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostIdDescriptionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update Addresses Update endpoint
 * @summary Update Addresses Update
 */
export const putAddressesId = (
    id: string,
 ) => {
      
      
      return customInstance<PutAddressesId200>(
      {url: `/addresses/${id}`, method: 'PUT'
    },
      );
    }
  


export const getPutAddressesIdMutationOptions = <TError = PutAddressesId400 | PutAddressesId401 | PutAddressesId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAddressesId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAddressesId>>, TError,{id: string}, TContext> => {

const mutationKey = ['putAddressesId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAddressesId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  putAddressesId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAddressesIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAddressesId>>>
    
    export type PutAddressesIdMutationError = PutAddressesId400 | PutAddressesId401 | PutAddressesId500

    /**
 * @summary Update Addresses Update
 */
export const usePutAddressesId = <TError = PutAddressesId400 | PutAddressesId401 | PutAddressesId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAddressesId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAddressesId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPutAddressesIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete Addresses Delete endpoint
 * @summary Delete Addresses Delete
 */
export const deleteAddressesId = (
    id: string,
 ) => {
      
      
      return customInstance<DeleteAddressesId200>(
      {url: `/addresses/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAddressesIdMutationOptions = <TError = DeleteAddressesId400 | DeleteAddressesId401 | DeleteAddressesId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAddressesId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAddressesId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteAddressesId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAddressesId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAddressesId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAddressesIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAddressesId>>>
    
    export type DeleteAddressesIdMutationError = DeleteAddressesId400 | DeleteAddressesId401 | DeleteAddressesId500

    /**
 * @summary Delete Addresses Delete
 */
export const useDeleteAddressesId = <TError = DeleteAddressesId400 | DeleteAddressesId401 | DeleteAddressesId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAddressesId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAddressesId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAddressesIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Trigger Payslip Matching endpoint
 * @summary Create Trigger Payslip Matching
 */
export const postPayslipsMatchingTrigger = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostPayslipsMatchingTrigger200>(
      {url: `/payslips_matching/trigger`, method: 'POST', signal
    },
      );
    }
  


export const getPostPayslipsMatchingTriggerMutationOptions = <TError = PostPayslipsMatchingTrigger400 | PostPayslipsMatchingTrigger401 | PostPayslipsMatchingTrigger500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayslipsMatchingTrigger>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postPayslipsMatchingTrigger>>, TError,void, TContext> => {

const mutationKey = ['postPayslipsMatchingTrigger'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPayslipsMatchingTrigger>>, void> = () => {
          

          return  postPayslipsMatchingTrigger()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPayslipsMatchingTriggerMutationResult = NonNullable<Awaited<ReturnType<typeof postPayslipsMatchingTrigger>>>
    
    export type PostPayslipsMatchingTriggerMutationError = PostPayslipsMatchingTrigger400 | PostPayslipsMatchingTrigger401 | PostPayslipsMatchingTrigger500

    /**
 * @summary Create Trigger Payslip Matching
 */
export const usePostPayslipsMatchingTrigger = <TError = PostPayslipsMatchingTrigger400 | PostPayslipsMatchingTrigger401 | PostPayslipsMatchingTrigger500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayslipsMatchingTrigger>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPayslipsMatchingTrigger>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostPayslipsMatchingTriggerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Trigger Notifications endpoint
 * @summary Create Trigger Notifications
 */
export const postNotificationsTrigger = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostNotificationsTrigger200>(
      {url: `/notifications/trigger`, method: 'POST', signal
    },
      );
    }
  


export const getPostNotificationsTriggerMutationOptions = <TError = PostNotificationsTrigger400 | PostNotificationsTrigger401 | PostNotificationsTrigger500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationsTrigger>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postNotificationsTrigger>>, TError,void, TContext> => {

const mutationKey = ['postNotificationsTrigger'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNotificationsTrigger>>, void> = () => {
          

          return  postNotificationsTrigger()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNotificationsTriggerMutationResult = NonNullable<Awaited<ReturnType<typeof postNotificationsTrigger>>>
    
    export type PostNotificationsTriggerMutationError = PostNotificationsTrigger400 | PostNotificationsTrigger401 | PostNotificationsTrigger500

    /**
 * @summary Create Trigger Notifications
 */
export const usePostNotificationsTrigger = <TError = PostNotificationsTrigger400 | PostNotificationsTrigger401 | PostNotificationsTrigger500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationsTrigger>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postNotificationsTrigger>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostNotificationsTriggerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create File Tags endpoint
 * @summary Create File Tags
 */
export const postFileTags = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostFileTags200>(
      {url: `/fileTags`, method: 'POST', signal
    },
      );
    }
  


export const getPostFileTagsMutationOptions = <TError = PostFileTags400 | PostFileTags401 | PostFileTags500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFileTags>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postFileTags>>, TError,void, TContext> => {

const mutationKey = ['postFileTags'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFileTags>>, void> = () => {
          

          return  postFileTags()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFileTagsMutationResult = NonNullable<Awaited<ReturnType<typeof postFileTags>>>
    
    export type PostFileTagsMutationError = PostFileTags400 | PostFileTags401 | PostFileTags500

    /**
 * @summary Create File Tags
 */
export const usePostFileTags = <TError = PostFileTags400 | PostFileTags401 | PostFileTags500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFileTags>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postFileTags>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostFileTagsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Stats endpoint
 * @summary Create Stats
 */
export const postStats = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostStats200>(
      {url: `/stats`, method: 'POST', signal
    },
      );
    }
  


export const getPostStatsMutationOptions = <TError = PostStats400 | PostStats401 | PostStats500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postStats>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postStats>>, TError,void, TContext> => {

const mutationKey = ['postStats'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postStats>>, void> = () => {
          

          return  postStats()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostStatsMutationResult = NonNullable<Awaited<ReturnType<typeof postStats>>>
    
    export type PostStatsMutationError = PostStats400 | PostStats401 | PostStats500

    /**
 * @summary Create Stats
 */
export const usePostStats = <TError = PostStats400 | PostStats401 | PostStats500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postStats>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postStats>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostStatsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Search Files endpoint
 * @summary Create Search Files
 */
export const postFilesSearch = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostFilesSearch200>(
      {url: `/files/search`, method: 'POST', signal
    },
      );
    }
  


export const getPostFilesSearchMutationOptions = <TError = PostFilesSearch400 | PostFilesSearch401 | PostFilesSearch500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFilesSearch>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postFilesSearch>>, TError,void, TContext> => {

const mutationKey = ['postFilesSearch'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFilesSearch>>, void> = () => {
          

          return  postFilesSearch()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFilesSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postFilesSearch>>>
    
    export type PostFilesSearchMutationError = PostFilesSearch400 | PostFilesSearch401 | PostFilesSearch500

    /**
 * @summary Create Search Files
 */
export const usePostFilesSearch = <TError = PostFilesSearch400 | PostFilesSearch401 | PostFilesSearch500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFilesSearch>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postFilesSearch>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostFilesSearchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update Restore Payslip Matching Result endpoint
 * @summary Update Restore Payslip Matching Result
 */
export const putPayslipMatchingResultsRestoreMatchingResultId = (
    matchingResultId: string,
 ) => {
      
      
      return customInstance<PutPayslipMatchingResultsRestoreMatchingResultId200>(
      {url: `/payslip/matching_results/restore/${matchingResultId}`, method: 'PUT'
    },
      );
    }
  


export const getPutPayslipMatchingResultsRestoreMatchingResultIdMutationOptions = <TError = PutPayslipMatchingResultsRestoreMatchingResultId400 | PutPayslipMatchingResultsRestoreMatchingResultId401 | PutPayslipMatchingResultsRestoreMatchingResultId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPayslipMatchingResultsRestoreMatchingResultId>>, TError,{matchingResultId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putPayslipMatchingResultsRestoreMatchingResultId>>, TError,{matchingResultId: string}, TContext> => {

const mutationKey = ['putPayslipMatchingResultsRestoreMatchingResultId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPayslipMatchingResultsRestoreMatchingResultId>>, {matchingResultId: string}> = (props) => {
          const {matchingResultId} = props ?? {};

          return  putPayslipMatchingResultsRestoreMatchingResultId(matchingResultId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPayslipMatchingResultsRestoreMatchingResultIdMutationResult = NonNullable<Awaited<ReturnType<typeof putPayslipMatchingResultsRestoreMatchingResultId>>>
    
    export type PutPayslipMatchingResultsRestoreMatchingResultIdMutationError = PutPayslipMatchingResultsRestoreMatchingResultId400 | PutPayslipMatchingResultsRestoreMatchingResultId401 | PutPayslipMatchingResultsRestoreMatchingResultId500

    /**
 * @summary Update Restore Payslip Matching Result
 */
export const usePutPayslipMatchingResultsRestoreMatchingResultId = <TError = PutPayslipMatchingResultsRestoreMatchingResultId400 | PutPayslipMatchingResultsRestoreMatchingResultId401 | PutPayslipMatchingResultsRestoreMatchingResultId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPayslipMatchingResultsRestoreMatchingResultId>>, TError,{matchingResultId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPayslipMatchingResultsRestoreMatchingResultId>>,
        TError,
        {matchingResultId: string},
        TContext
      > => {

      const mutationOptions = getPutPayslipMatchingResultsRestoreMatchingResultIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Conversations Restore endpoint
 * @summary Create Conversations Restore
 */
export const postConversationsId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostConversationsId200>(
      {url: `/conversations/${id}`, method: 'POST', signal
    },
      );
    }
  


export const getPostConversationsIdMutationOptions = <TError = PostConversationsId400 | PostConversationsId401 | PostConversationsId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConversationsId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postConversationsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['postConversationsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConversationsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postConversationsId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostConversationsIdMutationResult = NonNullable<Awaited<ReturnType<typeof postConversationsId>>>
    
    export type PostConversationsIdMutationError = PostConversationsId400 | PostConversationsId401 | PostConversationsId500

    /**
 * @summary Create Conversations Restore
 */
export const usePostConversationsId = <TError = PostConversationsId400 | PostConversationsId401 | PostConversationsId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConversationsId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postConversationsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostConversationsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete Conversations Delete endpoint
 * @summary Delete Conversations Delete
 */
export const deleteConversationsId = (
    id: string,
 ) => {
      
      
      return customInstance<DeleteConversationsId200>(
      {url: `/conversations/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteConversationsIdMutationOptions = <TError = DeleteConversationsId400 | DeleteConversationsId401 | DeleteConversationsId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConversationsId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteConversationsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteConversationsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteConversationsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteConversationsId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteConversationsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteConversationsId>>>
    
    export type DeleteConversationsIdMutationError = DeleteConversationsId400 | DeleteConversationsId401 | DeleteConversationsId500

    /**
 * @summary Delete Conversations Delete
 */
export const useDeleteConversationsId = <TError = DeleteConversationsId400 | DeleteConversationsId401 | DeleteConversationsId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConversationsId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteConversationsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteConversationsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Attachments Restore endpoint
 * @summary Create Attachments Restore
 */
export const postAttachmentsRestore = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostAttachmentsRestore200>(
      {url: `/attachments/restore`, method: 'POST', signal
    },
      );
    }
  


export const getPostAttachmentsRestoreMutationOptions = <TError = PostAttachmentsRestore400 | PostAttachmentsRestore401 | PostAttachmentsRestore500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAttachmentsRestore>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAttachmentsRestore>>, TError,void, TContext> => {

const mutationKey = ['postAttachmentsRestore'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAttachmentsRestore>>, void> = () => {
          

          return  postAttachmentsRestore()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAttachmentsRestoreMutationResult = NonNullable<Awaited<ReturnType<typeof postAttachmentsRestore>>>
    
    export type PostAttachmentsRestoreMutationError = PostAttachmentsRestore400 | PostAttachmentsRestore401 | PostAttachmentsRestore500

    /**
 * @summary Create Attachments Restore
 */
export const usePostAttachmentsRestore = <TError = PostAttachmentsRestore400 | PostAttachmentsRestore401 | PostAttachmentsRestore500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAttachmentsRestore>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAttachmentsRestore>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostAttachmentsRestoreMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Payslip Manual Match endpoint
 * @summary Create Payslip Manual Match
 */
export const postPayslipsMatchingManualMatch = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostPayslipsMatchingManualMatch200>(
      {url: `/payslips_matching/manual_match`, method: 'POST', signal
    },
      );
    }
  


export const getPostPayslipsMatchingManualMatchMutationOptions = <TError = PostPayslipsMatchingManualMatch400 | PostPayslipsMatchingManualMatch401 | PostPayslipsMatchingManualMatch500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayslipsMatchingManualMatch>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postPayslipsMatchingManualMatch>>, TError,void, TContext> => {

const mutationKey = ['postPayslipsMatchingManualMatch'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPayslipsMatchingManualMatch>>, void> = () => {
          

          return  postPayslipsMatchingManualMatch()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPayslipsMatchingManualMatchMutationResult = NonNullable<Awaited<ReturnType<typeof postPayslipsMatchingManualMatch>>>
    
    export type PostPayslipsMatchingManualMatchMutationError = PostPayslipsMatchingManualMatch400 | PostPayslipsMatchingManualMatch401 | PostPayslipsMatchingManualMatch500

    /**
 * @summary Create Payslip Manual Match
 */
export const usePostPayslipsMatchingManualMatch = <TError = PostPayslipsMatchingManualMatch400 | PostPayslipsMatchingManualMatch401 | PostPayslipsMatchingManualMatch500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayslipsMatchingManualMatch>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPayslipsMatchingManualMatch>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostPayslipsMatchingManualMatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Notify Tax Statement endpoint
 * @summary Create Notify Tax Statement
 */
export const postEmployeeTaxStatementNotify = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostEmployeeTaxStatementNotify200>(
      {url: `/employee/tax-statement/notify`, method: 'POST', signal
    },
      );
    }
  


export const getPostEmployeeTaxStatementNotifyMutationOptions = <TError = PostEmployeeTaxStatementNotify400 | PostEmployeeTaxStatementNotify401 | PostEmployeeTaxStatementNotify500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployeeTaxStatementNotify>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEmployeeTaxStatementNotify>>, TError,void, TContext> => {

const mutationKey = ['postEmployeeTaxStatementNotify'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEmployeeTaxStatementNotify>>, void> = () => {
          

          return  postEmployeeTaxStatementNotify()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEmployeeTaxStatementNotifyMutationResult = NonNullable<Awaited<ReturnType<typeof postEmployeeTaxStatementNotify>>>
    
    export type PostEmployeeTaxStatementNotifyMutationError = PostEmployeeTaxStatementNotify400 | PostEmployeeTaxStatementNotify401 | PostEmployeeTaxStatementNotify500

    /**
 * @summary Create Notify Tax Statement
 */
export const usePostEmployeeTaxStatementNotify = <TError = PostEmployeeTaxStatementNotify400 | PostEmployeeTaxStatementNotify401 | PostEmployeeTaxStatementNotify500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployeeTaxStatementNotify>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEmployeeTaxStatementNotify>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostEmployeeTaxStatementNotifyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Manual Payslip Match endpoint
 * @summary Create Manual Payslip Match
 */
export const postPayslipsManualMatch = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostPayslipsManualMatch200>(
      {url: `/payslips/manual-match`, method: 'POST', signal
    },
      );
    }
  


export const getPostPayslipsManualMatchMutationOptions = <TError = PostPayslipsManualMatch400 | PostPayslipsManualMatch401 | PostPayslipsManualMatch500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayslipsManualMatch>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postPayslipsManualMatch>>, TError,void, TContext> => {

const mutationKey = ['postPayslipsManualMatch'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPayslipsManualMatch>>, void> = () => {
          

          return  postPayslipsManualMatch()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPayslipsManualMatchMutationResult = NonNullable<Awaited<ReturnType<typeof postPayslipsManualMatch>>>
    
    export type PostPayslipsManualMatchMutationError = PostPayslipsManualMatch400 | PostPayslipsManualMatch401 | PostPayslipsManualMatch500

    /**
 * @summary Create Manual Payslip Match
 */
export const usePostPayslipsManualMatch = <TError = PostPayslipsManualMatch400 | PostPayslipsManualMatch401 | PostPayslipsManualMatch500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayslipsManualMatch>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPayslipsManualMatch>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostPayslipsManualMatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Lsp Onboard endpoint
 * @summary Create Lsp Onboard
 */
export const postLspOnboard = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostLspOnboard200>(
      {url: `/lsp/onboard`, method: 'POST', signal
    },
      );
    }
  


export const getPostLspOnboardMutationOptions = <TError = PostLspOnboard400 | PostLspOnboard401 | PostLspOnboard500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postLspOnboard>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postLspOnboard>>, TError,void, TContext> => {

const mutationKey = ['postLspOnboard'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postLspOnboard>>, void> = () => {
          

          return  postLspOnboard()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostLspOnboardMutationResult = NonNullable<Awaited<ReturnType<typeof postLspOnboard>>>
    
    export type PostLspOnboardMutationError = PostLspOnboard400 | PostLspOnboard401 | PostLspOnboard500

    /**
 * @summary Create Lsp Onboard
 */
export const usePostLspOnboard = <TError = PostLspOnboard400 | PostLspOnboard401 | PostLspOnboard500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postLspOnboard>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postLspOnboard>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostLspOnboardMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Logout endpoint
 * @summary Fetch Logout
 */
export const getLogout = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetLogout200>(
      {url: `/logout`, method: 'GET', signal
    },
      );
    }
  



export const getGetLogoutQueryKey = () => {
    return [
    `/logout`
    ] as const;
    }

    
export const getGetLogoutQueryOptions = <TData = Awaited<ReturnType<typeof getLogout>>, TError = GetLogout400 | GetLogout401 | GetLogout500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLogout>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLogoutQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLogout>>> = ({ signal }) => getLogout(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLogout>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLogoutQueryResult = NonNullable<Awaited<ReturnType<typeof getLogout>>>
export type GetLogoutQueryError = GetLogout400 | GetLogout401 | GetLogout500


export function useGetLogout<TData = Awaited<ReturnType<typeof getLogout>>, TError = GetLogout400 | GetLogout401 | GetLogout500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLogout>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLogout>>,
          TError,
          Awaited<ReturnType<typeof getLogout>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLogout<TData = Awaited<ReturnType<typeof getLogout>>, TError = GetLogout400 | GetLogout401 | GetLogout500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLogout>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLogout>>,
          TError,
          Awaited<ReturnType<typeof getLogout>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLogout<TData = Awaited<ReturnType<typeof getLogout>>, TError = GetLogout400 | GetLogout401 | GetLogout500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLogout>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Logout
 */

export function useGetLogout<TData = Awaited<ReturnType<typeof getLogout>>, TError = GetLogout400 | GetLogout401 | GetLogout500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLogout>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLogoutQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Login endpoint
 * @summary Fetch Login
 */
export const getLogin = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetLogin200>(
      {url: `/login`, method: 'GET', signal
    },
      );
    }
  



export const getGetLoginQueryKey = () => {
    return [
    `/login`
    ] as const;
    }

    
export const getGetLoginQueryOptions = <TData = Awaited<ReturnType<typeof getLogin>>, TError = GetLogin400 | GetLogin401 | GetLogin500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLogin>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoginQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLogin>>> = ({ signal }) => getLogin(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLogin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoginQueryResult = NonNullable<Awaited<ReturnType<typeof getLogin>>>
export type GetLoginQueryError = GetLogin400 | GetLogin401 | GetLogin500


export function useGetLogin<TData = Awaited<ReturnType<typeof getLogin>>, TError = GetLogin400 | GetLogin401 | GetLogin500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLogin>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLogin>>,
          TError,
          Awaited<ReturnType<typeof getLogin>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLogin<TData = Awaited<ReturnType<typeof getLogin>>, TError = GetLogin400 | GetLogin401 | GetLogin500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLogin>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLogin>>,
          TError,
          Awaited<ReturnType<typeof getLogin>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLogin<TData = Awaited<ReturnType<typeof getLogin>>, TError = GetLogin400 | GetLogin401 | GetLogin500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLogin>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Login
 */

export function useGetLogin<TData = Awaited<ReturnType<typeof getLogin>>, TError = GetLogin400 | GetLogin401 | GetLogin500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLogin>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLoginQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Health Check endpoint
 * @summary Fetch Health Check
 */
export const getHealthWebhooks = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetHealthWebhooks200>(
      {url: `/health/webhooks`, method: 'GET', signal
    },
      );
    }
  



export const getGetHealthWebhooksQueryKey = () => {
    return [
    `/health/webhooks`
    ] as const;
    }

    
export const getGetHealthWebhooksQueryOptions = <TData = Awaited<ReturnType<typeof getHealthWebhooks>>, TError = GetHealthWebhooks400 | GetHealthWebhooks401 | GetHealthWebhooks500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealthWebhooks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHealthWebhooksQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHealthWebhooks>>> = ({ signal }) => getHealthWebhooks(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHealthWebhooks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHealthWebhooksQueryResult = NonNullable<Awaited<ReturnType<typeof getHealthWebhooks>>>
export type GetHealthWebhooksQueryError = GetHealthWebhooks400 | GetHealthWebhooks401 | GetHealthWebhooks500


export function useGetHealthWebhooks<TData = Awaited<ReturnType<typeof getHealthWebhooks>>, TError = GetHealthWebhooks400 | GetHealthWebhooks401 | GetHealthWebhooks500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealthWebhooks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHealthWebhooks>>,
          TError,
          Awaited<ReturnType<typeof getHealthWebhooks>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHealthWebhooks<TData = Awaited<ReturnType<typeof getHealthWebhooks>>, TError = GetHealthWebhooks400 | GetHealthWebhooks401 | GetHealthWebhooks500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealthWebhooks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHealthWebhooks>>,
          TError,
          Awaited<ReturnType<typeof getHealthWebhooks>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHealthWebhooks<TData = Awaited<ReturnType<typeof getHealthWebhooks>>, TError = GetHealthWebhooks400 | GetHealthWebhooks401 | GetHealthWebhooks500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealthWebhooks>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Health Check
 */

export function useGetHealthWebhooks<TData = Awaited<ReturnType<typeof getHealthWebhooks>>, TError = GetHealthWebhooks400 | GetHealthWebhooks401 | GetHealthWebhooks500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealthWebhooks>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHealthWebhooksQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Get Tax Docs Years endpoint
 * @summary Fetch Get Tax Docs Years
 */
export const getTaxDocsYears = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetTaxDocsYears200>(
      {url: `/tax-docs/years`, method: 'GET', signal
    },
      );
    }
  



export const getGetTaxDocsYearsQueryKey = () => {
    return [
    `/tax-docs/years`
    ] as const;
    }

    
export const getGetTaxDocsYearsQueryOptions = <TData = Awaited<ReturnType<typeof getTaxDocsYears>>, TError = GetTaxDocsYears400 | GetTaxDocsYears401 | GetTaxDocsYears500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaxDocsYears>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaxDocsYearsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaxDocsYears>>> = ({ signal }) => getTaxDocsYears(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaxDocsYears>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTaxDocsYearsQueryResult = NonNullable<Awaited<ReturnType<typeof getTaxDocsYears>>>
export type GetTaxDocsYearsQueryError = GetTaxDocsYears400 | GetTaxDocsYears401 | GetTaxDocsYears500


export function useGetTaxDocsYears<TData = Awaited<ReturnType<typeof getTaxDocsYears>>, TError = GetTaxDocsYears400 | GetTaxDocsYears401 | GetTaxDocsYears500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaxDocsYears>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaxDocsYears>>,
          TError,
          Awaited<ReturnType<typeof getTaxDocsYears>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaxDocsYears<TData = Awaited<ReturnType<typeof getTaxDocsYears>>, TError = GetTaxDocsYears400 | GetTaxDocsYears401 | GetTaxDocsYears500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaxDocsYears>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaxDocsYears>>,
          TError,
          Awaited<ReturnType<typeof getTaxDocsYears>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaxDocsYears<TData = Awaited<ReturnType<typeof getTaxDocsYears>>, TError = GetTaxDocsYears400 | GetTaxDocsYears401 | GetTaxDocsYears500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaxDocsYears>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Get Tax Docs Years
 */

export function useGetTaxDocsYears<TData = Awaited<ReturnType<typeof getTaxDocsYears>>, TError = GetTaxDocsYears400 | GetTaxDocsYears401 | GetTaxDocsYears500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaxDocsYears>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTaxDocsYearsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Get Payslip Years endpoint
 * @summary Fetch Get Payslip Years
 */
export const getPayslipsYears = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetPayslipsYears200>(
      {url: `/payslips/years`, method: 'GET', signal
    },
      );
    }
  



export const getGetPayslipsYearsQueryKey = () => {
    return [
    `/payslips/years`
    ] as const;
    }

    
export const getGetPayslipsYearsQueryOptions = <TData = Awaited<ReturnType<typeof getPayslipsYears>>, TError = GetPayslipsYears400 | GetPayslipsYears401 | GetPayslipsYears500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayslipsYears>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayslipsYearsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayslipsYears>>> = ({ signal }) => getPayslipsYears(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayslipsYears>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayslipsYearsQueryResult = NonNullable<Awaited<ReturnType<typeof getPayslipsYears>>>
export type GetPayslipsYearsQueryError = GetPayslipsYears400 | GetPayslipsYears401 | GetPayslipsYears500


export function useGetPayslipsYears<TData = Awaited<ReturnType<typeof getPayslipsYears>>, TError = GetPayslipsYears400 | GetPayslipsYears401 | GetPayslipsYears500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayslipsYears>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayslipsYears>>,
          TError,
          Awaited<ReturnType<typeof getPayslipsYears>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayslipsYears<TData = Awaited<ReturnType<typeof getPayslipsYears>>, TError = GetPayslipsYears400 | GetPayslipsYears401 | GetPayslipsYears500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayslipsYears>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayslipsYears>>,
          TError,
          Awaited<ReturnType<typeof getPayslipsYears>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayslipsYears<TData = Awaited<ReturnType<typeof getPayslipsYears>>, TError = GetPayslipsYears400 | GetPayslipsYears401 | GetPayslipsYears500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayslipsYears>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Get Payslip Years
 */

export function useGetPayslipsYears<TData = Awaited<ReturnType<typeof getPayslipsYears>>, TError = GetPayslipsYears400 | GetPayslipsYears401 | GetPayslipsYears500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayslipsYears>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayslipsYearsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch File Upload Url endpoint
 * @summary Fetch File Upload Url
 */
export const getContainerSasToken = (
    container: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetContainerSasToken200>(
      {url: `/${container}/sas-token`, method: 'GET', signal
    },
      );
    }
  



export const getGetContainerSasTokenQueryKey = (container?: string,) => {
    return [
    `/${container}/sas-token`
    ] as const;
    }

    
export const getGetContainerSasTokenQueryOptions = <TData = Awaited<ReturnType<typeof getContainerSasToken>>, TError = GetContainerSasToken400 | GetContainerSasToken401 | GetContainerSasToken500>(container: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContainerSasToken>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContainerSasTokenQueryKey(container);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContainerSasToken>>> = ({ signal }) => getContainerSasToken(container, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(container), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContainerSasToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetContainerSasTokenQueryResult = NonNullable<Awaited<ReturnType<typeof getContainerSasToken>>>
export type GetContainerSasTokenQueryError = GetContainerSasToken400 | GetContainerSasToken401 | GetContainerSasToken500


export function useGetContainerSasToken<TData = Awaited<ReturnType<typeof getContainerSasToken>>, TError = GetContainerSasToken400 | GetContainerSasToken401 | GetContainerSasToken500>(
 container: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContainerSasToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContainerSasToken>>,
          TError,
          Awaited<ReturnType<typeof getContainerSasToken>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContainerSasToken<TData = Awaited<ReturnType<typeof getContainerSasToken>>, TError = GetContainerSasToken400 | GetContainerSasToken401 | GetContainerSasToken500>(
 container: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContainerSasToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContainerSasToken>>,
          TError,
          Awaited<ReturnType<typeof getContainerSasToken>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContainerSasToken<TData = Awaited<ReturnType<typeof getContainerSasToken>>, TError = GetContainerSasToken400 | GetContainerSasToken401 | GetContainerSasToken500>(
 container: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContainerSasToken>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch File Upload Url
 */

export function useGetContainerSasToken<TData = Awaited<ReturnType<typeof getContainerSasToken>>, TError = GetContainerSasToken400 | GetContainerSasToken401 | GetContainerSasToken500>(
 container: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContainerSasToken>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContainerSasTokenQueryOptions(container,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Users Audit endpoint
 * @summary Fetch Users Audit
 */
export const getUsersIdAudit = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetUsersIdAudit200>(
      {url: `/users/${id}/audit`, method: 'GET', signal
    },
      );
    }
  



export const getGetUsersIdAuditQueryKey = (id?: string,) => {
    return [
    `/users/${id}/audit`
    ] as const;
    }

    
export const getGetUsersIdAuditQueryOptions = <TData = Awaited<ReturnType<typeof getUsersIdAudit>>, TError = GetUsersIdAudit400 | GetUsersIdAudit401 | GetUsersIdAudit500>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersIdAudit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersIdAuditQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersIdAudit>>> = ({ signal }) => getUsersIdAudit(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsersIdAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersIdAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getUsersIdAudit>>>
export type GetUsersIdAuditQueryError = GetUsersIdAudit400 | GetUsersIdAudit401 | GetUsersIdAudit500


export function useGetUsersIdAudit<TData = Awaited<ReturnType<typeof getUsersIdAudit>>, TError = GetUsersIdAudit400 | GetUsersIdAudit401 | GetUsersIdAudit500>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersIdAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getUsersIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersIdAudit<TData = Awaited<ReturnType<typeof getUsersIdAudit>>, TError = GetUsersIdAudit400 | GetUsersIdAudit401 | GetUsersIdAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersIdAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getUsersIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersIdAudit<TData = Awaited<ReturnType<typeof getUsersIdAudit>>, TError = GetUsersIdAudit400 | GetUsersIdAudit401 | GetUsersIdAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Users Audit
 */

export function useGetUsersIdAudit<TData = Awaited<ReturnType<typeof getUsersIdAudit>>, TError = GetUsersIdAudit400 | GetUsersIdAudit401 | GetUsersIdAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersIdAuditQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch User Roles endpoint
 * @summary Fetch User Roles
 */
export const getUserManagementUsersUserRoles = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetUserManagementUsersUserRoles200>(
      {url: `/user-management/users/user-roles`, method: 'GET', signal
    },
      );
    }
  



export const getGetUserManagementUsersUserRolesQueryKey = () => {
    return [
    `/user-management/users/user-roles`
    ] as const;
    }

    
export const getGetUserManagementUsersUserRolesQueryOptions = <TData = Awaited<ReturnType<typeof getUserManagementUsersUserRoles>>, TError = GetUserManagementUsersUserRoles400 | GetUserManagementUsersUserRoles401 | GetUserManagementUsersUserRoles500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserManagementUsersUserRoles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserManagementUsersUserRolesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserManagementUsersUserRoles>>> = ({ signal }) => getUserManagementUsersUserRoles(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserManagementUsersUserRoles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserManagementUsersUserRolesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserManagementUsersUserRoles>>>
export type GetUserManagementUsersUserRolesQueryError = GetUserManagementUsersUserRoles400 | GetUserManagementUsersUserRoles401 | GetUserManagementUsersUserRoles500


export function useGetUserManagementUsersUserRoles<TData = Awaited<ReturnType<typeof getUserManagementUsersUserRoles>>, TError = GetUserManagementUsersUserRoles400 | GetUserManagementUsersUserRoles401 | GetUserManagementUsersUserRoles500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserManagementUsersUserRoles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserManagementUsersUserRoles>>,
          TError,
          Awaited<ReturnType<typeof getUserManagementUsersUserRoles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserManagementUsersUserRoles<TData = Awaited<ReturnType<typeof getUserManagementUsersUserRoles>>, TError = GetUserManagementUsersUserRoles400 | GetUserManagementUsersUserRoles401 | GetUserManagementUsersUserRoles500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserManagementUsersUserRoles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserManagementUsersUserRoles>>,
          TError,
          Awaited<ReturnType<typeof getUserManagementUsersUserRoles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserManagementUsersUserRoles<TData = Awaited<ReturnType<typeof getUserManagementUsersUserRoles>>, TError = GetUserManagementUsersUserRoles400 | GetUserManagementUsersUserRoles401 | GetUserManagementUsersUserRoles500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserManagementUsersUserRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch User Roles
 */

export function useGetUserManagementUsersUserRoles<TData = Awaited<ReturnType<typeof getUserManagementUsersUserRoles>>, TError = GetUserManagementUsersUserRoles400 | GetUserManagementUsersUserRoles401 | GetUserManagementUsersUserRoles500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserManagementUsersUserRoles>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserManagementUsersUserRolesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch User Current endpoint
 * @summary Fetch User Current
 */
export const getUsersCurrentMe = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetUsersCurrentMe200>(
      {url: `/users/current/me`, method: 'GET', signal
    },
      );
    }
  



export const getGetUsersCurrentMeQueryKey = () => {
    return [
    `/users/current/me`
    ] as const;
    }

    
export const getGetUsersCurrentMeQueryOptions = <TData = Awaited<ReturnType<typeof getUsersCurrentMe>>, TError = GetUsersCurrentMe400 | GetUsersCurrentMe401 | GetUsersCurrentMe500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersCurrentMe>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersCurrentMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersCurrentMe>>> = ({ signal }) => getUsersCurrentMe(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsersCurrentMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersCurrentMeQueryResult = NonNullable<Awaited<ReturnType<typeof getUsersCurrentMe>>>
export type GetUsersCurrentMeQueryError = GetUsersCurrentMe400 | GetUsersCurrentMe401 | GetUsersCurrentMe500


export function useGetUsersCurrentMe<TData = Awaited<ReturnType<typeof getUsersCurrentMe>>, TError = GetUsersCurrentMe400 | GetUsersCurrentMe401 | GetUsersCurrentMe500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersCurrentMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersCurrentMe>>,
          TError,
          Awaited<ReturnType<typeof getUsersCurrentMe>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersCurrentMe<TData = Awaited<ReturnType<typeof getUsersCurrentMe>>, TError = GetUsersCurrentMe400 | GetUsersCurrentMe401 | GetUsersCurrentMe500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersCurrentMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersCurrentMe>>,
          TError,
          Awaited<ReturnType<typeof getUsersCurrentMe>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersCurrentMe<TData = Awaited<ReturnType<typeof getUsersCurrentMe>>, TError = GetUsersCurrentMe400 | GetUsersCurrentMe401 | GetUsersCurrentMe500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersCurrentMe>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch User Current
 */

export function useGetUsersCurrentMe<TData = Awaited<ReturnType<typeof getUsersCurrentMe>>, TError = GetUsersCurrentMe400 | GetUsersCurrentMe401 | GetUsersCurrentMe500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersCurrentMe>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersCurrentMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Events Upcoming endpoint
 * @summary Fetch Events Upcoming
 */
export const getEventsUpcoming = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEventsUpcoming200>(
      {url: `/events/upcoming`, method: 'GET', signal
    },
      );
    }
  



export const getGetEventsUpcomingQueryKey = () => {
    return [
    `/events/upcoming`
    ] as const;
    }

    
export const getGetEventsUpcomingQueryOptions = <TData = Awaited<ReturnType<typeof getEventsUpcoming>>, TError = GetEventsUpcoming400 | GetEventsUpcoming401 | GetEventsUpcoming500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsUpcoming>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventsUpcomingQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventsUpcoming>>> = ({ signal }) => getEventsUpcoming(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventsUpcoming>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventsUpcomingQueryResult = NonNullable<Awaited<ReturnType<typeof getEventsUpcoming>>>
export type GetEventsUpcomingQueryError = GetEventsUpcoming400 | GetEventsUpcoming401 | GetEventsUpcoming500


export function useGetEventsUpcoming<TData = Awaited<ReturnType<typeof getEventsUpcoming>>, TError = GetEventsUpcoming400 | GetEventsUpcoming401 | GetEventsUpcoming500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsUpcoming>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventsUpcoming>>,
          TError,
          Awaited<ReturnType<typeof getEventsUpcoming>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventsUpcoming<TData = Awaited<ReturnType<typeof getEventsUpcoming>>, TError = GetEventsUpcoming400 | GetEventsUpcoming401 | GetEventsUpcoming500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsUpcoming>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventsUpcoming>>,
          TError,
          Awaited<ReturnType<typeof getEventsUpcoming>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventsUpcoming<TData = Awaited<ReturnType<typeof getEventsUpcoming>>, TError = GetEventsUpcoming400 | GetEventsUpcoming401 | GetEventsUpcoming500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsUpcoming>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Events Upcoming
 */

export function useGetEventsUpcoming<TData = Awaited<ReturnType<typeof getEventsUpcoming>>, TError = GetEventsUpcoming400 | GetEventsUpcoming401 | GetEventsUpcoming500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsUpcoming>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventsUpcomingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Fetch Tax Docs endpoint
 * @summary Fetch Fetch Tax Docs
 */
export const getTaxDocs = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetTaxDocs200>(
      {url: `/tax-docs`, method: 'GET', signal
    },
      );
    }
  



export const getGetTaxDocsQueryKey = () => {
    return [
    `/tax-docs`
    ] as const;
    }

    
export const getGetTaxDocsQueryOptions = <TData = Awaited<ReturnType<typeof getTaxDocs>>, TError = GetTaxDocs400 | GetTaxDocs401 | GetTaxDocs500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaxDocs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaxDocsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaxDocs>>> = ({ signal }) => getTaxDocs(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaxDocs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTaxDocsQueryResult = NonNullable<Awaited<ReturnType<typeof getTaxDocs>>>
export type GetTaxDocsQueryError = GetTaxDocs400 | GetTaxDocs401 | GetTaxDocs500


export function useGetTaxDocs<TData = Awaited<ReturnType<typeof getTaxDocs>>, TError = GetTaxDocs400 | GetTaxDocs401 | GetTaxDocs500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaxDocs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaxDocs>>,
          TError,
          Awaited<ReturnType<typeof getTaxDocs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaxDocs<TData = Awaited<ReturnType<typeof getTaxDocs>>, TError = GetTaxDocs400 | GetTaxDocs401 | GetTaxDocs500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaxDocs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaxDocs>>,
          TError,
          Awaited<ReturnType<typeof getTaxDocs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaxDocs<TData = Awaited<ReturnType<typeof getTaxDocs>>, TError = GetTaxDocs400 | GetTaxDocs401 | GetTaxDocs500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaxDocs>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Fetch Tax Docs
 */

export function useGetTaxDocs<TData = Awaited<ReturnType<typeof getTaxDocs>>, TError = GetTaxDocs400 | GetTaxDocs401 | GetTaxDocs500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaxDocs>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTaxDocsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Fetch States endpoint
 * @summary Fetch Fetch States
 */
export const getStates = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetStates200>(
      {url: `/states`, method: 'GET', signal
    },
      );
    }
  



export const getGetStatesQueryKey = () => {
    return [
    `/states`
    ] as const;
    }

    
export const getGetStatesQueryOptions = <TData = Awaited<ReturnType<typeof getStates>>, TError = GetStates400 | GetStates401 | GetStates500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStatesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStates>>> = ({ signal }) => getStates(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStatesQueryResult = NonNullable<Awaited<ReturnType<typeof getStates>>>
export type GetStatesQueryError = GetStates400 | GetStates401 | GetStates500


export function useGetStates<TData = Awaited<ReturnType<typeof getStates>>, TError = GetStates400 | GetStates401 | GetStates500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStates>>,
          TError,
          Awaited<ReturnType<typeof getStates>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStates<TData = Awaited<ReturnType<typeof getStates>>, TError = GetStates400 | GetStates401 | GetStates500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStates>>,
          TError,
          Awaited<ReturnType<typeof getStates>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStates<TData = Awaited<ReturnType<typeof getStates>>, TError = GetStates400 | GetStates401 | GetStates500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Fetch States
 */

export function useGetStates<TData = Awaited<ReturnType<typeof getStates>>, TError = GetStates400 | GetStates401 | GetStates500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStatesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Entities Shareholders endpoint
 * @summary Fetch Entities Shareholders
 */
export const getEntitiesEntityIdShareholders = (
    entityId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesEntityIdShareholders200>(
      {url: `/entities/${entityId}/shareholders`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesEntityIdShareholdersQueryKey = (entityId?: string,) => {
    return [
    `/entities/${entityId}/shareholders`
    ] as const;
    }

    
export const getGetEntitiesEntityIdShareholdersQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesEntityIdShareholders>>, TError = GetEntitiesEntityIdShareholders400 | GetEntitiesEntityIdShareholders401 | GetEntitiesEntityIdShareholders500>(entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdShareholders>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesEntityIdShareholdersQueryKey(entityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesEntityIdShareholders>>> = ({ signal }) => getEntitiesEntityIdShareholders(entityId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(entityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdShareholders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesEntityIdShareholdersQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesEntityIdShareholders>>>
export type GetEntitiesEntityIdShareholdersQueryError = GetEntitiesEntityIdShareholders400 | GetEntitiesEntityIdShareholders401 | GetEntitiesEntityIdShareholders500


export function useGetEntitiesEntityIdShareholders<TData = Awaited<ReturnType<typeof getEntitiesEntityIdShareholders>>, TError = GetEntitiesEntityIdShareholders400 | GetEntitiesEntityIdShareholders401 | GetEntitiesEntityIdShareholders500>(
 entityId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdShareholders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesEntityIdShareholders>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesEntityIdShareholders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesEntityIdShareholders<TData = Awaited<ReturnType<typeof getEntitiesEntityIdShareholders>>, TError = GetEntitiesEntityIdShareholders400 | GetEntitiesEntityIdShareholders401 | GetEntitiesEntityIdShareholders500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdShareholders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesEntityIdShareholders>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesEntityIdShareholders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesEntityIdShareholders<TData = Awaited<ReturnType<typeof getEntitiesEntityIdShareholders>>, TError = GetEntitiesEntityIdShareholders400 | GetEntitiesEntityIdShareholders401 | GetEntitiesEntityIdShareholders500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdShareholders>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Entities Shareholders
 */

export function useGetEntitiesEntityIdShareholders<TData = Awaited<ReturnType<typeof getEntitiesEntityIdShareholders>>, TError = GetEntitiesEntityIdShareholders400 | GetEntitiesEntityIdShareholders401 | GetEntitiesEntityIdShareholders500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdShareholders>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesEntityIdShareholdersQueryOptions(entityId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Entities Shareholders Audit endpoint
 * @summary Fetch Entities Shareholders Audit
 */
export const getEntitiesShareholdersShareholderIdAudit = (
    shareholderId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesShareholdersShareholderIdAudit200>(
      {url: `/entities/shareholders/${shareholderId}/audit`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesShareholdersShareholderIdAuditQueryKey = (shareholderId?: string,) => {
    return [
    `/entities/shareholders/${shareholderId}/audit`
    ] as const;
    }

    
export const getGetEntitiesShareholdersShareholderIdAuditQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdAudit>>, TError = GetEntitiesShareholdersShareholderIdAudit400 | GetEntitiesShareholdersShareholderIdAudit401 | GetEntitiesShareholdersShareholderIdAudit500>(shareholderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdAudit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesShareholdersShareholderIdAuditQueryKey(shareholderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdAudit>>> = ({ signal }) => getEntitiesShareholdersShareholderIdAudit(shareholderId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(shareholderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesShareholdersShareholderIdAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdAudit>>>
export type GetEntitiesShareholdersShareholderIdAuditQueryError = GetEntitiesShareholdersShareholderIdAudit400 | GetEntitiesShareholdersShareholderIdAudit401 | GetEntitiesShareholdersShareholderIdAudit500


export function useGetEntitiesShareholdersShareholderIdAudit<TData = Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdAudit>>, TError = GetEntitiesShareholdersShareholderIdAudit400 | GetEntitiesShareholdersShareholderIdAudit401 | GetEntitiesShareholdersShareholderIdAudit500>(
 shareholderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesShareholdersShareholderIdAudit<TData = Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdAudit>>, TError = GetEntitiesShareholdersShareholderIdAudit400 | GetEntitiesShareholdersShareholderIdAudit401 | GetEntitiesShareholdersShareholderIdAudit500>(
 shareholderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesShareholdersShareholderIdAudit<TData = Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdAudit>>, TError = GetEntitiesShareholdersShareholderIdAudit400 | GetEntitiesShareholdersShareholderIdAudit401 | GetEntitiesShareholdersShareholderIdAudit500>(
 shareholderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Entities Shareholders Audit
 */

export function useGetEntitiesShareholdersShareholderIdAudit<TData = Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdAudit>>, TError = GetEntitiesShareholdersShareholderIdAudit400 | GetEntitiesShareholdersShareholderIdAudit401 | GetEntitiesShareholdersShareholderIdAudit500>(
 shareholderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesShareholdersShareholderIdAuditQueryOptions(shareholderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Entities Shareholders Registry endpoint
 * @summary Fetch Entities Shareholders Registry
 */
export const getEntitiesShareholdersShareholderIdRegistry = (
    shareholderId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesShareholdersShareholderIdRegistry200>(
      {url: `/entities/shareholders/${shareholderId}/registry`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesShareholdersShareholderIdRegistryQueryKey = (shareholderId?: string,) => {
    return [
    `/entities/shareholders/${shareholderId}/registry`
    ] as const;
    }

    
export const getGetEntitiesShareholdersShareholderIdRegistryQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistry>>, TError = GetEntitiesShareholdersShareholderIdRegistry400 | GetEntitiesShareholdersShareholderIdRegistry401 | GetEntitiesShareholdersShareholderIdRegistry500>(shareholderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistry>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesShareholdersShareholderIdRegistryQueryKey(shareholderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistry>>> = ({ signal }) => getEntitiesShareholdersShareholderIdRegistry(shareholderId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(shareholderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistry>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesShareholdersShareholderIdRegistryQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistry>>>
export type GetEntitiesShareholdersShareholderIdRegistryQueryError = GetEntitiesShareholdersShareholderIdRegistry400 | GetEntitiesShareholdersShareholderIdRegistry401 | GetEntitiesShareholdersShareholderIdRegistry500


export function useGetEntitiesShareholdersShareholderIdRegistry<TData = Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistry>>, TError = GetEntitiesShareholdersShareholderIdRegistry400 | GetEntitiesShareholdersShareholderIdRegistry401 | GetEntitiesShareholdersShareholderIdRegistry500>(
 shareholderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistry>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistry>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistry>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesShareholdersShareholderIdRegistry<TData = Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistry>>, TError = GetEntitiesShareholdersShareholderIdRegistry400 | GetEntitiesShareholdersShareholderIdRegistry401 | GetEntitiesShareholdersShareholderIdRegistry500>(
 shareholderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistry>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistry>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistry>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesShareholdersShareholderIdRegistry<TData = Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistry>>, TError = GetEntitiesShareholdersShareholderIdRegistry400 | GetEntitiesShareholdersShareholderIdRegistry401 | GetEntitiesShareholdersShareholderIdRegistry500>(
 shareholderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistry>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Entities Shareholders Registry
 */

export function useGetEntitiesShareholdersShareholderIdRegistry<TData = Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistry>>, TError = GetEntitiesShareholdersShareholderIdRegistry400 | GetEntitiesShareholdersShareholderIdRegistry401 | GetEntitiesShareholdersShareholderIdRegistry500>(
 shareholderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistry>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesShareholdersShareholderIdRegistryQueryOptions(shareholderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create Entities Shareholders Registry Add endpoint
 * @summary Create Entities Shareholders Registry Add
 */
export const postEntitiesShareholdersShareholderIdRegistry = (
    shareholderId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostEntitiesShareholdersShareholderIdRegistry200>(
      {url: `/entities/shareholders/${shareholderId}/registry`, method: 'POST', signal
    },
      );
    }
  


export const getPostEntitiesShareholdersShareholderIdRegistryMutationOptions = <TError = PostEntitiesShareholdersShareholderIdRegistry400 | PostEntitiesShareholdersShareholderIdRegistry401 | PostEntitiesShareholdersShareholderIdRegistry500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEntitiesShareholdersShareholderIdRegistry>>, TError,{shareholderId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEntitiesShareholdersShareholderIdRegistry>>, TError,{shareholderId: string}, TContext> => {

const mutationKey = ['postEntitiesShareholdersShareholderIdRegistry'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEntitiesShareholdersShareholderIdRegistry>>, {shareholderId: string}> = (props) => {
          const {shareholderId} = props ?? {};

          return  postEntitiesShareholdersShareholderIdRegistry(shareholderId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEntitiesShareholdersShareholderIdRegistryMutationResult = NonNullable<Awaited<ReturnType<typeof postEntitiesShareholdersShareholderIdRegistry>>>
    
    export type PostEntitiesShareholdersShareholderIdRegistryMutationError = PostEntitiesShareholdersShareholderIdRegistry400 | PostEntitiesShareholdersShareholderIdRegistry401 | PostEntitiesShareholdersShareholderIdRegistry500

    /**
 * @summary Create Entities Shareholders Registry Add
 */
export const usePostEntitiesShareholdersShareholderIdRegistry = <TError = PostEntitiesShareholdersShareholderIdRegistry400 | PostEntitiesShareholdersShareholderIdRegistry401 | PostEntitiesShareholdersShareholderIdRegistry500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEntitiesShareholdersShareholderIdRegistry>>, TError,{shareholderId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEntitiesShareholdersShareholderIdRegistry>>,
        TError,
        {shareholderId: string},
        TContext
      > => {

      const mutationOptions = getPostEntitiesShareholdersShareholderIdRegistryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Entities Shareholders Registry Audit endpoint
 * @summary Fetch Entities Shareholders Registry Audit
 */
export const getEntitiesShareholdersShareholderIdRegistryAudit = (
    shareholderId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesShareholdersShareholderIdRegistryAudit200>(
      {url: `/entities/shareholders/${shareholderId}/registry/audit`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesShareholdersShareholderIdRegistryAuditQueryKey = (shareholderId?: string,) => {
    return [
    `/entities/shareholders/${shareholderId}/registry/audit`
    ] as const;
    }

    
export const getGetEntitiesShareholdersShareholderIdRegistryAuditQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistryAudit>>, TError = GetEntitiesShareholdersShareholderIdRegistryAudit400 | GetEntitiesShareholdersShareholderIdRegistryAudit401 | GetEntitiesShareholdersShareholderIdRegistryAudit500>(shareholderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistryAudit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesShareholdersShareholderIdRegistryAuditQueryKey(shareholderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistryAudit>>> = ({ signal }) => getEntitiesShareholdersShareholderIdRegistryAudit(shareholderId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(shareholderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistryAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesShareholdersShareholderIdRegistryAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistryAudit>>>
export type GetEntitiesShareholdersShareholderIdRegistryAuditQueryError = GetEntitiesShareholdersShareholderIdRegistryAudit400 | GetEntitiesShareholdersShareholderIdRegistryAudit401 | GetEntitiesShareholdersShareholderIdRegistryAudit500


export function useGetEntitiesShareholdersShareholderIdRegistryAudit<TData = Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistryAudit>>, TError = GetEntitiesShareholdersShareholderIdRegistryAudit400 | GetEntitiesShareholdersShareholderIdRegistryAudit401 | GetEntitiesShareholdersShareholderIdRegistryAudit500>(
 shareholderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistryAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistryAudit>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistryAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesShareholdersShareholderIdRegistryAudit<TData = Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistryAudit>>, TError = GetEntitiesShareholdersShareholderIdRegistryAudit400 | GetEntitiesShareholdersShareholderIdRegistryAudit401 | GetEntitiesShareholdersShareholderIdRegistryAudit500>(
 shareholderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistryAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistryAudit>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistryAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesShareholdersShareholderIdRegistryAudit<TData = Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistryAudit>>, TError = GetEntitiesShareholdersShareholderIdRegistryAudit400 | GetEntitiesShareholdersShareholderIdRegistryAudit401 | GetEntitiesShareholdersShareholderIdRegistryAudit500>(
 shareholderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistryAudit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Entities Shareholders Registry Audit
 */

export function useGetEntitiesShareholdersShareholderIdRegistryAudit<TData = Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistryAudit>>, TError = GetEntitiesShareholdersShareholderIdRegistryAudit400 | GetEntitiesShareholdersShareholderIdRegistryAudit401 | GetEntitiesShareholdersShareholderIdRegistryAudit500>(
 shareholderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesShareholdersShareholderIdRegistryAudit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesShareholdersShareholderIdRegistryAuditQueryOptions(shareholderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Services endpoint
 * @summary Fetch Services
 */
export const getServices = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetServices200>(
      {url: `/services`, method: 'GET', signal
    },
      );
    }
  



export const getGetServicesQueryKey = () => {
    return [
    `/services`
    ] as const;
    }

    
export const getGetServicesQueryOptions = <TData = Awaited<ReturnType<typeof getServices>>, TError = GetServices400 | GetServices401 | GetServices500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServicesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServices>>> = ({ signal }) => getServices(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServicesQueryResult = NonNullable<Awaited<ReturnType<typeof getServices>>>
export type GetServicesQueryError = GetServices400 | GetServices401 | GetServices500


export function useGetServices<TData = Awaited<ReturnType<typeof getServices>>, TError = GetServices400 | GetServices401 | GetServices500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServices>>,
          TError,
          Awaited<ReturnType<typeof getServices>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServices<TData = Awaited<ReturnType<typeof getServices>>, TError = GetServices400 | GetServices401 | GetServices500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServices>>,
          TError,
          Awaited<ReturnType<typeof getServices>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServices<TData = Awaited<ReturnType<typeof getServices>>, TError = GetServices400 | GetServices401 | GetServices500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Services
 */

export function useGetServices<TData = Awaited<ReturnType<typeof getServices>>, TError = GetServices400 | GetServices401 | GetServices500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServicesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Services Audit endpoint
 * @summary Fetch Services Audit
 */
export const getEntityIdServicesAudit = (
    entityId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntityIdServicesAudit200>(
      {url: `/${entityId}/services/audit`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntityIdServicesAuditQueryKey = (entityId?: string,) => {
    return [
    `/${entityId}/services/audit`
    ] as const;
    }

    
export const getGetEntityIdServicesAuditQueryOptions = <TData = Awaited<ReturnType<typeof getEntityIdServicesAudit>>, TError = GetEntityIdServicesAudit400 | GetEntityIdServicesAudit401 | GetEntityIdServicesAudit500>(entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntityIdServicesAudit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntityIdServicesAuditQueryKey(entityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntityIdServicesAudit>>> = ({ signal }) => getEntityIdServicesAudit(entityId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(entityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntityIdServicesAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntityIdServicesAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getEntityIdServicesAudit>>>
export type GetEntityIdServicesAuditQueryError = GetEntityIdServicesAudit400 | GetEntityIdServicesAudit401 | GetEntityIdServicesAudit500


export function useGetEntityIdServicesAudit<TData = Awaited<ReturnType<typeof getEntityIdServicesAudit>>, TError = GetEntityIdServicesAudit400 | GetEntityIdServicesAudit401 | GetEntityIdServicesAudit500>(
 entityId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntityIdServicesAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntityIdServicesAudit>>,
          TError,
          Awaited<ReturnType<typeof getEntityIdServicesAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntityIdServicesAudit<TData = Awaited<ReturnType<typeof getEntityIdServicesAudit>>, TError = GetEntityIdServicesAudit400 | GetEntityIdServicesAudit401 | GetEntityIdServicesAudit500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntityIdServicesAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntityIdServicesAudit>>,
          TError,
          Awaited<ReturnType<typeof getEntityIdServicesAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntityIdServicesAudit<TData = Awaited<ReturnType<typeof getEntityIdServicesAudit>>, TError = GetEntityIdServicesAudit400 | GetEntityIdServicesAudit401 | GetEntityIdServicesAudit500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntityIdServicesAudit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Services Audit
 */

export function useGetEntityIdServicesAudit<TData = Awaited<ReturnType<typeof getEntityIdServicesAudit>>, TError = GetEntityIdServicesAudit400 | GetEntityIdServicesAudit401 | GetEntityIdServicesAudit500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntityIdServicesAudit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntityIdServicesAuditQueryOptions(entityId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Requests endpoint
 * @summary Fetch Requests
 */
export const getRequests = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetRequests200>(
      {url: `/requests`, method: 'GET', signal
    },
      );
    }
  



export const getGetRequestsQueryKey = () => {
    return [
    `/requests`
    ] as const;
    }

    
export const getGetRequestsQueryOptions = <TData = Awaited<ReturnType<typeof getRequests>>, TError = GetRequests400 | GetRequests401 | GetRequests500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequests>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequestsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequests>>> = ({ signal }) => getRequests(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof getRequests>>>
export type GetRequestsQueryError = GetRequests400 | GetRequests401 | GetRequests500


export function useGetRequests<TData = Awaited<ReturnType<typeof getRequests>>, TError = GetRequests400 | GetRequests401 | GetRequests500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequests>>,
          TError,
          Awaited<ReturnType<typeof getRequests>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequests<TData = Awaited<ReturnType<typeof getRequests>>, TError = GetRequests400 | GetRequests401 | GetRequests500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequests>>,
          TError,
          Awaited<ReturnType<typeof getRequests>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequests<TData = Awaited<ReturnType<typeof getRequests>>, TError = GetRequests400 | GetRequests401 | GetRequests500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequests>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Requests
 */

export function useGetRequests<TData = Awaited<ReturnType<typeof getRequests>>, TError = GetRequests400 | GetRequests401 | GetRequests500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequests>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRequestsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create Requests Add endpoint
 * @summary Create Requests Add
 */
export const postRequests = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostRequests200>(
      {url: `/requests`, method: 'POST', signal
    },
      );
    }
  


export const getPostRequestsMutationOptions = <TError = PostRequests400 | PostRequests401 | PostRequests500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRequests>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postRequests>>, TError,void, TContext> => {

const mutationKey = ['postRequests'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRequests>>, void> = () => {
          

          return  postRequests()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostRequestsMutationResult = NonNullable<Awaited<ReturnType<typeof postRequests>>>
    
    export type PostRequestsMutationError = PostRequests400 | PostRequests401 | PostRequests500

    /**
 * @summary Create Requests Add
 */
export const usePostRequests = <TError = PostRequests400 | PostRequests401 | PostRequests500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRequests>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postRequests>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostRequestsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Requests By Id endpoint
 * @summary Fetch Requests By Id
 */
export const getRequestsId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetRequestsId200>(
      {url: `/requests/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetRequestsIdQueryKey = (id?: string,) => {
    return [
    `/requests/${id}`
    ] as const;
    }

    
export const getGetRequestsIdQueryOptions = <TData = Awaited<ReturnType<typeof getRequestsId>>, TError = GetRequestsId400 | GetRequestsId401 | GetRequestsId500>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestsId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequestsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestsId>>> = ({ signal }) => getRequestsId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequestsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getRequestsId>>>
export type GetRequestsIdQueryError = GetRequestsId400 | GetRequestsId401 | GetRequestsId500


export function useGetRequestsId<TData = Awaited<ReturnType<typeof getRequestsId>>, TError = GetRequestsId400 | GetRequestsId401 | GetRequestsId500>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequestsId>>,
          TError,
          Awaited<ReturnType<typeof getRequestsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestsId<TData = Awaited<ReturnType<typeof getRequestsId>>, TError = GetRequestsId400 | GetRequestsId401 | GetRequestsId500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequestsId>>,
          TError,
          Awaited<ReturnType<typeof getRequestsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestsId<TData = Awaited<ReturnType<typeof getRequestsId>>, TError = GetRequestsId400 | GetRequestsId401 | GetRequestsId500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestsId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Requests By Id
 */

export function useGetRequestsId<TData = Awaited<ReturnType<typeof getRequestsId>>, TError = GetRequestsId400 | GetRequestsId401 | GetRequestsId500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestsId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRequestsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Requests Documents endpoint
 * @summary Fetch Requests Documents
 */
export const getRequestsIdDocuments = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetRequestsIdDocuments200>(
      {url: `/requests/${id}/documents`, method: 'GET', signal
    },
      );
    }
  



export const getGetRequestsIdDocumentsQueryKey = (id?: string,) => {
    return [
    `/requests/${id}/documents`
    ] as const;
    }

    
export const getGetRequestsIdDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getRequestsIdDocuments>>, TError = GetRequestsIdDocuments400 | GetRequestsIdDocuments401 | GetRequestsIdDocuments500>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestsIdDocuments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequestsIdDocumentsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestsIdDocuments>>> = ({ signal }) => getRequestsIdDocuments(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequestsIdDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestsIdDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getRequestsIdDocuments>>>
export type GetRequestsIdDocumentsQueryError = GetRequestsIdDocuments400 | GetRequestsIdDocuments401 | GetRequestsIdDocuments500


export function useGetRequestsIdDocuments<TData = Awaited<ReturnType<typeof getRequestsIdDocuments>>, TError = GetRequestsIdDocuments400 | GetRequestsIdDocuments401 | GetRequestsIdDocuments500>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestsIdDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequestsIdDocuments>>,
          TError,
          Awaited<ReturnType<typeof getRequestsIdDocuments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestsIdDocuments<TData = Awaited<ReturnType<typeof getRequestsIdDocuments>>, TError = GetRequestsIdDocuments400 | GetRequestsIdDocuments401 | GetRequestsIdDocuments500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestsIdDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequestsIdDocuments>>,
          TError,
          Awaited<ReturnType<typeof getRequestsIdDocuments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestsIdDocuments<TData = Awaited<ReturnType<typeof getRequestsIdDocuments>>, TError = GetRequestsIdDocuments400 | GetRequestsIdDocuments401 | GetRequestsIdDocuments500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestsIdDocuments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Requests Documents
 */

export function useGetRequestsIdDocuments<TData = Awaited<ReturnType<typeof getRequestsIdDocuments>>, TError = GetRequestsIdDocuments400 | GetRequestsIdDocuments401 | GetRequestsIdDocuments500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestsIdDocuments>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRequestsIdDocumentsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Fetch Request Audit endpoint
 * @summary Fetch Fetch Request Audit
 */
export const getRequestsRequestIdAudit = (
    requestId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetRequestsRequestIdAudit200>(
      {url: `/requests/${requestId}/audit`, method: 'GET', signal
    },
      );
    }
  



export const getGetRequestsRequestIdAuditQueryKey = (requestId?: string,) => {
    return [
    `/requests/${requestId}/audit`
    ] as const;
    }

    
export const getGetRequestsRequestIdAuditQueryOptions = <TData = Awaited<ReturnType<typeof getRequestsRequestIdAudit>>, TError = GetRequestsRequestIdAudit400 | GetRequestsRequestIdAudit401 | GetRequestsRequestIdAudit500>(requestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestsRequestIdAudit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequestsRequestIdAuditQueryKey(requestId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestsRequestIdAudit>>> = ({ signal }) => getRequestsRequestIdAudit(requestId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(requestId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequestsRequestIdAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestsRequestIdAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getRequestsRequestIdAudit>>>
export type GetRequestsRequestIdAuditQueryError = GetRequestsRequestIdAudit400 | GetRequestsRequestIdAudit401 | GetRequestsRequestIdAudit500


export function useGetRequestsRequestIdAudit<TData = Awaited<ReturnType<typeof getRequestsRequestIdAudit>>, TError = GetRequestsRequestIdAudit400 | GetRequestsRequestIdAudit401 | GetRequestsRequestIdAudit500>(
 requestId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestsRequestIdAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequestsRequestIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getRequestsRequestIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestsRequestIdAudit<TData = Awaited<ReturnType<typeof getRequestsRequestIdAudit>>, TError = GetRequestsRequestIdAudit400 | GetRequestsRequestIdAudit401 | GetRequestsRequestIdAudit500>(
 requestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestsRequestIdAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequestsRequestIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getRequestsRequestIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestsRequestIdAudit<TData = Awaited<ReturnType<typeof getRequestsRequestIdAudit>>, TError = GetRequestsRequestIdAudit400 | GetRequestsRequestIdAudit401 | GetRequestsRequestIdAudit500>(
 requestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestsRequestIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Fetch Request Audit
 */

export function useGetRequestsRequestIdAudit<TData = Awaited<ReturnType<typeof getRequestsRequestIdAudit>>, TError = GetRequestsRequestIdAudit400 | GetRequestsRequestIdAudit401 | GetRequestsRequestIdAudit500>(
 requestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestsRequestIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRequestsRequestIdAuditQueryOptions(requestId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Fetch Recent Documents endpoint
 * @summary Fetch Fetch Recent Documents
 */
export const getEntitiesEntityIdDocumentsRecent = (
    entityId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesEntityIdDocumentsRecent200>(
      {url: `/entities/${entityId}/documents/recent`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesEntityIdDocumentsRecentQueryKey = (entityId?: string,) => {
    return [
    `/entities/${entityId}/documents/recent`
    ] as const;
    }

    
export const getGetEntitiesEntityIdDocumentsRecentQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesEntityIdDocumentsRecent>>, TError = GetEntitiesEntityIdDocumentsRecent400 | GetEntitiesEntityIdDocumentsRecent401 | GetEntitiesEntityIdDocumentsRecent500>(entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdDocumentsRecent>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesEntityIdDocumentsRecentQueryKey(entityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesEntityIdDocumentsRecent>>> = ({ signal }) => getEntitiesEntityIdDocumentsRecent(entityId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(entityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdDocumentsRecent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesEntityIdDocumentsRecentQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesEntityIdDocumentsRecent>>>
export type GetEntitiesEntityIdDocumentsRecentQueryError = GetEntitiesEntityIdDocumentsRecent400 | GetEntitiesEntityIdDocumentsRecent401 | GetEntitiesEntityIdDocumentsRecent500


export function useGetEntitiesEntityIdDocumentsRecent<TData = Awaited<ReturnType<typeof getEntitiesEntityIdDocumentsRecent>>, TError = GetEntitiesEntityIdDocumentsRecent400 | GetEntitiesEntityIdDocumentsRecent401 | GetEntitiesEntityIdDocumentsRecent500>(
 entityId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdDocumentsRecent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesEntityIdDocumentsRecent>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesEntityIdDocumentsRecent>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesEntityIdDocumentsRecent<TData = Awaited<ReturnType<typeof getEntitiesEntityIdDocumentsRecent>>, TError = GetEntitiesEntityIdDocumentsRecent400 | GetEntitiesEntityIdDocumentsRecent401 | GetEntitiesEntityIdDocumentsRecent500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdDocumentsRecent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesEntityIdDocumentsRecent>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesEntityIdDocumentsRecent>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesEntityIdDocumentsRecent<TData = Awaited<ReturnType<typeof getEntitiesEntityIdDocumentsRecent>>, TError = GetEntitiesEntityIdDocumentsRecent400 | GetEntitiesEntityIdDocumentsRecent401 | GetEntitiesEntityIdDocumentsRecent500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdDocumentsRecent>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Fetch Recent Documents
 */

export function useGetEntitiesEntityIdDocumentsRecent<TData = Awaited<ReturnType<typeof getEntitiesEntityIdDocumentsRecent>>, TError = GetEntitiesEntityIdDocumentsRecent400 | GetEntitiesEntityIdDocumentsRecent401 | GetEntitiesEntityIdDocumentsRecent500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdDocumentsRecent>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesEntityIdDocumentsRecentQueryOptions(entityId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Messages Public endpoint
 * @summary Fetch Messages Public
 */
export const getIdMessagesPublic = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetIdMessagesPublic200>(
      {url: `/${id}/messages/public`, method: 'GET', signal
    },
      );
    }
  



export const getGetIdMessagesPublicQueryKey = (id?: string,) => {
    return [
    `/${id}/messages/public`
    ] as const;
    }

    
export const getGetIdMessagesPublicQueryOptions = <TData = Awaited<ReturnType<typeof getIdMessagesPublic>>, TError = GetIdMessagesPublic400 | GetIdMessagesPublic401 | GetIdMessagesPublic500>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIdMessagesPublic>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIdMessagesPublicQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIdMessagesPublic>>> = ({ signal }) => getIdMessagesPublic(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIdMessagesPublic>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIdMessagesPublicQueryResult = NonNullable<Awaited<ReturnType<typeof getIdMessagesPublic>>>
export type GetIdMessagesPublicQueryError = GetIdMessagesPublic400 | GetIdMessagesPublic401 | GetIdMessagesPublic500


export function useGetIdMessagesPublic<TData = Awaited<ReturnType<typeof getIdMessagesPublic>>, TError = GetIdMessagesPublic400 | GetIdMessagesPublic401 | GetIdMessagesPublic500>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIdMessagesPublic>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIdMessagesPublic>>,
          TError,
          Awaited<ReturnType<typeof getIdMessagesPublic>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIdMessagesPublic<TData = Awaited<ReturnType<typeof getIdMessagesPublic>>, TError = GetIdMessagesPublic400 | GetIdMessagesPublic401 | GetIdMessagesPublic500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIdMessagesPublic>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIdMessagesPublic>>,
          TError,
          Awaited<ReturnType<typeof getIdMessagesPublic>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIdMessagesPublic<TData = Awaited<ReturnType<typeof getIdMessagesPublic>>, TError = GetIdMessagesPublic400 | GetIdMessagesPublic401 | GetIdMessagesPublic500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIdMessagesPublic>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Messages Public
 */

export function useGetIdMessagesPublic<TData = Awaited<ReturnType<typeof getIdMessagesPublic>>, TError = GetIdMessagesPublic400 | GetIdMessagesPublic401 | GetIdMessagesPublic500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIdMessagesPublic>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIdMessagesPublicQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Process Templates endpoint
 * @summary Fetch Process Templates
 */
export const getProcessTemplates = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetProcessTemplates200>(
      {url: `/process-templates`, method: 'GET', signal
    },
      );
    }
  



export const getGetProcessTemplatesQueryKey = () => {
    return [
    `/process-templates`
    ] as const;
    }

    
export const getGetProcessTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof getProcessTemplates>>, TError = GetProcessTemplates400 | GetProcessTemplates401 | GetProcessTemplates500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessTemplates>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProcessTemplatesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProcessTemplates>>> = ({ signal }) => getProcessTemplates(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProcessTemplates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProcessTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof getProcessTemplates>>>
export type GetProcessTemplatesQueryError = GetProcessTemplates400 | GetProcessTemplates401 | GetProcessTemplates500


export function useGetProcessTemplates<TData = Awaited<ReturnType<typeof getProcessTemplates>>, TError = GetProcessTemplates400 | GetProcessTemplates401 | GetProcessTemplates500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessTemplates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessTemplates>>,
          TError,
          Awaited<ReturnType<typeof getProcessTemplates>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessTemplates<TData = Awaited<ReturnType<typeof getProcessTemplates>>, TError = GetProcessTemplates400 | GetProcessTemplates401 | GetProcessTemplates500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessTemplates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessTemplates>>,
          TError,
          Awaited<ReturnType<typeof getProcessTemplates>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessTemplates<TData = Awaited<ReturnType<typeof getProcessTemplates>>, TError = GetProcessTemplates400 | GetProcessTemplates401 | GetProcessTemplates500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessTemplates>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Process Templates
 */

export function useGetProcessTemplates<TData = Awaited<ReturnType<typeof getProcessTemplates>>, TError = GetProcessTemplates400 | GetProcessTemplates401 | GetProcessTemplates500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessTemplates>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProcessTemplatesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Process Audit endpoint
 * @summary Fetch Process Audit
 */
export const getProcessesIdAudit = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetProcessesIdAudit200>(
      {url: `/processes/${id}/audit`, method: 'GET', signal
    },
      );
    }
  



export const getGetProcessesIdAuditQueryKey = (id?: string,) => {
    return [
    `/processes/${id}/audit`
    ] as const;
    }

    
export const getGetProcessesIdAuditQueryOptions = <TData = Awaited<ReturnType<typeof getProcessesIdAudit>>, TError = GetProcessesIdAudit400 | GetProcessesIdAudit401 | GetProcessesIdAudit500>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessesIdAudit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProcessesIdAuditQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProcessesIdAudit>>> = ({ signal }) => getProcessesIdAudit(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProcessesIdAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProcessesIdAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getProcessesIdAudit>>>
export type GetProcessesIdAuditQueryError = GetProcessesIdAudit400 | GetProcessesIdAudit401 | GetProcessesIdAudit500


export function useGetProcessesIdAudit<TData = Awaited<ReturnType<typeof getProcessesIdAudit>>, TError = GetProcessesIdAudit400 | GetProcessesIdAudit401 | GetProcessesIdAudit500>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessesIdAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessesIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getProcessesIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessesIdAudit<TData = Awaited<ReturnType<typeof getProcessesIdAudit>>, TError = GetProcessesIdAudit400 | GetProcessesIdAudit401 | GetProcessesIdAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessesIdAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessesIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getProcessesIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessesIdAudit<TData = Awaited<ReturnType<typeof getProcessesIdAudit>>, TError = GetProcessesIdAudit400 | GetProcessesIdAudit401 | GetProcessesIdAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessesIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Process Audit
 */

export function useGetProcessesIdAudit<TData = Awaited<ReturnType<typeof getProcessesIdAudit>>, TError = GetProcessesIdAudit400 | GetProcessesIdAudit401 | GetProcessesIdAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessesIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProcessesIdAuditQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Entities Personnel endpoint
 * @summary Fetch Entities Personnel
 */
export const getEntitiesEntityIdPersonnel = (
    entityId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesEntityIdPersonnel200>(
      {url: `/entities/${entityId}/personnel`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesEntityIdPersonnelQueryKey = (entityId?: string,) => {
    return [
    `/entities/${entityId}/personnel`
    ] as const;
    }

    
export const getGetEntitiesEntityIdPersonnelQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesEntityIdPersonnel>>, TError = GetEntitiesEntityIdPersonnel400 | GetEntitiesEntityIdPersonnel401 | GetEntitiesEntityIdPersonnel500>(entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdPersonnel>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesEntityIdPersonnelQueryKey(entityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesEntityIdPersonnel>>> = ({ signal }) => getEntitiesEntityIdPersonnel(entityId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(entityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdPersonnel>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesEntityIdPersonnelQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesEntityIdPersonnel>>>
export type GetEntitiesEntityIdPersonnelQueryError = GetEntitiesEntityIdPersonnel400 | GetEntitiesEntityIdPersonnel401 | GetEntitiesEntityIdPersonnel500


export function useGetEntitiesEntityIdPersonnel<TData = Awaited<ReturnType<typeof getEntitiesEntityIdPersonnel>>, TError = GetEntitiesEntityIdPersonnel400 | GetEntitiesEntityIdPersonnel401 | GetEntitiesEntityIdPersonnel500>(
 entityId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdPersonnel>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesEntityIdPersonnel>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesEntityIdPersonnel>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesEntityIdPersonnel<TData = Awaited<ReturnType<typeof getEntitiesEntityIdPersonnel>>, TError = GetEntitiesEntityIdPersonnel400 | GetEntitiesEntityIdPersonnel401 | GetEntitiesEntityIdPersonnel500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdPersonnel>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesEntityIdPersonnel>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesEntityIdPersonnel>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesEntityIdPersonnel<TData = Awaited<ReturnType<typeof getEntitiesEntityIdPersonnel>>, TError = GetEntitiesEntityIdPersonnel400 | GetEntitiesEntityIdPersonnel401 | GetEntitiesEntityIdPersonnel500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdPersonnel>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Entities Personnel
 */

export function useGetEntitiesEntityIdPersonnel<TData = Awaited<ReturnType<typeof getEntitiesEntityIdPersonnel>>, TError = GetEntitiesEntityIdPersonnel400 | GetEntitiesEntityIdPersonnel401 | GetEntitiesEntityIdPersonnel500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdPersonnel>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesEntityIdPersonnelQueryOptions(entityId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create Entities Personnel Add endpoint
 * @summary Create Entities Personnel Add
 */
export const postEntitiesEntityIdPersonnel = (
    entityId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostEntitiesEntityIdPersonnel200>(
      {url: `/entities/${entityId}/personnel`, method: 'POST', signal
    },
      );
    }
  


export const getPostEntitiesEntityIdPersonnelMutationOptions = <TError = PostEntitiesEntityIdPersonnel400 | PostEntitiesEntityIdPersonnel401 | PostEntitiesEntityIdPersonnel500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEntitiesEntityIdPersonnel>>, TError,{entityId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEntitiesEntityIdPersonnel>>, TError,{entityId: string}, TContext> => {

const mutationKey = ['postEntitiesEntityIdPersonnel'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEntitiesEntityIdPersonnel>>, {entityId: string}> = (props) => {
          const {entityId} = props ?? {};

          return  postEntitiesEntityIdPersonnel(entityId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEntitiesEntityIdPersonnelMutationResult = NonNullable<Awaited<ReturnType<typeof postEntitiesEntityIdPersonnel>>>
    
    export type PostEntitiesEntityIdPersonnelMutationError = PostEntitiesEntityIdPersonnel400 | PostEntitiesEntityIdPersonnel401 | PostEntitiesEntityIdPersonnel500

    /**
 * @summary Create Entities Personnel Add
 */
export const usePostEntitiesEntityIdPersonnel = <TError = PostEntitiesEntityIdPersonnel400 | PostEntitiesEntityIdPersonnel401 | PostEntitiesEntityIdPersonnel500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEntitiesEntityIdPersonnel>>, TError,{entityId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEntitiesEntityIdPersonnel>>,
        TError,
        {entityId: string},
        TContext
      > => {

      const mutationOptions = getPostEntitiesEntityIdPersonnelMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Entities Personnel Audit endpoint
 * @summary Fetch Entities Personnel Audit
 */
export const getEntitiesEntityIdPersonnelAudit = (
    entityId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesEntityIdPersonnelAudit200>(
      {url: `/entities/${entityId}/personnel/audit`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesEntityIdPersonnelAuditQueryKey = (entityId?: string,) => {
    return [
    `/entities/${entityId}/personnel/audit`
    ] as const;
    }

    
export const getGetEntitiesEntityIdPersonnelAuditQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesEntityIdPersonnelAudit>>, TError = GetEntitiesEntityIdPersonnelAudit400 | GetEntitiesEntityIdPersonnelAudit401 | GetEntitiesEntityIdPersonnelAudit500>(entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdPersonnelAudit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesEntityIdPersonnelAuditQueryKey(entityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesEntityIdPersonnelAudit>>> = ({ signal }) => getEntitiesEntityIdPersonnelAudit(entityId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(entityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdPersonnelAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesEntityIdPersonnelAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesEntityIdPersonnelAudit>>>
export type GetEntitiesEntityIdPersonnelAuditQueryError = GetEntitiesEntityIdPersonnelAudit400 | GetEntitiesEntityIdPersonnelAudit401 | GetEntitiesEntityIdPersonnelAudit500


export function useGetEntitiesEntityIdPersonnelAudit<TData = Awaited<ReturnType<typeof getEntitiesEntityIdPersonnelAudit>>, TError = GetEntitiesEntityIdPersonnelAudit400 | GetEntitiesEntityIdPersonnelAudit401 | GetEntitiesEntityIdPersonnelAudit500>(
 entityId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdPersonnelAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesEntityIdPersonnelAudit>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesEntityIdPersonnelAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesEntityIdPersonnelAudit<TData = Awaited<ReturnType<typeof getEntitiesEntityIdPersonnelAudit>>, TError = GetEntitiesEntityIdPersonnelAudit400 | GetEntitiesEntityIdPersonnelAudit401 | GetEntitiesEntityIdPersonnelAudit500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdPersonnelAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesEntityIdPersonnelAudit>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesEntityIdPersonnelAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesEntityIdPersonnelAudit<TData = Awaited<ReturnType<typeof getEntitiesEntityIdPersonnelAudit>>, TError = GetEntitiesEntityIdPersonnelAudit400 | GetEntitiesEntityIdPersonnelAudit401 | GetEntitiesEntityIdPersonnelAudit500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdPersonnelAudit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Entities Personnel Audit
 */

export function useGetEntitiesEntityIdPersonnelAudit<TData = Awaited<ReturnType<typeof getEntitiesEntityIdPersonnelAudit>>, TError = GetEntitiesEntityIdPersonnelAudit400 | GetEntitiesEntityIdPersonnelAudit401 | GetEntitiesEntityIdPersonnelAudit500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdPersonnelAudit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesEntityIdPersonnelAuditQueryOptions(entityId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Fetch Payslips endpoint
 * @summary Fetch Fetch Payslips
 */
export const getPayslips = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetPayslips200>(
      {url: `/payslips`, method: 'GET', signal
    },
      );
    }
  



export const getGetPayslipsQueryKey = () => {
    return [
    `/payslips`
    ] as const;
    }

    
export const getGetPayslipsQueryOptions = <TData = Awaited<ReturnType<typeof getPayslips>>, TError = GetPayslips400 | GetPayslips401 | GetPayslips500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayslips>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayslipsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayslips>>> = ({ signal }) => getPayslips(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayslips>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayslipsQueryResult = NonNullable<Awaited<ReturnType<typeof getPayslips>>>
export type GetPayslipsQueryError = GetPayslips400 | GetPayslips401 | GetPayslips500


export function useGetPayslips<TData = Awaited<ReturnType<typeof getPayslips>>, TError = GetPayslips400 | GetPayslips401 | GetPayslips500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayslips>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayslips>>,
          TError,
          Awaited<ReturnType<typeof getPayslips>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayslips<TData = Awaited<ReturnType<typeof getPayslips>>, TError = GetPayslips400 | GetPayslips401 | GetPayslips500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayslips>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayslips>>,
          TError,
          Awaited<ReturnType<typeof getPayslips>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayslips<TData = Awaited<ReturnType<typeof getPayslips>>, TError = GetPayslips400 | GetPayslips401 | GetPayslips500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayslips>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Fetch Payslips
 */

export function useGetPayslips<TData = Awaited<ReturnType<typeof getPayslips>>, TError = GetPayslips400 | GetPayslips401 | GetPayslips500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayslips>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayslipsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Payslip Matching Results endpoint
 * @summary Fetch Payslip Matching Results
 */
export const getPayslipMatchingResultsProcessId = (
    processId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetPayslipMatchingResultsProcessId200>(
      {url: `/payslip/matching_results/${processId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetPayslipMatchingResultsProcessIdQueryKey = (processId?: string,) => {
    return [
    `/payslip/matching_results/${processId}`
    ] as const;
    }

    
export const getGetPayslipMatchingResultsProcessIdQueryOptions = <TData = Awaited<ReturnType<typeof getPayslipMatchingResultsProcessId>>, TError = GetPayslipMatchingResultsProcessId400 | GetPayslipMatchingResultsProcessId401 | GetPayslipMatchingResultsProcessId500>(processId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayslipMatchingResultsProcessId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayslipMatchingResultsProcessIdQueryKey(processId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayslipMatchingResultsProcessId>>> = ({ signal }) => getPayslipMatchingResultsProcessId(processId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(processId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayslipMatchingResultsProcessId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayslipMatchingResultsProcessIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPayslipMatchingResultsProcessId>>>
export type GetPayslipMatchingResultsProcessIdQueryError = GetPayslipMatchingResultsProcessId400 | GetPayslipMatchingResultsProcessId401 | GetPayslipMatchingResultsProcessId500


export function useGetPayslipMatchingResultsProcessId<TData = Awaited<ReturnType<typeof getPayslipMatchingResultsProcessId>>, TError = GetPayslipMatchingResultsProcessId400 | GetPayslipMatchingResultsProcessId401 | GetPayslipMatchingResultsProcessId500>(
 processId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayslipMatchingResultsProcessId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayslipMatchingResultsProcessId>>,
          TError,
          Awaited<ReturnType<typeof getPayslipMatchingResultsProcessId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayslipMatchingResultsProcessId<TData = Awaited<ReturnType<typeof getPayslipMatchingResultsProcessId>>, TError = GetPayslipMatchingResultsProcessId400 | GetPayslipMatchingResultsProcessId401 | GetPayslipMatchingResultsProcessId500>(
 processId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayslipMatchingResultsProcessId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayslipMatchingResultsProcessId>>,
          TError,
          Awaited<ReturnType<typeof getPayslipMatchingResultsProcessId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayslipMatchingResultsProcessId<TData = Awaited<ReturnType<typeof getPayslipMatchingResultsProcessId>>, TError = GetPayslipMatchingResultsProcessId400 | GetPayslipMatchingResultsProcessId401 | GetPayslipMatchingResultsProcessId500>(
 processId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayslipMatchingResultsProcessId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Payslip Matching Results
 */

export function useGetPayslipMatchingResultsProcessId<TData = Awaited<ReturnType<typeof getPayslipMatchingResultsProcessId>>, TError = GetPayslipMatchingResultsProcessId400 | GetPayslipMatchingResultsProcessId401 | GetPayslipMatchingResultsProcessId500>(
 processId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayslipMatchingResultsProcessId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayslipMatchingResultsProcessIdQueryOptions(processId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Fetch Payslip Matching Result endpoint
 * @summary Fetch Fetch Payslip Matching Result
 */
export const getPayslipMatchingResultsResultId = (
    resultId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetPayslipMatchingResultsResultId200>(
      {url: `/payslip-matching-results/${resultId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetPayslipMatchingResultsResultIdQueryKey = (resultId?: string,) => {
    return [
    `/payslip-matching-results/${resultId}`
    ] as const;
    }

    
export const getGetPayslipMatchingResultsResultIdQueryOptions = <TData = Awaited<ReturnType<typeof getPayslipMatchingResultsResultId>>, TError = GetPayslipMatchingResultsResultId400 | GetPayslipMatchingResultsResultId401 | GetPayslipMatchingResultsResultId500>(resultId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayslipMatchingResultsResultId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayslipMatchingResultsResultIdQueryKey(resultId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayslipMatchingResultsResultId>>> = ({ signal }) => getPayslipMatchingResultsResultId(resultId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(resultId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayslipMatchingResultsResultId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayslipMatchingResultsResultIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPayslipMatchingResultsResultId>>>
export type GetPayslipMatchingResultsResultIdQueryError = GetPayslipMatchingResultsResultId400 | GetPayslipMatchingResultsResultId401 | GetPayslipMatchingResultsResultId500


export function useGetPayslipMatchingResultsResultId<TData = Awaited<ReturnType<typeof getPayslipMatchingResultsResultId>>, TError = GetPayslipMatchingResultsResultId400 | GetPayslipMatchingResultsResultId401 | GetPayslipMatchingResultsResultId500>(
 resultId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayslipMatchingResultsResultId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayslipMatchingResultsResultId>>,
          TError,
          Awaited<ReturnType<typeof getPayslipMatchingResultsResultId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayslipMatchingResultsResultId<TData = Awaited<ReturnType<typeof getPayslipMatchingResultsResultId>>, TError = GetPayslipMatchingResultsResultId400 | GetPayslipMatchingResultsResultId401 | GetPayslipMatchingResultsResultId500>(
 resultId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayslipMatchingResultsResultId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayslipMatchingResultsResultId>>,
          TError,
          Awaited<ReturnType<typeof getPayslipMatchingResultsResultId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayslipMatchingResultsResultId<TData = Awaited<ReturnType<typeof getPayslipMatchingResultsResultId>>, TError = GetPayslipMatchingResultsResultId400 | GetPayslipMatchingResultsResultId401 | GetPayslipMatchingResultsResultId500>(
 resultId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayslipMatchingResultsResultId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Fetch Payslip Matching Result
 */

export function useGetPayslipMatchingResultsResultId<TData = Awaited<ReturnType<typeof getPayslipMatchingResultsResultId>>, TError = GetPayslipMatchingResultsResultId400 | GetPayslipMatchingResultsResultId401 | GetPayslipMatchingResultsResultId500>(
 resultId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayslipMatchingResultsResultId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayslipMatchingResultsResultIdQueryOptions(resultId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Delete Delete Payslip Matching Result endpoint
 * @summary Delete Delete Payslip Matching Result
 */
export const deletePayslipMatchingResultsResultId = (
    resultId: string,
 ) => {
      
      
      return customInstance<DeletePayslipMatchingResultsResultId200>(
      {url: `/payslip-matching-results/${resultId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeletePayslipMatchingResultsResultIdMutationOptions = <TError = DeletePayslipMatchingResultsResultId400 | DeletePayslipMatchingResultsResultId401 | DeletePayslipMatchingResultsResultId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePayslipMatchingResultsResultId>>, TError,{resultId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePayslipMatchingResultsResultId>>, TError,{resultId: string}, TContext> => {

const mutationKey = ['deletePayslipMatchingResultsResultId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePayslipMatchingResultsResultId>>, {resultId: string}> = (props) => {
          const {resultId} = props ?? {};

          return  deletePayslipMatchingResultsResultId(resultId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePayslipMatchingResultsResultIdMutationResult = NonNullable<Awaited<ReturnType<typeof deletePayslipMatchingResultsResultId>>>
    
    export type DeletePayslipMatchingResultsResultIdMutationError = DeletePayslipMatchingResultsResultId400 | DeletePayslipMatchingResultsResultId401 | DeletePayslipMatchingResultsResultId500

    /**
 * @summary Delete Delete Payslip Matching Result
 */
export const useDeletePayslipMatchingResultsResultId = <TError = DeletePayslipMatchingResultsResultId400 | DeletePayslipMatchingResultsResultId401 | DeletePayslipMatchingResultsResultId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePayslipMatchingResultsResultId>>, TError,{resultId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePayslipMatchingResultsResultId>>,
        TError,
        {resultId: string},
        TContext
      > => {

      const mutationOptions = getDeletePayslipMatchingResultsResultIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Organizations endpoint
 * @summary Fetch Organizations
 */
export const getOrganizations = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetOrganizations200>(
      {url: `/organizations`, method: 'GET', signal
    },
      );
    }
  



export const getGetOrganizationsQueryKey = () => {
    return [
    `/organizations`
    ] as const;
    }

    
export const getGetOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizations>>, TError = GetOrganizations400 | GetOrganizations401 | GetOrganizations500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizations>>> = ({ signal }) => getOrganizations(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizations>>>
export type GetOrganizationsQueryError = GetOrganizations400 | GetOrganizations401 | GetOrganizations500


export function useGetOrganizations<TData = Awaited<ReturnType<typeof getOrganizations>>, TError = GetOrganizations400 | GetOrganizations401 | GetOrganizations500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizations>>,
          TError,
          Awaited<ReturnType<typeof getOrganizations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizations<TData = Awaited<ReturnType<typeof getOrganizations>>, TError = GetOrganizations400 | GetOrganizations401 | GetOrganizations500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizations>>,
          TError,
          Awaited<ReturnType<typeof getOrganizations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizations<TData = Awaited<ReturnType<typeof getOrganizations>>, TError = GetOrganizations400 | GetOrganizations401 | GetOrganizations500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Organizations
 */

export function useGetOrganizations<TData = Awaited<ReturnType<typeof getOrganizations>>, TError = GetOrganizations400 | GetOrganizations401 | GetOrganizations500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Fetch Officers endpoint
 * @summary Fetch Fetch Officers
 */
export const getEntitiesEntityIdOfficers = (
    entityId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesEntityIdOfficers200>(
      {url: `/entities/${entityId}/officers`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesEntityIdOfficersQueryKey = (entityId?: string,) => {
    return [
    `/entities/${entityId}/officers`
    ] as const;
    }

    
export const getGetEntitiesEntityIdOfficersQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesEntityIdOfficers>>, TError = GetEntitiesEntityIdOfficers400 | GetEntitiesEntityIdOfficers401 | GetEntitiesEntityIdOfficers500>(entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdOfficers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesEntityIdOfficersQueryKey(entityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesEntityIdOfficers>>> = ({ signal }) => getEntitiesEntityIdOfficers(entityId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(entityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdOfficers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesEntityIdOfficersQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesEntityIdOfficers>>>
export type GetEntitiesEntityIdOfficersQueryError = GetEntitiesEntityIdOfficers400 | GetEntitiesEntityIdOfficers401 | GetEntitiesEntityIdOfficers500


export function useGetEntitiesEntityIdOfficers<TData = Awaited<ReturnType<typeof getEntitiesEntityIdOfficers>>, TError = GetEntitiesEntityIdOfficers400 | GetEntitiesEntityIdOfficers401 | GetEntitiesEntityIdOfficers500>(
 entityId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdOfficers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesEntityIdOfficers>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesEntityIdOfficers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesEntityIdOfficers<TData = Awaited<ReturnType<typeof getEntitiesEntityIdOfficers>>, TError = GetEntitiesEntityIdOfficers400 | GetEntitiesEntityIdOfficers401 | GetEntitiesEntityIdOfficers500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdOfficers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesEntityIdOfficers>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesEntityIdOfficers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesEntityIdOfficers<TData = Awaited<ReturnType<typeof getEntitiesEntityIdOfficers>>, TError = GetEntitiesEntityIdOfficers400 | GetEntitiesEntityIdOfficers401 | GetEntitiesEntityIdOfficers500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdOfficers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Fetch Officers
 */

export function useGetEntitiesEntityIdOfficers<TData = Awaited<ReturnType<typeof getEntitiesEntityIdOfficers>>, TError = GetEntitiesEntityIdOfficers400 | GetEntitiesEntityIdOfficers401 | GetEntitiesEntityIdOfficers500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdOfficers>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesEntityIdOfficersQueryOptions(entityId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create Add Officer endpoint
 * @summary Create Add Officer
 */
export const postEntitiesEntityIdOfficers = (
    entityId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostEntitiesEntityIdOfficers200>(
      {url: `/entities/${entityId}/officers`, method: 'POST', signal
    },
      );
    }
  


export const getPostEntitiesEntityIdOfficersMutationOptions = <TError = PostEntitiesEntityIdOfficers400 | PostEntitiesEntityIdOfficers401 | PostEntitiesEntityIdOfficers500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEntitiesEntityIdOfficers>>, TError,{entityId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEntitiesEntityIdOfficers>>, TError,{entityId: string}, TContext> => {

const mutationKey = ['postEntitiesEntityIdOfficers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEntitiesEntityIdOfficers>>, {entityId: string}> = (props) => {
          const {entityId} = props ?? {};

          return  postEntitiesEntityIdOfficers(entityId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEntitiesEntityIdOfficersMutationResult = NonNullable<Awaited<ReturnType<typeof postEntitiesEntityIdOfficers>>>
    
    export type PostEntitiesEntityIdOfficersMutationError = PostEntitiesEntityIdOfficers400 | PostEntitiesEntityIdOfficers401 | PostEntitiesEntityIdOfficers500

    /**
 * @summary Create Add Officer
 */
export const usePostEntitiesEntityIdOfficers = <TError = PostEntitiesEntityIdOfficers400 | PostEntitiesEntityIdOfficers401 | PostEntitiesEntityIdOfficers500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEntitiesEntityIdOfficers>>, TError,{entityId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEntitiesEntityIdOfficers>>,
        TError,
        {entityId: string},
        TContext
      > => {

      const mutationOptions = getPostEntitiesEntityIdOfficersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Fetch Officer Audit endpoint
 * @summary Fetch Fetch Officer Audit
 */
export const getEntitiesOfficersOfficerIdAudit = (
    officerId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesOfficersOfficerIdAudit200>(
      {url: `/entities/officers/${officerId}/audit`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesOfficersOfficerIdAuditQueryKey = (officerId?: string,) => {
    return [
    `/entities/officers/${officerId}/audit`
    ] as const;
    }

    
export const getGetEntitiesOfficersOfficerIdAuditQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesOfficersOfficerIdAudit>>, TError = GetEntitiesOfficersOfficerIdAudit400 | GetEntitiesOfficersOfficerIdAudit401 | GetEntitiesOfficersOfficerIdAudit500>(officerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesOfficersOfficerIdAudit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesOfficersOfficerIdAuditQueryKey(officerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesOfficersOfficerIdAudit>>> = ({ signal }) => getEntitiesOfficersOfficerIdAudit(officerId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(officerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesOfficersOfficerIdAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesOfficersOfficerIdAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesOfficersOfficerIdAudit>>>
export type GetEntitiesOfficersOfficerIdAuditQueryError = GetEntitiesOfficersOfficerIdAudit400 | GetEntitiesOfficersOfficerIdAudit401 | GetEntitiesOfficersOfficerIdAudit500


export function useGetEntitiesOfficersOfficerIdAudit<TData = Awaited<ReturnType<typeof getEntitiesOfficersOfficerIdAudit>>, TError = GetEntitiesOfficersOfficerIdAudit400 | GetEntitiesOfficersOfficerIdAudit401 | GetEntitiesOfficersOfficerIdAudit500>(
 officerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesOfficersOfficerIdAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesOfficersOfficerIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesOfficersOfficerIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesOfficersOfficerIdAudit<TData = Awaited<ReturnType<typeof getEntitiesOfficersOfficerIdAudit>>, TError = GetEntitiesOfficersOfficerIdAudit400 | GetEntitiesOfficersOfficerIdAudit401 | GetEntitiesOfficersOfficerIdAudit500>(
 officerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesOfficersOfficerIdAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesOfficersOfficerIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesOfficersOfficerIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesOfficersOfficerIdAudit<TData = Awaited<ReturnType<typeof getEntitiesOfficersOfficerIdAudit>>, TError = GetEntitiesOfficersOfficerIdAudit400 | GetEntitiesOfficersOfficerIdAudit401 | GetEntitiesOfficersOfficerIdAudit500>(
 officerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesOfficersOfficerIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Fetch Officer Audit
 */

export function useGetEntitiesOfficersOfficerIdAudit<TData = Awaited<ReturnType<typeof getEntitiesOfficersOfficerIdAudit>>, TError = GetEntitiesOfficersOfficerIdAudit400 | GetEntitiesOfficersOfficerIdAudit401 | GetEntitiesOfficersOfficerIdAudit500>(
 officerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesOfficersOfficerIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesOfficersOfficerIdAuditQueryOptions(officerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Process Milestones endpoint
 * @summary Fetch Process Milestones
 */
export const getProcessesIdMilestones = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetProcessesIdMilestones200>(
      {url: `/processes/${id}/milestones`, method: 'GET', signal
    },
      );
    }
  



export const getGetProcessesIdMilestonesQueryKey = (id?: string,) => {
    return [
    `/processes/${id}/milestones`
    ] as const;
    }

    
export const getGetProcessesIdMilestonesQueryOptions = <TData = Awaited<ReturnType<typeof getProcessesIdMilestones>>, TError = GetProcessesIdMilestones400 | GetProcessesIdMilestones401 | GetProcessesIdMilestones500>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessesIdMilestones>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProcessesIdMilestonesQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProcessesIdMilestones>>> = ({ signal }) => getProcessesIdMilestones(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProcessesIdMilestones>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProcessesIdMilestonesQueryResult = NonNullable<Awaited<ReturnType<typeof getProcessesIdMilestones>>>
export type GetProcessesIdMilestonesQueryError = GetProcessesIdMilestones400 | GetProcessesIdMilestones401 | GetProcessesIdMilestones500


export function useGetProcessesIdMilestones<TData = Awaited<ReturnType<typeof getProcessesIdMilestones>>, TError = GetProcessesIdMilestones400 | GetProcessesIdMilestones401 | GetProcessesIdMilestones500>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessesIdMilestones>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessesIdMilestones>>,
          TError,
          Awaited<ReturnType<typeof getProcessesIdMilestones>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessesIdMilestones<TData = Awaited<ReturnType<typeof getProcessesIdMilestones>>, TError = GetProcessesIdMilestones400 | GetProcessesIdMilestones401 | GetProcessesIdMilestones500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessesIdMilestones>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessesIdMilestones>>,
          TError,
          Awaited<ReturnType<typeof getProcessesIdMilestones>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessesIdMilestones<TData = Awaited<ReturnType<typeof getProcessesIdMilestones>>, TError = GetProcessesIdMilestones400 | GetProcessesIdMilestones401 | GetProcessesIdMilestones500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessesIdMilestones>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Process Milestones
 */

export function useGetProcessesIdMilestones<TData = Awaited<ReturnType<typeof getProcessesIdMilestones>>, TError = GetProcessesIdMilestones400 | GetProcessesIdMilestones401 | GetProcessesIdMilestones500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessesIdMilestones>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProcessesIdMilestonesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Process Milestone Siblings endpoint
 * @summary Fetch Process Milestone Siblings
 */
export const getProcessesMilestonesIdSiblings = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetProcessesMilestonesIdSiblings200>(
      {url: `/processes/milestones/${id}/siblings`, method: 'GET', signal
    },
      );
    }
  



export const getGetProcessesMilestonesIdSiblingsQueryKey = (id?: string,) => {
    return [
    `/processes/milestones/${id}/siblings`
    ] as const;
    }

    
export const getGetProcessesMilestonesIdSiblingsQueryOptions = <TData = Awaited<ReturnType<typeof getProcessesMilestonesIdSiblings>>, TError = GetProcessesMilestonesIdSiblings400 | GetProcessesMilestonesIdSiblings401 | GetProcessesMilestonesIdSiblings500>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessesMilestonesIdSiblings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProcessesMilestonesIdSiblingsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProcessesMilestonesIdSiblings>>> = ({ signal }) => getProcessesMilestonesIdSiblings(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProcessesMilestonesIdSiblings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProcessesMilestonesIdSiblingsQueryResult = NonNullable<Awaited<ReturnType<typeof getProcessesMilestonesIdSiblings>>>
export type GetProcessesMilestonesIdSiblingsQueryError = GetProcessesMilestonesIdSiblings400 | GetProcessesMilestonesIdSiblings401 | GetProcessesMilestonesIdSiblings500


export function useGetProcessesMilestonesIdSiblings<TData = Awaited<ReturnType<typeof getProcessesMilestonesIdSiblings>>, TError = GetProcessesMilestonesIdSiblings400 | GetProcessesMilestonesIdSiblings401 | GetProcessesMilestonesIdSiblings500>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessesMilestonesIdSiblings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessesMilestonesIdSiblings>>,
          TError,
          Awaited<ReturnType<typeof getProcessesMilestonesIdSiblings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessesMilestonesIdSiblings<TData = Awaited<ReturnType<typeof getProcessesMilestonesIdSiblings>>, TError = GetProcessesMilestonesIdSiblings400 | GetProcessesMilestonesIdSiblings401 | GetProcessesMilestonesIdSiblings500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessesMilestonesIdSiblings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessesMilestonesIdSiblings>>,
          TError,
          Awaited<ReturnType<typeof getProcessesMilestonesIdSiblings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessesMilestonesIdSiblings<TData = Awaited<ReturnType<typeof getProcessesMilestonesIdSiblings>>, TError = GetProcessesMilestonesIdSiblings400 | GetProcessesMilestonesIdSiblings401 | GetProcessesMilestonesIdSiblings500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessesMilestonesIdSiblings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Process Milestone Siblings
 */

export function useGetProcessesMilestonesIdSiblings<TData = Awaited<ReturnType<typeof getProcessesMilestonesIdSiblings>>, TError = GetProcessesMilestonesIdSiblings400 | GetProcessesMilestonesIdSiblings401 | GetProcessesMilestonesIdSiblings500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessesMilestonesIdSiblings>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProcessesMilestonesIdSiblingsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Lsps endpoint
 * @summary Fetch Lsps
 */
export const getLsps = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetLsps200>(
      {url: `/lsps`, method: 'GET', signal
    },
      );
    }
  



export const getGetLspsQueryKey = () => {
    return [
    `/lsps`
    ] as const;
    }

    
export const getGetLspsQueryOptions = <TData = Awaited<ReturnType<typeof getLsps>>, TError = GetLsps400 | GetLsps401 | GetLsps500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLsps>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLspsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLsps>>> = ({ signal }) => getLsps(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLsps>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLspsQueryResult = NonNullable<Awaited<ReturnType<typeof getLsps>>>
export type GetLspsQueryError = GetLsps400 | GetLsps401 | GetLsps500


export function useGetLsps<TData = Awaited<ReturnType<typeof getLsps>>, TError = GetLsps400 | GetLsps401 | GetLsps500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLsps>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLsps>>,
          TError,
          Awaited<ReturnType<typeof getLsps>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLsps<TData = Awaited<ReturnType<typeof getLsps>>, TError = GetLsps400 | GetLsps401 | GetLsps500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLsps>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLsps>>,
          TError,
          Awaited<ReturnType<typeof getLsps>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLsps<TData = Awaited<ReturnType<typeof getLsps>>, TError = GetLsps400 | GetLsps401 | GetLsps500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLsps>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Lsps
 */

export function useGetLsps<TData = Awaited<ReturnType<typeof getLsps>>, TError = GetLsps400 | GetLsps401 | GetLsps500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLsps>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLspsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Lsps Audits endpoint
 * @summary Fetch Lsps Audits
 */
export const getLspsAudits = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetLspsAudits200>(
      {url: `/lspsAudits`, method: 'GET', signal
    },
      );
    }
  



export const getGetLspsAuditsQueryKey = () => {
    return [
    `/lspsAudits`
    ] as const;
    }

    
export const getGetLspsAuditsQueryOptions = <TData = Awaited<ReturnType<typeof getLspsAudits>>, TError = GetLspsAudits400 | GetLspsAudits401 | GetLspsAudits500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLspsAudits>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLspsAuditsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLspsAudits>>> = ({ signal }) => getLspsAudits(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLspsAudits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLspsAuditsQueryResult = NonNullable<Awaited<ReturnType<typeof getLspsAudits>>>
export type GetLspsAuditsQueryError = GetLspsAudits400 | GetLspsAudits401 | GetLspsAudits500


export function useGetLspsAudits<TData = Awaited<ReturnType<typeof getLspsAudits>>, TError = GetLspsAudits400 | GetLspsAudits401 | GetLspsAudits500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLspsAudits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLspsAudits>>,
          TError,
          Awaited<ReturnType<typeof getLspsAudits>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLspsAudits<TData = Awaited<ReturnType<typeof getLspsAudits>>, TError = GetLspsAudits400 | GetLspsAudits401 | GetLspsAudits500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLspsAudits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLspsAudits>>,
          TError,
          Awaited<ReturnType<typeof getLspsAudits>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLspsAudits<TData = Awaited<ReturnType<typeof getLspsAudits>>, TError = GetLspsAudits400 | GetLspsAudits401 | GetLspsAudits500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLspsAudits>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Lsps Audits
 */

export function useGetLspsAudits<TData = Awaited<ReturnType<typeof getLspsAudits>>, TError = GetLspsAudits400 | GetLspsAudits401 | GetLspsAudits500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLspsAudits>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLspsAuditsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Lsp Audit endpoint
 * @summary Fetch Lsp Audit
 */
export const getLspIdAudit = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetLspIdAudit200>(
      {url: `/lsp/${id}/audit`, method: 'GET', signal
    },
      );
    }
  



export const getGetLspIdAuditQueryKey = (id?: string,) => {
    return [
    `/lsp/${id}/audit`
    ] as const;
    }

    
export const getGetLspIdAuditQueryOptions = <TData = Awaited<ReturnType<typeof getLspIdAudit>>, TError = GetLspIdAudit400 | GetLspIdAudit401 | GetLspIdAudit500>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLspIdAudit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLspIdAuditQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLspIdAudit>>> = ({ signal }) => getLspIdAudit(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLspIdAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLspIdAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getLspIdAudit>>>
export type GetLspIdAuditQueryError = GetLspIdAudit400 | GetLspIdAudit401 | GetLspIdAudit500


export function useGetLspIdAudit<TData = Awaited<ReturnType<typeof getLspIdAudit>>, TError = GetLspIdAudit400 | GetLspIdAudit401 | GetLspIdAudit500>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLspIdAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLspIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getLspIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLspIdAudit<TData = Awaited<ReturnType<typeof getLspIdAudit>>, TError = GetLspIdAudit400 | GetLspIdAudit401 | GetLspIdAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLspIdAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLspIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getLspIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLspIdAudit<TData = Awaited<ReturnType<typeof getLspIdAudit>>, TError = GetLspIdAudit400 | GetLspIdAudit401 | GetLspIdAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLspIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Lsp Audit
 */

export function useGetLspIdAudit<TData = Awaited<ReturnType<typeof getLspIdAudit>>, TError = GetLspIdAudit400 | GetLspIdAudit401 | GetLspIdAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLspIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLspIdAuditQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Messages Internal endpoint
 * @summary Fetch Messages Internal
 */
export const getIdMessagesInternal = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetIdMessagesInternal200>(
      {url: `/${id}/messages/internal`, method: 'GET', signal
    },
      );
    }
  



export const getGetIdMessagesInternalQueryKey = (id?: string,) => {
    return [
    `/${id}/messages/internal`
    ] as const;
    }

    
export const getGetIdMessagesInternalQueryOptions = <TData = Awaited<ReturnType<typeof getIdMessagesInternal>>, TError = GetIdMessagesInternal400 | GetIdMessagesInternal401 | GetIdMessagesInternal500>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIdMessagesInternal>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIdMessagesInternalQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIdMessagesInternal>>> = ({ signal }) => getIdMessagesInternal(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIdMessagesInternal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIdMessagesInternalQueryResult = NonNullable<Awaited<ReturnType<typeof getIdMessagesInternal>>>
export type GetIdMessagesInternalQueryError = GetIdMessagesInternal400 | GetIdMessagesInternal401 | GetIdMessagesInternal500


export function useGetIdMessagesInternal<TData = Awaited<ReturnType<typeof getIdMessagesInternal>>, TError = GetIdMessagesInternal400 | GetIdMessagesInternal401 | GetIdMessagesInternal500>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIdMessagesInternal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIdMessagesInternal>>,
          TError,
          Awaited<ReturnType<typeof getIdMessagesInternal>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIdMessagesInternal<TData = Awaited<ReturnType<typeof getIdMessagesInternal>>, TError = GetIdMessagesInternal400 | GetIdMessagesInternal401 | GetIdMessagesInternal500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIdMessagesInternal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIdMessagesInternal>>,
          TError,
          Awaited<ReturnType<typeof getIdMessagesInternal>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIdMessagesInternal<TData = Awaited<ReturnType<typeof getIdMessagesInternal>>, TError = GetIdMessagesInternal400 | GetIdMessagesInternal401 | GetIdMessagesInternal500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIdMessagesInternal>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Messages Internal
 */

export function useGetIdMessagesInternal<TData = Awaited<ReturnType<typeof getIdMessagesInternal>>, TError = GetIdMessagesInternal400 | GetIdMessagesInternal401 | GetIdMessagesInternal500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIdMessagesInternal>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIdMessagesInternalQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Holidays endpoint
 * @summary Fetch Holidays
 */
export const getHolidays = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetHolidays200>(
      {url: `/holidays`, method: 'GET', signal
    },
      );
    }
  



export const getGetHolidaysQueryKey = () => {
    return [
    `/holidays`
    ] as const;
    }

    
export const getGetHolidaysQueryOptions = <TData = Awaited<ReturnType<typeof getHolidays>>, TError = GetHolidays400 | GetHolidays401 | GetHolidays500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHolidays>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHolidaysQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHolidays>>> = ({ signal }) => getHolidays(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHolidays>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHolidaysQueryResult = NonNullable<Awaited<ReturnType<typeof getHolidays>>>
export type GetHolidaysQueryError = GetHolidays400 | GetHolidays401 | GetHolidays500


export function useGetHolidays<TData = Awaited<ReturnType<typeof getHolidays>>, TError = GetHolidays400 | GetHolidays401 | GetHolidays500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHolidays>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHolidays>>,
          TError,
          Awaited<ReturnType<typeof getHolidays>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHolidays<TData = Awaited<ReturnType<typeof getHolidays>>, TError = GetHolidays400 | GetHolidays401 | GetHolidays500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHolidays>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHolidays>>,
          TError,
          Awaited<ReturnType<typeof getHolidays>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHolidays<TData = Awaited<ReturnType<typeof getHolidays>>, TError = GetHolidays400 | GetHolidays401 | GetHolidays500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHolidays>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Holidays
 */

export function useGetHolidays<TData = Awaited<ReturnType<typeof getHolidays>>, TError = GetHolidays400 | GetHolidays401 | GetHolidays500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHolidays>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHolidaysQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Events endpoint
 * @summary Fetch Events
 */
export const getEvents = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEvents200>(
      {url: `/events`, method: 'GET', signal
    },
      );
    }
  



export const getGetEventsQueryKey = () => {
    return [
    `/events`
    ] as const;
    }

    
export const getGetEventsQueryOptions = <TData = Awaited<ReturnType<typeof getEvents>>, TError = GetEvents400 | GetEvents401 | GetEvents500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvents>>> = ({ signal }) => getEvents(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getEvents>>>
export type GetEventsQueryError = GetEvents400 | GetEvents401 | GetEvents500


export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = GetEvents400 | GetEvents401 | GetEvents500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvents>>,
          TError,
          Awaited<ReturnType<typeof getEvents>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = GetEvents400 | GetEvents401 | GetEvents500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvents>>,
          TError,
          Awaited<ReturnType<typeof getEvents>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = GetEvents400 | GetEvents401 | GetEvents500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Events
 */

export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = GetEvents400 | GetEvents401 | GetEvents500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Entities Plus Config Audit endpoint
 * @summary Fetch Entities Plus Config Audit
 */
export const getEntitiesIdPlusConfigAudit = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesIdPlusConfigAudit200>(
      {url: `/entities/${id}/plus-config/audit`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesIdPlusConfigAuditQueryKey = (id?: string,) => {
    return [
    `/entities/${id}/plus-config/audit`
    ] as const;
    }

    
export const getGetEntitiesIdPlusConfigAuditQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesIdPlusConfigAudit>>, TError = GetEntitiesIdPlusConfigAudit400 | GetEntitiesIdPlusConfigAudit401 | GetEntitiesIdPlusConfigAudit500>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesIdPlusConfigAudit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesIdPlusConfigAuditQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesIdPlusConfigAudit>>> = ({ signal }) => getEntitiesIdPlusConfigAudit(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesIdPlusConfigAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesIdPlusConfigAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesIdPlusConfigAudit>>>
export type GetEntitiesIdPlusConfigAuditQueryError = GetEntitiesIdPlusConfigAudit400 | GetEntitiesIdPlusConfigAudit401 | GetEntitiesIdPlusConfigAudit500


export function useGetEntitiesIdPlusConfigAudit<TData = Awaited<ReturnType<typeof getEntitiesIdPlusConfigAudit>>, TError = GetEntitiesIdPlusConfigAudit400 | GetEntitiesIdPlusConfigAudit401 | GetEntitiesIdPlusConfigAudit500>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesIdPlusConfigAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesIdPlusConfigAudit>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesIdPlusConfigAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesIdPlusConfigAudit<TData = Awaited<ReturnType<typeof getEntitiesIdPlusConfigAudit>>, TError = GetEntitiesIdPlusConfigAudit400 | GetEntitiesIdPlusConfigAudit401 | GetEntitiesIdPlusConfigAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesIdPlusConfigAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesIdPlusConfigAudit>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesIdPlusConfigAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesIdPlusConfigAudit<TData = Awaited<ReturnType<typeof getEntitiesIdPlusConfigAudit>>, TError = GetEntitiesIdPlusConfigAudit400 | GetEntitiesIdPlusConfigAudit401 | GetEntitiesIdPlusConfigAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesIdPlusConfigAudit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Entities Plus Config Audit
 */

export function useGetEntitiesIdPlusConfigAudit<TData = Awaited<ReturnType<typeof getEntitiesIdPlusConfigAudit>>, TError = GetEntitiesIdPlusConfigAudit400 | GetEntitiesIdPlusConfigAudit401 | GetEntitiesIdPlusConfigAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesIdPlusConfigAudit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesIdPlusConfigAuditQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Fetch Entity Lsps endpoint
 * @summary Fetch Fetch Entity Lsps
 */
export const getEntitiesEntityIdLsp = (
    entityId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesEntityIdLsp200>(
      {url: `/entities/${entityId}/lsp`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesEntityIdLspQueryKey = (entityId?: string,) => {
    return [
    `/entities/${entityId}/lsp`
    ] as const;
    }

    
export const getGetEntitiesEntityIdLspQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesEntityIdLsp>>, TError = GetEntitiesEntityIdLsp400 | GetEntitiesEntityIdLsp401 | GetEntitiesEntityIdLsp500>(entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdLsp>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesEntityIdLspQueryKey(entityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesEntityIdLsp>>> = ({ signal }) => getEntitiesEntityIdLsp(entityId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(entityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdLsp>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesEntityIdLspQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesEntityIdLsp>>>
export type GetEntitiesEntityIdLspQueryError = GetEntitiesEntityIdLsp400 | GetEntitiesEntityIdLsp401 | GetEntitiesEntityIdLsp500


export function useGetEntitiesEntityIdLsp<TData = Awaited<ReturnType<typeof getEntitiesEntityIdLsp>>, TError = GetEntitiesEntityIdLsp400 | GetEntitiesEntityIdLsp401 | GetEntitiesEntityIdLsp500>(
 entityId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdLsp>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesEntityIdLsp>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesEntityIdLsp>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesEntityIdLsp<TData = Awaited<ReturnType<typeof getEntitiesEntityIdLsp>>, TError = GetEntitiesEntityIdLsp400 | GetEntitiesEntityIdLsp401 | GetEntitiesEntityIdLsp500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdLsp>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesEntityIdLsp>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesEntityIdLsp>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesEntityIdLsp<TData = Awaited<ReturnType<typeof getEntitiesEntityIdLsp>>, TError = GetEntitiesEntityIdLsp400 | GetEntitiesEntityIdLsp401 | GetEntitiesEntityIdLsp500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdLsp>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Fetch Entity Lsps
 */

export function useGetEntitiesEntityIdLsp<TData = Awaited<ReturnType<typeof getEntitiesEntityIdLsp>>, TError = GetEntitiesEntityIdLsp400 | GetEntitiesEntityIdLsp401 | GetEntitiesEntityIdLsp500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdLsp>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesEntityIdLspQueryOptions(entityId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Entities Audit endpoint
 * @summary Fetch Entities Audit
 */
export const getEntitiesIdAudit = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesIdAudit200>(
      {url: `/entities/${id}/audit`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesIdAuditQueryKey = (id?: string,) => {
    return [
    `/entities/${id}/audit`
    ] as const;
    }

    
export const getGetEntitiesIdAuditQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesIdAudit>>, TError = GetEntitiesIdAudit400 | GetEntitiesIdAudit401 | GetEntitiesIdAudit500>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesIdAudit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesIdAuditQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesIdAudit>>> = ({ signal }) => getEntitiesIdAudit(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesIdAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesIdAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesIdAudit>>>
export type GetEntitiesIdAuditQueryError = GetEntitiesIdAudit400 | GetEntitiesIdAudit401 | GetEntitiesIdAudit500


export function useGetEntitiesIdAudit<TData = Awaited<ReturnType<typeof getEntitiesIdAudit>>, TError = GetEntitiesIdAudit400 | GetEntitiesIdAudit401 | GetEntitiesIdAudit500>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesIdAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesIdAudit<TData = Awaited<ReturnType<typeof getEntitiesIdAudit>>, TError = GetEntitiesIdAudit400 | GetEntitiesIdAudit401 | GetEntitiesIdAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesIdAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesIdAudit<TData = Awaited<ReturnType<typeof getEntitiesIdAudit>>, TError = GetEntitiesIdAudit400 | GetEntitiesIdAudit401 | GetEntitiesIdAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Entities Audit
 */

export function useGetEntitiesIdAudit<TData = Awaited<ReturnType<typeof getEntitiesIdAudit>>, TError = GetEntitiesIdAudit400 | GetEntitiesIdAudit401 | GetEntitiesIdAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesIdAuditQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Entities Audit All endpoint
 * @summary Fetch Entities Audit All
 */
export const getEntitiesAudit = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesAudit200>(
      {url: `/entities/audit`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesAuditQueryKey = () => {
    return [
    `/entities/audit`
    ] as const;
    }

    
export const getGetEntitiesAuditQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesAudit>>, TError = GetEntitiesAudit400 | GetEntitiesAudit401 | GetEntitiesAudit500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesAudit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesAuditQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesAudit>>> = ({ signal }) => getEntitiesAudit(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesAudit>>>
export type GetEntitiesAuditQueryError = GetEntitiesAudit400 | GetEntitiesAudit401 | GetEntitiesAudit500


export function useGetEntitiesAudit<TData = Awaited<ReturnType<typeof getEntitiesAudit>>, TError = GetEntitiesAudit400 | GetEntitiesAudit401 | GetEntitiesAudit500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesAudit>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesAudit<TData = Awaited<ReturnType<typeof getEntitiesAudit>>, TError = GetEntitiesAudit400 | GetEntitiesAudit401 | GetEntitiesAudit500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesAudit>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesAudit<TData = Awaited<ReturnType<typeof getEntitiesAudit>>, TError = GetEntitiesAudit400 | GetEntitiesAudit401 | GetEntitiesAudit500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesAudit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Entities Audit All
 */

export function useGetEntitiesAudit<TData = Awaited<ReturnType<typeof getEntitiesAudit>>, TError = GetEntitiesAudit400 | GetEntitiesAudit401 | GetEntitiesAudit500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesAudit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesAuditQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Fetch Employees endpoint
 * @summary Fetch Fetch Employees
 */
export const getEntitiesEntityIdEmployee = (
    entityId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesEntityIdEmployee200>(
      {url: `/entities/${entityId}/employee`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesEntityIdEmployeeQueryKey = (entityId?: string,) => {
    return [
    `/entities/${entityId}/employee`
    ] as const;
    }

    
export const getGetEntitiesEntityIdEmployeeQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesEntityIdEmployee>>, TError = GetEntitiesEntityIdEmployee400 | GetEntitiesEntityIdEmployee401 | GetEntitiesEntityIdEmployee500>(entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdEmployee>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesEntityIdEmployeeQueryKey(entityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesEntityIdEmployee>>> = ({ signal }) => getEntitiesEntityIdEmployee(entityId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(entityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdEmployee>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesEntityIdEmployeeQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesEntityIdEmployee>>>
export type GetEntitiesEntityIdEmployeeQueryError = GetEntitiesEntityIdEmployee400 | GetEntitiesEntityIdEmployee401 | GetEntitiesEntityIdEmployee500


export function useGetEntitiesEntityIdEmployee<TData = Awaited<ReturnType<typeof getEntitiesEntityIdEmployee>>, TError = GetEntitiesEntityIdEmployee400 | GetEntitiesEntityIdEmployee401 | GetEntitiesEntityIdEmployee500>(
 entityId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdEmployee>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesEntityIdEmployee>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesEntityIdEmployee>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesEntityIdEmployee<TData = Awaited<ReturnType<typeof getEntitiesEntityIdEmployee>>, TError = GetEntitiesEntityIdEmployee400 | GetEntitiesEntityIdEmployee401 | GetEntitiesEntityIdEmployee500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdEmployee>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesEntityIdEmployee>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesEntityIdEmployee>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesEntityIdEmployee<TData = Awaited<ReturnType<typeof getEntitiesEntityIdEmployee>>, TError = GetEntitiesEntityIdEmployee400 | GetEntitiesEntityIdEmployee401 | GetEntitiesEntityIdEmployee500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdEmployee>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Fetch Employees
 */

export function useGetEntitiesEntityIdEmployee<TData = Awaited<ReturnType<typeof getEntitiesEntityIdEmployee>>, TError = GetEntitiesEntityIdEmployee400 | GetEntitiesEntityIdEmployee401 | GetEntitiesEntityIdEmployee500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdEmployee>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesEntityIdEmployeeQueryOptions(entityId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create Add Employee endpoint
 * @summary Create Add Employee
 */
export const postEntitiesEntityIdEmployee = (
    entityId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostEntitiesEntityIdEmployee200>(
      {url: `/entities/${entityId}/employee`, method: 'POST', signal
    },
      );
    }
  


export const getPostEntitiesEntityIdEmployeeMutationOptions = <TError = PostEntitiesEntityIdEmployee400 | PostEntitiesEntityIdEmployee401 | PostEntitiesEntityIdEmployee500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEntitiesEntityIdEmployee>>, TError,{entityId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEntitiesEntityIdEmployee>>, TError,{entityId: string}, TContext> => {

const mutationKey = ['postEntitiesEntityIdEmployee'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEntitiesEntityIdEmployee>>, {entityId: string}> = (props) => {
          const {entityId} = props ?? {};

          return  postEntitiesEntityIdEmployee(entityId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEntitiesEntityIdEmployeeMutationResult = NonNullable<Awaited<ReturnType<typeof postEntitiesEntityIdEmployee>>>
    
    export type PostEntitiesEntityIdEmployeeMutationError = PostEntitiesEntityIdEmployee400 | PostEntitiesEntityIdEmployee401 | PostEntitiesEntityIdEmployee500

    /**
 * @summary Create Add Employee
 */
export const usePostEntitiesEntityIdEmployee = <TError = PostEntitiesEntityIdEmployee400 | PostEntitiesEntityIdEmployee401 | PostEntitiesEntityIdEmployee500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEntitiesEntityIdEmployee>>, TError,{entityId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEntitiesEntityIdEmployee>>,
        TError,
        {entityId: string},
        TContext
      > => {

      const mutationOptions = getPostEntitiesEntityIdEmployeeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Entities Employee Audit endpoint
 * @summary Fetch Entities Employee Audit
 */
export const getEmployeeAudit = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEmployeeAudit200>(
      {url: `/employee/audit`, method: 'GET', signal
    },
      );
    }
  



export const getGetEmployeeAuditQueryKey = () => {
    return [
    `/employee/audit`
    ] as const;
    }

    
export const getGetEmployeeAuditQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeAudit>>, TError = GetEmployeeAudit400 | GetEmployeeAudit401 | GetEmployeeAudit500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeAudit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeAuditQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeAudit>>> = ({ signal }) => getEmployeeAudit(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeeAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeAudit>>>
export type GetEmployeeAuditQueryError = GetEmployeeAudit400 | GetEmployeeAudit401 | GetEmployeeAudit500


export function useGetEmployeeAudit<TData = Awaited<ReturnType<typeof getEmployeeAudit>>, TError = GetEmployeeAudit400 | GetEmployeeAudit401 | GetEmployeeAudit500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeAudit>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeAudit<TData = Awaited<ReturnType<typeof getEmployeeAudit>>, TError = GetEmployeeAudit400 | GetEmployeeAudit401 | GetEmployeeAudit500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeAudit>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeeAudit<TData = Awaited<ReturnType<typeof getEmployeeAudit>>, TError = GetEmployeeAudit400 | GetEmployeeAudit401 | GetEmployeeAudit500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeAudit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Entities Employee Audit
 */

export function useGetEmployeeAudit<TData = Awaited<ReturnType<typeof getEmployeeAudit>>, TError = GetEmployeeAudit400 | GetEmployeeAudit401 | GetEmployeeAudit500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeAudit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeeAuditQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Fetch Employee Ess Data endpoint
 * @summary Fetch Fetch Employee Ess Data
 */
export const getEssProfileMe = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEssProfileMe200>(
      {url: `/ess/profile/me`, method: 'GET', signal
    },
      );
    }
  



export const getGetEssProfileMeQueryKey = () => {
    return [
    `/ess/profile/me`
    ] as const;
    }

    
export const getGetEssProfileMeQueryOptions = <TData = Awaited<ReturnType<typeof getEssProfileMe>>, TError = GetEssProfileMe400 | GetEssProfileMe401 | GetEssProfileMe500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEssProfileMe>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEssProfileMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEssProfileMe>>> = ({ signal }) => getEssProfileMe(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEssProfileMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEssProfileMeQueryResult = NonNullable<Awaited<ReturnType<typeof getEssProfileMe>>>
export type GetEssProfileMeQueryError = GetEssProfileMe400 | GetEssProfileMe401 | GetEssProfileMe500


export function useGetEssProfileMe<TData = Awaited<ReturnType<typeof getEssProfileMe>>, TError = GetEssProfileMe400 | GetEssProfileMe401 | GetEssProfileMe500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEssProfileMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEssProfileMe>>,
          TError,
          Awaited<ReturnType<typeof getEssProfileMe>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEssProfileMe<TData = Awaited<ReturnType<typeof getEssProfileMe>>, TError = GetEssProfileMe400 | GetEssProfileMe401 | GetEssProfileMe500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEssProfileMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEssProfileMe>>,
          TError,
          Awaited<ReturnType<typeof getEssProfileMe>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEssProfileMe<TData = Awaited<ReturnType<typeof getEssProfileMe>>, TError = GetEssProfileMe400 | GetEssProfileMe401 | GetEssProfileMe500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEssProfileMe>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Fetch Employee Ess Data
 */

export function useGetEssProfileMe<TData = Awaited<ReturnType<typeof getEssProfileMe>>, TError = GetEssProfileMe400 | GetEssProfileMe401 | GetEssProfileMe500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEssProfileMe>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEssProfileMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Fetch Documents endpoint
 * @summary Fetch Fetch Documents
 */
export const getDocuments = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetDocuments200>(
      {url: `/documents`, method: 'GET', signal
    },
      );
    }
  



export const getGetDocumentsQueryKey = () => {
    return [
    `/documents`
    ] as const;
    }

    
export const getGetDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getDocuments>>, TError = GetDocuments400 | GetDocuments401 | GetDocuments500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocuments>>> = ({ signal }) => getDocuments(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getDocuments>>>
export type GetDocumentsQueryError = GetDocuments400 | GetDocuments401 | GetDocuments500


export function useGetDocuments<TData = Awaited<ReturnType<typeof getDocuments>>, TError = GetDocuments400 | GetDocuments401 | GetDocuments500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocuments>>,
          TError,
          Awaited<ReturnType<typeof getDocuments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocuments<TData = Awaited<ReturnType<typeof getDocuments>>, TError = GetDocuments400 | GetDocuments401 | GetDocuments500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocuments>>,
          TError,
          Awaited<ReturnType<typeof getDocuments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocuments<TData = Awaited<ReturnType<typeof getDocuments>>, TError = GetDocuments400 | GetDocuments401 | GetDocuments500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Fetch Documents
 */

export function useGetDocuments<TData = Awaited<ReturnType<typeof getDocuments>>, TError = GetDocuments400 | GetDocuments401 | GetDocuments500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDocumentsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create Fetch Document Version endpoint
 * @summary Create Fetch Document Version
 */
export const postDocumentVersion = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostDocumentVersion200>(
      {url: `/document_version`, method: 'POST', signal
    },
      );
    }
  


export const getPostDocumentVersionMutationOptions = <TError = PostDocumentVersion400 | PostDocumentVersion401 | PostDocumentVersion500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDocumentVersion>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postDocumentVersion>>, TError,void, TContext> => {

const mutationKey = ['postDocumentVersion'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postDocumentVersion>>, void> = () => {
          

          return  postDocumentVersion()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostDocumentVersionMutationResult = NonNullable<Awaited<ReturnType<typeof postDocumentVersion>>>
    
    export type PostDocumentVersionMutationError = PostDocumentVersion400 | PostDocumentVersion401 | PostDocumentVersion500

    /**
 * @summary Create Fetch Document Version
 */
export const usePostDocumentVersion = <TError = PostDocumentVersion400 | PostDocumentVersion401 | PostDocumentVersion500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDocumentVersion>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postDocumentVersion>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostDocumentVersionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Fetch Document Folders endpoint
 * @summary Fetch Fetch Document Folders
 */
export const getEntitiesEntityIdDocumentFolders = (
    entityId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesEntityIdDocumentFolders200>(
      {url: `/entities/${entityId}/document-folders`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesEntityIdDocumentFoldersQueryKey = (entityId?: string,) => {
    return [
    `/entities/${entityId}/document-folders`
    ] as const;
    }

    
export const getGetEntitiesEntityIdDocumentFoldersQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesEntityIdDocumentFolders>>, TError = GetEntitiesEntityIdDocumentFolders400 | GetEntitiesEntityIdDocumentFolders401 | GetEntitiesEntityIdDocumentFolders500>(entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdDocumentFolders>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesEntityIdDocumentFoldersQueryKey(entityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesEntityIdDocumentFolders>>> = ({ signal }) => getEntitiesEntityIdDocumentFolders(entityId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(entityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdDocumentFolders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesEntityIdDocumentFoldersQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesEntityIdDocumentFolders>>>
export type GetEntitiesEntityIdDocumentFoldersQueryError = GetEntitiesEntityIdDocumentFolders400 | GetEntitiesEntityIdDocumentFolders401 | GetEntitiesEntityIdDocumentFolders500


export function useGetEntitiesEntityIdDocumentFolders<TData = Awaited<ReturnType<typeof getEntitiesEntityIdDocumentFolders>>, TError = GetEntitiesEntityIdDocumentFolders400 | GetEntitiesEntityIdDocumentFolders401 | GetEntitiesEntityIdDocumentFolders500>(
 entityId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdDocumentFolders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesEntityIdDocumentFolders>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesEntityIdDocumentFolders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesEntityIdDocumentFolders<TData = Awaited<ReturnType<typeof getEntitiesEntityIdDocumentFolders>>, TError = GetEntitiesEntityIdDocumentFolders400 | GetEntitiesEntityIdDocumentFolders401 | GetEntitiesEntityIdDocumentFolders500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdDocumentFolders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesEntityIdDocumentFolders>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesEntityIdDocumentFolders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesEntityIdDocumentFolders<TData = Awaited<ReturnType<typeof getEntitiesEntityIdDocumentFolders>>, TError = GetEntitiesEntityIdDocumentFolders400 | GetEntitiesEntityIdDocumentFolders401 | GetEntitiesEntityIdDocumentFolders500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdDocumentFolders>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Fetch Document Folders
 */

export function useGetEntitiesEntityIdDocumentFolders<TData = Awaited<ReturnType<typeof getEntitiesEntityIdDocumentFolders>>, TError = GetEntitiesEntityIdDocumentFolders400 | GetEntitiesEntityIdDocumentFolders401 | GetEntitiesEntityIdDocumentFolders500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdDocumentFolders>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesEntityIdDocumentFoldersQueryOptions(entityId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Fetch Directors endpoint
 * @summary Fetch Fetch Directors
 */
export const getEntitiesEntityIdDirectors = (
    entityId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesEntityIdDirectors200>(
      {url: `/entities/${entityId}/directors`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesEntityIdDirectorsQueryKey = (entityId?: string,) => {
    return [
    `/entities/${entityId}/directors`
    ] as const;
    }

    
export const getGetEntitiesEntityIdDirectorsQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesEntityIdDirectors>>, TError = GetEntitiesEntityIdDirectors400 | GetEntitiesEntityIdDirectors401 | GetEntitiesEntityIdDirectors500>(entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdDirectors>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesEntityIdDirectorsQueryKey(entityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesEntityIdDirectors>>> = ({ signal }) => getEntitiesEntityIdDirectors(entityId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(entityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdDirectors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesEntityIdDirectorsQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesEntityIdDirectors>>>
export type GetEntitiesEntityIdDirectorsQueryError = GetEntitiesEntityIdDirectors400 | GetEntitiesEntityIdDirectors401 | GetEntitiesEntityIdDirectors500


export function useGetEntitiesEntityIdDirectors<TData = Awaited<ReturnType<typeof getEntitiesEntityIdDirectors>>, TError = GetEntitiesEntityIdDirectors400 | GetEntitiesEntityIdDirectors401 | GetEntitiesEntityIdDirectors500>(
 entityId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdDirectors>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesEntityIdDirectors>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesEntityIdDirectors>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesEntityIdDirectors<TData = Awaited<ReturnType<typeof getEntitiesEntityIdDirectors>>, TError = GetEntitiesEntityIdDirectors400 | GetEntitiesEntityIdDirectors401 | GetEntitiesEntityIdDirectors500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdDirectors>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesEntityIdDirectors>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesEntityIdDirectors>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesEntityIdDirectors<TData = Awaited<ReturnType<typeof getEntitiesEntityIdDirectors>>, TError = GetEntitiesEntityIdDirectors400 | GetEntitiesEntityIdDirectors401 | GetEntitiesEntityIdDirectors500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdDirectors>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Fetch Directors
 */

export function useGetEntitiesEntityIdDirectors<TData = Awaited<ReturnType<typeof getEntitiesEntityIdDirectors>>, TError = GetEntitiesEntityIdDirectors400 | GetEntitiesEntityIdDirectors401 | GetEntitiesEntityIdDirectors500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdDirectors>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesEntityIdDirectorsQueryOptions(entityId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Fetch Directors Audit endpoint
 * @summary Fetch Fetch Directors Audit
 */
export const getEntitiesEntityIdDirectorsAudit = (
    entityId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesEntityIdDirectorsAudit200>(
      {url: `/entities/${entityId}/directors/audit`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesEntityIdDirectorsAuditQueryKey = (entityId?: string,) => {
    return [
    `/entities/${entityId}/directors/audit`
    ] as const;
    }

    
export const getGetEntitiesEntityIdDirectorsAuditQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesEntityIdDirectorsAudit>>, TError = GetEntitiesEntityIdDirectorsAudit400 | GetEntitiesEntityIdDirectorsAudit401 | GetEntitiesEntityIdDirectorsAudit500>(entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdDirectorsAudit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesEntityIdDirectorsAuditQueryKey(entityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesEntityIdDirectorsAudit>>> = ({ signal }) => getEntitiesEntityIdDirectorsAudit(entityId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(entityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdDirectorsAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesEntityIdDirectorsAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesEntityIdDirectorsAudit>>>
export type GetEntitiesEntityIdDirectorsAuditQueryError = GetEntitiesEntityIdDirectorsAudit400 | GetEntitiesEntityIdDirectorsAudit401 | GetEntitiesEntityIdDirectorsAudit500


export function useGetEntitiesEntityIdDirectorsAudit<TData = Awaited<ReturnType<typeof getEntitiesEntityIdDirectorsAudit>>, TError = GetEntitiesEntityIdDirectorsAudit400 | GetEntitiesEntityIdDirectorsAudit401 | GetEntitiesEntityIdDirectorsAudit500>(
 entityId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdDirectorsAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesEntityIdDirectorsAudit>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesEntityIdDirectorsAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesEntityIdDirectorsAudit<TData = Awaited<ReturnType<typeof getEntitiesEntityIdDirectorsAudit>>, TError = GetEntitiesEntityIdDirectorsAudit400 | GetEntitiesEntityIdDirectorsAudit401 | GetEntitiesEntityIdDirectorsAudit500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdDirectorsAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesEntityIdDirectorsAudit>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesEntityIdDirectorsAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesEntityIdDirectorsAudit<TData = Awaited<ReturnType<typeof getEntitiesEntityIdDirectorsAudit>>, TError = GetEntitiesEntityIdDirectorsAudit400 | GetEntitiesEntityIdDirectorsAudit401 | GetEntitiesEntityIdDirectorsAudit500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdDirectorsAudit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Fetch Directors Audit
 */

export function useGetEntitiesEntityIdDirectorsAudit<TData = Awaited<ReturnType<typeof getEntitiesEntityIdDirectorsAudit>>, TError = GetEntitiesEntityIdDirectorsAudit400 | GetEntitiesEntityIdDirectorsAudit401 | GetEntitiesEntityIdDirectorsAudit500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdDirectorsAudit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesEntityIdDirectorsAuditQueryOptions(entityId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Fetch Director Appointments endpoint
 * @summary Fetch Fetch Director Appointments
 */
export const getEntitiesDirectorsDirectorIdAppointments = (
    directorId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesDirectorsDirectorIdAppointments200>(
      {url: `/entities/directors/${directorId}/appointments`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesDirectorsDirectorIdAppointmentsQueryKey = (directorId?: string,) => {
    return [
    `/entities/directors/${directorId}/appointments`
    ] as const;
    }

    
export const getGetEntitiesDirectorsDirectorIdAppointmentsQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointments>>, TError = GetEntitiesDirectorsDirectorIdAppointments400 | GetEntitiesDirectorsDirectorIdAppointments401 | GetEntitiesDirectorsDirectorIdAppointments500>(directorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesDirectorsDirectorIdAppointmentsQueryKey(directorId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointments>>> = ({ signal }) => getEntitiesDirectorsDirectorIdAppointments(directorId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(directorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesDirectorsDirectorIdAppointmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointments>>>
export type GetEntitiesDirectorsDirectorIdAppointmentsQueryError = GetEntitiesDirectorsDirectorIdAppointments400 | GetEntitiesDirectorsDirectorIdAppointments401 | GetEntitiesDirectorsDirectorIdAppointments500


export function useGetEntitiesDirectorsDirectorIdAppointments<TData = Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointments>>, TError = GetEntitiesDirectorsDirectorIdAppointments400 | GetEntitiesDirectorsDirectorIdAppointments401 | GetEntitiesDirectorsDirectorIdAppointments500>(
 directorId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointments>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesDirectorsDirectorIdAppointments<TData = Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointments>>, TError = GetEntitiesDirectorsDirectorIdAppointments400 | GetEntitiesDirectorsDirectorIdAppointments401 | GetEntitiesDirectorsDirectorIdAppointments500>(
 directorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointments>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesDirectorsDirectorIdAppointments<TData = Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointments>>, TError = GetEntitiesDirectorsDirectorIdAppointments400 | GetEntitiesDirectorsDirectorIdAppointments401 | GetEntitiesDirectorsDirectorIdAppointments500>(
 directorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Fetch Director Appointments
 */

export function useGetEntitiesDirectorsDirectorIdAppointments<TData = Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointments>>, TError = GetEntitiesDirectorsDirectorIdAppointments400 | GetEntitiesDirectorsDirectorIdAppointments401 | GetEntitiesDirectorsDirectorIdAppointments500>(
 directorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesDirectorsDirectorIdAppointments>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesDirectorsDirectorIdAppointmentsQueryOptions(directorId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create Add Director Appointment endpoint
 * @summary Create Add Director Appointment
 */
export const postEntitiesDirectorsDirectorIdAppointments = (
    directorId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostEntitiesDirectorsDirectorIdAppointments200>(
      {url: `/entities/directors/${directorId}/appointments`, method: 'POST', signal
    },
      );
    }
  


export const getPostEntitiesDirectorsDirectorIdAppointmentsMutationOptions = <TError = PostEntitiesDirectorsDirectorIdAppointments400 | PostEntitiesDirectorsDirectorIdAppointments401 | PostEntitiesDirectorsDirectorIdAppointments500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEntitiesDirectorsDirectorIdAppointments>>, TError,{directorId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEntitiesDirectorsDirectorIdAppointments>>, TError,{directorId: string}, TContext> => {

const mutationKey = ['postEntitiesDirectorsDirectorIdAppointments'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEntitiesDirectorsDirectorIdAppointments>>, {directorId: string}> = (props) => {
          const {directorId} = props ?? {};

          return  postEntitiesDirectorsDirectorIdAppointments(directorId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEntitiesDirectorsDirectorIdAppointmentsMutationResult = NonNullable<Awaited<ReturnType<typeof postEntitiesDirectorsDirectorIdAppointments>>>
    
    export type PostEntitiesDirectorsDirectorIdAppointmentsMutationError = PostEntitiesDirectorsDirectorIdAppointments400 | PostEntitiesDirectorsDirectorIdAppointments401 | PostEntitiesDirectorsDirectorIdAppointments500

    /**
 * @summary Create Add Director Appointment
 */
export const usePostEntitiesDirectorsDirectorIdAppointments = <TError = PostEntitiesDirectorsDirectorIdAppointments400 | PostEntitiesDirectorsDirectorIdAppointments401 | PostEntitiesDirectorsDirectorIdAppointments500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEntitiesDirectorsDirectorIdAppointments>>, TError,{directorId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEntitiesDirectorsDirectorIdAppointments>>,
        TError,
        {directorId: string},
        TContext
      > => {

      const mutationOptions = getPostEntitiesDirectorsDirectorIdAppointmentsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Customer Audit endpoint
 * @summary Fetch Customer Audit
 */
export const getLspIdCustomerAudit = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetLspIdCustomerAudit200>(
      {url: `/lsp/${id}/customer-audit`, method: 'GET', signal
    },
      );
    }
  



export const getGetLspIdCustomerAuditQueryKey = (id?: string,) => {
    return [
    `/lsp/${id}/customer-audit`
    ] as const;
    }

    
export const getGetLspIdCustomerAuditQueryOptions = <TData = Awaited<ReturnType<typeof getLspIdCustomerAudit>>, TError = GetLspIdCustomerAudit400 | GetLspIdCustomerAudit401 | GetLspIdCustomerAudit500>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLspIdCustomerAudit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLspIdCustomerAuditQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLspIdCustomerAudit>>> = ({ signal }) => getLspIdCustomerAudit(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLspIdCustomerAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLspIdCustomerAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getLspIdCustomerAudit>>>
export type GetLspIdCustomerAuditQueryError = GetLspIdCustomerAudit400 | GetLspIdCustomerAudit401 | GetLspIdCustomerAudit500


export function useGetLspIdCustomerAudit<TData = Awaited<ReturnType<typeof getLspIdCustomerAudit>>, TError = GetLspIdCustomerAudit400 | GetLspIdCustomerAudit401 | GetLspIdCustomerAudit500>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLspIdCustomerAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLspIdCustomerAudit>>,
          TError,
          Awaited<ReturnType<typeof getLspIdCustomerAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLspIdCustomerAudit<TData = Awaited<ReturnType<typeof getLspIdCustomerAudit>>, TError = GetLspIdCustomerAudit400 | GetLspIdCustomerAudit401 | GetLspIdCustomerAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLspIdCustomerAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLspIdCustomerAudit>>,
          TError,
          Awaited<ReturnType<typeof getLspIdCustomerAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLspIdCustomerAudit<TData = Awaited<ReturnType<typeof getLspIdCustomerAudit>>, TError = GetLspIdCustomerAudit400 | GetLspIdCustomerAudit401 | GetLspIdCustomerAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLspIdCustomerAudit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Customer Audit
 */

export function useGetLspIdCustomerAudit<TData = Awaited<ReturnType<typeof getLspIdCustomerAudit>>, TError = GetLspIdCustomerAudit400 | GetLspIdCustomerAudit401 | GetLspIdCustomerAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLspIdCustomerAudit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLspIdCustomerAuditQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Conversations endpoint
 * @summary Fetch Conversations
 */
export const getConversations = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetConversations200>(
      {url: `/conversations`, method: 'GET', signal
    },
      );
    }
  



export const getGetConversationsQueryKey = () => {
    return [
    `/conversations`
    ] as const;
    }

    
export const getGetConversationsQueryOptions = <TData = Awaited<ReturnType<typeof getConversations>>, TError = GetConversations400 | GetConversations401 | GetConversations500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConversationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConversations>>> = ({ signal }) => getConversations(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConversations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof getConversations>>>
export type GetConversationsQueryError = GetConversations400 | GetConversations401 | GetConversations500


export function useGetConversations<TData = Awaited<ReturnType<typeof getConversations>>, TError = GetConversations400 | GetConversations401 | GetConversations500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversations>>,
          TError,
          Awaited<ReturnType<typeof getConversations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConversations<TData = Awaited<ReturnType<typeof getConversations>>, TError = GetConversations400 | GetConversations401 | GetConversations500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversations>>,
          TError,
          Awaited<ReturnType<typeof getConversations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConversations<TData = Awaited<ReturnType<typeof getConversations>>, TError = GetConversations400 | GetConversations401 | GetConversations500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Conversations
 */

export function useGetConversations<TData = Awaited<ReturnType<typeof getConversations>>, TError = GetConversations400 | GetConversations401 | GetConversations500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversations>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConversationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Comments endpoint
 * @summary Fetch Comments
 */
export const getComments = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetComments200>(
      {url: `/comments`, method: 'GET', signal
    },
      );
    }
  



export const getGetCommentsQueryKey = () => {
    return [
    `/comments`
    ] as const;
    }

    
export const getGetCommentsQueryOptions = <TData = Awaited<ReturnType<typeof getComments>>, TError = GetComments400 | GetComments401 | GetComments500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getComments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCommentsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getComments>>> = ({ signal }) => getComments(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getComments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCommentsQueryResult = NonNullable<Awaited<ReturnType<typeof getComments>>>
export type GetCommentsQueryError = GetComments400 | GetComments401 | GetComments500


export function useGetComments<TData = Awaited<ReturnType<typeof getComments>>, TError = GetComments400 | GetComments401 | GetComments500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getComments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getComments>>,
          TError,
          Awaited<ReturnType<typeof getComments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetComments<TData = Awaited<ReturnType<typeof getComments>>, TError = GetComments400 | GetComments401 | GetComments500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getComments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getComments>>,
          TError,
          Awaited<ReturnType<typeof getComments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetComments<TData = Awaited<ReturnType<typeof getComments>>, TError = GetComments400 | GetComments401 | GetComments500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getComments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Comments
 */

export function useGetComments<TData = Awaited<ReturnType<typeof getComments>>, TError = GetComments400 | GetComments401 | GetComments500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getComments>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCommentsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create Comments Add endpoint
 * @summary Create Comments Add
 */
export const postComments = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostComments200>(
      {url: `/comments`, method: 'POST', signal
    },
      );
    }
  


export const getPostCommentsMutationOptions = <TError = PostComments400 | PostComments401 | PostComments500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postComments>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postComments>>, TError,void, TContext> => {

const mutationKey = ['postComments'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postComments>>, void> = () => {
          

          return  postComments()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCommentsMutationResult = NonNullable<Awaited<ReturnType<typeof postComments>>>
    
    export type PostCommentsMutationError = PostComments400 | PostComments401 | PostComments500

    /**
 * @summary Create Comments Add
 */
export const usePostComments = <TError = PostComments400 | PostComments401 | PostComments500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postComments>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postComments>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostCommentsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Cities endpoint
 * @summary Fetch Cities
 */
export const getCities = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetCities200>(
      {url: `/cities`, method: 'GET', signal
    },
      );
    }
  



export const getGetCitiesQueryKey = () => {
    return [
    `/cities`
    ] as const;
    }

    
export const getGetCitiesQueryOptions = <TData = Awaited<ReturnType<typeof getCities>>, TError = GetCities400 | GetCities401 | GetCities500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCities>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCitiesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCities>>> = ({ signal }) => getCities(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getCities>>>
export type GetCitiesQueryError = GetCities400 | GetCities401 | GetCities500


export function useGetCities<TData = Awaited<ReturnType<typeof getCities>>, TError = GetCities400 | GetCities401 | GetCities500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCities>>,
          TError,
          Awaited<ReturnType<typeof getCities>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCities<TData = Awaited<ReturnType<typeof getCities>>, TError = GetCities400 | GetCities401 | GetCities500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCities>>,
          TError,
          Awaited<ReturnType<typeof getCities>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCities<TData = Awaited<ReturnType<typeof getCities>>, TError = GetCities400 | GetCities401 | GetCities500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCities>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Cities
 */

export function useGetCities<TData = Awaited<ReturnType<typeof getCities>>, TError = GetCities400 | GetCities401 | GetCities500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCities>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCitiesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Fetch Blob Url Function endpoint
 * @summary Fetch Fetch Blob Url Function
 */
export const getBlobDownload = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetBlobDownload200>(
      {url: `/blob_download`, method: 'GET', signal
    },
      );
    }
  



export const getGetBlobDownloadQueryKey = () => {
    return [
    `/blob_download`
    ] as const;
    }

    
export const getGetBlobDownloadQueryOptions = <TData = Awaited<ReturnType<typeof getBlobDownload>>, TError = GetBlobDownload400 | GetBlobDownload401 | GetBlobDownload500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBlobDownload>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBlobDownloadQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBlobDownload>>> = ({ signal }) => getBlobDownload(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBlobDownload>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBlobDownloadQueryResult = NonNullable<Awaited<ReturnType<typeof getBlobDownload>>>
export type GetBlobDownloadQueryError = GetBlobDownload400 | GetBlobDownload401 | GetBlobDownload500


export function useGetBlobDownload<TData = Awaited<ReturnType<typeof getBlobDownload>>, TError = GetBlobDownload400 | GetBlobDownload401 | GetBlobDownload500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBlobDownload>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBlobDownload>>,
          TError,
          Awaited<ReturnType<typeof getBlobDownload>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBlobDownload<TData = Awaited<ReturnType<typeof getBlobDownload>>, TError = GetBlobDownload400 | GetBlobDownload401 | GetBlobDownload500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBlobDownload>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBlobDownload>>,
          TError,
          Awaited<ReturnType<typeof getBlobDownload>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBlobDownload<TData = Awaited<ReturnType<typeof getBlobDownload>>, TError = GetBlobDownload400 | GetBlobDownload401 | GetBlobDownload500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBlobDownload>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Fetch Blob Url Function
 */

export function useGetBlobDownload<TData = Awaited<ReturnType<typeof getBlobDownload>>, TError = GetBlobDownload400 | GetBlobDownload401 | GetBlobDownload500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBlobDownload>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBlobDownloadQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Fetch Attachment Audit endpoint
 * @summary Fetch Fetch Attachment Audit
 */
export const getAttachmentsIdAudit = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetAttachmentsIdAudit200>(
      {url: `/attachments/${id}/audit`, method: 'GET', signal
    },
      );
    }
  



export const getGetAttachmentsIdAuditQueryKey = (id?: string,) => {
    return [
    `/attachments/${id}/audit`
    ] as const;
    }

    
export const getGetAttachmentsIdAuditQueryOptions = <TData = Awaited<ReturnType<typeof getAttachmentsIdAudit>>, TError = GetAttachmentsIdAudit400 | GetAttachmentsIdAudit401 | GetAttachmentsIdAudit500>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentsIdAudit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAttachmentsIdAuditQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttachmentsIdAudit>>> = ({ signal }) => getAttachmentsIdAudit(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAttachmentsIdAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAttachmentsIdAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getAttachmentsIdAudit>>>
export type GetAttachmentsIdAuditQueryError = GetAttachmentsIdAudit400 | GetAttachmentsIdAudit401 | GetAttachmentsIdAudit500


export function useGetAttachmentsIdAudit<TData = Awaited<ReturnType<typeof getAttachmentsIdAudit>>, TError = GetAttachmentsIdAudit400 | GetAttachmentsIdAudit401 | GetAttachmentsIdAudit500>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentsIdAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttachmentsIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getAttachmentsIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttachmentsIdAudit<TData = Awaited<ReturnType<typeof getAttachmentsIdAudit>>, TError = GetAttachmentsIdAudit400 | GetAttachmentsIdAudit401 | GetAttachmentsIdAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentsIdAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttachmentsIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getAttachmentsIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttachmentsIdAudit<TData = Awaited<ReturnType<typeof getAttachmentsIdAudit>>, TError = GetAttachmentsIdAudit400 | GetAttachmentsIdAudit401 | GetAttachmentsIdAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentsIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Fetch Attachment Audit
 */

export function useGetAttachmentsIdAudit<TData = Awaited<ReturnType<typeof getAttachmentsIdAudit>>, TError = GetAttachmentsIdAudit400 | GetAttachmentsIdAudit401 | GetAttachmentsIdAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentsIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAttachmentsIdAuditQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create Add-document-audit endpoint
 * @summary Create Add-document-audit
 */
export const postAttachmentsIdAudit = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostAttachmentsIdAudit200>(
      {url: `/attachments/${id}/audit`, method: 'POST', signal
    },
      );
    }
  


export const getPostAttachmentsIdAuditMutationOptions = <TError = PostAttachmentsIdAudit400 | PostAttachmentsIdAudit401 | PostAttachmentsIdAudit500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAttachmentsIdAudit>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAttachmentsIdAudit>>, TError,{id: string}, TContext> => {

const mutationKey = ['postAttachmentsIdAudit'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAttachmentsIdAudit>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postAttachmentsIdAudit(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAttachmentsIdAuditMutationResult = NonNullable<Awaited<ReturnType<typeof postAttachmentsIdAudit>>>
    
    export type PostAttachmentsIdAuditMutationError = PostAttachmentsIdAudit400 | PostAttachmentsIdAudit401 | PostAttachmentsIdAudit500

    /**
 * @summary Create Add-document-audit
 */
export const usePostAttachmentsIdAudit = <TError = PostAttachmentsIdAudit400 | PostAttachmentsIdAudit401 | PostAttachmentsIdAudit500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAttachmentsIdAudit>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAttachmentsIdAudit>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostAttachmentsIdAuditMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Entity Addresses endpoint
 * @summary Fetch Entity Addresses
 */
export const getEntitiesEntityIdAddresses = (
    entityId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesEntityIdAddresses200>(
      {url: `/entities/${entityId}/addresses`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesEntityIdAddressesQueryKey = (entityId?: string,) => {
    return [
    `/entities/${entityId}/addresses`
    ] as const;
    }

    
export const getGetEntitiesEntityIdAddressesQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesEntityIdAddresses>>, TError = GetEntitiesEntityIdAddresses400 | GetEntitiesEntityIdAddresses401 | GetEntitiesEntityIdAddresses500>(entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdAddresses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesEntityIdAddressesQueryKey(entityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesEntityIdAddresses>>> = ({ signal }) => getEntitiesEntityIdAddresses(entityId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(entityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdAddresses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesEntityIdAddressesQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesEntityIdAddresses>>>
export type GetEntitiesEntityIdAddressesQueryError = GetEntitiesEntityIdAddresses400 | GetEntitiesEntityIdAddresses401 | GetEntitiesEntityIdAddresses500


export function useGetEntitiesEntityIdAddresses<TData = Awaited<ReturnType<typeof getEntitiesEntityIdAddresses>>, TError = GetEntitiesEntityIdAddresses400 | GetEntitiesEntityIdAddresses401 | GetEntitiesEntityIdAddresses500>(
 entityId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdAddresses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesEntityIdAddresses>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesEntityIdAddresses>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesEntityIdAddresses<TData = Awaited<ReturnType<typeof getEntitiesEntityIdAddresses>>, TError = GetEntitiesEntityIdAddresses400 | GetEntitiesEntityIdAddresses401 | GetEntitiesEntityIdAddresses500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdAddresses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesEntityIdAddresses>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesEntityIdAddresses>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesEntityIdAddresses<TData = Awaited<ReturnType<typeof getEntitiesEntityIdAddresses>>, TError = GetEntitiesEntityIdAddresses400 | GetEntitiesEntityIdAddresses401 | GetEntitiesEntityIdAddresses500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdAddresses>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Entity Addresses
 */

export function useGetEntitiesEntityIdAddresses<TData = Awaited<ReturnType<typeof getEntitiesEntityIdAddresses>>, TError = GetEntitiesEntityIdAddresses400 | GetEntitiesEntityIdAddresses401 | GetEntitiesEntityIdAddresses500>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesEntityIdAddresses>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesEntityIdAddressesQueryOptions(entityId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create Entity Addresses Add endpoint
 * @summary Create Entity Addresses Add
 */
export const postEntitiesEntityIdAddresses = (
    entityId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostEntitiesEntityIdAddresses200>(
      {url: `/entities/${entityId}/addresses`, method: 'POST', signal
    },
      );
    }
  


export const getPostEntitiesEntityIdAddressesMutationOptions = <TError = PostEntitiesEntityIdAddresses400 | PostEntitiesEntityIdAddresses401 | PostEntitiesEntityIdAddresses500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEntitiesEntityIdAddresses>>, TError,{entityId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEntitiesEntityIdAddresses>>, TError,{entityId: string}, TContext> => {

const mutationKey = ['postEntitiesEntityIdAddresses'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEntitiesEntityIdAddresses>>, {entityId: string}> = (props) => {
          const {entityId} = props ?? {};

          return  postEntitiesEntityIdAddresses(entityId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEntitiesEntityIdAddressesMutationResult = NonNullable<Awaited<ReturnType<typeof postEntitiesEntityIdAddresses>>>
    
    export type PostEntitiesEntityIdAddressesMutationError = PostEntitiesEntityIdAddresses400 | PostEntitiesEntityIdAddresses401 | PostEntitiesEntityIdAddresses500

    /**
 * @summary Create Entity Addresses Add
 */
export const usePostEntitiesEntityIdAddresses = <TError = PostEntitiesEntityIdAddresses400 | PostEntitiesEntityIdAddresses401 | PostEntitiesEntityIdAddresses500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEntitiesEntityIdAddresses>>, TError,{entityId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEntitiesEntityIdAddresses>>,
        TError,
        {entityId: string},
        TContext
      > => {

      const mutationOptions = getPostEntitiesEntityIdAddressesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Addresses Audit endpoint
 * @summary Fetch Addresses Audit
 */
export const getAddressesIdAudit = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetAddressesIdAudit200>(
      {url: `/addresses/${id}/audit`, method: 'GET', signal
    },
      );
    }
  



export const getGetAddressesIdAuditQueryKey = (id?: string,) => {
    return [
    `/addresses/${id}/audit`
    ] as const;
    }

    
export const getGetAddressesIdAuditQueryOptions = <TData = Awaited<ReturnType<typeof getAddressesIdAudit>>, TError = GetAddressesIdAudit400 | GetAddressesIdAudit401 | GetAddressesIdAudit500>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddressesIdAudit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAddressesIdAuditQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAddressesIdAudit>>> = ({ signal }) => getAddressesIdAudit(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAddressesIdAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAddressesIdAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getAddressesIdAudit>>>
export type GetAddressesIdAuditQueryError = GetAddressesIdAudit400 | GetAddressesIdAudit401 | GetAddressesIdAudit500


export function useGetAddressesIdAudit<TData = Awaited<ReturnType<typeof getAddressesIdAudit>>, TError = GetAddressesIdAudit400 | GetAddressesIdAudit401 | GetAddressesIdAudit500>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddressesIdAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAddressesIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getAddressesIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAddressesIdAudit<TData = Awaited<ReturnType<typeof getAddressesIdAudit>>, TError = GetAddressesIdAudit400 | GetAddressesIdAudit401 | GetAddressesIdAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddressesIdAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAddressesIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getAddressesIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAddressesIdAudit<TData = Awaited<ReturnType<typeof getAddressesIdAudit>>, TError = GetAddressesIdAudit400 | GetAddressesIdAudit401 | GetAddressesIdAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddressesIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Addresses Audit
 */

export function useGetAddressesIdAudit<TData = Awaited<ReturnType<typeof getAddressesIdAudit>>, TError = GetAddressesIdAudit400 | GetAddressesIdAudit401 | GetAddressesIdAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddressesIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAddressesIdAuditQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create Ess Webhook Controller endpoint
 * @summary Create Ess Webhook Controller
 */
export const postEssWebhookNotifications = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostEssWebhookNotifications200>(
      {url: `/ess/webhook/notifications`, method: 'POST', signal
    },
      );
    }
  


export const getPostEssWebhookNotificationsMutationOptions = <TError = PostEssWebhookNotifications400 | PostEssWebhookNotifications401 | PostEssWebhookNotifications500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEssWebhookNotifications>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEssWebhookNotifications>>, TError,void, TContext> => {

const mutationKey = ['postEssWebhookNotifications'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEssWebhookNotifications>>, void> = () => {
          

          return  postEssWebhookNotifications()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEssWebhookNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof postEssWebhookNotifications>>>
    
    export type PostEssWebhookNotificationsMutationError = PostEssWebhookNotifications400 | PostEssWebhookNotifications401 | PostEssWebhookNotifications500

    /**
 * @summary Create Ess Webhook Controller
 */
export const usePostEssWebhookNotifications = <TError = PostEssWebhookNotifications400 | PostEssWebhookNotifications401 | PostEssWebhookNotifications500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEssWebhookNotifications>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEssWebhookNotifications>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostEssWebhookNotificationsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Download Tax Doc endpoint
 * @summary Create Download Tax Doc
 */
export const postTaxDocsDownload = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostTaxDocsDownload200>(
      {url: `/tax-docs/download`, method: 'POST', signal
    },
      );
    }
  


export const getPostTaxDocsDownloadMutationOptions = <TError = PostTaxDocsDownload400 | PostTaxDocsDownload401 | PostTaxDocsDownload500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTaxDocsDownload>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postTaxDocsDownload>>, TError,void, TContext> => {

const mutationKey = ['postTaxDocsDownload'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTaxDocsDownload>>, void> = () => {
          

          return  postTaxDocsDownload()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTaxDocsDownloadMutationResult = NonNullable<Awaited<ReturnType<typeof postTaxDocsDownload>>>
    
    export type PostTaxDocsDownloadMutationError = PostTaxDocsDownload400 | PostTaxDocsDownload401 | PostTaxDocsDownload500

    /**
 * @summary Create Download Tax Doc
 */
export const usePostTaxDocsDownload = <TError = PostTaxDocsDownload400 | PostTaxDocsDownload401 | PostTaxDocsDownload500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTaxDocsDownload>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postTaxDocsDownload>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostTaxDocsDownloadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Download Payslip endpoint
 * @summary Create Download Payslip
 */
export const postPayslipsDownload = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostPayslipsDownload200>(
      {url: `/payslips/download`, method: 'POST', signal
    },
      );
    }
  


export const getPostPayslipsDownloadMutationOptions = <TError = PostPayslipsDownload400 | PostPayslipsDownload401 | PostPayslipsDownload500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayslipsDownload>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postPayslipsDownload>>, TError,void, TContext> => {

const mutationKey = ['postPayslipsDownload'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPayslipsDownload>>, void> = () => {
          

          return  postPayslipsDownload()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPayslipsDownloadMutationResult = NonNullable<Awaited<ReturnType<typeof postPayslipsDownload>>>
    
    export type PostPayslipsDownloadMutationError = PostPayslipsDownload400 | PostPayslipsDownload401 | PostPayslipsDownload500

    /**
 * @summary Create Download Payslip
 */
export const usePostPayslipsDownload = <TError = PostPayslipsDownload400 | PostPayslipsDownload401 | PostPayslipsDownload500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayslipsDownload>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPayslipsDownload>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostPayslipsDownloadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update User Notifications Disable endpoint
 * @summary Update User Notifications Disable
 */
export const putUsersCurrentMeNotificationsPublicMessages = (
    
 ) => {
      
      
      return customInstance<PutUsersCurrentMeNotificationsPublicMessages200>(
      {url: `/users/current/me/notifications/public-messages`, method: 'PUT'
    },
      );
    }
  


export const getPutUsersCurrentMeNotificationsPublicMessagesMutationOptions = <TError = PutUsersCurrentMeNotificationsPublicMessages400 | PutUsersCurrentMeNotificationsPublicMessages401 | PutUsersCurrentMeNotificationsPublicMessages500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUsersCurrentMeNotificationsPublicMessages>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putUsersCurrentMeNotificationsPublicMessages>>, TError,void, TContext> => {

const mutationKey = ['putUsersCurrentMeNotificationsPublicMessages'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUsersCurrentMeNotificationsPublicMessages>>, void> = () => {
          

          return  putUsersCurrentMeNotificationsPublicMessages()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUsersCurrentMeNotificationsPublicMessagesMutationResult = NonNullable<Awaited<ReturnType<typeof putUsersCurrentMeNotificationsPublicMessages>>>
    
    export type PutUsersCurrentMeNotificationsPublicMessagesMutationError = PutUsersCurrentMeNotificationsPublicMessages400 | PutUsersCurrentMeNotificationsPublicMessages401 | PutUsersCurrentMeNotificationsPublicMessages500

    /**
 * @summary Update User Notifications Disable
 */
export const usePutUsersCurrentMeNotificationsPublicMessages = <TError = PutUsersCurrentMeNotificationsPublicMessages400 | PutUsersCurrentMeNotificationsPublicMessages401 | PutUsersCurrentMeNotificationsPublicMessages500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUsersCurrentMeNotificationsPublicMessages>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putUsersCurrentMeNotificationsPublicMessages>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPutUsersCurrentMeNotificationsPublicMessagesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete Users Delete endpoint
 * @summary Delete Users Delete
 */
export const deleteUsersId = (
    id: string,
 ) => {
      
      
      return customInstance<DeleteUsersId200>(
      {url: `/users/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteUsersIdMutationOptions = <TError = DeleteUsersId400 | DeleteUsersId401 | DeleteUsersId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUsersId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteUsersId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteUsersId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUsersId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteUsersId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUsersIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUsersId>>>
    
    export type DeleteUsersIdMutationError = DeleteUsersId400 | DeleteUsersId401 | DeleteUsersId500

    /**
 * @summary Delete Users Delete
 */
export const useDeleteUsersId = <TError = DeleteUsersId400 | DeleteUsersId401 | DeleteUsersId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUsersId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUsersId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteUsersIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update Update User endpoint
 * @summary Update Update User
 */
export const putUsersId = (
    id: string,
    putUsersIdBody: PutUsersIdBody,
 ) => {
      
      
      return customInstance<PutUsersId200>(
      {url: `/users/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUsersIdBody
    },
      );
    }
  


export const getPutUsersIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUsersId>>, TError,{id: string;data: PutUsersIdBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putUsersId>>, TError,{id: string;data: PutUsersIdBody}, TContext> => {

const mutationKey = ['putUsersId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUsersId>>, {id: string;data: PutUsersIdBody}> = (props) => {
          const {id,data} = props ?? {};

          return  putUsersId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUsersIdMutationResult = NonNullable<Awaited<ReturnType<typeof putUsersId>>>
    export type PutUsersIdMutationBody = PutUsersIdBody
    export type PutUsersIdMutationError = unknown

    /**
 * @summary Update Update User
 */
export const usePutUsersId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUsersId>>, TError,{id: string;data: PutUsersIdBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putUsersId>>,
        TError,
        {id: string;data: PutUsersIdBody},
        TContext
      > => {

      const mutationOptions = getPutUsersIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Users By Id endpoint
 * @summary Fetch Users By Id
 */
export const getUsersId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetUsersId200>(
      {url: `/users/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetUsersIdQueryKey = (id?: string,) => {
    return [
    `/users/${id}`
    ] as const;
    }

    
export const getGetUsersIdQueryOptions = <TData = Awaited<ReturnType<typeof getUsersId>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersId>>> = ({ signal }) => getUsersId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsersId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUsersId>>>
export type GetUsersIdQueryError = unknown


export function useGetUsersId<TData = Awaited<ReturnType<typeof getUsersId>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersId>>,
          TError,
          Awaited<ReturnType<typeof getUsersId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersId<TData = Awaited<ReturnType<typeof getUsersId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersId>>,
          TError,
          Awaited<ReturnType<typeof getUsersId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersId<TData = Awaited<ReturnType<typeof getUsersId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Users By Id
 */

export function useGetUsersId<TData = Awaited<ReturnType<typeof getUsersId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Delete Delete Process endpoint
 * @summary Delete Delete Process
 */
export const deleteProcessesId = (
    id: string,
 ) => {
      
      
      return customInstance<DeleteProcessesId200>(
      {url: `/processes/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteProcessesIdMutationOptions = <TError = DeleteProcessesId400 | DeleteProcessesId401 | DeleteProcessesId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProcessesId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteProcessesId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteProcessesId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProcessesId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteProcessesId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProcessesIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProcessesId>>>
    
    export type DeleteProcessesIdMutationError = DeleteProcessesId400 | DeleteProcessesId401 | DeleteProcessesId500

    /**
 * @summary Delete Delete Process
 */
export const useDeleteProcessesId = <TError = DeleteProcessesId400 | DeleteProcessesId401 | DeleteProcessesId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProcessesId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProcessesId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteProcessesIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Process By Id endpoint
 * @summary Fetch Process By Id
 */
export const getProcessesId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetProcessesId200>(
      {url: `/processes/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetProcessesIdQueryKey = (id?: string,) => {
    return [
    `/processes/${id}`
    ] as const;
    }

    
export const getGetProcessesIdQueryOptions = <TData = Awaited<ReturnType<typeof getProcessesId>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessesId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProcessesIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProcessesId>>> = ({ signal }) => getProcessesId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProcessesId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProcessesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getProcessesId>>>
export type GetProcessesIdQueryError = unknown


export function useGetProcessesId<TData = Awaited<ReturnType<typeof getProcessesId>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessesId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessesId>>,
          TError,
          Awaited<ReturnType<typeof getProcessesId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessesId<TData = Awaited<ReturnType<typeof getProcessesId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessesId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessesId>>,
          TError,
          Awaited<ReturnType<typeof getProcessesId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessesId<TData = Awaited<ReturnType<typeof getProcessesId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessesId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Process By Id
 */

export function useGetProcessesId<TData = Awaited<ReturnType<typeof getProcessesId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessesId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProcessesIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Delete Personnel Delete endpoint
 * @summary Delete Personnel Delete
 */
export const deletePersonnelDeleteId = (
    id: string,
 ) => {
      
      
      return customInstance<DeletePersonnelDeleteId200>(
      {url: `/personnel/delete/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeletePersonnelDeleteIdMutationOptions = <TError = DeletePersonnelDeleteId400 | DeletePersonnelDeleteId401 | DeletePersonnelDeleteId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePersonnelDeleteId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePersonnelDeleteId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deletePersonnelDeleteId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePersonnelDeleteId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deletePersonnelDeleteId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePersonnelDeleteIdMutationResult = NonNullable<Awaited<ReturnType<typeof deletePersonnelDeleteId>>>
    
    export type DeletePersonnelDeleteIdMutationError = DeletePersonnelDeleteId400 | DeletePersonnelDeleteId401 | DeletePersonnelDeleteId500

    /**
 * @summary Delete Personnel Delete
 */
export const useDeletePersonnelDeleteId = <TError = DeletePersonnelDeleteId400 | DeletePersonnelDeleteId401 | DeletePersonnelDeleteId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePersonnelDeleteId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePersonnelDeleteId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeletePersonnelDeleteIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete Delete Payslip Matching Results endpoint
 * @summary Delete Delete Payslip Matching Results
 */
export const deletePayslipMatchingResultsMatchingResultId = (
    matchingResultId: string,
 ) => {
      
      
      return customInstance<DeletePayslipMatchingResultsMatchingResultId200>(
      {url: `/payslip/matching_results/${matchingResultId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeletePayslipMatchingResultsMatchingResultIdMutationOptions = <TError = DeletePayslipMatchingResultsMatchingResultId400 | DeletePayslipMatchingResultsMatchingResultId401 | DeletePayslipMatchingResultsMatchingResultId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePayslipMatchingResultsMatchingResultId>>, TError,{matchingResultId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePayslipMatchingResultsMatchingResultId>>, TError,{matchingResultId: string}, TContext> => {

const mutationKey = ['deletePayslipMatchingResultsMatchingResultId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePayslipMatchingResultsMatchingResultId>>, {matchingResultId: string}> = (props) => {
          const {matchingResultId} = props ?? {};

          return  deletePayslipMatchingResultsMatchingResultId(matchingResultId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePayslipMatchingResultsMatchingResultIdMutationResult = NonNullable<Awaited<ReturnType<typeof deletePayslipMatchingResultsMatchingResultId>>>
    
    export type DeletePayslipMatchingResultsMatchingResultIdMutationError = DeletePayslipMatchingResultsMatchingResultId400 | DeletePayslipMatchingResultsMatchingResultId401 | DeletePayslipMatchingResultsMatchingResultId500

    /**
 * @summary Delete Delete Payslip Matching Results
 */
export const useDeletePayslipMatchingResultsMatchingResultId = <TError = DeletePayslipMatchingResultsMatchingResultId400 | DeletePayslipMatchingResultsMatchingResultId401 | DeletePayslipMatchingResultsMatchingResultId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePayslipMatchingResultsMatchingResultId>>, TError,{matchingResultId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePayslipMatchingResultsMatchingResultId>>,
        TError,
        {matchingResultId: string},
        TContext
      > => {

      const mutationOptions = getDeletePayslipMatchingResultsMatchingResultIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete Attachments Delete endpoint
 * @summary Delete Attachments Delete
 */
export const deleteAttachments = (
    
 ) => {
      
      
      return customInstance<DeleteAttachments200>(
      {url: `/attachments`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAttachmentsMutationOptions = <TError = DeleteAttachments400 | DeleteAttachments401 | DeleteAttachments500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAttachments>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAttachments>>, TError,void, TContext> => {

const mutationKey = ['deleteAttachments'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAttachments>>, void> = () => {
          

          return  deleteAttachments()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAttachmentsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAttachments>>>
    
    export type DeleteAttachmentsMutationError = DeleteAttachments400 | DeleteAttachments401 | DeleteAttachments500

    /**
 * @summary Delete Attachments Delete
 */
export const useDeleteAttachments = <TError = DeleteAttachments400 | DeleteAttachments401 | DeleteAttachments500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAttachments>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAttachments>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getDeleteAttachmentsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Check Employee Id Function endpoint
 * @summary Create Check Employee Id Function
 */
export const postEntitiesEntityIdEmployeeId = (
    entityId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostEntitiesEntityIdEmployeeId200>(
      {url: `/entities/${entityId}/employeeId`, method: 'POST', signal
    },
      );
    }
  


export const getPostEntitiesEntityIdEmployeeIdMutationOptions = <TError = PostEntitiesEntityIdEmployeeId400 | PostEntitiesEntityIdEmployeeId401 | PostEntitiesEntityIdEmployeeId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEntitiesEntityIdEmployeeId>>, TError,{entityId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEntitiesEntityIdEmployeeId>>, TError,{entityId: string}, TContext> => {

const mutationKey = ['postEntitiesEntityIdEmployeeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEntitiesEntityIdEmployeeId>>, {entityId: string}> = (props) => {
          const {entityId} = props ?? {};

          return  postEntitiesEntityIdEmployeeId(entityId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEntitiesEntityIdEmployeeIdMutationResult = NonNullable<Awaited<ReturnType<typeof postEntitiesEntityIdEmployeeId>>>
    
    export type PostEntitiesEntityIdEmployeeIdMutationError = PostEntitiesEntityIdEmployeeId400 | PostEntitiesEntityIdEmployeeId401 | PostEntitiesEntityIdEmployeeId500

    /**
 * @summary Create Check Employee Id Function
 */
export const usePostEntitiesEntityIdEmployeeId = <TError = PostEntitiesEntityIdEmployeeId400 | PostEntitiesEntityIdEmployeeId401 | PostEntitiesEntityIdEmployeeId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEntitiesEntityIdEmployeeId>>, TError,{entityId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEntitiesEntityIdEmployeeId>>,
        TError,
        {entityId: string},
        TContext
      > => {

      const mutationOptions = getPostEntitiesEntityIdEmployeeIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Bulk Import Payroll Plus Tasks endpoint
 * @summary Create Bulk Import Payroll Plus Tasks
 */
export const postBulkImportPayrollPlusTasks = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostBulkImportPayrollPlusTasks200>(
      {url: `/bulk-import/payroll-plus-tasks`, method: 'POST', signal
    },
      );
    }
  


export const getPostBulkImportPayrollPlusTasksMutationOptions = <TError = PostBulkImportPayrollPlusTasks400 | PostBulkImportPayrollPlusTasks401 | PostBulkImportPayrollPlusTasks500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBulkImportPayrollPlusTasks>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postBulkImportPayrollPlusTasks>>, TError,void, TContext> => {

const mutationKey = ['postBulkImportPayrollPlusTasks'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBulkImportPayrollPlusTasks>>, void> = () => {
          

          return  postBulkImportPayrollPlusTasks()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBulkImportPayrollPlusTasksMutationResult = NonNullable<Awaited<ReturnType<typeof postBulkImportPayrollPlusTasks>>>
    
    export type PostBulkImportPayrollPlusTasksMutationError = PostBulkImportPayrollPlusTasks400 | PostBulkImportPayrollPlusTasks401 | PostBulkImportPayrollPlusTasks500

    /**
 * @summary Create Bulk Import Payroll Plus Tasks
 */
export const usePostBulkImportPayrollPlusTasks = <TError = PostBulkImportPayrollPlusTasks400 | PostBulkImportPayrollPlusTasks401 | PostBulkImportPayrollPlusTasks500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBulkImportPayrollPlusTasks>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBulkImportPayrollPlusTasks>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostBulkImportPayrollPlusTasksMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Auth Url endpoint
 * @summary Fetch Auth Url
 */
export const getAuthUrl = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetAuthUrl200>(
      {url: `/auth/url`, method: 'GET', signal
    },
      );
    }
  



export const getGetAuthUrlQueryKey = () => {
    return [
    `/auth/url`
    ] as const;
    }

    
export const getGetAuthUrlQueryOptions = <TData = Awaited<ReturnType<typeof getAuthUrl>>, TError = GetAuthUrl400 | GetAuthUrl401 | GetAuthUrl500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthUrl>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuthUrlQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthUrl>>> = ({ signal }) => getAuthUrl(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuthUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuthUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthUrl>>>
export type GetAuthUrlQueryError = GetAuthUrl400 | GetAuthUrl401 | GetAuthUrl500


export function useGetAuthUrl<TData = Awaited<ReturnType<typeof getAuthUrl>>, TError = GetAuthUrl400 | GetAuthUrl401 | GetAuthUrl500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthUrl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthUrl>>,
          TError,
          Awaited<ReturnType<typeof getAuthUrl>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthUrl<TData = Awaited<ReturnType<typeof getAuthUrl>>, TError = GetAuthUrl400 | GetAuthUrl401 | GetAuthUrl500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthUrl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthUrl>>,
          TError,
          Awaited<ReturnType<typeof getAuthUrl>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthUrl<TData = Awaited<ReturnType<typeof getAuthUrl>>, TError = GetAuthUrl400 | GetAuthUrl401 | GetAuthUrl500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthUrl>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Auth Url
 */

export function useGetAuthUrl<TData = Awaited<ReturnType<typeof getAuthUrl>>, TError = GetAuthUrl400 | GetAuthUrl401 | GetAuthUrl500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthUrl>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAuthUrlQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create Entities Shareholders Add endpoint
 * @summary Create Entities Shareholders Add
 */
export const postShareholders = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostShareholders200>(
      {url: `/shareholders`, method: 'POST', signal
    },
      );
    }
  


export const getPostShareholdersMutationOptions = <TError = PostShareholders400 | PostShareholders401 | PostShareholders500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postShareholders>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postShareholders>>, TError,void, TContext> => {

const mutationKey = ['postShareholders'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postShareholders>>, void> = () => {
          

          return  postShareholders()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostShareholdersMutationResult = NonNullable<Awaited<ReturnType<typeof postShareholders>>>
    
    export type PostShareholdersMutationError = PostShareholders400 | PostShareholders401 | PostShareholders500

    /**
 * @summary Create Entities Shareholders Add
 */
export const usePostShareholders = <TError = PostShareholders400 | PostShareholders401 | PostShareholders500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postShareholders>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postShareholders>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostShareholdersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Add Payslip Processing Message endpoint
 * @summary Create Add Payslip Processing Message
 */
export const postPayslipProcessingMessageAdd = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostPayslipProcessingMessageAdd200>(
      {url: `/payslip/processing_message/add`, method: 'POST', signal
    },
      );
    }
  


export const getPostPayslipProcessingMessageAddMutationOptions = <TError = PostPayslipProcessingMessageAdd400 | PostPayslipProcessingMessageAdd401 | PostPayslipProcessingMessageAdd500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayslipProcessingMessageAdd>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postPayslipProcessingMessageAdd>>, TError,void, TContext> => {

const mutationKey = ['postPayslipProcessingMessageAdd'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPayslipProcessingMessageAdd>>, void> = () => {
          

          return  postPayslipProcessingMessageAdd()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPayslipProcessingMessageAddMutationResult = NonNullable<Awaited<ReturnType<typeof postPayslipProcessingMessageAdd>>>
    
    export type PostPayslipProcessingMessageAddMutationError = PostPayslipProcessingMessageAdd400 | PostPayslipProcessingMessageAdd401 | PostPayslipProcessingMessageAdd500

    /**
 * @summary Create Add Payslip Processing Message
 */
export const usePostPayslipProcessingMessageAdd = <TError = PostPayslipProcessingMessageAdd400 | PostPayslipProcessingMessageAdd401 | PostPayslipProcessingMessageAdd500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayslipProcessingMessageAdd>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPayslipProcessingMessageAdd>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostPayslipProcessingMessageAddMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Add Payslip Matchingresult Message endpoint
 * @summary Create Add Payslip Matchingresult Message
 */
export const postPayslipMatchingResultsMessageAdd = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostPayslipMatchingResultsMessageAdd200>(
      {url: `/payslip/matching_results_message/add`, method: 'POST', signal
    },
      );
    }
  


export const getPostPayslipMatchingResultsMessageAddMutationOptions = <TError = PostPayslipMatchingResultsMessageAdd400 | PostPayslipMatchingResultsMessageAdd401 | PostPayslipMatchingResultsMessageAdd500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayslipMatchingResultsMessageAdd>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postPayslipMatchingResultsMessageAdd>>, TError,void, TContext> => {

const mutationKey = ['postPayslipMatchingResultsMessageAdd'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPayslipMatchingResultsMessageAdd>>, void> = () => {
          

          return  postPayslipMatchingResultsMessageAdd()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPayslipMatchingResultsMessageAddMutationResult = NonNullable<Awaited<ReturnType<typeof postPayslipMatchingResultsMessageAdd>>>
    
    export type PostPayslipMatchingResultsMessageAddMutationError = PostPayslipMatchingResultsMessageAdd400 | PostPayslipMatchingResultsMessageAdd401 | PostPayslipMatchingResultsMessageAdd500

    /**
 * @summary Create Add Payslip Matchingresult Message
 */
export const usePostPayslipMatchingResultsMessageAdd = <TError = PostPayslipMatchingResultsMessageAdd400 | PostPayslipMatchingResultsMessageAdd401 | PostPayslipMatchingResultsMessageAdd500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayslipMatchingResultsMessageAdd>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPayslipMatchingResultsMessageAdd>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostPayslipMatchingResultsMessageAddMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Add Payslip Matching Results endpoint
 * @summary Create Add Payslip Matching Results
 */
export const postPayslipMatchingResultsAdd = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostPayslipMatchingResultsAdd200>(
      {url: `/payslip/matching_results/add`, method: 'POST', signal
    },
      );
    }
  


export const getPostPayslipMatchingResultsAddMutationOptions = <TError = PostPayslipMatchingResultsAdd400 | PostPayslipMatchingResultsAdd401 | PostPayslipMatchingResultsAdd500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayslipMatchingResultsAdd>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postPayslipMatchingResultsAdd>>, TError,void, TContext> => {

const mutationKey = ['postPayslipMatchingResultsAdd'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPayslipMatchingResultsAdd>>, void> = () => {
          

          return  postPayslipMatchingResultsAdd()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPayslipMatchingResultsAddMutationResult = NonNullable<Awaited<ReturnType<typeof postPayslipMatchingResultsAdd>>>
    
    export type PostPayslipMatchingResultsAddMutationError = PostPayslipMatchingResultsAdd400 | PostPayslipMatchingResultsAdd401 | PostPayslipMatchingResultsAdd500

    /**
 * @summary Create Add Payslip Matching Results
 */
export const usePostPayslipMatchingResultsAdd = <TError = PostPayslipMatchingResultsAdd400 | PostPayslipMatchingResultsAdd401 | PostPayslipMatchingResultsAdd500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayslipMatchingResultsAdd>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPayslipMatchingResultsAdd>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostPayslipMatchingResultsAddMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Add Payslip Matching Result endpoint
 * @summary Create Add Payslip Matching Result
 */
export const postPayslipMatchingResult = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostPayslipMatchingResult200>(
      {url: `/payslip-matching-result`, method: 'POST', signal
    },
      );
    }
  


export const getPostPayslipMatchingResultMutationOptions = <TError = PostPayslipMatchingResult400 | PostPayslipMatchingResult401 | PostPayslipMatchingResult500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayslipMatchingResult>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postPayslipMatchingResult>>, TError,void, TContext> => {

const mutationKey = ['postPayslipMatchingResult'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPayslipMatchingResult>>, void> = () => {
          

          return  postPayslipMatchingResult()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPayslipMatchingResultMutationResult = NonNullable<Awaited<ReturnType<typeof postPayslipMatchingResult>>>
    
    export type PostPayslipMatchingResultMutationError = PostPayslipMatchingResult400 | PostPayslipMatchingResult401 | PostPayslipMatchingResult500

    /**
 * @summary Create Add Payslip Matching Result
 */
export const usePostPayslipMatchingResult = <TError = PostPayslipMatchingResult400 | PostPayslipMatchingResult401 | PostPayslipMatchingResult500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayslipMatchingResult>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPayslipMatchingResult>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostPayslipMatchingResultMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Messages Add endpoint
 * @summary Create Messages Add
 */
export const postMessagesAdd = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostMessagesAdd200>(
      {url: `/messages/add`, method: 'POST', signal
    },
      );
    }
  


export const getPostMessagesAddMutationOptions = <TError = PostMessagesAdd400 | PostMessagesAdd401 | PostMessagesAdd500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMessagesAdd>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postMessagesAdd>>, TError,void, TContext> => {

const mutationKey = ['postMessagesAdd'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMessagesAdd>>, void> = () => {
          

          return  postMessagesAdd()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMessagesAddMutationResult = NonNullable<Awaited<ReturnType<typeof postMessagesAdd>>>
    
    export type PostMessagesAddMutationError = PostMessagesAdd400 | PostMessagesAdd401 | PostMessagesAdd500

    /**
 * @summary Create Messages Add
 */
export const usePostMessagesAdd = <TError = PostMessagesAdd400 | PostMessagesAdd401 | PostMessagesAdd500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMessagesAdd>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMessagesAdd>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostMessagesAddMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Add File endpoint
 * @summary Create Add File
 */
export const postFilesAdd = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostFilesAdd200>(
      {url: `/files/add`, method: 'POST', signal
    },
      );
    }
  


export const getPostFilesAddMutationOptions = <TError = PostFilesAdd400 | PostFilesAdd401 | PostFilesAdd500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFilesAdd>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postFilesAdd>>, TError,void, TContext> => {

const mutationKey = ['postFilesAdd'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFilesAdd>>, void> = () => {
          

          return  postFilesAdd()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFilesAddMutationResult = NonNullable<Awaited<ReturnType<typeof postFilesAdd>>>
    
    export type PostFilesAddMutationError = PostFilesAdd400 | PostFilesAdd401 | PostFilesAdd500

    /**
 * @summary Create Add File
 */
export const usePostFilesAdd = <TError = PostFilesAdd400 | PostFilesAdd401 | PostFilesAdd500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFilesAdd>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postFilesAdd>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostFilesAddMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Add Director endpoint
 * @summary Create Add Director
 */
export const postDirectors = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostDirectors200>(
      {url: `/directors`, method: 'POST', signal
    },
      );
    }
  


export const getPostDirectorsMutationOptions = <TError = PostDirectors400 | PostDirectors401 | PostDirectors500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDirectors>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postDirectors>>, TError,void, TContext> => {

const mutationKey = ['postDirectors'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postDirectors>>, void> = () => {
          

          return  postDirectors()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostDirectorsMutationResult = NonNullable<Awaited<ReturnType<typeof postDirectors>>>
    
    export type PostDirectorsMutationError = PostDirectors400 | PostDirectors401 | PostDirectors500

    /**
 * @summary Create Add Director
 */
export const usePostDirectors = <TError = PostDirectors400 | PostDirectors401 | PostDirectors500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDirectors>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postDirectors>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostDirectorsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Verify Domain Availability endpoint
 * @summary Fetch Verify Domain Availability
 */
export const getDomainsVerify = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetDomainsVerify200>(
      {url: `/domains/verify`, method: 'GET', signal
    },
      );
    }
  



export const getGetDomainsVerifyQueryKey = () => {
    return [
    `/domains/verify`
    ] as const;
    }

    
export const getGetDomainsVerifyQueryOptions = <TData = Awaited<ReturnType<typeof getDomainsVerify>>, TError = GetDomainsVerify400 | GetDomainsVerify401 | GetDomainsVerify500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDomainsVerify>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDomainsVerifyQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDomainsVerify>>> = ({ signal }) => getDomainsVerify(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDomainsVerify>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDomainsVerifyQueryResult = NonNullable<Awaited<ReturnType<typeof getDomainsVerify>>>
export type GetDomainsVerifyQueryError = GetDomainsVerify400 | GetDomainsVerify401 | GetDomainsVerify500


export function useGetDomainsVerify<TData = Awaited<ReturnType<typeof getDomainsVerify>>, TError = GetDomainsVerify400 | GetDomainsVerify401 | GetDomainsVerify500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDomainsVerify>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDomainsVerify>>,
          TError,
          Awaited<ReturnType<typeof getDomainsVerify>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDomainsVerify<TData = Awaited<ReturnType<typeof getDomainsVerify>>, TError = GetDomainsVerify400 | GetDomainsVerify401 | GetDomainsVerify500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDomainsVerify>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDomainsVerify>>,
          TError,
          Awaited<ReturnType<typeof getDomainsVerify>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDomainsVerify<TData = Awaited<ReturnType<typeof getDomainsVerify>>, TError = GetDomainsVerify400 | GetDomainsVerify401 | GetDomainsVerify500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDomainsVerify>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Verify Domain Availability
 */

export function useGetDomainsVerify<TData = Awaited<ReturnType<typeof getDomainsVerify>>, TError = GetDomainsVerify400 | GetDomainsVerify401 | GetDomainsVerify500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDomainsVerify>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDomainsVerifyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update Update Entity endpoint
 * @summary Update Update Entity
 */
export const putEntitiesId = (
    id: string,
    putEntitiesIdBody: PutEntitiesIdBody,
 ) => {
      
      
      return customInstance<PutEntitiesId200>(
      {url: `/entities/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putEntitiesIdBody
    },
      );
    }
  


export const getPutEntitiesIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEntitiesId>>, TError,{id: string;data: PutEntitiesIdBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putEntitiesId>>, TError,{id: string;data: PutEntitiesIdBody}, TContext> => {

const mutationKey = ['putEntitiesId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEntitiesId>>, {id: string;data: PutEntitiesIdBody}> = (props) => {
          const {id,data} = props ?? {};

          return  putEntitiesId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEntitiesIdMutationResult = NonNullable<Awaited<ReturnType<typeof putEntitiesId>>>
    export type PutEntitiesIdMutationBody = PutEntitiesIdBody
    export type PutEntitiesIdMutationError = unknown

    /**
 * @summary Update Update Entity
 */
export const usePutEntitiesId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEntitiesId>>, TError,{id: string;data: PutEntitiesIdBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEntitiesId>>,
        TError,
        {id: string;data: PutEntitiesIdBody},
        TContext
      > => {

      const mutationOptions = getPutEntitiesIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Get Entity endpoint
 * @summary Fetch Get Entity
 */
export const getEntitiesId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesId200>(
      {url: `/entities/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesIdQueryKey = (id?: string,) => {
    return [
    `/entities/${id}`
    ] as const;
    }

    
export const getGetEntitiesIdQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesId>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesId>>> = ({ signal }) => getEntitiesId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesId>>>
export type GetEntitiesIdQueryError = unknown


export function useGetEntitiesId<TData = Awaited<ReturnType<typeof getEntitiesId>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesId>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesId<TData = Awaited<ReturnType<typeof getEntitiesId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesId>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesId<TData = Awaited<ReturnType<typeof getEntitiesId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Get Entity
 */

export function useGetEntitiesId<TData = Awaited<ReturnType<typeof getEntitiesId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update Update Account Manager endpoint
 * @summary Update Update Account Manager
 */
export const patchAccountManagersId = (
    id: string,
 ) => {
      
      
      return customInstance<PatchAccountManagersId200>(
      {url: `/account-managers/${id}`, method: 'PATCH'
    },
      );
    }
  


export const getPatchAccountManagersIdMutationOptions = <TError = PatchAccountManagersId400 | PatchAccountManagersId401 | PatchAccountManagersId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAccountManagersId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchAccountManagersId>>, TError,{id: string}, TContext> => {

const mutationKey = ['patchAccountManagersId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAccountManagersId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  patchAccountManagersId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchAccountManagersIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchAccountManagersId>>>
    
    export type PatchAccountManagersIdMutationError = PatchAccountManagersId400 | PatchAccountManagersId401 | PatchAccountManagersId500

    /**
 * @summary Update Update Account Manager
 */
export const usePatchAccountManagersId = <TError = PatchAccountManagersId400 | PatchAccountManagersId401 | PatchAccountManagersId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAccountManagersId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchAccountManagersId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPatchAccountManagersIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Get Account Manager endpoint
 * @summary Fetch Get Account Manager
 */
export const getAccountManagersId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetAccountManagersId200>(
      {url: `/account-managers/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetAccountManagersIdQueryKey = (id?: string,) => {
    return [
    `/account-managers/${id}`
    ] as const;
    }

    
export const getGetAccountManagersIdQueryOptions = <TData = Awaited<ReturnType<typeof getAccountManagersId>>, TError = GetAccountManagersId400 | GetAccountManagersId401 | GetAccountManagersId500>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountManagersId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountManagersIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountManagersId>>> = ({ signal }) => getAccountManagersId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountManagersId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccountManagersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountManagersId>>>
export type GetAccountManagersIdQueryError = GetAccountManagersId400 | GetAccountManagersId401 | GetAccountManagersId500


export function useGetAccountManagersId<TData = Awaited<ReturnType<typeof getAccountManagersId>>, TError = GetAccountManagersId400 | GetAccountManagersId401 | GetAccountManagersId500>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountManagersId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountManagersId>>,
          TError,
          Awaited<ReturnType<typeof getAccountManagersId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccountManagersId<TData = Awaited<ReturnType<typeof getAccountManagersId>>, TError = GetAccountManagersId400 | GetAccountManagersId401 | GetAccountManagersId500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountManagersId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountManagersId>>,
          TError,
          Awaited<ReturnType<typeof getAccountManagersId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccountManagersId<TData = Awaited<ReturnType<typeof getAccountManagersId>>, TError = GetAccountManagersId400 | GetAccountManagersId401 | GetAccountManagersId500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountManagersId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Get Account Manager
 */

export function useGetAccountManagersId<TData = Awaited<ReturnType<typeof getAccountManagersId>>, TError = GetAccountManagersId400 | GetAccountManagersId401 | GetAccountManagersId500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountManagersId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccountManagersIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Delete Delete Account Manager endpoint
 * @summary Delete Delete Account Manager
 */
export const deleteAccountManagersId = (
    id: string,
 ) => {
      
      
      return customInstance<DeleteAccountManagersId200>(
      {url: `/account-managers/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAccountManagersIdMutationOptions = <TError = DeleteAccountManagersId400 | DeleteAccountManagersId401 | DeleteAccountManagersId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccountManagersId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAccountManagersId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteAccountManagersId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAccountManagersId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAccountManagersId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccountManagersIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccountManagersId>>>
    
    export type DeleteAccountManagersIdMutationError = DeleteAccountManagersId400 | DeleteAccountManagersId401 | DeleteAccountManagersId500

    /**
 * @summary Delete Delete Account Manager
 */
export const useDeleteAccountManagersId = <TError = DeleteAccountManagersId400 | DeleteAccountManagersId401 | DeleteAccountManagersId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccountManagersId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAccountManagersId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAccountManagersIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Get Tenant Audit endpoint
 * @summary Fetch Get Tenant Audit
 */
export const getTenantsTenantIdAudit = (
    tenantId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetTenantsTenantIdAudit200>(
      {url: `/tenants/${tenantId}/audit`, method: 'GET', signal
    },
      );
    }
  



export const getGetTenantsTenantIdAuditQueryKey = (tenantId?: string,) => {
    return [
    `/tenants/${tenantId}/audit`
    ] as const;
    }

    
export const getGetTenantsTenantIdAuditQueryOptions = <TData = Awaited<ReturnType<typeof getTenantsTenantIdAudit>>, TError = GetTenantsTenantIdAudit400 | GetTenantsTenantIdAudit401 | GetTenantsTenantIdAudit500>(tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsTenantIdAudit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTenantsTenantIdAuditQueryKey(tenantId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenantsTenantIdAudit>>> = ({ signal }) => getTenantsTenantIdAudit(tenantId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(tenantId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTenantsTenantIdAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTenantsTenantIdAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getTenantsTenantIdAudit>>>
export type GetTenantsTenantIdAuditQueryError = GetTenantsTenantIdAudit400 | GetTenantsTenantIdAudit401 | GetTenantsTenantIdAudit500


export function useGetTenantsTenantIdAudit<TData = Awaited<ReturnType<typeof getTenantsTenantIdAudit>>, TError = GetTenantsTenantIdAudit400 | GetTenantsTenantIdAudit401 | GetTenantsTenantIdAudit500>(
 tenantId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsTenantIdAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantsTenantIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getTenantsTenantIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantsTenantIdAudit<TData = Awaited<ReturnType<typeof getTenantsTenantIdAudit>>, TError = GetTenantsTenantIdAudit400 | GetTenantsTenantIdAudit401 | GetTenantsTenantIdAudit500>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsTenantIdAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantsTenantIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getTenantsTenantIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantsTenantIdAudit<TData = Awaited<ReturnType<typeof getTenantsTenantIdAudit>>, TError = GetTenantsTenantIdAudit400 | GetTenantsTenantIdAudit401 | GetTenantsTenantIdAudit500>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsTenantIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Get Tenant Audit
 */

export function useGetTenantsTenantIdAudit<TData = Awaited<ReturnType<typeof getTenantsTenantIdAudit>>, TError = GetTenantsTenantIdAudit400 | GetTenantsTenantIdAudit401 | GetTenantsTenantIdAudit500>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsTenantIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTenantsTenantIdAuditQueryOptions(tenantId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Get Tenant Assigned Users Audit endpoint
 * @summary Fetch Get Tenant Assigned Users Audit
 */
export const getTenantsTenantIdAssignedUsersAudit = (
    tenantId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetTenantsTenantIdAssignedUsersAudit200>(
      {url: `/tenants/${tenantId}/assigned-users/audit`, method: 'GET', signal
    },
      );
    }
  



export const getGetTenantsTenantIdAssignedUsersAuditQueryKey = (tenantId?: string,) => {
    return [
    `/tenants/${tenantId}/assigned-users/audit`
    ] as const;
    }

    
export const getGetTenantsTenantIdAssignedUsersAuditQueryOptions = <TData = Awaited<ReturnType<typeof getTenantsTenantIdAssignedUsersAudit>>, TError = GetTenantsTenantIdAssignedUsersAudit400 | GetTenantsTenantIdAssignedUsersAudit401 | GetTenantsTenantIdAssignedUsersAudit500>(tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsTenantIdAssignedUsersAudit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTenantsTenantIdAssignedUsersAuditQueryKey(tenantId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenantsTenantIdAssignedUsersAudit>>> = ({ signal }) => getTenantsTenantIdAssignedUsersAudit(tenantId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(tenantId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTenantsTenantIdAssignedUsersAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTenantsTenantIdAssignedUsersAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getTenantsTenantIdAssignedUsersAudit>>>
export type GetTenantsTenantIdAssignedUsersAuditQueryError = GetTenantsTenantIdAssignedUsersAudit400 | GetTenantsTenantIdAssignedUsersAudit401 | GetTenantsTenantIdAssignedUsersAudit500


export function useGetTenantsTenantIdAssignedUsersAudit<TData = Awaited<ReturnType<typeof getTenantsTenantIdAssignedUsersAudit>>, TError = GetTenantsTenantIdAssignedUsersAudit400 | GetTenantsTenantIdAssignedUsersAudit401 | GetTenantsTenantIdAssignedUsersAudit500>(
 tenantId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsTenantIdAssignedUsersAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantsTenantIdAssignedUsersAudit>>,
          TError,
          Awaited<ReturnType<typeof getTenantsTenantIdAssignedUsersAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantsTenantIdAssignedUsersAudit<TData = Awaited<ReturnType<typeof getTenantsTenantIdAssignedUsersAudit>>, TError = GetTenantsTenantIdAssignedUsersAudit400 | GetTenantsTenantIdAssignedUsersAudit401 | GetTenantsTenantIdAssignedUsersAudit500>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsTenantIdAssignedUsersAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantsTenantIdAssignedUsersAudit>>,
          TError,
          Awaited<ReturnType<typeof getTenantsTenantIdAssignedUsersAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantsTenantIdAssignedUsersAudit<TData = Awaited<ReturnType<typeof getTenantsTenantIdAssignedUsersAudit>>, TError = GetTenantsTenantIdAssignedUsersAudit400 | GetTenantsTenantIdAssignedUsersAudit401 | GetTenantsTenantIdAssignedUsersAudit500>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsTenantIdAssignedUsersAudit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Get Tenant Assigned Users Audit
 */

export function useGetTenantsTenantIdAssignedUsersAudit<TData = Awaited<ReturnType<typeof getTenantsTenantIdAssignedUsersAudit>>, TError = GetTenantsTenantIdAssignedUsersAudit400 | GetTenantsTenantIdAssignedUsersAudit401 | GetTenantsTenantIdAssignedUsersAudit500>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsTenantIdAssignedUsersAudit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTenantsTenantIdAssignedUsersAuditQueryOptions(tenantId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create Entities Shareholders Restore endpoint
 * @summary Create Entities Shareholders Restore
 */
export const postEntitiesShareholdersShareholderIdRestore = (
    shareholderId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostEntitiesShareholdersShareholderIdRestore200>(
      {url: `/entities/shareholders/${shareholderId}/restore`, method: 'POST', signal
    },
      );
    }
  


export const getPostEntitiesShareholdersShareholderIdRestoreMutationOptions = <TError = PostEntitiesShareholdersShareholderIdRestore400 | PostEntitiesShareholdersShareholderIdRestore401 | PostEntitiesShareholdersShareholderIdRestore500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEntitiesShareholdersShareholderIdRestore>>, TError,{shareholderId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEntitiesShareholdersShareholderIdRestore>>, TError,{shareholderId: string}, TContext> => {

const mutationKey = ['postEntitiesShareholdersShareholderIdRestore'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEntitiesShareholdersShareholderIdRestore>>, {shareholderId: string}> = (props) => {
          const {shareholderId} = props ?? {};

          return  postEntitiesShareholdersShareholderIdRestore(shareholderId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEntitiesShareholdersShareholderIdRestoreMutationResult = NonNullable<Awaited<ReturnType<typeof postEntitiesShareholdersShareholderIdRestore>>>
    
    export type PostEntitiesShareholdersShareholderIdRestoreMutationError = PostEntitiesShareholdersShareholderIdRestore400 | PostEntitiesShareholdersShareholderIdRestore401 | PostEntitiesShareholdersShareholderIdRestore500

    /**
 * @summary Create Entities Shareholders Restore
 */
export const usePostEntitiesShareholdersShareholderIdRestore = <TError = PostEntitiesShareholdersShareholderIdRestore400 | PostEntitiesShareholdersShareholderIdRestore401 | PostEntitiesShareholdersShareholderIdRestore500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEntitiesShareholdersShareholderIdRestore>>, TError,{shareholderId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEntitiesShareholdersShareholderIdRestore>>,
        TError,
        {shareholderId: string},
        TContext
      > => {

      const mutationOptions = getPostEntitiesShareholdersShareholderIdRestoreMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Promote Document endpoint
 * @summary Create Promote Document
 */
export const postDocumentsPromote = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostDocumentsPromote200>(
      {url: `/documents/promote`, method: 'POST', signal
    },
      );
    }
  


export const getPostDocumentsPromoteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDocumentsPromote>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postDocumentsPromote>>, TError,void, TContext> => {

const mutationKey = ['postDocumentsPromote'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postDocumentsPromote>>, void> = () => {
          

          return  postDocumentsPromote()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostDocumentsPromoteMutationResult = NonNullable<Awaited<ReturnType<typeof postDocumentsPromote>>>
    
    export type PostDocumentsPromoteMutationError = unknown

    /**
 * @summary Create Promote Document
 */
export const usePostDocumentsPromote = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDocumentsPromote>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postDocumentsPromote>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostDocumentsPromoteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Get Lsp Entity Access Audit endpoint
 * @summary Fetch Get Lsp Entity Access Audit
 */
export const getTenantsLspTenantIdEntityAccessAudit = (
    lspTenantId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetTenantsLspTenantIdEntityAccessAudit200>(
      {url: `/tenants/${lspTenantId}/entity-access/audit`, method: 'GET', signal
    },
      );
    }
  



export const getGetTenantsLspTenantIdEntityAccessAuditQueryKey = (lspTenantId?: string,) => {
    return [
    `/tenants/${lspTenantId}/entity-access/audit`
    ] as const;
    }

    
export const getGetTenantsLspTenantIdEntityAccessAuditQueryOptions = <TData = Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccessAudit>>, TError = GetTenantsLspTenantIdEntityAccessAudit400 | GetTenantsLspTenantIdEntityAccessAudit401 | GetTenantsLspTenantIdEntityAccessAudit500>(lspTenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccessAudit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTenantsLspTenantIdEntityAccessAuditQueryKey(lspTenantId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccessAudit>>> = ({ signal }) => getTenantsLspTenantIdEntityAccessAudit(lspTenantId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(lspTenantId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccessAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTenantsLspTenantIdEntityAccessAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccessAudit>>>
export type GetTenantsLspTenantIdEntityAccessAuditQueryError = GetTenantsLspTenantIdEntityAccessAudit400 | GetTenantsLspTenantIdEntityAccessAudit401 | GetTenantsLspTenantIdEntityAccessAudit500


export function useGetTenantsLspTenantIdEntityAccessAudit<TData = Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccessAudit>>, TError = GetTenantsLspTenantIdEntityAccessAudit400 | GetTenantsLspTenantIdEntityAccessAudit401 | GetTenantsLspTenantIdEntityAccessAudit500>(
 lspTenantId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccessAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccessAudit>>,
          TError,
          Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccessAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantsLspTenantIdEntityAccessAudit<TData = Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccessAudit>>, TError = GetTenantsLspTenantIdEntityAccessAudit400 | GetTenantsLspTenantIdEntityAccessAudit401 | GetTenantsLspTenantIdEntityAccessAudit500>(
 lspTenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccessAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccessAudit>>,
          TError,
          Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccessAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantsLspTenantIdEntityAccessAudit<TData = Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccessAudit>>, TError = GetTenantsLspTenantIdEntityAccessAudit400 | GetTenantsLspTenantIdEntityAccessAudit401 | GetTenantsLspTenantIdEntityAccessAudit500>(
 lspTenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccessAudit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Get Lsp Entity Access Audit
 */

export function useGetTenantsLspTenantIdEntityAccessAudit<TData = Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccessAudit>>, TError = GetTenantsLspTenantIdEntityAccessAudit400 | GetTenantsLspTenantIdEntityAccessAudit401 | GetTenantsLspTenantIdEntityAccessAudit500>(
 lspTenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccessAudit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTenantsLspTenantIdEntityAccessAuditQueryOptions(lspTenantId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update Update Lsp Entity Access endpoint
 * @summary Update Update Lsp Entity Access
 */
export const putTenantsLspTenantIdEntityAccessEntityId = (
    lspTenantId: string,
    entityId: string,
 ) => {
      
      
      return customInstance<PutTenantsLspTenantIdEntityAccessEntityId200>(
      {url: `/tenants/${lspTenantId}/entity-access/${entityId}`, method: 'PUT'
    },
      );
    }
  


export const getPutTenantsLspTenantIdEntityAccessEntityIdMutationOptions = <TError = PutTenantsLspTenantIdEntityAccessEntityId400 | PutTenantsLspTenantIdEntityAccessEntityId401 | PutTenantsLspTenantIdEntityAccessEntityId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTenantsLspTenantIdEntityAccessEntityId>>, TError,{lspTenantId: string;entityId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putTenantsLspTenantIdEntityAccessEntityId>>, TError,{lspTenantId: string;entityId: string}, TContext> => {

const mutationKey = ['putTenantsLspTenantIdEntityAccessEntityId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTenantsLspTenantIdEntityAccessEntityId>>, {lspTenantId: string;entityId: string}> = (props) => {
          const {lspTenantId,entityId} = props ?? {};

          return  putTenantsLspTenantIdEntityAccessEntityId(lspTenantId,entityId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutTenantsLspTenantIdEntityAccessEntityIdMutationResult = NonNullable<Awaited<ReturnType<typeof putTenantsLspTenantIdEntityAccessEntityId>>>
    
    export type PutTenantsLspTenantIdEntityAccessEntityIdMutationError = PutTenantsLspTenantIdEntityAccessEntityId400 | PutTenantsLspTenantIdEntityAccessEntityId401 | PutTenantsLspTenantIdEntityAccessEntityId500

    /**
 * @summary Update Update Lsp Entity Access
 */
export const usePutTenantsLspTenantIdEntityAccessEntityId = <TError = PutTenantsLspTenantIdEntityAccessEntityId400 | PutTenantsLspTenantIdEntityAccessEntityId401 | PutTenantsLspTenantIdEntityAccessEntityId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTenantsLspTenantIdEntityAccessEntityId>>, TError,{lspTenantId: string;entityId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putTenantsLspTenantIdEntityAccessEntityId>>,
        TError,
        {lspTenantId: string;entityId: string},
        TContext
      > => {

      const mutationOptions = getPutTenantsLspTenantIdEntityAccessEntityIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete Delete Lsp Entity Access endpoint
 * @summary Delete Delete Lsp Entity Access
 */
export const deleteTenantsLspTenantIdEntityAccessEntityId = (
    lspTenantId: string,
    entityId: string,
 ) => {
      
      
      return customInstance<DeleteTenantsLspTenantIdEntityAccessEntityId200>(
      {url: `/tenants/${lspTenantId}/entity-access/${entityId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteTenantsLspTenantIdEntityAccessEntityIdMutationOptions = <TError = DeleteTenantsLspTenantIdEntityAccessEntityId400 | DeleteTenantsLspTenantIdEntityAccessEntityId401 | DeleteTenantsLspTenantIdEntityAccessEntityId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTenantsLspTenantIdEntityAccessEntityId>>, TError,{lspTenantId: string;entityId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteTenantsLspTenantIdEntityAccessEntityId>>, TError,{lspTenantId: string;entityId: string}, TContext> => {

const mutationKey = ['deleteTenantsLspTenantIdEntityAccessEntityId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTenantsLspTenantIdEntityAccessEntityId>>, {lspTenantId: string;entityId: string}> = (props) => {
          const {lspTenantId,entityId} = props ?? {};

          return  deleteTenantsLspTenantIdEntityAccessEntityId(lspTenantId,entityId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTenantsLspTenantIdEntityAccessEntityIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTenantsLspTenantIdEntityAccessEntityId>>>
    
    export type DeleteTenantsLspTenantIdEntityAccessEntityIdMutationError = DeleteTenantsLspTenantIdEntityAccessEntityId400 | DeleteTenantsLspTenantIdEntityAccessEntityId401 | DeleteTenantsLspTenantIdEntityAccessEntityId500

    /**
 * @summary Delete Delete Lsp Entity Access
 */
export const useDeleteTenantsLspTenantIdEntityAccessEntityId = <TError = DeleteTenantsLspTenantIdEntityAccessEntityId400 | DeleteTenantsLspTenantIdEntityAccessEntityId401 | DeleteTenantsLspTenantIdEntityAccessEntityId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTenantsLspTenantIdEntityAccessEntityId>>, TError,{lspTenantId: string;entityId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTenantsLspTenantIdEntityAccessEntityId>>,
        TError,
        {lspTenantId: string;entityId: string},
        TContext
      > => {

      const mutationOptions = getDeleteTenantsLspTenantIdEntityAccessEntityIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch List Lsp Entity Access endpoint
 * @summary Fetch List Lsp Entity Access
 */
export const getTenantsLspTenantIdEntityAccess = (
    lspTenantId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetTenantsLspTenantIdEntityAccess200>(
      {url: `/tenants/${lspTenantId}/entity-access`, method: 'GET', signal
    },
      );
    }
  



export const getGetTenantsLspTenantIdEntityAccessQueryKey = (lspTenantId?: string,) => {
    return [
    `/tenants/${lspTenantId}/entity-access`
    ] as const;
    }

    
export const getGetTenantsLspTenantIdEntityAccessQueryOptions = <TData = Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccess>>, TError = GetTenantsLspTenantIdEntityAccess400 | GetTenantsLspTenantIdEntityAccess401 | GetTenantsLspTenantIdEntityAccess500>(lspTenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccess>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTenantsLspTenantIdEntityAccessQueryKey(lspTenantId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccess>>> = ({ signal }) => getTenantsLspTenantIdEntityAccess(lspTenantId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(lspTenantId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTenantsLspTenantIdEntityAccessQueryResult = NonNullable<Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccess>>>
export type GetTenantsLspTenantIdEntityAccessQueryError = GetTenantsLspTenantIdEntityAccess400 | GetTenantsLspTenantIdEntityAccess401 | GetTenantsLspTenantIdEntityAccess500


export function useGetTenantsLspTenantIdEntityAccess<TData = Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccess>>, TError = GetTenantsLspTenantIdEntityAccess400 | GetTenantsLspTenantIdEntityAccess401 | GetTenantsLspTenantIdEntityAccess500>(
 lspTenantId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccess>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccess>>,
          TError,
          Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccess>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantsLspTenantIdEntityAccess<TData = Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccess>>, TError = GetTenantsLspTenantIdEntityAccess400 | GetTenantsLspTenantIdEntityAccess401 | GetTenantsLspTenantIdEntityAccess500>(
 lspTenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccess>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccess>>,
          TError,
          Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccess>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantsLspTenantIdEntityAccess<TData = Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccess>>, TError = GetTenantsLspTenantIdEntityAccess400 | GetTenantsLspTenantIdEntityAccess401 | GetTenantsLspTenantIdEntityAccess500>(
 lspTenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccess>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch List Lsp Entity Access
 */

export function useGetTenantsLspTenantIdEntityAccess<TData = Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccess>>, TError = GetTenantsLspTenantIdEntityAccess400 | GetTenantsLspTenantIdEntityAccess401 | GetTenantsLspTenantIdEntityAccess500>(
 lspTenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsLspTenantIdEntityAccess>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTenantsLspTenantIdEntityAccessQueryOptions(lspTenantId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create Create Lsp Entity Access endpoint
 * @summary Create Create Lsp Entity Access
 */
export const postTenantsLspTenantIdEntityAccess = (
    lspTenantId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostTenantsLspTenantIdEntityAccess200>(
      {url: `/tenants/${lspTenantId}/entity-access`, method: 'POST', signal
    },
      );
    }
  


export const getPostTenantsLspTenantIdEntityAccessMutationOptions = <TError = PostTenantsLspTenantIdEntityAccess400 | PostTenantsLspTenantIdEntityAccess401 | PostTenantsLspTenantIdEntityAccess500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTenantsLspTenantIdEntityAccess>>, TError,{lspTenantId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postTenantsLspTenantIdEntityAccess>>, TError,{lspTenantId: string}, TContext> => {

const mutationKey = ['postTenantsLspTenantIdEntityAccess'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTenantsLspTenantIdEntityAccess>>, {lspTenantId: string}> = (props) => {
          const {lspTenantId} = props ?? {};

          return  postTenantsLspTenantIdEntityAccess(lspTenantId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTenantsLspTenantIdEntityAccessMutationResult = NonNullable<Awaited<ReturnType<typeof postTenantsLspTenantIdEntityAccess>>>
    
    export type PostTenantsLspTenantIdEntityAccessMutationError = PostTenantsLspTenantIdEntityAccess400 | PostTenantsLspTenantIdEntityAccess401 | PostTenantsLspTenantIdEntityAccess500

    /**
 * @summary Create Create Lsp Entity Access
 */
export const usePostTenantsLspTenantIdEntityAccess = <TError = PostTenantsLspTenantIdEntityAccess400 | PostTenantsLspTenantIdEntityAccess401 | PostTenantsLspTenantIdEntityAccess500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTenantsLspTenantIdEntityAccess>>, TError,{lspTenantId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postTenantsLspTenantIdEntityAccess>>,
        TError,
        {lspTenantId: string},
        TContext
      > => {

      const mutationOptions = getPostTenantsLspTenantIdEntityAccessMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch List Users endpoint
 * @summary Fetch List Users
 */
export const getUsers = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetUsers200>(
      {url: `/users`, method: 'GET', signal
    },
      );
    }
  



export const getGetUsersQueryKey = () => {
    return [
    `/users`
    ] as const;
    }

    
export const getGetUsersQueryOptions = <TData = Awaited<ReturnType<typeof getUsers>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsers>>> = ({ signal }) => getUsers(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getUsers>>>
export type GetUsersQueryError = unknown


export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsers>>,
          TError,
          Awaited<ReturnType<typeof getUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsers>>,
          TError,
          Awaited<ReturnType<typeof getUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch List Users
 */

export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch List Tenants endpoint
 * @summary Fetch List Tenants
 */
export const getTenants = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetTenants200>(
      {url: `/tenants`, method: 'GET', signal
    },
      );
    }
  



export const getGetTenantsQueryKey = () => {
    return [
    `/tenants`
    ] as const;
    }

    
export const getGetTenantsQueryOptions = <TData = Awaited<ReturnType<typeof getTenants>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenants>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTenantsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenants>>> = ({ signal }) => getTenants(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTenants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTenantsQueryResult = NonNullable<Awaited<ReturnType<typeof getTenants>>>
export type GetTenantsQueryError = unknown


export function useGetTenants<TData = Awaited<ReturnType<typeof getTenants>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenants>>,
          TError,
          Awaited<ReturnType<typeof getTenants>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenants<TData = Awaited<ReturnType<typeof getTenants>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenants>>,
          TError,
          Awaited<ReturnType<typeof getTenants>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenants<TData = Awaited<ReturnType<typeof getTenants>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenants>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch List Tenants
 */

export function useGetTenants<TData = Awaited<ReturnType<typeof getTenants>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenants>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTenantsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create Create Tenant endpoint
 * @summary Create Create Tenant
 */
export const postTenants = (
    postTenantsBody: PostTenantsBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostTenants200>(
      {url: `/tenants`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postTenantsBody, signal
    },
      );
    }
  


export const getPostTenantsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTenants>>, TError,{data: PostTenantsBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postTenants>>, TError,{data: PostTenantsBody}, TContext> => {

const mutationKey = ['postTenants'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTenants>>, {data: PostTenantsBody}> = (props) => {
          const {data} = props ?? {};

          return  postTenants(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTenantsMutationResult = NonNullable<Awaited<ReturnType<typeof postTenants>>>
    export type PostTenantsMutationBody = PostTenantsBody
    export type PostTenantsMutationError = unknown

    /**
 * @summary Create Create Tenant
 */
export const usePostTenants = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTenants>>, TError,{data: PostTenantsBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postTenants>>,
        TError,
        {data: PostTenantsBody},
        TContext
      > => {

      const mutationOptions = getPostTenantsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch List Single Tenant endpoint
 * @summary Fetch List Single Tenant
 */
export const getTenantsId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetTenantsId200>(
      {url: `/tenants/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetTenantsIdQueryKey = (id?: string,) => {
    return [
    `/tenants/${id}`
    ] as const;
    }

    
export const getGetTenantsIdQueryOptions = <TData = Awaited<ReturnType<typeof getTenantsId>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTenantsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenantsId>>> = ({ signal }) => getTenantsId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTenantsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTenantsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getTenantsId>>>
export type GetTenantsIdQueryError = unknown


export function useGetTenantsId<TData = Awaited<ReturnType<typeof getTenantsId>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantsId>>,
          TError,
          Awaited<ReturnType<typeof getTenantsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantsId<TData = Awaited<ReturnType<typeof getTenantsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantsId>>,
          TError,
          Awaited<ReturnType<typeof getTenantsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantsId<TData = Awaited<ReturnType<typeof getTenantsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch List Single Tenant
 */

export function useGetTenantsId<TData = Awaited<ReturnType<typeof getTenantsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTenantsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update Edit Tenant endpoint
 * @summary Update Edit Tenant
 */
export const patchTenantsId = (
    id: string,
    patchTenantsIdBody: PatchTenantsIdBody,
 ) => {
      
      
      return customInstance<PatchTenantsId200>(
      {url: `/tenants/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchTenantsIdBody
    },
      );
    }
  


export const getPatchTenantsIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTenantsId>>, TError,{id: string;data: PatchTenantsIdBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchTenantsId>>, TError,{id: string;data: PatchTenantsIdBody}, TContext> => {

const mutationKey = ['patchTenantsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchTenantsId>>, {id: string;data: PatchTenantsIdBody}> = (props) => {
          const {id,data} = props ?? {};

          return  patchTenantsId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchTenantsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchTenantsId>>>
    export type PatchTenantsIdMutationBody = PatchTenantsIdBody
    export type PatchTenantsIdMutationError = unknown

    /**
 * @summary Update Edit Tenant
 */
export const usePatchTenantsId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTenantsId>>, TError,{id: string;data: PatchTenantsIdBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchTenantsId>>,
        TError,
        {id: string;data: PatchTenantsIdBody},
        TContext
      > => {

      const mutationOptions = getPatchTenantsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete Delete Tenant endpoint
 * @summary Delete Delete Tenant
 */
export const deleteTenantsId = (
    id: string,
 ) => {
      
      
      return customInstance<DeleteTenantsId200>(
      {url: `/tenants/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteTenantsIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTenantsId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteTenantsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteTenantsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTenantsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteTenantsId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTenantsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTenantsId>>>
    
    export type DeleteTenantsIdMutationError = unknown

    /**
 * @summary Delete Delete Tenant
 */
export const useDeleteTenantsId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTenantsId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTenantsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteTenantsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch List Tenant Entities endpoint
 * @summary Fetch List Tenant Entities
 */
export const getTenantsTenantIdEntities = (
    tenantId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetTenantsTenantIdEntities200>(
      {url: `/tenants/${tenantId}/entities`, method: 'GET', signal
    },
      );
    }
  



export const getGetTenantsTenantIdEntitiesQueryKey = (tenantId?: string,) => {
    return [
    `/tenants/${tenantId}/entities`
    ] as const;
    }

    
export const getGetTenantsTenantIdEntitiesQueryOptions = <TData = Awaited<ReturnType<typeof getTenantsTenantIdEntities>>, TError = GetTenantsTenantIdEntities400 | GetTenantsTenantIdEntities401 | GetTenantsTenantIdEntities500>(tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsTenantIdEntities>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTenantsTenantIdEntitiesQueryKey(tenantId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenantsTenantIdEntities>>> = ({ signal }) => getTenantsTenantIdEntities(tenantId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(tenantId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTenantsTenantIdEntities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTenantsTenantIdEntitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getTenantsTenantIdEntities>>>
export type GetTenantsTenantIdEntitiesQueryError = GetTenantsTenantIdEntities400 | GetTenantsTenantIdEntities401 | GetTenantsTenantIdEntities500


export function useGetTenantsTenantIdEntities<TData = Awaited<ReturnType<typeof getTenantsTenantIdEntities>>, TError = GetTenantsTenantIdEntities400 | GetTenantsTenantIdEntities401 | GetTenantsTenantIdEntities500>(
 tenantId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsTenantIdEntities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantsTenantIdEntities>>,
          TError,
          Awaited<ReturnType<typeof getTenantsTenantIdEntities>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantsTenantIdEntities<TData = Awaited<ReturnType<typeof getTenantsTenantIdEntities>>, TError = GetTenantsTenantIdEntities400 | GetTenantsTenantIdEntities401 | GetTenantsTenantIdEntities500>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsTenantIdEntities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantsTenantIdEntities>>,
          TError,
          Awaited<ReturnType<typeof getTenantsTenantIdEntities>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantsTenantIdEntities<TData = Awaited<ReturnType<typeof getTenantsTenantIdEntities>>, TError = GetTenantsTenantIdEntities400 | GetTenantsTenantIdEntities401 | GetTenantsTenantIdEntities500>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsTenantIdEntities>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch List Tenant Entities
 */

export function useGetTenantsTenantIdEntities<TData = Awaited<ReturnType<typeof getTenantsTenantIdEntities>>, TError = GetTenantsTenantIdEntities400 | GetTenantsTenantIdEntities401 | GetTenantsTenantIdEntities500>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsTenantIdEntities>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTenantsTenantIdEntitiesQueryOptions(tenantId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch List Processes endpoint
 * @summary Fetch List Processes
 */
export const getProcesses = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetProcesses200>(
      {url: `/processes`, method: 'GET', signal
    },
      );
    }
  



export const getGetProcessesQueryKey = () => {
    return [
    `/processes`
    ] as const;
    }

    
export const getGetProcessesQueryOptions = <TData = Awaited<ReturnType<typeof getProcesses>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcesses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProcessesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProcesses>>> = ({ signal }) => getProcesses(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProcesses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProcessesQueryResult = NonNullable<Awaited<ReturnType<typeof getProcesses>>>
export type GetProcessesQueryError = unknown


export function useGetProcesses<TData = Awaited<ReturnType<typeof getProcesses>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcesses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcesses>>,
          TError,
          Awaited<ReturnType<typeof getProcesses>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcesses<TData = Awaited<ReturnType<typeof getProcesses>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcesses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcesses>>,
          TError,
          Awaited<ReturnType<typeof getProcesses>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcesses<TData = Awaited<ReturnType<typeof getProcesses>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcesses>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch List Processes
 */

export function useGetProcesses<TData = Awaited<ReturnType<typeof getProcesses>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcesses>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProcessesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch List Managed Entities endpoint
 * @summary Fetch List Managed Entities
 */
export const getAccountManagerIdManagedEntities = (
    accountManagerId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetAccountManagerIdManagedEntities200>(
      {url: `/${accountManagerId}/managed-entities`, method: 'GET', signal
    },
      );
    }
  



export const getGetAccountManagerIdManagedEntitiesQueryKey = (accountManagerId?: string,) => {
    return [
    `/${accountManagerId}/managed-entities`
    ] as const;
    }

    
export const getGetAccountManagerIdManagedEntitiesQueryOptions = <TData = Awaited<ReturnType<typeof getAccountManagerIdManagedEntities>>, TError = GetAccountManagerIdManagedEntities400 | GetAccountManagerIdManagedEntities401 | GetAccountManagerIdManagedEntities500>(accountManagerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountManagerIdManagedEntities>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountManagerIdManagedEntitiesQueryKey(accountManagerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountManagerIdManagedEntities>>> = ({ signal }) => getAccountManagerIdManagedEntities(accountManagerId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(accountManagerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountManagerIdManagedEntities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccountManagerIdManagedEntitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountManagerIdManagedEntities>>>
export type GetAccountManagerIdManagedEntitiesQueryError = GetAccountManagerIdManagedEntities400 | GetAccountManagerIdManagedEntities401 | GetAccountManagerIdManagedEntities500


export function useGetAccountManagerIdManagedEntities<TData = Awaited<ReturnType<typeof getAccountManagerIdManagedEntities>>, TError = GetAccountManagerIdManagedEntities400 | GetAccountManagerIdManagedEntities401 | GetAccountManagerIdManagedEntities500>(
 accountManagerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountManagerIdManagedEntities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountManagerIdManagedEntities>>,
          TError,
          Awaited<ReturnType<typeof getAccountManagerIdManagedEntities>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccountManagerIdManagedEntities<TData = Awaited<ReturnType<typeof getAccountManagerIdManagedEntities>>, TError = GetAccountManagerIdManagedEntities400 | GetAccountManagerIdManagedEntities401 | GetAccountManagerIdManagedEntities500>(
 accountManagerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountManagerIdManagedEntities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountManagerIdManagedEntities>>,
          TError,
          Awaited<ReturnType<typeof getAccountManagerIdManagedEntities>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccountManagerIdManagedEntities<TData = Awaited<ReturnType<typeof getAccountManagerIdManagedEntities>>, TError = GetAccountManagerIdManagedEntities400 | GetAccountManagerIdManagedEntities401 | GetAccountManagerIdManagedEntities500>(
 accountManagerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountManagerIdManagedEntities>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch List Managed Entities
 */

export function useGetAccountManagerIdManagedEntities<TData = Awaited<ReturnType<typeof getAccountManagerIdManagedEntities>>, TError = GetAccountManagerIdManagedEntities400 | GetAccountManagerIdManagedEntities401 | GetAccountManagerIdManagedEntities500>(
 accountManagerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountManagerIdManagedEntities>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccountManagerIdManagedEntitiesQueryOptions(accountManagerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch List Entities endpoint
 * @summary Fetch List Entities
 */
export const getEntities = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntities200>(
      {url: `/entities`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesQueryKey = () => {
    return [
    `/entities`
    ] as const;
    }

    
export const getGetEntitiesQueryOptions = <TData = Awaited<ReturnType<typeof getEntities>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntities>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntities>>> = ({ signal }) => getEntities(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getEntities>>>
export type GetEntitiesQueryError = unknown


export function useGetEntities<TData = Awaited<ReturnType<typeof getEntities>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntities>>,
          TError,
          Awaited<ReturnType<typeof getEntities>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntities<TData = Awaited<ReturnType<typeof getEntities>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntities>>,
          TError,
          Awaited<ReturnType<typeof getEntities>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntities<TData = Awaited<ReturnType<typeof getEntities>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntities>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch List Entities
 */

export function useGetEntities<TData = Awaited<ReturnType<typeof getEntities>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntities>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create Create Entity endpoint
 * @summary Create Create Entity
 */
export const postEntities = (
    postEntitiesBody: PostEntitiesBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostEntities200>(
      {url: `/entities`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postEntitiesBody, signal
    },
      );
    }
  


export const getPostEntitiesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEntities>>, TError,{data: PostEntitiesBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEntities>>, TError,{data: PostEntitiesBody}, TContext> => {

const mutationKey = ['postEntities'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEntities>>, {data: PostEntitiesBody}> = (props) => {
          const {data} = props ?? {};

          return  postEntities(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEntitiesMutationResult = NonNullable<Awaited<ReturnType<typeof postEntities>>>
    export type PostEntitiesMutationBody = PostEntitiesBody
    export type PostEntitiesMutationError = unknown

    /**
 * @summary Create Create Entity
 */
export const usePostEntities = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEntities>>, TError,{data: PostEntitiesBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEntities>>,
        TError,
        {data: PostEntitiesBody},
        TContext
      > => {

      const mutationOptions = getPostEntitiesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch List Account Managers endpoint
 * @summary Fetch List Account Managers
 */
export const getAccountManagers = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetAccountManagers200>(
      {url: `/account-managers`, method: 'GET', signal
    },
      );
    }
  



export const getGetAccountManagersQueryKey = () => {
    return [
    `/account-managers`
    ] as const;
    }

    
export const getGetAccountManagersQueryOptions = <TData = Awaited<ReturnType<typeof getAccountManagers>>, TError = GetAccountManagers400 | GetAccountManagers401 | GetAccountManagers500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountManagers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountManagersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountManagers>>> = ({ signal }) => getAccountManagers(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountManagers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccountManagersQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountManagers>>>
export type GetAccountManagersQueryError = GetAccountManagers400 | GetAccountManagers401 | GetAccountManagers500


export function useGetAccountManagers<TData = Awaited<ReturnType<typeof getAccountManagers>>, TError = GetAccountManagers400 | GetAccountManagers401 | GetAccountManagers500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountManagers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountManagers>>,
          TError,
          Awaited<ReturnType<typeof getAccountManagers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccountManagers<TData = Awaited<ReturnType<typeof getAccountManagers>>, TError = GetAccountManagers400 | GetAccountManagers401 | GetAccountManagers500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountManagers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountManagers>>,
          TError,
          Awaited<ReturnType<typeof getAccountManagers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccountManagers<TData = Awaited<ReturnType<typeof getAccountManagers>>, TError = GetAccountManagers400 | GetAccountManagers401 | GetAccountManagers500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountManagers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch List Account Managers
 */

export function useGetAccountManagers<TData = Awaited<ReturnType<typeof getAccountManagers>>, TError = GetAccountManagers400 | GetAccountManagers401 | GetAccountManagers500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountManagers>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccountManagersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create Create Account Manager endpoint
 * @summary Create Create Account Manager
 */
export const postAccountManagers = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostAccountManagers200>(
      {url: `/account-managers`, method: 'POST', signal
    },
      );
    }
  


export const getPostAccountManagersMutationOptions = <TError = PostAccountManagers400 | PostAccountManagers401 | PostAccountManagers500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccountManagers>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAccountManagers>>, TError,void, TContext> => {

const mutationKey = ['postAccountManagers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAccountManagers>>, void> = () => {
          

          return  postAccountManagers()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAccountManagersMutationResult = NonNullable<Awaited<ReturnType<typeof postAccountManagers>>>
    
    export type PostAccountManagersMutationError = PostAccountManagers400 | PostAccountManagers401 | PostAccountManagers500

    /**
 * @summary Create Create Account Manager
 */
export const usePostAccountManagers = <TError = PostAccountManagers400 | PostAccountManagers401 | PostAccountManagers500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccountManagers>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAccountManagers>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostAccountManagersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Get Duplicate Shareholders Function endpoint
 * @summary Create Get Duplicate Shareholders Function
 */
export const postTenantsTenantIdShareholdersDuplicates = (
    tenantId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostTenantsTenantIdShareholdersDuplicates200>(
      {url: `/tenants/${tenantId}/shareholders/duplicates`, method: 'POST', signal
    },
      );
    }
  


export const getPostTenantsTenantIdShareholdersDuplicatesMutationOptions = <TError = PostTenantsTenantIdShareholdersDuplicates400 | PostTenantsTenantIdShareholdersDuplicates401 | PostTenantsTenantIdShareholdersDuplicates500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTenantsTenantIdShareholdersDuplicates>>, TError,{tenantId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postTenantsTenantIdShareholdersDuplicates>>, TError,{tenantId: string}, TContext> => {

const mutationKey = ['postTenantsTenantIdShareholdersDuplicates'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTenantsTenantIdShareholdersDuplicates>>, {tenantId: string}> = (props) => {
          const {tenantId} = props ?? {};

          return  postTenantsTenantIdShareholdersDuplicates(tenantId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTenantsTenantIdShareholdersDuplicatesMutationResult = NonNullable<Awaited<ReturnType<typeof postTenantsTenantIdShareholdersDuplicates>>>
    
    export type PostTenantsTenantIdShareholdersDuplicatesMutationError = PostTenantsTenantIdShareholdersDuplicates400 | PostTenantsTenantIdShareholdersDuplicates401 | PostTenantsTenantIdShareholdersDuplicates500

    /**
 * @summary Create Get Duplicate Shareholders Function
 */
export const usePostTenantsTenantIdShareholdersDuplicates = <TError = PostTenantsTenantIdShareholdersDuplicates400 | PostTenantsTenantIdShareholdersDuplicates401 | PostTenantsTenantIdShareholdersDuplicates500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTenantsTenantIdShareholdersDuplicates>>, TError,{tenantId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postTenantsTenantIdShareholdersDuplicates>>,
        TError,
        {tenantId: string},
        TContext
      > => {

      const mutationOptions = getPostTenantsTenantIdShareholdersDuplicatesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Get Duplicate Directors Function endpoint
 * @summary Create Get Duplicate Directors Function
 */
export const postTenantsTenantIdDirectorsDuplicates = (
    tenantId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostTenantsTenantIdDirectorsDuplicates200>(
      {url: `/tenants/${tenantId}/directors/duplicates`, method: 'POST', signal
    },
      );
    }
  


export const getPostTenantsTenantIdDirectorsDuplicatesMutationOptions = <TError = PostTenantsTenantIdDirectorsDuplicates400 | PostTenantsTenantIdDirectorsDuplicates401 | PostTenantsTenantIdDirectorsDuplicates500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTenantsTenantIdDirectorsDuplicates>>, TError,{tenantId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postTenantsTenantIdDirectorsDuplicates>>, TError,{tenantId: string}, TContext> => {

const mutationKey = ['postTenantsTenantIdDirectorsDuplicates'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTenantsTenantIdDirectorsDuplicates>>, {tenantId: string}> = (props) => {
          const {tenantId} = props ?? {};

          return  postTenantsTenantIdDirectorsDuplicates(tenantId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTenantsTenantIdDirectorsDuplicatesMutationResult = NonNullable<Awaited<ReturnType<typeof postTenantsTenantIdDirectorsDuplicates>>>
    
    export type PostTenantsTenantIdDirectorsDuplicatesMutationError = PostTenantsTenantIdDirectorsDuplicates400 | PostTenantsTenantIdDirectorsDuplicates401 | PostTenantsTenantIdDirectorsDuplicates500

    /**
 * @summary Create Get Duplicate Directors Function
 */
export const usePostTenantsTenantIdDirectorsDuplicates = <TError = PostTenantsTenantIdDirectorsDuplicates400 | PostTenantsTenantIdDirectorsDuplicates401 | PostTenantsTenantIdDirectorsDuplicates500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTenantsTenantIdDirectorsDuplicates>>, TError,{tenantId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postTenantsTenantIdDirectorsDuplicates>>,
        TError,
        {tenantId: string},
        TContext
      > => {

      const mutationOptions = getPostTenantsTenantIdDirectorsDuplicatesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Get Director Audit endpoint
 * @summary Fetch Get Director Audit
 */
export const getDirectorIdAudit = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetDirectorIdAudit200>(
      {url: `/director/${id}/audit`, method: 'GET', signal
    },
      );
    }
  



export const getGetDirectorIdAuditQueryKey = (id?: string,) => {
    return [
    `/director/${id}/audit`
    ] as const;
    }

    
export const getGetDirectorIdAuditQueryOptions = <TData = Awaited<ReturnType<typeof getDirectorIdAudit>>, TError = GetDirectorIdAudit400 | GetDirectorIdAudit401 | GetDirectorIdAudit500>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDirectorIdAudit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDirectorIdAuditQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDirectorIdAudit>>> = ({ signal }) => getDirectorIdAudit(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDirectorIdAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDirectorIdAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getDirectorIdAudit>>>
export type GetDirectorIdAuditQueryError = GetDirectorIdAudit400 | GetDirectorIdAudit401 | GetDirectorIdAudit500


export function useGetDirectorIdAudit<TData = Awaited<ReturnType<typeof getDirectorIdAudit>>, TError = GetDirectorIdAudit400 | GetDirectorIdAudit401 | GetDirectorIdAudit500>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDirectorIdAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDirectorIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getDirectorIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDirectorIdAudit<TData = Awaited<ReturnType<typeof getDirectorIdAudit>>, TError = GetDirectorIdAudit400 | GetDirectorIdAudit401 | GetDirectorIdAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDirectorIdAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDirectorIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getDirectorIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDirectorIdAudit<TData = Awaited<ReturnType<typeof getDirectorIdAudit>>, TError = GetDirectorIdAudit400 | GetDirectorIdAudit401 | GetDirectorIdAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDirectorIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Get Director Audit
 */

export function useGetDirectorIdAudit<TData = Awaited<ReturnType<typeof getDirectorIdAudit>>, TError = GetDirectorIdAudit400 | GetDirectorIdAudit401 | GetDirectorIdAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDirectorIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDirectorIdAuditQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Get Director Appointment Audit endpoint
 * @summary Fetch Get Director Appointment Audit
 */
export const getEntitiesIdDirectorAppointmentsDirectorIdAudit = (
    id: string,
    directorId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEntitiesIdDirectorAppointmentsDirectorIdAudit200>(
      {url: `/entities/${id}/director-appointments/${directorId}/audit`, method: 'GET', signal
    },
      );
    }
  



export const getGetEntitiesIdDirectorAppointmentsDirectorIdAuditQueryKey = (id?: string,
    directorId?: string,) => {
    return [
    `/entities/${id}/director-appointments/${directorId}/audit`
    ] as const;
    }

    
export const getGetEntitiesIdDirectorAppointmentsDirectorIdAuditQueryOptions = <TData = Awaited<ReturnType<typeof getEntitiesIdDirectorAppointmentsDirectorIdAudit>>, TError = GetEntitiesIdDirectorAppointmentsDirectorIdAudit400 | GetEntitiesIdDirectorAppointmentsDirectorIdAudit401 | GetEntitiesIdDirectorAppointmentsDirectorIdAudit500>(id: string,
    directorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesIdDirectorAppointmentsDirectorIdAudit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntitiesIdDirectorAppointmentsDirectorIdAuditQueryKey(id,directorId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitiesIdDirectorAppointmentsDirectorIdAudit>>> = ({ signal }) => getEntitiesIdDirectorAppointmentsDirectorIdAudit(id,directorId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id && directorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntitiesIdDirectorAppointmentsDirectorIdAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitiesIdDirectorAppointmentsDirectorIdAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getEntitiesIdDirectorAppointmentsDirectorIdAudit>>>
export type GetEntitiesIdDirectorAppointmentsDirectorIdAuditQueryError = GetEntitiesIdDirectorAppointmentsDirectorIdAudit400 | GetEntitiesIdDirectorAppointmentsDirectorIdAudit401 | GetEntitiesIdDirectorAppointmentsDirectorIdAudit500


export function useGetEntitiesIdDirectorAppointmentsDirectorIdAudit<TData = Awaited<ReturnType<typeof getEntitiesIdDirectorAppointmentsDirectorIdAudit>>, TError = GetEntitiesIdDirectorAppointmentsDirectorIdAudit400 | GetEntitiesIdDirectorAppointmentsDirectorIdAudit401 | GetEntitiesIdDirectorAppointmentsDirectorIdAudit500>(
 id: string,
    directorId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesIdDirectorAppointmentsDirectorIdAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesIdDirectorAppointmentsDirectorIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesIdDirectorAppointmentsDirectorIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesIdDirectorAppointmentsDirectorIdAudit<TData = Awaited<ReturnType<typeof getEntitiesIdDirectorAppointmentsDirectorIdAudit>>, TError = GetEntitiesIdDirectorAppointmentsDirectorIdAudit400 | GetEntitiesIdDirectorAppointmentsDirectorIdAudit401 | GetEntitiesIdDirectorAppointmentsDirectorIdAudit500>(
 id: string,
    directorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesIdDirectorAppointmentsDirectorIdAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntitiesIdDirectorAppointmentsDirectorIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getEntitiesIdDirectorAppointmentsDirectorIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitiesIdDirectorAppointmentsDirectorIdAudit<TData = Awaited<ReturnType<typeof getEntitiesIdDirectorAppointmentsDirectorIdAudit>>, TError = GetEntitiesIdDirectorAppointmentsDirectorIdAudit400 | GetEntitiesIdDirectorAppointmentsDirectorIdAudit401 | GetEntitiesIdDirectorAppointmentsDirectorIdAudit500>(
 id: string,
    directorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesIdDirectorAppointmentsDirectorIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Get Director Appointment Audit
 */

export function useGetEntitiesIdDirectorAppointmentsDirectorIdAudit<TData = Awaited<ReturnType<typeof getEntitiesIdDirectorAppointmentsDirectorIdAudit>>, TError = GetEntitiesIdDirectorAppointmentsDirectorIdAudit400 | GetEntitiesIdDirectorAppointmentsDirectorIdAudit401 | GetEntitiesIdDirectorAppointmentsDirectorIdAudit500>(
 id: string,
    directorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitiesIdDirectorAppointmentsDirectorIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitiesIdDirectorAppointmentsDirectorIdAuditQueryOptions(id,directorId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create Create Process endpoint
 * @summary Create Create Process
 */
export const postEntitiesEntityIdProcesses = (
    entityId: string,
    postEntitiesEntityIdProcessesBody: PostEntitiesEntityIdProcessesBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostEntitiesEntityIdProcesses200>(
      {url: `/entities/${entityId}/processes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postEntitiesEntityIdProcessesBody, signal
    },
      );
    }
  


export const getPostEntitiesEntityIdProcessesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEntitiesEntityIdProcesses>>, TError,{entityId: string;data: PostEntitiesEntityIdProcessesBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEntitiesEntityIdProcesses>>, TError,{entityId: string;data: PostEntitiesEntityIdProcessesBody}, TContext> => {

const mutationKey = ['postEntitiesEntityIdProcesses'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEntitiesEntityIdProcesses>>, {entityId: string;data: PostEntitiesEntityIdProcessesBody}> = (props) => {
          const {entityId,data} = props ?? {};

          return  postEntitiesEntityIdProcesses(entityId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEntitiesEntityIdProcessesMutationResult = NonNullable<Awaited<ReturnType<typeof postEntitiesEntityIdProcesses>>>
    export type PostEntitiesEntityIdProcessesMutationBody = PostEntitiesEntityIdProcessesBody
    export type PostEntitiesEntityIdProcessesMutationError = unknown

    /**
 * @summary Create Create Process
 */
export const usePostEntitiesEntityIdProcesses = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEntitiesEntityIdProcesses>>, TError,{entityId: string;data: PostEntitiesEntityIdProcessesBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEntitiesEntityIdProcesses>>,
        TError,
        {entityId: string;data: PostEntitiesEntityIdProcessesBody},
        TContext
      > => {

      const mutationOptions = getPostEntitiesEntityIdProcessesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Check User Permissions endpoint
 * @summary Create Check User Permissions
 */
export const postPermissionsCheck = (
    postPermissionsCheckBody: PostPermissionsCheckBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostPermissionsCheck200>(
      {url: `/permissions/check`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postPermissionsCheckBody, signal
    },
      );
    }
  


export const getPostPermissionsCheckMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPermissionsCheck>>, TError,{data: PostPermissionsCheckBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postPermissionsCheck>>, TError,{data: PostPermissionsCheckBody}, TContext> => {

const mutationKey = ['postPermissionsCheck'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPermissionsCheck>>, {data: PostPermissionsCheckBody}> = (props) => {
          const {data} = props ?? {};

          return  postPermissionsCheck(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPermissionsCheckMutationResult = NonNullable<Awaited<ReturnType<typeof postPermissionsCheck>>>
    export type PostPermissionsCheckMutationBody = PostPermissionsCheckBody
    export type PostPermissionsCheckMutationError = unknown

    /**
 * @summary Create Check User Permissions
 */
export const usePostPermissionsCheck = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPermissionsCheck>>, TError,{data: PostPermissionsCheckBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPermissionsCheck>>,
        TError,
        {data: PostPermissionsCheckBody},
        TContext
      > => {

      const mutationOptions = getPostPermissionsCheckMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch Get Account Manager Entity Audit endpoint
 * @summary Fetch Get Account Manager Entity Audit
 */
export const getAccountManagerIdEntitiesAudit = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetAccountManagerIdEntitiesAudit200>(
      {url: `/account-manager/${id}/entities/audit`, method: 'GET', signal
    },
      );
    }
  



export const getGetAccountManagerIdEntitiesAuditQueryKey = (id?: string,) => {
    return [
    `/account-manager/${id}/entities/audit`
    ] as const;
    }

    
export const getGetAccountManagerIdEntitiesAuditQueryOptions = <TData = Awaited<ReturnType<typeof getAccountManagerIdEntitiesAudit>>, TError = GetAccountManagerIdEntitiesAudit400 | GetAccountManagerIdEntitiesAudit401 | GetAccountManagerIdEntitiesAudit500>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountManagerIdEntitiesAudit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountManagerIdEntitiesAuditQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountManagerIdEntitiesAudit>>> = ({ signal }) => getAccountManagerIdEntitiesAudit(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountManagerIdEntitiesAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccountManagerIdEntitiesAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountManagerIdEntitiesAudit>>>
export type GetAccountManagerIdEntitiesAuditQueryError = GetAccountManagerIdEntitiesAudit400 | GetAccountManagerIdEntitiesAudit401 | GetAccountManagerIdEntitiesAudit500


export function useGetAccountManagerIdEntitiesAudit<TData = Awaited<ReturnType<typeof getAccountManagerIdEntitiesAudit>>, TError = GetAccountManagerIdEntitiesAudit400 | GetAccountManagerIdEntitiesAudit401 | GetAccountManagerIdEntitiesAudit500>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountManagerIdEntitiesAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountManagerIdEntitiesAudit>>,
          TError,
          Awaited<ReturnType<typeof getAccountManagerIdEntitiesAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccountManagerIdEntitiesAudit<TData = Awaited<ReturnType<typeof getAccountManagerIdEntitiesAudit>>, TError = GetAccountManagerIdEntitiesAudit400 | GetAccountManagerIdEntitiesAudit401 | GetAccountManagerIdEntitiesAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountManagerIdEntitiesAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountManagerIdEntitiesAudit>>,
          TError,
          Awaited<ReturnType<typeof getAccountManagerIdEntitiesAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccountManagerIdEntitiesAudit<TData = Awaited<ReturnType<typeof getAccountManagerIdEntitiesAudit>>, TError = GetAccountManagerIdEntitiesAudit400 | GetAccountManagerIdEntitiesAudit401 | GetAccountManagerIdEntitiesAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountManagerIdEntitiesAudit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Get Account Manager Entity Audit
 */

export function useGetAccountManagerIdEntitiesAudit<TData = Awaited<ReturnType<typeof getAccountManagerIdEntitiesAudit>>, TError = GetAccountManagerIdEntitiesAudit400 | GetAccountManagerIdEntitiesAudit401 | GetAccountManagerIdEntitiesAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountManagerIdEntitiesAudit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccountManagerIdEntitiesAuditQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Get Account Manager Audit endpoint
 * @summary Fetch Get Account Manager Audit
 */
export const getAccountManagerIdAudit = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetAccountManagerIdAudit200>(
      {url: `/account-manager/${id}/audit`, method: 'GET', signal
    },
      );
    }
  



export const getGetAccountManagerIdAuditQueryKey = (id?: string,) => {
    return [
    `/account-manager/${id}/audit`
    ] as const;
    }

    
export const getGetAccountManagerIdAuditQueryOptions = <TData = Awaited<ReturnType<typeof getAccountManagerIdAudit>>, TError = GetAccountManagerIdAudit400 | GetAccountManagerIdAudit401 | GetAccountManagerIdAudit500>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountManagerIdAudit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountManagerIdAuditQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountManagerIdAudit>>> = ({ signal }) => getAccountManagerIdAudit(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountManagerIdAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccountManagerIdAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountManagerIdAudit>>>
export type GetAccountManagerIdAuditQueryError = GetAccountManagerIdAudit400 | GetAccountManagerIdAudit401 | GetAccountManagerIdAudit500


export function useGetAccountManagerIdAudit<TData = Awaited<ReturnType<typeof getAccountManagerIdAudit>>, TError = GetAccountManagerIdAudit400 | GetAccountManagerIdAudit401 | GetAccountManagerIdAudit500>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountManagerIdAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountManagerIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getAccountManagerIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccountManagerIdAudit<TData = Awaited<ReturnType<typeof getAccountManagerIdAudit>>, TError = GetAccountManagerIdAudit400 | GetAccountManagerIdAudit401 | GetAccountManagerIdAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountManagerIdAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountManagerIdAudit>>,
          TError,
          Awaited<ReturnType<typeof getAccountManagerIdAudit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccountManagerIdAudit<TData = Awaited<ReturnType<typeof getAccountManagerIdAudit>>, TError = GetAccountManagerIdAudit400 | GetAccountManagerIdAudit401 | GetAccountManagerIdAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountManagerIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch Get Account Manager Audit
 */

export function useGetAccountManagerIdAudit<TData = Awaited<ReturnType<typeof getAccountManagerIdAudit>>, TError = GetAccountManagerIdAudit400 | GetAccountManagerIdAudit401 | GetAccountManagerIdAudit500>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountManagerIdAudit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccountManagerIdAuditQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}
